import type { TypedDocumentNode as DocumentNode } from '@urql/vue';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BusinessIdentityCode: { input: string; output: string; }
  CountryCode: { input: string; output: string; }
  Currency: { input: string; output: string; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Decimal: { input: string; output: string; }
  EmailAddress: { input: string; output: string; }
  HexColorCode: { input: string; output: string; }
  IP: { input: string; output: string; }
  JSONObject: { input: Record<string, unknown>; output: Record<string, unknown>; }
  NonEmptyString: { input: string; output: string; }
  NonNegativeFloat: { input: number; output: number; }
  NonNegativeInt: { input: number; output: number; }
  PhoneNumber: { input: string; output: string; }
  Point: { input: { type: "Point", coordinates: [number, number] }; output: { type: "Point", coordinates: [number, number] }; }
  PositiveFloat: { input: number; output: number; }
  PositiveInt: { input: number; output: number; }
  PostalCode: { input: string; output: string; }
  SafeInt: { input: number; output: number; }
  TimeZone: { input: string; output: string; }
  URL: { input: string; output: string; }
  UUID: { input: string; output: string; }
  UnsignedFloat: { input: number; output: number; }
};

export type Attribute = Node & {
  __typename: 'Attribute';
  code: Maybe<Scalars['NonEmptyString']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  filterTitle: Maybe<Scalars['NonEmptyString']['output']>;
  group: Maybe<AttributeGroup>;
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  name: Scalars['NonEmptyString']['output'];
  options: Array<AttributeOption>;
  optionsOrder: Maybe<AttributeOptionOrder>;
  pim: AttributePim;
  prefix: Maybe<Scalars['NonEmptyString']['output']>;
  showInCategoryFilter: Scalars['Boolean']['output'];
  showInProductListing: Scalars['Boolean']['output'];
  showInProductPage: Scalars['Boolean']['output'];
  suffix: Maybe<Scalars['NonEmptyString']['output']>;
  title: Maybe<Scalars['NonEmptyString']['output']>;
  type: AttributeType;
  updatedAt: Scalars['DateTime']['output'];
};

export type AttributeCreateInput = {
  code?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  filterTitle?: InputMaybe<Scalars['NonEmptyString']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['NonEmptyString']['input'];
  optionsOrder?: InputMaybe<AttributeOptionOrder>;
  pimAllowUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  pimName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  prefix?: InputMaybe<Scalars['NonEmptyString']['input']>;
  showInCategoryFilter?: InputMaybe<Scalars['Boolean']['input']>;
  showInProductListing?: InputMaybe<Scalars['Boolean']['input']>;
  showInProductPage?: InputMaybe<Scalars['Boolean']['input']>;
  suffix?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type: AttributeType;
};

export type AttributeCreatePayload = {
  __typename: 'AttributeCreatePayload';
  attribute: Attribute;
};

export type AttributeCreateUnion = AttributeCreatePayload | InvalidInputError;

export type AttributeDeletePayload = {
  __typename: 'AttributeDeletePayload';
  attribute: Attribute;
};

export type AttributeDeleteUnion = AttributeDeletePayload | EntityNotFoundError;

export type AttributeGroup = Node & {
  __typename: 'AttributeGroup';
  attributeCount: Scalars['NonNegativeInt']['output'];
  attributes: Array<Attribute>;
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  id: Scalars['ID']['output'];
  position: Scalars['NonNegativeInt']['output'];
  title: Scalars['NonEmptyString']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type AttributeGroupAttributesArgs = {
  showInProductListing?: InputMaybe<Scalars['Boolean']['input']>;
  showInProductPage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AttributeGroupAddAttributesPayload = {
  __typename: 'AttributeGroupAddAttributesPayload';
  attributeGroup: AttributeGroup;
  attributes: Array<Attribute>;
};

export type AttributeGroupAddAttributesUnion = AttributeGroupAddAttributesPayload | EntityNotFoundError;

export type AttributeGroupCreateInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title: Scalars['NonEmptyString']['input'];
};

export type AttributeGroupCreatePayload = {
  __typename: 'AttributeGroupCreatePayload';
  attributeGroup: AttributeGroup;
};

export type AttributeGroupCreateUnion = AttributeGroupCreatePayload | InvalidInputError;

export type AttributeGroupDeletePayload = {
  __typename: 'AttributeGroupDeletePayload';
  attributeGroup: AttributeGroup;
};

export type AttributeGroupDeleteUnion = AttributeGroupDeletePayload | EntityNotFoundError;

export enum AttributeGroupOrderByField {
  CreatedAt = 'CREATED_AT',
  Position = 'POSITION',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type AttributeGroupOrderByInput = {
  direction: OrderByDirection;
  field: AttributeGroupOrderByField;
};

export type AttributeGroupRemoveAttributesPayload = {
  __typename: 'AttributeGroupRemoveAttributesPayload';
  attributeGroup: AttributeGroup;
  attributes: Array<Attribute>;
};

export type AttributeGroupRemoveAttributesUnion = AttributeGroupRemoveAttributesPayload | EntityNotFoundError;

export type AttributeGroupReorderAttributesPayload = {
  __typename: 'AttributeGroupReorderAttributesPayload';
  attributeGroup: AttributeGroup;
};

export type AttributeGroupReorderAttributesUnion = AttributeGroupReorderAttributesPayload | EntityNotFoundError;

export type AttributeGroupReorderPayload = {
  __typename: 'AttributeGroupReorderPayload';
  attributeGroups: Array<AttributeGroup>;
};

export type AttributeGroupReorderUnion = AttributeGroupReorderPayload | InvalidInputError;

export type AttributeGroupResultUnion = AttributeGroup | EntityNotFoundError;

export type AttributeGroupUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type AttributeGroupUpdateInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type AttributeGroupUpdatePayload = {
  __typename: 'AttributeGroupUpdatePayload';
  attributeGroup: AttributeGroup;
};

export type AttributeGroupUpdateUnion = AttributeGroupUpdatePayload | EntityNotFoundError;

export type AttributeGroupWhereInput = {
  AND?: InputMaybe<Array<AttributeGroupWhereSubInput>>;
  OR?: InputMaybe<Array<AttributeGroupWhereSubInput>>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type AttributeGroupWhereSubInput = {
  AND?: InputMaybe<Array<AttributeGroupWhereSubInput>>;
  OR?: InputMaybe<Array<AttributeGroupWhereSubInput>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type AttributeGroupsConnection = {
  __typename: 'AttributeGroupsConnection';
  edges: Array<AttributeGroupsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type AttributeGroupsEdge = {
  __typename: 'AttributeGroupsEdge';
  cursor: Scalars['String']['output'];
  node: AttributeGroup;
};

export type AttributeOption = Node & {
  __typename: 'AttributeOption';
  attribute: Attribute;
  color: Maybe<Scalars['HexColorCode']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  id: Scalars['ID']['output'];
  image: Maybe<Scalars['URL']['output']>;
  position: Maybe<Scalars['NonNegativeInt']['output']>;
  title: Scalars['NonEmptyString']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AttributeOptionCreateInput = {
  attributeId: Scalars['ID']['input'];
  color?: InputMaybe<Scalars['HexColorCode']['input']>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  image?: InputMaybe<Scalars['NonEmptyString']['input']>;
  position?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  title: Scalars['NonEmptyString']['input'];
};

export type AttributeOptionCreatePayload = {
  __typename: 'AttributeOptionCreatePayload';
  attribute: Attribute;
  attributeOption: AttributeOption;
};

export type AttributeOptionCreateUnion = AttributeOptionCreatePayload | InvalidInputError;

export type AttributeOptionDeletePayload = {
  __typename: 'AttributeOptionDeletePayload';
  attribute: Attribute;
  attributeOption: AttributeOption;
};

export type AttributeOptionDeleteUnion = AttributeOptionDeletePayload | EntityNotFoundError;

export enum AttributeOptionOrder {
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

export enum AttributeOptionOrderByField {
  CreatedAt = 'CREATED_AT',
  Position = 'POSITION',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type AttributeOptionOrderByInput = {
  direction: OrderByDirection;
  field: AttributeOptionOrderByField;
};

export type AttributeOptionResultUnion = AttributeOption | EntityNotFoundError;

export type AttributeOptionUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type AttributeOptionUpdateInput = {
  color?: InputMaybe<Scalars['HexColorCode']['input']>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  image?: InputMaybe<Scalars['NonEmptyString']['input']>;
  position?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type AttributeOptionUpdatePayload = {
  __typename: 'AttributeOptionUpdatePayload';
  attribute: Attribute;
  attributeOption: AttributeOption;
};

export type AttributeOptionUpdateUnion = AttributeOptionUpdatePayload | EntityNotFoundError;

export type AttributeOptionWhereInput = {
  AND?: InputMaybe<Array<AttributeOptionWhereSubInput>>;
  OR?: InputMaybe<Array<AttributeOptionWhereSubInput>>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type AttributeOptionWhereSubInput = {
  AND?: InputMaybe<Array<AttributeOptionWhereSubInput>>;
  OR?: InputMaybe<Array<AttributeOptionWhereSubInput>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type AttributeOptionsConnection = {
  __typename: 'AttributeOptionsConnection';
  edges: Array<AttributeOptionsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type AttributeOptionsEdge = {
  __typename: 'AttributeOptionsEdge';
  cursor: Scalars['String']['output'];
  node: AttributeOption;
};

export enum AttributeOrderByField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  Title = 'TITLE',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  VisibilityFilter = 'VISIBILITY_FILTER',
  VisibilityProduct = 'VISIBILITY_PRODUCT'
}

export type AttributeOrderByInput = {
  direction: OrderByDirection;
  field: AttributeOrderByField;
};

export type AttributePim = {
  __typename: 'AttributePim';
  allowUpdates: Scalars['Boolean']['output'];
  name: Maybe<Scalars['NonEmptyString']['output']>;
};

export type AttributeReorderOptionsPayload = {
  __typename: 'AttributeReorderOptionsPayload';
  attribute: Attribute;
};

export type AttributeReorderOptionsUnion = AttributeReorderOptionsPayload | EntityNotFoundError;

export type AttributeResultUnion = Attribute | EntityNotFoundError;

export enum AttributeType {
  Color = 'COLOR',
  Date = 'DATE',
  Dropdown = 'DROPDOWN',
  Multiselect = 'MULTISELECT',
  Number = 'NUMBER',
  Tags = 'TAGS',
  Text = 'TEXT',
  Textarea = 'TEXTAREA',
  Toggle = 'TOGGLE'
}

export type AttributeUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type AttributeUpdateInput = {
  code?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  filterTitle?: InputMaybe<Scalars['NonEmptyString']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['NonEmptyString']['input']>;
  optionsOrder?: InputMaybe<AttributeOptionOrder>;
  pimAllowUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  pimName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  prefix?: InputMaybe<Scalars['NonEmptyString']['input']>;
  showInCategoryFilter?: InputMaybe<Scalars['Boolean']['input']>;
  showInProductListing?: InputMaybe<Scalars['Boolean']['input']>;
  showInProductPage?: InputMaybe<Scalars['Boolean']['input']>;
  suffix?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type AttributeUpdatePayload = {
  __typename: 'AttributeUpdatePayload';
  attribute: Attribute;
};

export type AttributeUpdateUnion = AttributeUpdatePayload | EntityNotFoundError;

export type AttributeWhereInput = {
  AND?: InputMaybe<Array<AttributeWhereSubInput>>;
  OR?: InputMaybe<Array<AttributeWhereSubInput>>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  showInCategoryFilter?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type AttributeWhereSubInput = {
  AND?: InputMaybe<Array<AttributeWhereSubInput>>;
  OR?: InputMaybe<Array<AttributeWhereSubInput>>;
  showInCategoryFilter?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type AttributesConnection = {
  __typename: 'AttributesConnection';
  edges: Array<AttributesEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type AttributesEdge = {
  __typename: 'AttributesEdge';
  cursor: Scalars['String']['output'];
  node: Attribute;
};

export type Audit = {
  action: AuditAction;
  createdAt: Scalars['DateTime']['output'];
  diffs: Array<AuditDiff>;
  id: Scalars['ID']['output'];
  source: Maybe<AuditSource>;
  user: Maybe<User>;
};

export enum AuditAction {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

export type AuditBooleanDiff = AuditDiff & {
  __typename: 'AuditBooleanDiff';
  name: Scalars['String']['output'];
  newValue: Maybe<Scalars['Boolean']['output']>;
  oldValue: Maybe<Scalars['Boolean']['output']>;
};

export type AuditCategory = Audit & Node & {
  __typename: 'AuditCategory';
  action: AuditAction;
  category: Category;
  createdAt: Scalars['DateTime']['output'];
  diffs: Array<AuditDiff>;
  id: Scalars['ID']['output'];
  source: Maybe<AuditSource>;
  user: Maybe<User>;
};

export type AuditCustomer = Audit & Node & {
  __typename: 'AuditCustomer';
  action: AuditAction;
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  diffs: Array<AuditDiff>;
  id: Scalars['ID']['output'];
  source: Maybe<AuditSource>;
  user: Maybe<User>;
};

export type AuditCustomerAddress = Audit & Node & {
  __typename: 'AuditCustomerAddress';
  action: AuditAction;
  createdAt: Scalars['DateTime']['output'];
  customer: Maybe<Customer>;
  customerAddress: CustomerAddress;
  diffs: Array<AuditDiff>;
  id: Scalars['ID']['output'];
  source: Maybe<AuditSource>;
  user: Maybe<User>;
};

export type AuditDateDiff = AuditDiff & {
  __typename: 'AuditDateDiff';
  name: Scalars['String']['output'];
  newValue: Maybe<Scalars['DateTime']['output']>;
  oldValue: Maybe<Scalars['DateTime']['output']>;
};

export type AuditDiff = {
  name: Scalars['String']['output'];
};

export type AuditEnumDiff = AuditDiff & {
  __typename: 'AuditEnumDiff';
  name: Scalars['String']['output'];
  newValue: Maybe<Scalars['String']['output']>;
  oldValue: Maybe<Scalars['String']['output']>;
};

export type AuditMoneyDiff = AuditDiff & {
  __typename: 'AuditMoneyDiff';
  name: Scalars['String']['output'];
  newValue: Maybe<Scalars['String']['output']>;
  oldValue: Maybe<Scalars['String']['output']>;
};

export type AuditNumberArrayDiff = AuditDiff & {
  __typename: 'AuditNumberArrayDiff';
  name: Scalars['String']['output'];
  newValue: Maybe<Array<Scalars['Float']['output']>>;
  oldValue: Maybe<Array<Scalars['Float']['output']>>;
};

export type AuditNumberDiff = AuditDiff & {
  __typename: 'AuditNumberDiff';
  name: Scalars['String']['output'];
  newValue: Maybe<Scalars['Float']['output']>;
  oldValue: Maybe<Scalars['Float']['output']>;
};

export type AuditOrderAddress = Audit & Node & {
  __typename: 'AuditOrderAddress';
  action: AuditAction;
  createdAt: Scalars['DateTime']['output'];
  diffs: Array<AuditDiff>;
  id: Scalars['ID']['output'];
  order: Maybe<Order>;
  orderAddress: OrderAddress;
  source: Maybe<AuditSource>;
  user: Maybe<User>;
};

export enum AuditOrderByField {
  CreatedAt = 'CREATED_AT'
}

export type AuditOrderByInput = {
  direction: OrderByDirection;
  field: AuditOrderByField;
};

export type AuditOrderPayment = Audit & Node & {
  __typename: 'AuditOrderPayment';
  action: AuditAction;
  createdAt: Scalars['DateTime']['output'];
  diffs: Array<AuditDiff>;
  id: Scalars['ID']['output'];
  order: Maybe<Order>;
  orderPayment: OrderPayment;
  source: Maybe<AuditSource>;
  user: Maybe<User>;
};

export type AuditProduct = Audit & Node & {
  __typename: 'AuditProduct';
  action: AuditAction;
  createdAt: Scalars['DateTime']['output'];
  diffs: Array<AuditDiff>;
  id: Scalars['ID']['output'];
  product: Product;
  source: Maybe<AuditSource>;
  user: Maybe<User>;
};

export type AuditProductAsset = Audit & Node & {
  __typename: 'AuditProductAsset';
  action: AuditAction;
  createdAt: Scalars['DateTime']['output'];
  diffs: Array<AuditDiff>;
  id: Scalars['ID']['output'];
  product: Product;
  productAsset: ProductAsset;
  source: Maybe<AuditSource>;
  user: Maybe<User>;
};

export type AuditProductAttributeValue = Audit & Node & {
  __typename: 'AuditProductAttributeValue';
  action: AuditAction;
  createdAt: Scalars['DateTime']['output'];
  diffs: Array<AuditDiff>;
  id: Scalars['ID']['output'];
  product: Product;
  productAttributeValue: ProductAttributeValue;
  source: Maybe<AuditSource>;
  user: Maybe<User>;
};

export type AuditProductMedia = Audit & Node & {
  __typename: 'AuditProductMedia';
  action: AuditAction;
  createdAt: Scalars['DateTime']['output'];
  diffs: Array<AuditDiff>;
  id: Scalars['ID']['output'];
  product: Product;
  productMedia: ProductMedia;
  source: Maybe<AuditSource>;
  user: Maybe<User>;
};

export enum AuditSource {
  ProductEditor = 'PRODUCT_EDITOR',
  ProductImport = 'PRODUCT_IMPORT'
}

export type AuditTextArrayDiff = AuditDiff & {
  __typename: 'AuditTextArrayDiff';
  name: Scalars['String']['output'];
  newValue: Maybe<Array<Scalars['String']['output']>>;
  oldValue: Maybe<Array<Scalars['String']['output']>>;
};

export type AuditTextDiff = AuditDiff & {
  __typename: 'AuditTextDiff';
  name: Scalars['String']['output'];
  newValue: Maybe<Scalars['String']['output']>;
  oldValue: Maybe<Scalars['String']['output']>;
};

export type AuditWhereInput = {
  itemId: Scalars['ID']['input'];
};

export type AuditsConnection = {
  __typename: 'AuditsConnection';
  edges: Array<AuditsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type AuditsEdge = {
  __typename: 'AuditsEdge';
  cursor: Scalars['String']['output'];
  node: Audit;
};

export enum AvardaPaymentMethodType {
  B2BInvoice = 'B2_B_INVOICE',
  Card = 'CARD',
  DirectInvoice = 'DIRECT_INVOICE',
  DirectPayment = 'DIRECT_PAYMENT',
  HighAmountLoan = 'HIGH_AMOUNT_LOAN',
  Invoice = 'INVOICE',
  Loan = 'LOAN',
  Masterpass = 'MASTERPASS',
  MobilePay = 'MOBILE_PAY',
  PartPayment = 'PART_PAYMENT',
  PayOnDelivery = 'PAY_ON_DELIVERY',
  PayPal = 'PAY_PAL',
  Swish = 'SWISH',
  Vipps = 'VIPPS',
  ZeroAmount = 'ZERO_AMOUNT'
}

export type Brand = Node & {
  __typename: 'Brand';
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['URL']['output']>;
  number: Maybe<Scalars['NonEmptyString']['output']>;
  parent: Maybe<Brand>;
  productCount: Scalars['NonNegativeInt']['output'];
  state: BrandState;
  title: Scalars['NonEmptyString']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Maybe<Scalars['URL']['output']>;
};

export type BrandCreateInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  logo?: InputMaybe<Scalars['NonEmptyString']['input']>;
  number?: InputMaybe<Scalars['NonEmptyString']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<BrandState>;
  title: Scalars['NonEmptyString']['input'];
  url?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type BrandCreatePayload = {
  __typename: 'BrandCreatePayload';
  brand: Brand;
};

export type BrandCreateUnion = BrandCreatePayload | InvalidInputError;

export type BrandDeletePayload = {
  __typename: 'BrandDeletePayload';
  brand: Brand;
};

export type BrandDeleteUnion = BrandDeletePayload | EntityNotFoundError;

export enum BrandOrderByField {
  CreatedAt = 'CREATED_AT',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type BrandOrderByInput = {
  direction: OrderByDirection;
  field: BrandOrderByField;
};

export type BrandResultUnion = Brand | EntityNotFoundError;

export enum BrandState {
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED'
}

export type BrandUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type BrandUpdateInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  logo?: InputMaybe<Scalars['NonEmptyString']['input']>;
  number?: InputMaybe<Scalars['NonEmptyString']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<BrandState>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  url?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type BrandUpdatePayload = {
  __typename: 'BrandUpdatePayload';
  brand: Brand;
};

export type BrandUpdateUnion = BrandUpdatePayload | EntityNotFoundError;

export type BrandWhereInput = {
  AND?: InputMaybe<Array<BrandWhereSubInput>>;
  OR?: InputMaybe<Array<BrandWhereSubInput>>;
  number?: InputMaybe<Scalars['NonEmptyString']['input']>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type BrandWhereSubInput = {
  AND?: InputMaybe<Array<BrandWhereSubInput>>;
  OR?: InputMaybe<Array<BrandWhereSubInput>>;
  number?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type BrandsConnection = {
  __typename: 'BrandsConnection';
  edges: Array<BrandsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type BrandsEdge = {
  __typename: 'BrandsEdge';
  cursor: Scalars['String']['output'];
  node: Brand;
};

export type Cart = Node & {
  __typename: 'Cart';
  createdAt: Scalars['DateTime']['output'];
  giftCard: Maybe<GiftCard>;
  hasFreeShipping: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isWishlist: Scalars['Boolean']['output'];
  price: Money;
  productCount: Scalars['NonNegativeInt']['output'];
  products: Array<CartProduct>;
  promotionCode: Maybe<PromotionCode>;
  promotions: Array<Promotion>;
  recommendedProducts: Array<Product>;
  relatedProductsByCategory: Array<CartRelatedProductGroup>;
  updatedAt: Scalars['DateTime']['output'];
};


export type CartRelatedProductsByCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CartCreateInput = {
  isWishlist?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CartCreatePayload = {
  __typename: 'CartCreatePayload';
  cart: Cart;
};

export type CartCreateUnion = CartCreatePayload | InvalidInputError;

export type CartDeletePayload = {
  __typename: 'CartDeletePayload';
  cart: Cart;
};

export type CartDeleteUnion = CartDeletePayload | EntityNotFoundError;

export type CartProduct = Node & {
  __typename: 'CartProduct';
  createdAt: Scalars['DateTime']['output'];
  discounts: Array<CartProductDiscount>;
  id: Scalars['ID']['output'];
  price: Money;
  product: SimpleProduct;
  properties: Array<CartProductProperty>;
  quantity: Scalars['PositiveInt']['output'];
  unitPrice: Money;
  updatedAt: Scalars['DateTime']['output'];
};

export type CartProductConfigurationInput = {
  properties?: InputMaybe<Array<CartProductConfigurationPropertiesInput>>;
};

export type CartProductConfigurationPropertiesInput = {
  id: Scalars['ID']['input'];
  optionId: Scalars['ID']['input'];
};

export type CartProductCreateInput = {
  cartId: Scalars['ID']['input'];
  configuration?: InputMaybe<CartProductConfigurationInput>;
  productId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type CartProductCreatePayload = {
  __typename: 'CartProductCreatePayload';
  cart: Cart;
  cartProduct: CartProduct;
};

export type CartProductCreateUnion = CartProductCreatePayload | CartProductOutOfBoundsError | InvalidInputError;

export type CartProductDeletePayload = {
  __typename: 'CartProductDeletePayload';
  cart: Cart;
  cartProduct: CartProduct;
};

export type CartProductDeleteUnion = CartProductDeletePayload | EntityNotFoundError;

export type CartProductDiscount = {
  __typename: 'CartProductDiscount';
  amount: Money;
  promotion: Promotion;
};

export type CartProductOutOfBoundsError = GenericError & {
  __typename: 'CartProductOutOfBoundsError';
  code: Maybe<Scalars['String']['output']>;
  detailedMessage: Scalars['String']['output'];
  isError: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CartProductProperty = Node & {
  __typename: 'CartProductProperty';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CartProductUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type CartProductUpdateInput = {
  quantity: Scalars['PositiveInt']['input'];
};

export type CartProductUpdatePayload = {
  __typename: 'CartProductUpdatePayload';
  cart: Cart;
  cartProduct: CartProduct;
};

export type CartProductUpdateUnion = CartProductOutOfBoundsError | CartProductUpdatePayload | EntityNotFoundError;

export type CartPromotion = {
  activeFrom: Maybe<Scalars['DateTime']['output']>;
  activeTo: Maybe<Scalars['DateTime']['output']>;
  continueProcessing: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  discountType: CartPromotionDiscountType;
  filterRuleset: Maybe<Ruleset>;
  id: Scalars['ID']['output'];
  isSticky: Scalars['Boolean']['output'];
  matchRuleset: Maybe<Ruleset>;
  name: Scalars['NonEmptyString']['output'];
  priority: Scalars['NonNegativeInt']['output'];
  requiresLogin: Scalars['Boolean']['output'];
  state: PromotionState;
  title: Maybe<Scalars['NonEmptyString']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  usesPerCode: Maybe<Scalars['PositiveInt']['output']>;
};

export type CartPromotionClubPrice = CartPromotion & Node & Promotion & {
  __typename: 'CartPromotionClubPrice';
  activeFrom: Maybe<Scalars['DateTime']['output']>;
  activeTo: Maybe<Scalars['DateTime']['output']>;
  continueProcessing: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  discount: CartPromotionClubPriceDiscount;
  discountType: CartPromotionDiscountType;
  filterRuleset: Maybe<Ruleset>;
  id: Scalars['ID']['output'];
  isSticky: Scalars['Boolean']['output'];
  matchRuleset: Maybe<Ruleset>;
  name: Scalars['NonEmptyString']['output'];
  priority: Scalars['NonNegativeInt']['output'];
  requiresLogin: Scalars['Boolean']['output'];
  state: PromotionState;
  title: Maybe<Scalars['NonEmptyString']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  usesPerCode: Maybe<Scalars['PositiveInt']['output']>;
};

export type CartPromotionClubPriceDiscount = {
  __typename: 'CartPromotionClubPriceDiscount';
  discountAmount: Maybe<Scalars['NonNegativeInt']['output']>;
};

export enum CartPromotionDiscountType {
  ClubPrice = 'CLUB_PRICE',
  FixedAmountFromCart = 'FIXED_AMOUNT_FROM_CART',
  FixedAmountFromProduct = 'FIXED_AMOUNT_FROM_PRODUCT',
  Freebie = 'FREEBIE',
  FreeShipping = 'FREE_SHIPPING',
  Percent = 'PERCENT',
  ProductCartPromotionPrice = 'PRODUCT_CART_PROMOTION_PRICE'
}

export type CartPromotionFixedAmountFromCart = CartPromotion & Node & Promotion & {
  __typename: 'CartPromotionFixedAmountFromCart';
  activeFrom: Maybe<Scalars['DateTime']['output']>;
  activeTo: Maybe<Scalars['DateTime']['output']>;
  continueProcessing: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  discount: CartPromotionFixedAmountFromCartDiscount;
  discountType: CartPromotionDiscountType;
  filterRuleset: Maybe<Ruleset>;
  id: Scalars['ID']['output'];
  isSticky: Scalars['Boolean']['output'];
  matchRuleset: Maybe<Ruleset>;
  name: Scalars['NonEmptyString']['output'];
  priority: Scalars['NonNegativeInt']['output'];
  requiresLogin: Scalars['Boolean']['output'];
  state: PromotionState;
  title: Maybe<Scalars['NonEmptyString']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  usesPerCode: Maybe<Scalars['PositiveInt']['output']>;
};

export type CartPromotionFixedAmountFromCartDiscount = {
  __typename: 'CartPromotionFixedAmountFromCartDiscount';
  amount: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type CartPromotionFixedAmountFromProduct = CartPromotion & Node & Promotion & {
  __typename: 'CartPromotionFixedAmountFromProduct';
  activeFrom: Maybe<Scalars['DateTime']['output']>;
  activeTo: Maybe<Scalars['DateTime']['output']>;
  continueProcessing: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  discount: CartPromotionFixedAmountFromProductDiscount;
  discountType: CartPromotionDiscountType;
  filterRuleset: Maybe<Ruleset>;
  id: Scalars['ID']['output'];
  isSticky: Scalars['Boolean']['output'];
  matchRuleset: Maybe<Ruleset>;
  name: Scalars['NonEmptyString']['output'];
  priority: Scalars['NonNegativeInt']['output'];
  requiresLogin: Scalars['Boolean']['output'];
  state: PromotionState;
  title: Maybe<Scalars['NonEmptyString']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  usesPerCode: Maybe<Scalars['PositiveInt']['output']>;
};

export type CartPromotionFixedAmountFromProductDiscount = {
  __typename: 'CartPromotionFixedAmountFromProductDiscount';
  amount: Maybe<Scalars['NonNegativeInt']['output']>;
  discountQuantityPerCart: Maybe<Scalars['PositiveInt']['output']>;
  discountQuantityPerProductRow: Maybe<Scalars['PositiveInt']['output']>;
};

export type CartPromotionFreeShipping = CartPromotion & Node & Promotion & {
  __typename: 'CartPromotionFreeShipping';
  activeFrom: Maybe<Scalars['DateTime']['output']>;
  activeTo: Maybe<Scalars['DateTime']['output']>;
  continueProcessing: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  discountType: CartPromotionDiscountType;
  filterRuleset: Maybe<Ruleset>;
  id: Scalars['ID']['output'];
  isSticky: Scalars['Boolean']['output'];
  matchRuleset: Maybe<Ruleset>;
  name: Scalars['NonEmptyString']['output'];
  priority: Scalars['NonNegativeInt']['output'];
  requiresLogin: Scalars['Boolean']['output'];
  state: PromotionState;
  title: Maybe<Scalars['NonEmptyString']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  usesPerCode: Maybe<Scalars['PositiveInt']['output']>;
};

export type CartPromotionFreebie = CartPromotion & Node & Promotion & {
  __typename: 'CartPromotionFreebie';
  activeFrom: Maybe<Scalars['DateTime']['output']>;
  activeTo: Maybe<Scalars['DateTime']['output']>;
  continueProcessing: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  discount: CartPromotionFreebieDiscount;
  discountType: CartPromotionDiscountType;
  filterRuleset: Maybe<Ruleset>;
  id: Scalars['ID']['output'];
  isSticky: Scalars['Boolean']['output'];
  matchRuleset: Maybe<Ruleset>;
  name: Scalars['NonEmptyString']['output'];
  priority: Scalars['NonNegativeInt']['output'];
  requiresLogin: Scalars['Boolean']['output'];
  state: PromotionState;
  title: Maybe<Scalars['NonEmptyString']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  usesPerCode: Maybe<Scalars['PositiveInt']['output']>;
};

export type CartPromotionFreebieDiscount = {
  __typename: 'CartPromotionFreebieDiscount';
  divider: Maybe<Scalars['PositiveInt']['output']>;
  percent: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type CartPromotionPercent = CartPromotion & Node & Promotion & {
  __typename: 'CartPromotionPercent';
  activeFrom: Maybe<Scalars['DateTime']['output']>;
  activeTo: Maybe<Scalars['DateTime']['output']>;
  continueProcessing: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  discount: CartPromotionPercentDiscount;
  discountType: CartPromotionDiscountType;
  filterRuleset: Maybe<Ruleset>;
  id: Scalars['ID']['output'];
  isSticky: Scalars['Boolean']['output'];
  matchRuleset: Maybe<Ruleset>;
  name: Scalars['NonEmptyString']['output'];
  priority: Scalars['NonNegativeInt']['output'];
  requiresLogin: Scalars['Boolean']['output'];
  state: PromotionState;
  title: Maybe<Scalars['NonEmptyString']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  usesPerCode: Maybe<Scalars['PositiveInt']['output']>;
};

export type CartPromotionPercentDiscount = {
  __typename: 'CartPromotionPercentDiscount';
  discountQuantityPerCart: Maybe<Scalars['PositiveInt']['output']>;
  discountQuantityPerProductRow: Maybe<Scalars['PositiveInt']['output']>;
  percent: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type CartPromotionProductCartPromotionPrice = CartPromotion & Node & Promotion & {
  __typename: 'CartPromotionProductCartPromotionPrice';
  activeFrom: Maybe<Scalars['DateTime']['output']>;
  activeTo: Maybe<Scalars['DateTime']['output']>;
  continueProcessing: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  discountType: CartPromotionDiscountType;
  filterRuleset: Maybe<Ruleset>;
  id: Scalars['ID']['output'];
  isSticky: Scalars['Boolean']['output'];
  matchRuleset: Maybe<Ruleset>;
  name: Scalars['NonEmptyString']['output'];
  priority: Scalars['NonNegativeInt']['output'];
  requiresLogin: Scalars['Boolean']['output'];
  state: PromotionState;
  title: Maybe<Scalars['NonEmptyString']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  usesPerCode: Maybe<Scalars['PositiveInt']['output']>;
};

export type CartRecommendation = Node & {
  __typename: 'CartRecommendation';
  activeFrom: Maybe<Scalars['DateTime']['output']>;
  activeTo: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  id: Scalars['ID']['output'];
  priority: Scalars['NonNegativeInt']['output'];
  products: Array<Product>;
  productsRuleset: Maybe<Ruleset>;
  productsType: CartRecommendationProductsType;
  ruleset: Maybe<Ruleset>;
  state: CartRecommendationState;
  title: Scalars['NonEmptyString']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CartRecommendationAddProductsPayload = {
  __typename: 'CartRecommendationAddProductsPayload';
  cartRecommendation: CartRecommendation;
  products: Array<Product>;
};

export type CartRecommendationAddProductsUnion = CartRecommendationAddProductsPayload | EntityNotFoundError;

export type CartRecommendationCreateInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  priority?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  productsRulesetId?: InputMaybe<Scalars['ID']['input']>;
  productsType?: InputMaybe<CartRecommendationProductsType>;
  rulesetId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<CartRecommendationState>;
  title: Scalars['NonEmptyString']['input'];
};

export type CartRecommendationCreatePayload = {
  __typename: 'CartRecommendationCreatePayload';
  cartRecommendation: CartRecommendation;
};

export type CartRecommendationCreateUnion = CartRecommendationCreatePayload | InvalidInputError;

export type CartRecommendationDeletePayload = {
  __typename: 'CartRecommendationDeletePayload';
  cartRecommendation: CartRecommendation;
};

export type CartRecommendationDeleteUnion = CartRecommendationDeletePayload | EntityNotFoundError;

export enum CartRecommendationOrderByField {
  CreatedAt = 'CREATED_AT',
  Priority = 'PRIORITY',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type CartRecommendationOrderByInput = {
  direction: OrderByDirection;
  field: CartRecommendationOrderByField;
};

export enum CartRecommendationProductsType {
  Dynamic = 'DYNAMIC',
  Static = 'STATIC'
}

export type CartRecommendationRemoveProductsPayload = {
  __typename: 'CartRecommendationRemoveProductsPayload';
  cartRecommendation: CartRecommendation;
  products: Array<Product>;
};

export type CartRecommendationRemoveProductsUnion = CartRecommendationRemoveProductsPayload | EntityNotFoundError;

export type CartRecommendationResultUnion = CartRecommendation | EntityNotFoundError;

export enum CartRecommendationRulesetType {
  Fetch = 'FETCH',
  Match = 'MATCH'
}

export enum CartRecommendationState {
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED',
  Scheduled = 'SCHEDULED'
}

export type CartRecommendationUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type CartRecommendationUpdateInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  priority?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  productsType?: InputMaybe<CartRecommendationProductsType>;
  state?: InputMaybe<CartRecommendationState>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type CartRecommendationUpdatePayload = {
  __typename: 'CartRecommendationUpdatePayload';
  cartRecommendation: CartRecommendation;
};

export type CartRecommendationUpdateUnion = CartRecommendationUpdatePayload | EntityNotFoundError;

export type CartRecommendationWhereInput = {
  AND?: InputMaybe<Array<CartRecommendationWhereSubInput>>;
  OR?: InputMaybe<Array<CartRecommendationWhereSubInput>>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type CartRecommendationWhereSubInput = {
  AND?: InputMaybe<Array<CartRecommendationWhereSubInput>>;
  OR?: InputMaybe<Array<CartRecommendationWhereSubInput>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type CartRecommendationsConnection = {
  __typename: 'CartRecommendationsConnection';
  edges: Array<CartRecommendationsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type CartRecommendationsEdge = {
  __typename: 'CartRecommendationsEdge';
  cursor: Scalars['String']['output'];
  node: CartRecommendation;
};

export type CartRelatedProductGroup = {
  __typename: 'CartRelatedProductGroup';
  category: ProductGroupingCategory;
  products: CartRelatedProductsConnection;
};

export type CartRelatedProductsConnection = {
  __typename: 'CartRelatedProductsConnection';
  edges: Array<CartRelatedProductsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type CartRelatedProductsEdge = {
  __typename: 'CartRelatedProductsEdge';
  cursor: Scalars['String']['output'];
  node: Product;
};

export type CartResultUnion = Cart | EntityNotFoundError;

export type CartUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type CartUpdatePayload = {
  __typename: 'CartUpdatePayload';
  cart: Cart;
};

export type CartUpdateUnion = CartUpdatePayload | EntityNotFoundError;

export type CatalogPromotion = {
  activeFrom: Maybe<Scalars['DateTime']['output']>;
  activeTo: Maybe<Scalars['DateTime']['output']>;
  continueProcessing: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  discountType: CatalogPromotionDiscountType;
  id: Scalars['ID']['output'];
  isSticky: Scalars['Boolean']['output'];
  matchProductCount: Scalars['NonNegativeInt']['output'];
  matchRuleset: Maybe<Ruleset>;
  name: Scalars['NonEmptyString']['output'];
  priceType: Maybe<PriceType>;
  priority: Scalars['NonNegativeInt']['output'];
  state: PromotionState;
  style: Maybe<PromotionStyle>;
  title: Maybe<Scalars['NonEmptyString']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type CatalogPromotionStyleArgs = {
  allowDefault?: Scalars['Boolean']['input'];
};

export enum CatalogPromotionDiscountType {
  FixedAmount = 'FIXED_AMOUNT',
  Percent = 'PERCENT',
  ProductPromotionPrice = 'PRODUCT_PROMOTION_PRICE'
}

export type CatalogPromotionFixedAmount = CatalogPromotion & Node & Promotion & {
  __typename: 'CatalogPromotionFixedAmount';
  activeFrom: Maybe<Scalars['DateTime']['output']>;
  activeTo: Maybe<Scalars['DateTime']['output']>;
  continueProcessing: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  discount: CatalogPromotionFixedAmountDiscount;
  discountType: CatalogPromotionDiscountType;
  id: Scalars['ID']['output'];
  isSticky: Scalars['Boolean']['output'];
  matchProductCount: Scalars['NonNegativeInt']['output'];
  matchRuleset: Maybe<Ruleset>;
  name: Scalars['NonEmptyString']['output'];
  priceType: Maybe<PriceType>;
  priority: Scalars['NonNegativeInt']['output'];
  state: PromotionState;
  style: Maybe<PromotionStyle>;
  title: Maybe<Scalars['NonEmptyString']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type CatalogPromotionFixedAmountStyleArgs = {
  allowDefault?: Scalars['Boolean']['input'];
};

export type CatalogPromotionFixedAmountDiscount = {
  __typename: 'CatalogPromotionFixedAmountDiscount';
  amount: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type CatalogPromotionPercent = CatalogPromotion & Node & Promotion & {
  __typename: 'CatalogPromotionPercent';
  activeFrom: Maybe<Scalars['DateTime']['output']>;
  activeTo: Maybe<Scalars['DateTime']['output']>;
  continueProcessing: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  discount: CatalogPromotionPercentDiscount;
  discountType: CatalogPromotionDiscountType;
  id: Scalars['ID']['output'];
  isSticky: Scalars['Boolean']['output'];
  matchProductCount: Scalars['NonNegativeInt']['output'];
  matchRuleset: Maybe<Ruleset>;
  name: Scalars['NonEmptyString']['output'];
  priceType: Maybe<PriceType>;
  priority: Scalars['NonNegativeInt']['output'];
  state: PromotionState;
  style: Maybe<PromotionStyle>;
  title: Maybe<Scalars['NonEmptyString']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type CatalogPromotionPercentStyleArgs = {
  allowDefault?: Scalars['Boolean']['input'];
};

export type CatalogPromotionPercentDiscount = {
  __typename: 'CatalogPromotionPercentDiscount';
  percent: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type CatalogPromotionProductPromotionPrice = CatalogPromotion & Node & Promotion & {
  __typename: 'CatalogPromotionProductPromotionPrice';
  activeFrom: Maybe<Scalars['DateTime']['output']>;
  activeTo: Maybe<Scalars['DateTime']['output']>;
  continueProcessing: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  discountType: CatalogPromotionDiscountType;
  id: Scalars['ID']['output'];
  isSticky: Scalars['Boolean']['output'];
  matchProductCount: Scalars['NonNegativeInt']['output'];
  matchRuleset: Maybe<Ruleset>;
  name: Scalars['NonEmptyString']['output'];
  priceType: Maybe<PriceType>;
  priority: Scalars['NonNegativeInt']['output'];
  state: PromotionState;
  style: Maybe<PromotionStyle>;
  title: Maybe<Scalars['NonEmptyString']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type CatalogPromotionProductPromotionPriceStyleArgs = {
  allowDefault?: Scalars['Boolean']['input'];
};

export type CategoriesConnection = {
  __typename: 'CategoriesConnection';
  edges: Array<CategoriesEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type CategoriesEdge = {
  __typename: 'CategoriesEdge';
  cursor: Scalars['String']['output'];
  node: Category;
};

export type Category = Node & {
  __typename: 'Category';
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  id: Scalars['ID']['output'];
  image: Maybe<Scalars['URL']['output']>;
  parent: Maybe<Category>;
  pimCode: Maybe<Scalars['NonEmptyString']['output']>;
  position: Scalars['NonNegativeInt']['output'];
  productCount: Scalars['NonNegativeInt']['output'];
  productsPerPage: Maybe<Scalars['PositiveInt']['output']>;
  publishedFrom: Maybe<Scalars['DateTime']['output']>;
  publishedTo: Maybe<Scalars['DateTime']['output']>;
  ruleset: Maybe<Ruleset>;
  seo: CategorySeo;
  state: CategoryState;
  taxonomyId: Maybe<Scalars['NonNegativeInt']['output']>;
  title: Scalars['NonEmptyString']['output'];
  type: CategoryType;
  updatedAt: Scalars['DateTime']['output'];
};

export type CategoryAddProductsPayload = {
  __typename: 'CategoryAddProductsPayload';
  category: Category;
  products: Array<Product>;
};

export type CategoryAddProductsUnion = CategoryAddProductsPayload | EntityNotFoundError;

export type CategoryCreateInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  image?: InputMaybe<Scalars['NonEmptyString']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  pimCode?: InputMaybe<Scalars['NonEmptyString']['input']>;
  position: Scalars['NonNegativeInt']['input'];
  productsPerPage?: InputMaybe<Scalars['PositiveInt']['input']>;
  publishedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  publishedTo?: InputMaybe<Scalars['DateTime']['input']>;
  rulesetId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<CategoryState>;
  taxonomyId?: InputMaybe<Scalars['PositiveInt']['input']>;
  title: Scalars['NonEmptyString']['input'];
  type?: InputMaybe<CategoryType>;
};

export type CategoryCreatePayload = {
  __typename: 'CategoryCreatePayload';
  category: Category;
};

export type CategoryCreateUnion = CategoryCreatePayload | InvalidInputError;

export type CategoryDeletePayload = {
  __typename: 'CategoryDeletePayload';
  category: Category;
};

export type CategoryDeleteUnion = CategoryDeletePayload | EntityNotFoundError;

export type CategoryDuplicatePayload = {
  __typename: 'CategoryDuplicatePayload';
  category: Category;
};

export type CategoryDuplicateUnion = CategoryDuplicatePayload | EntityNotFoundError | InvalidInputError;

export enum CategoryOrderByField {
  CreatedAt = 'CREATED_AT',
  Position = 'POSITION',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type CategoryOrderByInput = {
  direction: OrderByDirection;
  field: CategoryOrderByField;
};

export type CategoryRemoveProductsPayload = {
  __typename: 'CategoryRemoveProductsPayload';
  category: Category;
  products: Array<Product>;
};

export type CategoryRemoveProductsUnion = CategoryRemoveProductsPayload | EntityNotFoundError;

export type CategoryReorderInput = {
  id: Scalars['ID']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  position: Scalars['NonNegativeInt']['input'];
};

export type CategoryReorderPayload = {
  __typename: 'CategoryReorderPayload';
  categories: Array<Category>;
};

export type CategoryReorderUnion = CategoryReorderPayload | InvalidInputError;

export type CategoryResultUnion = Category | EntityNotFoundError;

export type CategorySeo = {
  __typename: 'CategorySeo';
  description: Maybe<Scalars['NonEmptyString']['output']>;
  hasCustomSlug: Scalars['Boolean']['output'];
  keywords: Maybe<Scalars['NonEmptyString']['output']>;
  slug: Maybe<Scalars['NonEmptyString']['output']>;
  title: Maybe<Scalars['NonEmptyString']['output']>;
};

export enum CategoryState {
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED',
  Scheduled = 'SCHEDULED'
}

export enum CategoryType {
  Dynamic = 'DYNAMIC',
  Static = 'STATIC'
}

export type CategoryUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type CategoryUpdateInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  image?: InputMaybe<Scalars['NonEmptyString']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  pimCode?: InputMaybe<Scalars['NonEmptyString']['input']>;
  position?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  productsPerPage?: InputMaybe<Scalars['PositiveInt']['input']>;
  publishedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  publishedTo?: InputMaybe<Scalars['DateTime']['input']>;
  rulesetId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<CategoryState>;
  taxonomyId?: InputMaybe<Scalars['PositiveInt']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type?: InputMaybe<CategoryType>;
};

export type CategoryUpdatePayload = {
  __typename: 'CategoryUpdatePayload';
  category: Category;
};

export type CategoryUpdateSeoInput = {
  description?: InputMaybe<CategoryType>;
  keywords?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type CategoryUpdateSeoPayload = {
  __typename: 'CategoryUpdateSeoPayload';
  category: Category;
};

export type CategoryUpdateSeoUnion = CategoryUpdateSeoPayload | EntityNotFoundError;

export type CategoryUpdateUnion = CategoryUpdatePayload | EntityNotFoundError;

export type CategoryWhereInput = {
  AND?: InputMaybe<Array<CategoryWhereSubInput>>;
  OR?: InputMaybe<Array<CategoryWhereSubInput>>;
  pimCode?: InputMaybe<Scalars['NonEmptyString']['input']>;
  pimCode_ne?: InputMaybe<Scalars['NonEmptyString']['input']>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type?: InputMaybe<CategoryType>;
};

export type CategoryWhereSubInput = {
  AND?: InputMaybe<Array<CategoryWhereSubInput>>;
  OR?: InputMaybe<Array<CategoryWhereSubInput>>;
  pimCode?: InputMaybe<Scalars['NonEmptyString']['input']>;
  pimCode_ne?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type?: InputMaybe<CategoryType>;
};

export type CompaniesConnection = {
  __typename: 'CompaniesConnection';
  edges: Array<CompaniesEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type CompaniesEdge = {
  __typename: 'CompaniesEdge';
  cursor: Scalars['String']['output'];
  node: Company;
};

export type Company = Node & {
  __typename: 'Company';
  addresses: CompanyAddressesConnection;
  businessIdentityCode: Maybe<Scalars['BusinessIdentityCode']['output']>;
  contact: Customer;
  createdAt: Scalars['DateTime']['output'];
  customerCount: Scalars['NonNegativeInt']['output'];
  customers: CompanyCustomersConnection;
  id: Scalars['ID']['output'];
  name: Scalars['NonEmptyString']['output'];
  orderStatistics: CompanyOrderStatistics;
  orders: OrdersConnection;
  updatedAt: Scalars['DateTime']['output'];
};


export type CompanyAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompanyAddressOrderByInput>>;
  where?: InputMaybe<CompanyAddressWhereInput>;
};


export type CompanyCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderOrderByInput>>;
  where?: InputMaybe<OrderWhereInput>;
};

export type CompanyAddCustomerPayload = {
  __typename: 'CompanyAddCustomerPayload';
  company: Company;
  customer: Customer;
  role: CompanyCustomerRole;
};

export type CompanyAddCustomerUnion = CompanyAddCustomerPayload | EntityNotFoundError;

export type CompanyAddress = Node & {
  __typename: 'CompanyAddress';
  address: Scalars['NonEmptyString']['output'];
  city: Scalars['NonEmptyString']['output'];
  countryCode: Scalars['CountryCode']['output'];
  createdAt: Scalars['DateTime']['output'];
  firstName: Scalars['NonEmptyString']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['NonEmptyString']['output'];
  phone: Maybe<Scalars['PhoneNumber']['output']>;
  postalCode: Scalars['PostalCode']['output'];
  type: CompanyAddressType;
  updatedAt: Scalars['DateTime']['output'];
};

export type CompanyAddressCreateInput = {
  address: Scalars['NonEmptyString']['input'];
  city: Scalars['NonEmptyString']['input'];
  companyId: Scalars['ID']['input'];
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  firstName: Scalars['NonEmptyString']['input'];
  lastName: Scalars['NonEmptyString']['input'];
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  postalCode: Scalars['PostalCode']['input'];
  type?: InputMaybe<CompanyAddressType>;
};

export type CompanyAddressCreatePayload = {
  __typename: 'CompanyAddressCreatePayload';
  company: Company;
  companyAddress: CompanyAddress;
};

export type CompanyAddressCreateUnion = CompanyAddressCreatePayload | InvalidInputError;

export type CompanyAddressDeletePayload = {
  __typename: 'CompanyAddressDeletePayload';
  company: Company;
  companyAddress: CompanyAddress;
};

export type CompanyAddressDeleteUnion = CompanyAddressDeletePayload | EntityNotFoundError;

export enum CompanyAddressOrderByField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type CompanyAddressOrderByInput = {
  direction: OrderByDirection;
  field: CompanyAddressOrderByField;
};

export type CompanyAddressResultUnion = CompanyAddress | EntityNotFoundError;

export enum CompanyAddressType {
  Billing = 'BILLING',
  Shipping = 'SHIPPING'
}

export type CompanyAddressUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type CompanyAddressUpdateInput = {
  address?: InputMaybe<Scalars['NonEmptyString']['input']>;
  city?: InputMaybe<Scalars['NonEmptyString']['input']>;
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  firstName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  lastName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
  type?: InputMaybe<CompanyAddressType>;
};

export type CompanyAddressUpdatePayload = {
  __typename: 'CompanyAddressUpdatePayload';
  company: Company;
  companyAddress: CompanyAddress;
};

export type CompanyAddressUpdateUnion = CompanyAddressUpdatePayload | EntityNotFoundError;

export type CompanyAddressWhereInput = {
  AND?: InputMaybe<Array<CompanyAddressWhereSubInput>>;
  OR?: InputMaybe<Array<CompanyAddressWhereSubInput>>;
  address_lk?: InputMaybe<Scalars['NonEmptyString']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type?: InputMaybe<CompanyAddressType>;
};

export type CompanyAddressWhereSubInput = {
  AND?: InputMaybe<Array<CompanyAddressWhereSubInput>>;
  OR?: InputMaybe<Array<CompanyAddressWhereSubInput>>;
  address_lk?: InputMaybe<Scalars['NonEmptyString']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<CompanyAddressType>;
};

export type CompanyAddressesConnection = {
  __typename: 'CompanyAddressesConnection';
  edges: Array<CompanyAddressesEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type CompanyAddressesEdge = {
  __typename: 'CompanyAddressesEdge';
  cursor: Scalars['String']['output'];
  node: CompanyAddress;
};

export type CompanyCreateInput = {
  businessIdentityCode?: InputMaybe<Scalars['NonEmptyString']['input']>;
  name: Scalars['NonEmptyString']['input'];
};

export type CompanyCreatePayload = {
  __typename: 'CompanyCreatePayload';
  company: Company;
};

export type CompanyCreateUnion = CompanyCreatePayload | InvalidInputError;

export type CompanyCustomer = Node & {
  __typename: 'CompanyCustomer';
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  id: Scalars['ID']['output'];
  role: CompanyCustomerRole;
  updatedAt: Scalars['DateTime']['output'];
};

export enum CompanyCustomerRole {
  Admin = 'ADMIN',
  Owner = 'OWNER',
  User = 'USER'
}

export type CompanyCustomersConnection = {
  __typename: 'CompanyCustomersConnection';
  edges: Array<CompanyCustomersEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type CompanyCustomersEdge = {
  __typename: 'CompanyCustomersEdge';
  cursor: Scalars['String']['output'];
  node: CompanyCustomer;
};

export type CompanyDeletePayload = {
  __typename: 'CompanyDeletePayload';
  company: Company;
};

export type CompanyDeleteUnion = CompanyDeletePayload | EntityNotFoundError;

export enum CompanyOrderByField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export type CompanyOrderByInput = {
  direction: OrderByDirection;
  field: CompanyOrderByField;
};

export type CompanyOrderStatistics = {
  __typename: 'CompanyOrderStatistics';
  totalAmount: Money;
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type CompanyRemoveCustomerPayload = {
  __typename: 'CompanyRemoveCustomerPayload';
  company: Company;
  customer: Customer;
  role: CompanyCustomerRole;
};

export type CompanyRemoveCustomerUnion = CompanyRemoveCustomerPayload | EntityNotFoundError;

export type CompanyResultUnion = Company | EntityNotFoundError;

export type CompanyUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type CompanyUpdateCustomerPayload = {
  __typename: 'CompanyUpdateCustomerPayload';
  company: Company;
  customer: Customer;
  role: CompanyCustomerRole;
};

export type CompanyUpdateCustomerUnion = CompanyUpdateCustomerPayload | EntityNotFoundError;

export type CompanyUpdateInput = {
  businessIdentityCode?: InputMaybe<Scalars['NonEmptyString']['input']>;
  name?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type CompanyUpdatePayload = {
  __typename: 'CompanyUpdatePayload';
  company: Company;
};

export type CompanyUpdateUnion = CompanyUpdatePayload | EntityNotFoundError;

export type CompanyWhereInput = {
  AND?: InputMaybe<Array<CompanyWhereSubInput>>;
  OR?: InputMaybe<Array<CompanyWhereSubInput>>;
  businessIdentityCode?: InputMaybe<Scalars['NonEmptyString']['input']>;
  name?: InputMaybe<Scalars['NonEmptyString']['input']>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type CompanyWhereSubInput = {
  AND?: InputMaybe<Array<CompanyWhereSubInput>>;
  OR?: InputMaybe<Array<CompanyWhereSubInput>>;
  businessIdentityCode?: InputMaybe<Scalars['NonEmptyString']['input']>;
  name?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ConfigurableProduct = Node & Product & {
  __typename: 'ConfigurableProduct';
  assets: Array<ProductAsset>;
  attributes: Array<ProductAttributeValue>;
  brand: Maybe<Brand>;
  brandLogo: Maybe<Scalars['String']['output']>;
  brandTitle: Maybe<Scalars['String']['output']>;
  cartRecommendations: Array<CartRecommendation>;
  categories: Array<Category>;
  collections: Array<ProductCollection>;
  configuration: ProductConfiguration;
  configurationErrors: Array<ProductConfigurationErrorType>;
  createdAt: Scalars['DateTime']['output'];
  crossellProducts: ProductsConnection;
  description: Maybe<Scalars['NonEmptyString']['output']>;
  dimensions: ProductDimensions;
  disclaimers: Array<ProductDisclaimer>;
  fetchRelations: Array<ProductRelation>;
  group: ProductGroup;
  hasCustomName: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  internalIdentifier: Maybe<Scalars['NonEmptyString']['output']>;
  isGiftCard: Scalars['Boolean']['output'];
  listingImage: Maybe<ProductImage>;
  mainCategory: Maybe<Category>;
  maskMedias: Array<ProductMaskMedia>;
  matchRelations: Array<ProductRelation>;
  measurementImage: Maybe<ProductAsset>;
  medias: Array<ProductMedia>;
  name: Scalars['NonEmptyString']['output'];
  parcels: Array<ProductParcel>;
  productBadges: Array<ProductBadge>;
  productClass: Maybe<ProductClass>;
  properties: Array<ProductProperty>;
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  qaItems: Maybe<Array<QuestionAndAnswer>>;
  relatedProducts: ProductsConnection;
  seo: ProductSeo;
  shortDescription: Maybe<Scalars['NonEmptyString']['output']>;
  sku: Maybe<Scalars['NonEmptyString']['output']>;
  specification: Maybe<Scalars['NonEmptyString']['output']>;
  state: ProductState;
  title: Maybe<Scalars['NonEmptyString']['output']>;
  type: ProductType;
  updatedAt: Scalars['DateTime']['output'];
  upsellProducts: ProductsConnection;
};


export type ConfigurableProductAttributesArgs = {
  attributeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  code?: InputMaybe<Scalars['NonEmptyString']['input']>;
  showInProductListing?: InputMaybe<Scalars['Boolean']['input']>;
  showInProductPage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConfigurableProductConfigurationArgs = {
  availableProductsOnly?: Scalars['Boolean']['input'];
};


export type ConfigurableProductCrossellProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ConfigurableProductDisclaimersArgs = {
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConfigurableProductRelatedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ConfigurableProductUpsellProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Customer = Node & {
  __typename: 'Customer';
  addresses: CustomerAddressesConnection;
  allowEmailMarketing: Scalars['Boolean']['output'];
  allowSmsMarketing: Scalars['Boolean']['output'];
  auth0UserId: Maybe<Scalars['NonEmptyString']['output']>;
  company: Maybe<Company>;
  countryCode: Scalars['CountryCode']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['EmailAddress']['output'];
  firstName: Maybe<Scalars['NonEmptyString']['output']>;
  hasLoggedIn: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isFirstTimeSetupDone: Scalars['Boolean']['output'];
  lastName: Maybe<Scalars['NonEmptyString']['output']>;
  number: Scalars['SafeInt']['output'];
  orderStatistics: CustomerOrderStatistics;
  orders: OrdersConnection;
  phone: Maybe<Scalars['PhoneNumber']['output']>;
  requiresEmailVerification: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type CustomerAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomerAddressOrderByInput>>;
  where?: InputMaybe<CustomerAddressWhereInput>;
};


export type CustomerOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderOrderByInput>>;
  where?: InputMaybe<OrderWhereInput>;
};

export type CustomerAddress = Node & {
  __typename: 'CustomerAddress';
  address: Scalars['NonEmptyString']['output'];
  businessIdentityCode: Maybe<Scalars['NonEmptyString']['output']>;
  city: Scalars['NonEmptyString']['output'];
  companyName: Maybe<Scalars['NonEmptyString']['output']>;
  countryCode: Scalars['CountryCode']['output'];
  createdAt: Scalars['DateTime']['output'];
  firstName: Scalars['NonEmptyString']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['NonEmptyString']['output'];
  phone: Maybe<Scalars['PhoneNumber']['output']>;
  postalCode: Scalars['PostalCode']['output'];
  type: CustomerAddressType;
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomerAddressCreateInput = {
  address: Scalars['NonEmptyString']['input'];
  businessIdentityCode?: InputMaybe<Scalars['NonEmptyString']['input']>;
  city: Scalars['NonEmptyString']['input'];
  companyName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  customerId: Scalars['ID']['input'];
  firstName: Scalars['NonEmptyString']['input'];
  lastName: Scalars['NonEmptyString']['input'];
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  postalCode: Scalars['PostalCode']['input'];
  type?: InputMaybe<CustomerAddressType>;
};

export type CustomerAddressCreatePayload = {
  __typename: 'CustomerAddressCreatePayload';
  customer: Customer;
  customerAddress: CustomerAddress;
};

export type CustomerAddressCreateUnion = CustomerAddressCreatePayload | InvalidInputError;

export type CustomerAddressDeletePayload = {
  __typename: 'CustomerAddressDeletePayload';
  customer: Customer;
  customerAddress: CustomerAddress;
};

export type CustomerAddressDeleteUnion = CustomerAddressDeletePayload | EntityNotFoundError;

export enum CustomerAddressOrderByField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type CustomerAddressOrderByInput = {
  direction: OrderByDirection;
  field: CustomerAddressOrderByField;
};

export type CustomerAddressResultUnion = CustomerAddress | EntityNotFoundError;

export enum CustomerAddressType {
  Billing = 'BILLING',
  Shipping = 'SHIPPING'
}

export type CustomerAddressUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type CustomerAddressUpdateInput = {
  address?: InputMaybe<Scalars['NonEmptyString']['input']>;
  businessIdentityCode?: InputMaybe<Scalars['NonEmptyString']['input']>;
  city?: InputMaybe<Scalars['NonEmptyString']['input']>;
  companyName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  firstName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  lastName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
};

export type CustomerAddressUpdatePayload = {
  __typename: 'CustomerAddressUpdatePayload';
  customer: Customer;
  customerAddress: CustomerAddress;
};

export type CustomerAddressUpdateUnion = CustomerAddressUpdatePayload | EntityNotFoundError;

export type CustomerAddressWhereInput = {
  AND?: InputMaybe<Array<CustomerAddressWhereSubInput>>;
  OR?: InputMaybe<Array<CustomerAddressWhereSubInput>>;
  address_lk?: InputMaybe<Scalars['NonEmptyString']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type?: InputMaybe<CustomerAddressType>;
};

export type CustomerAddressWhereSubInput = {
  AND?: InputMaybe<Array<CustomerAddressWhereSubInput>>;
  OR?: InputMaybe<Array<CustomerAddressWhereSubInput>>;
  address_lk?: InputMaybe<Scalars['NonEmptyString']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<CustomerAddressType>;
};

export type CustomerAddressesConnection = {
  __typename: 'CustomerAddressesConnection';
  edges: Array<CustomerAddressesEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type CustomerAddressesEdge = {
  __typename: 'CustomerAddressesEdge';
  cursor: Scalars['String']['output'];
  node: CustomerAddress;
};

export type CustomerCreateInput = {
  allowEmailMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  allowSmsMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  auth0UserId?: InputMaybe<Scalars['NonEmptyString']['input']>;
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  email: Scalars['EmailAddress']['input'];
  firstName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  lastName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type CustomerCreatePayload = {
  __typename: 'CustomerCreatePayload';
  customer: Customer;
};

export type CustomerCreateUnion = CustomerCreatePayload | CustomerExistsError | InvalidInputError;

export type CustomerDeletePayload = {
  __typename: 'CustomerDeletePayload';
  customer: Customer;
};

export type CustomerDeleteUnion = CustomerDeletePayload | EntityNotFoundError;

export type CustomerExistsError = GenericError & {
  __typename: 'CustomerExistsError';
  code: Maybe<Scalars['String']['output']>;
  detailedMessage: Maybe<Scalars['String']['output']>;
  email: Scalars['EmailAddress']['output'];
  isError: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export enum CustomerOrderByField {
  CreatedAt = 'CREATED_AT',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  UpdatedAt = 'UPDATED_AT'
}

export type CustomerOrderByInput = {
  direction: OrderByDirection;
  field: CustomerOrderByField;
};

export type CustomerOrderStatistics = {
  __typename: 'CustomerOrderStatistics';
  totalAmount: Money;
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type CustomerResultUnion = Customer | EntityNotFoundError;

export type CustomerStatistics = {
  __typename: 'CustomerStatistics';
  date: Scalars['Date']['output'];
  newCount: Scalars['NonNegativeInt']['output'];
};

export type CustomerStatisticsRangeInput = {
  from: Scalars['Date']['input'];
  interval: CustomerStatisticsRangeInterval;
  to: Scalars['Date']['input'];
};

export enum CustomerStatisticsRangeInterval {
  Day = 'DAY',
  Month = 'MONTH'
}

export type CustomerUniqueWhereInput = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CustomerUpdateInput = {
  allowEmailMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  allowSmsMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  auth0UserId?: InputMaybe<Scalars['NonEmptyString']['input']>;
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  firstName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  lastName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type CustomerUpdatePayload = {
  __typename: 'CustomerUpdatePayload';
  customer: Customer;
};

export type CustomerUpdateUnion = CustomerUpdatePayload | EntityNotFoundError;

export type CustomerWhereInput = {
  AND?: InputMaybe<Array<CustomerWhereSubInput>>;
  OR?: InputMaybe<Array<CustomerWhereSubInput>>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  email_lk?: InputMaybe<Scalars['NonEmptyString']['input']>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CustomerWhereSubInput = {
  AND?: InputMaybe<Array<CustomerWhereSubInput>>;
  OR?: InputMaybe<Array<CustomerWhereSubInput>>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  email_lk?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CustomersConnection = {
  __typename: 'CustomersConnection';
  edges: Array<CustomersEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type CustomersEdge = {
  __typename: 'CustomersEdge';
  cursor: Scalars['String']['output'];
  node: Customer;
};

export type Editor = Node & {
  __typename: 'Editor';
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  fields: Array<EditorField>;
  id: Scalars['ID']['output'];
  isSticky: Scalars['Boolean']['output'];
  pendingUpdateCount: Scalars['NonNegativeInt']['output'];
  productCount: Scalars['NonNegativeInt']['output'];
  ruleset: Maybe<Ruleset>;
  title: Scalars['NonEmptyString']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EditorAttributeField = EditorField & Node & {
  __typename: 'EditorAttributeField';
  attribute: Attribute;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  position: Scalars['NonNegativeInt']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EditorAttributeUpdate = EditorUpdate & Node & {
  __typename: 'EditorAttributeUpdate';
  attribute: Attribute;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  product: Product;
  updatedAt: Scalars['DateTime']['output'];
  value: Maybe<Scalars['NonEmptyString']['output']>;
};

export type EditorCreateInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  isSticky?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['NonEmptyString']['input'];
};

export type EditorCreatePayload = {
  __typename: 'EditorCreatePayload';
  editor: Editor;
};

export type EditorCreateUnion = EditorCreatePayload | InvalidInputError;

export type EditorDeletePayload = {
  __typename: 'EditorDeletePayload';
  editor: Editor;
};

export type EditorDeleteUnion = EditorDeletePayload | EntityNotFoundError;

export type EditorDuplicatePayload = {
  __typename: 'EditorDuplicatePayload';
  editor: Editor;
};

export type EditorDuplicateUnion = EditorDuplicatePayload | EntityNotFoundError | InvalidInputError;

export type EditorExecutePayload = {
  __typename: 'EditorExecutePayload';
  editor: Editor;
};

export type EditorExecuteUnion = EditorExecutePayload | EntityNotFoundError;

export type EditorExportPayload = {
  __typename: 'EditorExportPayload';
  editor: Editor;
};

export type EditorExportUnion = EditorExportPayload | EntityNotFoundError;

export type EditorField = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  position: Scalars['NonNegativeInt']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EditorFieldCreateInput = {
  attributeId?: InputMaybe<Scalars['ID']['input']>;
  editorId: Scalars['ID']['input'];
  priceTypeId?: InputMaybe<Scalars['ID']['input']>;
  property?: InputMaybe<EditorFieldProperty>;
};

export type EditorFieldCreatePayload = {
  __typename: 'EditorFieldCreatePayload';
  editor: Editor;
  editorField: EditorField;
};

export type EditorFieldCreateUnion = EditorFieldCreatePayload | InvalidInputError;

export type EditorFieldDeletePayload = {
  __typename: 'EditorFieldDeletePayload';
  editor: Editor;
  editorField: EditorField;
};

export type EditorFieldDeleteUnion = EditorFieldDeletePayload | EntityNotFoundError;

export enum EditorFieldProperty {
  AlertQuantity = 'ALERT_QUANTITY',
  AssemblyTime = 'ASSEMBLY_TIME',
  AvailableFromNextShipment = 'AVAILABLE_FROM_NEXT_SHIPMENT',
  AvailableQuantity = 'AVAILABLE_QUANTITY',
  Brand = 'BRAND',
  CartMaxAmount = 'CART_MAX_AMOUNT',
  CartMinAmount = 'CART_MIN_AMOUNT',
  CartMultiplier = 'CART_MULTIPLIER',
  CartPromotionPrice = 'CART_PROMOTION_PRICE',
  Categories = 'CATEGORIES',
  ClubPrice = 'CLUB_PRICE',
  CustomSlug = 'CUSTOM_SLUG',
  DeliveryEstimateDays = 'DELIVERY_ESTIMATE_DAYS',
  Depth = 'DEPTH',
  Description = 'DESCRIPTION',
  Diameter = 'DIAMETER',
  ExpectedShipmentDate = 'EXPECTED_SHIPMENT_DATE',
  Group = 'GROUP',
  Height = 'HEIGHT',
  IncludeInPromotions = 'INCLUDE_IN_PROMOTIONS',
  InternalIdentifier = 'INTERNAL_IDENTIFIER',
  InventoryState = 'INVENTORY_STATE',
  IsGiftCard = 'IS_GIFT_CARD',
  Name = 'NAME',
  OriginalPrice = 'ORIGINAL_PRICE',
  ParcelsAreVisible = 'PARCELS_ARE_VISIBLE',
  ProductClass = 'PRODUCT_CLASS',
  PromotionGroup = 'PROMOTION_GROUP',
  PromotionPrice = 'PROMOTION_PRICE',
  PublishedAt = 'PUBLISHED_AT',
  PurchasePrice = 'PURCHASE_PRICE',
  SeoDescription = 'SEO_DESCRIPTION',
  SeoKeywords = 'SEO_KEYWORDS',
  SeoTitle = 'SEO_TITLE',
  ShortDescription = 'SHORT_DESCRIPTION',
  SkipMarginCalculation = 'SKIP_MARGIN_CALCULATION',
  Sku = 'SKU',
  Specification = 'SPECIFICATION',
  State = 'STATE',
  SuggestedRetailPrice = 'SUGGESTED_RETAIL_PRICE',
  TaxClass = 'TAX_CLASS',
  Title = 'TITLE',
  UseInventoryTracking = 'USE_INVENTORY_TRACKING',
  Volume = 'VOLUME',
  Weight = 'WEIGHT',
  Width = 'WIDTH'
}

export type EditorFieldUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type EditorFieldUpdateInput = {
  property?: InputMaybe<EditorFieldProperty>;
};

export type EditorFieldUpdatePayload = {
  __typename: 'EditorFieldUpdatePayload';
  editor: Editor;
  editorField: EditorField;
};

export type EditorFieldUpdateUnion = EditorFieldUpdatePayload | EntityNotFoundError;

export enum EditorOrderByField {
  CreatedAt = 'CREATED_AT',
  IsSticky = 'IS_STICKY',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type EditorOrderByInput = {
  direction: OrderByDirection;
  field: EditorOrderByField;
};

export type EditorPriceTypeField = EditorField & Node & {
  __typename: 'EditorPriceTypeField';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  position: Scalars['NonNegativeInt']['output'];
  priceType: PriceType;
  updatedAt: Scalars['DateTime']['output'];
};

export type EditorPriceTypeUpdate = EditorUpdate & Node & {
  __typename: 'EditorPriceTypeUpdate';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  priceType: PriceType;
  product: Product;
  updatedAt: Scalars['DateTime']['output'];
  value: Maybe<Scalars['NonEmptyString']['output']>;
};

export type EditorPropertyField = EditorField & Node & {
  __typename: 'EditorPropertyField';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  position: Scalars['NonNegativeInt']['output'];
  property: EditorFieldProperty;
  updatedAt: Scalars['DateTime']['output'];
};

export type EditorPropertyUpdate = EditorUpdate & Node & {
  __typename: 'EditorPropertyUpdate';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  product: Product;
  property: EditorFieldProperty;
  updatedAt: Scalars['DateTime']['output'];
  value: Maybe<Scalars['NonEmptyString']['output']>;
};

export type EditorReorderFieldsPayload = {
  __typename: 'EditorReorderFieldsPayload';
  editor: Editor;
};

export type EditorReorderFieldsUnion = EditorReorderFieldsPayload | EntityNotFoundError;

export type EditorResultUnion = Editor | EntityNotFoundError;

export type EditorUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type EditorUpdate = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  product: Product;
  updatedAt: Scalars['DateTime']['output'];
  value: Maybe<Scalars['NonEmptyString']['output']>;
};

export type EditorUpdateInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  isSticky?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type EditorUpdateItemInput = {
  attributeId?: InputMaybe<Scalars['ID']['input']>;
  priceTypeId?: InputMaybe<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
  property?: InputMaybe<EditorFieldProperty>;
  value?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type EditorUpdatePayload = {
  __typename: 'EditorUpdatePayload';
  editor: Editor;
};

export type EditorUpdateUnion = EditorUpdatePayload | EntityNotFoundError;

export type EditorUpdateUpsertInput = {
  editorId: Scalars['ID']['input'];
  updates: Array<EditorUpdateItemInput>;
};

export type EditorUpdateUpsertPayload = {
  __typename: 'EditorUpdateUpsertPayload';
  editor: Editor;
  editorUpdates: Array<EditorUpdate>;
};

export type EditorUpdateUpsertUnion = EditorUpdateUpsertPayload | InvalidInputError;

export type EditorUpdateWhereInput = {
  editorId: Scalars['ID']['input'];
};

export type EditorUpdatesConnection = {
  __typename: 'EditorUpdatesConnection';
  edges: Array<EditorUpdatesEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type EditorUpdatesEdge = {
  __typename: 'EditorUpdatesEdge';
  cursor: Scalars['String']['output'];
  node: EditorUpdate;
};

export type EditorWhereInput = {
  AND?: InputMaybe<Array<EditorWhereSubInput>>;
  OR?: InputMaybe<Array<EditorWhereSubInput>>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type EditorWhereSubInput = {
  AND?: InputMaybe<Array<EditorWhereSubInput>>;
  OR?: InputMaybe<Array<EditorWhereSubInput>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type EditorsConnection = {
  __typename: 'EditorsConnection';
  edges: Array<EditorsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type EditorsEdge = {
  __typename: 'EditorsEdge';
  cursor: Scalars['String']['output'];
  node: Editor;
};

export type EmailNotificationTemplate = Node & NotificationTemplate & {
  __typename: 'EmailNotificationTemplate';
  content: Maybe<Scalars['NonEmptyString']['output']>;
  contentType: NotificationTemplateContentType;
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  from: Maybe<Scalars['NonEmptyString']['output']>;
  id: Scalars['ID']['output'];
  receivers: Maybe<Scalars['NonEmptyString']['output']>;
  state: NotificationTemplateState;
  subject: Maybe<Scalars['NonEmptyString']['output']>;
  title: Scalars['NonEmptyString']['output'];
  type: NotificationTemplateType;
  updatedAt: Scalars['DateTime']['output'];
};

export type EntityNotFoundError = GenericError & {
  __typename: 'EntityNotFoundError';
  code: Maybe<Scalars['String']['output']>;
  detailedMessage: Scalars['String']['output'];
  isError: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type GenericError = {
  code: Maybe<Scalars['String']['output']>;
  detailedMessage: Maybe<Scalars['String']['output']>;
  isError: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export type GiftCard = Node & {
  __typename: 'GiftCard';
  code: Scalars['NonEmptyString']['output'];
  createDate: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['NonEmptyString']['output'];
  giftCardOrders: Array<GiftCardOrder>;
  id: Scalars['ID']['output'];
  initialAmount: Maybe<Money>;
  number: Scalars['Float']['output'];
  orderProduct: Maybe<OrderProduct>;
  remainingAmount: Maybe<Money>;
  updatedAt: Scalars['DateTime']['output'];
  validUntil: Scalars['DateTime']['output'];
};


export type GiftCardGiftCardOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includePending?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GiftCardCreateForCustomerInput = {
  email: Scalars['String']['input'];
  originalPrice: Scalars['Float']['input'];
  validUntil: Scalars['DateTime']['input'];
};

export type GiftCardDeletePayload = {
  __typename: 'GiftCardDeletePayload';
  giftCard: GiftCard;
};

export type GiftCardDeleteUnion = EntityNotFoundError | GiftCardDeletePayload;

export type GiftCardOrder = Node & {
  __typename: 'GiftCardOrder';
  amount: Money;
  confirmedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  giftCard: GiftCard;
  id: Scalars['ID']['output'];
  order: Order;
  updatedAt: Scalars['DateTime']['output'];
};

export enum GiftCardOrderByField {
  Code = 'CODE',
  CreatedAt = 'CREATED_AT',
  CreateDate = 'CREATE_DATE',
  Email = 'EMAIL',
  InitialAmount = 'INITIAL_AMOUNT',
  RemainingAmount = 'REMAINING_AMOUNT',
  UpdatedAt = 'UPDATED_AT',
  ValidUntil = 'VALID_UNTIL'
}

export type GiftCardOrderByInput = {
  direction: OrderByDirection;
  field: GiftCardOrderByField;
};

export type GiftCardResultUnion = EntityNotFoundError | GiftCard | InvalidInputError;

export type GiftCardUniqueWhereInput = {
  code?: InputMaybe<Scalars['NonEmptyString']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GiftCardWhereInput = {
  code?: InputMaybe<Scalars['NonEmptyString']['input']>;
  code_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  code_ilike?: InputMaybe<Scalars['NonEmptyString']['input']>;
  createDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['NonEmptyString']['input']>;
  email_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  email_ilike?: InputMaybe<Scalars['NonEmptyString']['input']>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  validUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GiftCardsConnection = {
  __typename: 'GiftCardsConnection';
  edges: Array<GiftCardsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type GiftCardsEdge = {
  __typename: 'GiftCardsEdge';
  cursor: Scalars['String']['output'];
  node: GiftCard;
};

export type InvalidInputError = GenericError & {
  __typename: 'InvalidInputError';
  code: Maybe<Scalars['String']['output']>;
  detailedMessage: Scalars['String']['output'];
  isError: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Money = {
  __typename: 'Money';
  amount: Scalars['Decimal']['output'];
  currencyCode: Scalars['Currency']['output'];
};

export type MoneyRange = {
  __typename: 'MoneyRange';
  max: Maybe<Money>;
  min: Maybe<Money>;
};

export type Mutation = {
  __typename: 'Mutation';
  attributeCreate: AttributeCreateUnion;
  attributeDelete: AttributeDeleteUnion;
  attributeGroupAddAttributes: AttributeGroupAddAttributesUnion;
  attributeGroupCreate: AttributeGroupCreateUnion;
  attributeGroupDelete: AttributeGroupDeleteUnion;
  attributeGroupRemoveAttributes: AttributeGroupRemoveAttributesUnion;
  attributeGroupReorder: AttributeGroupReorderUnion;
  attributeGroupReorderAttributes: AttributeGroupReorderAttributesUnion;
  attributeGroupUpdate: AttributeGroupUpdateUnion;
  attributeOptionCreate: AttributeOptionCreateUnion;
  attributeOptionDelete: AttributeOptionDeleteUnion;
  attributeOptionUpdate: AttributeOptionUpdateUnion;
  attributeReorderOptions: AttributeReorderOptionsUnion;
  attributeUpdate: AttributeUpdateUnion;
  brandCreate: BrandCreateUnion;
  brandDelete: BrandDeleteUnion;
  brandUpdate: BrandUpdateUnion;
  cartCreate: CartCreateUnion;
  cartDelete: CartDeleteUnion;
  cartProductCreate: CartProductCreateUnion;
  cartProductDelete: CartProductDeleteUnion;
  cartProductUpdate: CartProductUpdateUnion;
  cartRecommendationAddProducts: CartRecommendationAddProductsUnion;
  cartRecommendationCreate: CartRecommendationCreateUnion;
  cartRecommendationDelete: CartRecommendationDeleteUnion;
  cartRecommendationRemoveProducts: CartRecommendationRemoveProductsUnion;
  cartRecommendationSetRuleset: CartRecommendationUpdateUnion;
  cartRecommendationUpdate: CartRecommendationUpdateUnion;
  cartUpdateGiftCard: CartUpdateUnion;
  cartUpdatePromotionCode: CartUpdateUnion;
  categoryAddProducts: CategoryAddProductsUnion;
  categoryCreate: CategoryCreateUnion;
  categoryDelete: CategoryDeleteUnion;
  categoryDuplicate: CategoryDuplicateUnion;
  categoryRemoveProducts: CategoryRemoveProductsUnion;
  categoryReorder: CategoryReorderUnion;
  categorySetRuleset: CategoryUpdateUnion;
  categoryUpdate: CategoryUpdateUnion;
  categoryUpdateSeo: CategoryUpdateSeoUnion;
  companyAddCustomer: CompanyAddCustomerUnion;
  companyAddressCreate: CompanyAddressCreateUnion;
  companyAddressDelete: CompanyAddressDeleteUnion;
  companyAddressUpdate: CompanyAddressUpdateUnion;
  companyCreate: CompanyCreateUnion;
  companyDelete: CompanyDeleteUnion;
  companyRemoveCustomer: CompanyRemoveCustomerUnion;
  companyUpdate: CompanyUpdateUnion;
  companyUpdateCustomer: CompanyUpdateCustomerUnion;
  customerAddressCreate: CustomerAddressCreateUnion;
  customerAddressDelete: CustomerAddressDeleteUnion;
  customerAddressUpdate: CustomerAddressUpdateUnion;
  customerCreate: CustomerCreateUnion;
  customerDelete: CustomerDeleteUnion;
  customerFinishFirstTimeSetup: CustomerUpdateUnion;
  customerSendEmailVerification: CustomerUpdateUnion;
  customerUpdate: CustomerUpdateUnion;
  editorCreate: EditorCreateUnion;
  editorDelete: EditorDeleteUnion;
  editorDuplicate: EditorDuplicateUnion;
  editorExecute: EditorExecuteUnion;
  editorExport: EditorExportUnion;
  editorFieldCreate: EditorFieldCreateUnion;
  editorFieldDelete: EditorFieldDeleteUnion;
  editorFieldUpdate: EditorFieldUpdateUnion;
  editorReorderFields: EditorReorderFieldsUnion;
  editorUpdate: EditorUpdateUnion;
  editorUpdateUpsert: EditorUpdateUpsertUnion;
  giftCardCreate: GiftCardResultUnion;
  giftCardDelete: GiftCardDeleteUnion;
  notificationMarkAsRead: NotificationMarkAsReadUnion;
  notificationTemplateCreate: NotificationTemplateCreateUnion;
  notificationTemplateDelete: NotificationTemplateDeleteUnion;
  notificationTemplatePreview: NotificationTemplatePreviewUnion;
  notificationTemplateUpdate: NotificationTemplateUpdateUnion;
  orderAddressCreate: OrderAddressCreateUnion;
  orderAddressCreateFromCustomerAddress: OrderAddressCreateUnion;
  orderAddressUpdate: OrderAddressUpdateUnion;
  orderCancel: OrderCancelUnion;
  orderClearHandler: OrderUpdateUnion;
  orderComplete: OrderCompleteUnion;
  orderCreateFromCart: OrderCreateUnion;
  orderDelete: OrderDeleteUnion;
  orderFinalize: OrderFinalizeUnion;
  orderPaymentCancel: OrderPaymentCancelUnion;
  orderPaymentComplete: OrderPaymentCompleteUnion;
  orderPaymentCreate: OrderPaymentCreateUnion;
  orderPaymentExecute: OrderPaymentExecuteUnion;
  orderPaymentNotify: OrderPaymentNotifyUnion;
  orderPaymentUpdate: OrderPaymentUpdateUnion;
  orderReceive: OrderReceiveUnion;
  orderSetBillingAddress: OrderUpdateUnion;
  orderSetCustomer: OrderUpdateUnion;
  orderSetHandler: OrderUpdateUnion;
  orderSetPaymentMethod: OrderUpdateUnion;
  orderSetShippingAddress: OrderUpdateUnion;
  orderSetShippingMethod: OrderUpdateUnion;
  orderUndoFinalize: OrderUndoFinalizeUnion;
  orderUpdate: OrderUpdateUnion;
  outletCreate: OutletCreateUnion;
  outletDelete: OutletDeleteUnion;
  outletUpdate: OutletUpdateUnion;
  paymentMethodCreate: PaymentMethodCreateUnion;
  paymentMethodDelete: PaymentMethodDeleteUnion;
  paymentMethodGroupAddPaymentMethods: PaymentMethodGroupAddPaymentMethodsUnion;
  paymentMethodGroupCreate: PaymentMethodGroupCreateUnion;
  paymentMethodGroupDelete: PaymentMethodGroupDeleteUnion;
  paymentMethodGroupRemovePaymentMethods: PaymentMethodGroupRemovePaymentMethodsUnion;
  paymentMethodGroupReorder: PaymentMethodGroupReorderUnion;
  paymentMethodGroupReorderPaymentMethods: PaymentMethodGroupReorderPaymentMethodsUnion;
  paymentMethodGroupUpdate: PaymentMethodGroupUpdateUnion;
  paymentMethodReorder: PaymentMethodReorderUnion;
  paymentMethodUpdate: PaymentMethodUpdateUnion;
  priceTypeCreate: PriceTypeCreateUnion;
  priceTypeDelete: PriceTypeDeleteUnion;
  priceTypeUpdate: PriceTypeUpdateUnion;
  productAddCategories: ProductAddCategoriesUnion;
  productAssetsCreate: ProductAssetCreateUnion;
  productAssetsDelete: ProductAssetDeleteUnion;
  productAssetsUpdate: ProductAssetUpdateUnion;
  productBadgeCreate: ProductBadgeCreateUnion;
  productBadgeDelete: ProductBadgeDeleteUnion;
  productBadgeDuplicate: ProductBadgeDuplicateUnion;
  productBadgeSetRuleset: ProductBadgeUpdateUnion;
  productBadgeUpdate: ProductBadgeUpdateUnion;
  productClassCreate: ProductClassCreateUnion;
  productClassDelete: ProductClassDeleteUnion;
  productClassUpdate: ProductClassUpdateUnion;
  productClearStocks: ProductClearStocksUnion;
  productCollectionAddProducts: ProductCollectionAddProductsUnion;
  productCollectionCreate: ProductCollectionCreateUnion;
  productCollectionDelete: ProductCollectionDeleteUnion;
  productCollectionDuplicate: ProductCollectionDuplicateUnion;
  productCollectionRemoveProducts: ProductCollectionRemoveProductsUnion;
  productCollectionSetRuleset: ProductCollectionUpdateUnion;
  productCollectionUpdate: ProductCollectionUpdateUnion;
  productCreate: ProductCreateUnion;
  productDelete: ProductDeleteUnion;
  productDisclaimerCreate: ProductDisclaimerCreateUnion;
  productDisclaimerDelete: ProductDisclaimerDeleteUnion;
  productDisclaimerDuplicate: ProductDisclaimerDuplicateUnion;
  productDisclaimerSetRuleset: ProductDisclaimerUpdateUnion;
  productDisclaimerUpdate: ProductDisclaimerUpdateUnion;
  productDuplicate: ProductDuplicateUnion;
  productExportCreate: ProductExportCreateUnion;
  productExportDelete: ProductExportDeleteUnion;
  productExportUpdate: ProductExportUpdateUnion;
  productGroupAddAttributes: ProductGroupAddAttributesUnion;
  productGroupCreate: ProductGroupCreateUnion;
  productGroupDelete: ProductGroupDeleteUnion;
  productGroupRemoveAttributes: ProductGroupRemoveAttributesUnion;
  productGroupUpdate: ProductGroupUpdateUnion;
  productImportCreate: ProductImportCreateUnion;
  productImportDelete: ProductImportDeleteUnion;
  productImportExecute: ProductImportExecuteUnion;
  productImportUpdate: ProductImportUpdateUnion;
  productMaskMediaCreate: ProductMaskMediaCreateUnion;
  productMaskMediaDelete: ProductMaskMediaDeleteUnion;
  productMaskMediaUpdate: ProductMaskMediaUpdateUnion;
  productMediasCreate: ProductMediaCreateUnion;
  productMediasDelete: ProductMediaDeleteUnion;
  productMediasUpdate: ProductMediaUpdateUnion;
  productParcelCreate: ProductParcelCreateUnion;
  productParcelDelete: ProductParcelDeleteUnion;
  productParcelUpdate: ProductParcelUpdateUnion;
  productPriceTypeCreate: ProductPriceTypeCreateUnion;
  productPriceTypeDelete: ProductPriceTypeDeleteUnion;
  productPriceTypeUpdate: ProductPriceTypeUpdateUnion;
  productPropertyCreate: ProductPropertyCreateUnion;
  productPropertyDelete: ProductPropertyDeleteUnion;
  productPropertyOptionCreate: ProductPropertyOptionCreateUnion;
  productPropertyOptionDelete: ProductPropertyOptionDeleteUnion;
  productPropertyOptionUpdate: ProductPropertyOptionUpdateUnion;
  productPropertyReorderOptions: ProductPropertyReorderOptionsUnion;
  productPropertyUpdate: ProductPropertyUpdateUnion;
  productRelationAddProducts: ProductRelationAddProductsUnion;
  productRelationCreate: ProductRelationCreateUnion;
  productRelationDelete: ProductRelationDeleteUnion;
  productRelationRemoveProducts: ProductRelationRemoveProductsUnion;
  productRelationSetRuleset: ProductRelationUpdateUnion;
  productRelationUpdate: ProductRelationUpdateUnion;
  productRemoveCategories: ProductRemoveCategoriesUnion;
  productReorderAssets: ProductReorderAssetsUnion;
  productReorderMedias: ProductReorderMediasUnion;
  productReorderProperties: ProductReorderPropertiesUnion;
  productSetBrand: ProductUpdateUnion;
  productSetDefaultMedia: ProductSetDefaultMediaUnion;
  productSetMeasurementAsset: ProductSetMeasurementAssetUnion;
  productSetProductClass: ProductUpdateUnion;
  productSetProductGroup: ProductUpdateUnion;
  productSetPromotionGroup: ProductUpdateUnion;
  productSetTaxClass: ProductUpdateUnion;
  productUpdate: ProductUpdateUnion;
  productUpdateAttributes: ProductUpdateAttributesUnion;
  productUpdateCart: ProductUpdateUnion;
  productUpdateConfigurableData: ProductUpdateConfigurableDataUnion;
  productUpdateDimensions: ProductUpdateUnion;
  productUpdateInventory: ProductUpdateUnion;
  productUpdateOutlets: ProductUpdateUnion;
  productUpdatePricing: ProductUpdateUnion;
  productUpdateSeo: ProductUpdateUnion;
  productValueCollectionAddProducts: ProductValueCollectionAddProductsUnion;
  productValueCollectionCreate: ProductValueCollectionCreateUnion;
  productValueCollectionDelete: ProductValueCollectionDeleteUnion;
  productValueCollectionRemoveProducts: ProductValueCollectionRemoveProductsUnion;
  productValueCollectionSetRuleset: ProductValueCollectionUpdateUnion;
  productValueCollectionUpdate: ProductValueCollectionUpdateUnion;
  promotionAddCodes: PromotionAddCodesUnion;
  promotionCodeDelete: PromotionCodeDeleteUnion;
  promotionCreate: PromotionCreateUnion;
  promotionDelete: PromotionDeleteUnion;
  promotionDeleteCodes: PromotionDeleteCodesUnion;
  promotionDuplicate: PromotionDuplicateUnion;
  promotionGenerateCodes: PromotionGenerateCodesUnion;
  promotionGroupCreate: PromotionGroupCreateUnion;
  promotionGroupDelete: PromotionGroupDeleteUnion;
  promotionGroupUpdate: PromotionGroupUpdateUnion;
  promotionSetFilterRuleset: PromotionUpdateUnion;
  promotionSetMatchRuleset: PromotionUpdateUnion;
  promotionSetPriceType: PromotionUpdateUnion;
  promotionSetStyle: PromotionUpdateUnion;
  promotionStyleCreate: PromotionStyleCreateUnion;
  promotionStyleDelete: PromotionStyleDeleteUnion;
  promotionStyleDuplicate: PromotionStyleDuplicateUnion;
  promotionStyleUpdate: PromotionStyleUpdateUnion;
  promotionUpdate: PromotionUpdateUnion;
  rulesetCreate: RulesetCreateUnion;
  rulesetDelete: RulesetDeleteUnion;
  rulesetRefresh: RulesetRefreshUnion;
  rulesetUpdate: RulesetUpdateUnion;
  shippingAreaCreate: ShippingAreaCreateUnion;
  shippingAreaDelete: ShippingAreaDeleteUnion;
  shippingAreaUpdate: ShippingAreaUpdateUnion;
  shippingMethodAreaCreate: ShippingMethodAreaCreateUnion;
  shippingMethodAreaDelete: ShippingMethodAreaDeleteUnion;
  shippingMethodAreaUpdate: ShippingMethodAreaUpdateUnion;
  shippingMethodCreate: ShippingMethodCreateUnion;
  shippingMethodDelete: ShippingMethodDeleteUnion;
  shippingMethodDuplicate: ShippingMethodDuplicateUnion;
  shippingMethodGroupAddShippingMethods: ShippingMethodGroupAddShippingMethodsUnion;
  shippingMethodGroupCreate: ShippingMethodGroupCreateUnion;
  shippingMethodGroupDelete: ShippingMethodGroupDeleteUnion;
  shippingMethodGroupRemoveShippingMethods: ShippingMethodGroupRemoveShippingMethodsUnion;
  shippingMethodGroupReorder: ShippingMethodGroupReorderUnion;
  shippingMethodGroupReorderShippingMethods: ShippingMethodGroupReorderShippingMethodsUnion;
  shippingMethodGroupUpdate: ShippingMethodGroupUpdateUnion;
  shippingMethodServiceCreate: ShippingMethodServiceCreateUnion;
  shippingMethodServiceDelete: ShippingMethodServiceDeleteUnion;
  shippingMethodServiceUpdate: ShippingMethodServiceUpdateUnion;
  shippingMethodSetTaxClass: ShippingMethodUpdateUnion;
  shippingMethodUpdate: ShippingMethodUpdateUnion;
  storeCreate: StoreCreateUnion;
  storeDelete: StoreDeleteUnion;
  storeUpdate: StoreUpdateUnion;
  taxClassCreate: TaxClassCreateUnion;
  taxClassDelete: TaxClassDeleteUnion;
  taxClassUpdate: TaxClassUpdateUnion;
  userSetRoles: Maybe<UserSetRolesPayload>;
  userUpdate: Maybe<UserUpdatePayload>;
};


export type MutationAttributeCreateArgs = {
  input: AttributeCreateInput;
};


export type MutationAttributeDeleteArgs = {
  where: AttributeUniqueWhereInput;
};


export type MutationAttributeGroupAddAttributesArgs = {
  attributeGroupId: Scalars['ID']['input'];
  attributeIds: Array<Scalars['ID']['input']>;
};


export type MutationAttributeGroupCreateArgs = {
  input: AttributeGroupCreateInput;
};


export type MutationAttributeGroupDeleteArgs = {
  where: AttributeGroupUniqueWhereInput;
};


export type MutationAttributeGroupRemoveAttributesArgs = {
  attributeGroupId: Scalars['ID']['input'];
  attributeIds: Array<Scalars['ID']['input']>;
};


export type MutationAttributeGroupReorderArgs = {
  order: Array<ReorderInput>;
};


export type MutationAttributeGroupReorderAttributesArgs = {
  order: Array<ReorderInput>;
  where: AttributeGroupUniqueWhereInput;
};


export type MutationAttributeGroupUpdateArgs = {
  input: AttributeGroupUpdateInput;
  where: AttributeGroupUniqueWhereInput;
};


export type MutationAttributeOptionCreateArgs = {
  input: AttributeOptionCreateInput;
};


export type MutationAttributeOptionDeleteArgs = {
  where: AttributeOptionUniqueWhereInput;
};


export type MutationAttributeOptionUpdateArgs = {
  input: AttributeOptionUpdateInput;
  where: AttributeOptionUniqueWhereInput;
};


export type MutationAttributeReorderOptionsArgs = {
  order: Array<ReorderInput>;
  where: AttributeUniqueWhereInput;
};


export type MutationAttributeUpdateArgs = {
  input: AttributeUpdateInput;
  where: AttributeUniqueWhereInput;
};


export type MutationBrandCreateArgs = {
  input: BrandCreateInput;
};


export type MutationBrandDeleteArgs = {
  where: BrandUniqueWhereInput;
};


export type MutationBrandUpdateArgs = {
  input: BrandUpdateInput;
  where: BrandUniqueWhereInput;
};


export type MutationCartCreateArgs = {
  input: CartCreateInput;
};


export type MutationCartDeleteArgs = {
  where: CartUniqueWhereInput;
};


export type MutationCartProductCreateArgs = {
  input: CartProductCreateInput;
};


export type MutationCartProductDeleteArgs = {
  where: CartProductUniqueWhereInput;
};


export type MutationCartProductUpdateArgs = {
  input: CartProductUpdateInput;
  where: CartProductUniqueWhereInput;
};


export type MutationCartRecommendationAddProductsArgs = {
  cartRecommendationId: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationCartRecommendationCreateArgs = {
  input: CartRecommendationCreateInput;
};


export type MutationCartRecommendationDeleteArgs = {
  where: CartRecommendationUniqueWhereInput;
};


export type MutationCartRecommendationRemoveProductsArgs = {
  cartRecommendationId: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationCartRecommendationSetRulesetArgs = {
  rulesetId: Scalars['ID']['input'];
  type: CartRecommendationRulesetType;
  where: CartRecommendationUniqueWhereInput;
};


export type MutationCartRecommendationUpdateArgs = {
  input: CartRecommendationUpdateInput;
  where: CartRecommendationUniqueWhereInput;
};


export type MutationCartUpdateGiftCardArgs = {
  giftCardCode?: InputMaybe<Scalars['NonEmptyString']['input']>;
  where: CartUniqueWhereInput;
};


export type MutationCartUpdatePromotionCodeArgs = {
  promotionCode?: InputMaybe<Scalars['NonEmptyString']['input']>;
  where: CartUniqueWhereInput;
};


export type MutationCategoryAddProductsArgs = {
  categoryId: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationCategoryCreateArgs = {
  input: CategoryCreateInput;
};


export type MutationCategoryDeleteArgs = {
  where: CategoryUniqueWhereInput;
};


export type MutationCategoryDuplicateArgs = {
  where: CategoryUniqueWhereInput;
};


export type MutationCategoryRemoveProductsArgs = {
  categoryId: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationCategoryReorderArgs = {
  order: Array<CategoryReorderInput>;
};


export type MutationCategorySetRulesetArgs = {
  rulesetId?: InputMaybe<Scalars['ID']['input']>;
  where: CategoryUniqueWhereInput;
};


export type MutationCategoryUpdateArgs = {
  input: CategoryUpdateInput;
  where: CategoryUniqueWhereInput;
};


export type MutationCategoryUpdateSeoArgs = {
  input: CategoryUpdateSeoInput;
  where: CategoryUniqueWhereInput;
};


export type MutationCompanyAddCustomerArgs = {
  companyId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  role: CompanyCustomerRole;
};


export type MutationCompanyAddressCreateArgs = {
  input: CompanyAddressCreateInput;
};


export type MutationCompanyAddressDeleteArgs = {
  where: CompanyAddressUniqueWhereInput;
};


export type MutationCompanyAddressUpdateArgs = {
  input: CompanyAddressUpdateInput;
  where: CompanyAddressUniqueWhereInput;
};


export type MutationCompanyCreateArgs = {
  input: CompanyCreateInput;
};


export type MutationCompanyDeleteArgs = {
  where: CompanyUniqueWhereInput;
};


export type MutationCompanyRemoveCustomerArgs = {
  companyId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};


export type MutationCompanyUpdateArgs = {
  input: CompanyUpdateInput;
  where: CompanyUniqueWhereInput;
};


export type MutationCompanyUpdateCustomerArgs = {
  companyId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  role: CompanyCustomerRole;
};


export type MutationCustomerAddressCreateArgs = {
  input: CustomerAddressCreateInput;
};


export type MutationCustomerAddressDeleteArgs = {
  where: CustomerAddressUniqueWhereInput;
};


export type MutationCustomerAddressUpdateArgs = {
  input: CustomerAddressUpdateInput;
  where: CustomerAddressUniqueWhereInput;
};


export type MutationCustomerCreateArgs = {
  input: CustomerCreateInput;
};


export type MutationCustomerDeleteArgs = {
  where: CustomerUniqueWhereInput;
};


export type MutationCustomerFinishFirstTimeSetupArgs = {
  where: CustomerUniqueWhereInput;
};


export type MutationCustomerSendEmailVerificationArgs = {
  where: CustomerUniqueWhereInput;
};


export type MutationCustomerUpdateArgs = {
  input: CustomerUpdateInput;
  where: CustomerUniqueWhereInput;
};


export type MutationEditorCreateArgs = {
  input: EditorCreateInput;
};


export type MutationEditorDeleteArgs = {
  where: EditorUniqueWhereInput;
};


export type MutationEditorDuplicateArgs = {
  where: EditorUniqueWhereInput;
};


export type MutationEditorExecuteArgs = {
  where: EditorUniqueWhereInput;
};


export type MutationEditorExportArgs = {
  where: EditorUniqueWhereInput;
};


export type MutationEditorFieldCreateArgs = {
  input: EditorFieldCreateInput;
};


export type MutationEditorFieldDeleteArgs = {
  where: EditorFieldUniqueWhereInput;
};


export type MutationEditorFieldUpdateArgs = {
  input: EditorFieldUpdateInput;
  where: EditorFieldUniqueWhereInput;
};


export type MutationEditorReorderFieldsArgs = {
  order: Array<ReorderInput>;
  where: EditorUniqueWhereInput;
};


export type MutationEditorUpdateArgs = {
  input: EditorUpdateInput;
  where: EditorUniqueWhereInput;
};


export type MutationEditorUpdateUpsertArgs = {
  input: EditorUpdateUpsertInput;
};


export type MutationGiftCardCreateArgs = {
  input: GiftCardCreateForCustomerInput;
};


export type MutationGiftCardDeleteArgs = {
  where: GiftCardUniqueWhereInput;
};


export type MutationNotificationMarkAsReadArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationNotificationTemplateCreateArgs = {
  input: NotificationTemplateCreateInput;
};


export type MutationNotificationTemplateDeleteArgs = {
  where: NotificationTemplateUniqueWhereInput;
};


export type MutationNotificationTemplatePreviewArgs = {
  input: NotificationTemplatePreviewInput;
};


export type MutationNotificationTemplateUpdateArgs = {
  input: NotificationTemplateUpdateInput;
  where: NotificationTemplateUniqueWhereInput;
};


export type MutationOrderAddressCreateArgs = {
  input: OrderAddressCreateInput;
};


export type MutationOrderAddressCreateFromCustomerAddressArgs = {
  customerAddressId: Scalars['ID']['input'];
};


export type MutationOrderAddressUpdateArgs = {
  input: OrderAddressUpdateInput;
  where: OrderAddressUniqueWhereInput;
};


export type MutationOrderCancelArgs = {
  where: OrderUniqueWhereInput;
};


export type MutationOrderClearHandlerArgs = {
  where: OrderUniqueWhereInput;
};


export type MutationOrderCompleteArgs = {
  where: OrderUniqueWhereInput;
};


export type MutationOrderCreateFromCartArgs = {
  cartId: Scalars['ID']['input'];
};


export type MutationOrderDeleteArgs = {
  where: OrderUniqueWhereInput;
};


export type MutationOrderFinalizeArgs = {
  where: OrderUniqueWhereInput;
};


export type MutationOrderPaymentCancelArgs = {
  where: OrderPaymentFingerprintWhereInput;
};


export type MutationOrderPaymentCompleteArgs = {
  input: OrderPaymentReturnResponseInput;
  where: OrderPaymentFingerprintWhereInput;
};


export type MutationOrderPaymentCreateArgs = {
  input: OrderPaymentCreateInput;
};


export type MutationOrderPaymentExecuteArgs = {
  input: OrderPaymentExecuteInput;
  where: OrderPaymentFingerprintWhereInput;
};


export type MutationOrderPaymentNotifyArgs = {
  input: OrderPaymentReturnResponseInput;
  where: OrderPaymentFingerprintWhereInput;
};


export type MutationOrderPaymentUpdateArgs = {
  input: OrderPaymentUpdateInput;
  where: OrderPaymentFingerprintWhereInput;
};


export type MutationOrderReceiveArgs = {
  where: OrderUniqueWhereInput;
};


export type MutationOrderSetBillingAddressArgs = {
  addressId: Scalars['ID']['input'];
  where: OrderUniqueWhereInput;
};


export type MutationOrderSetCustomerArgs = {
  customerId: Scalars['ID']['input'];
  where: OrderUniqueWhereInput;
};


export type MutationOrderSetHandlerArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
  where: OrderUniqueWhereInput;
};


export type MutationOrderSetPaymentMethodArgs = {
  paymentData?: InputMaybe<Array<OrderDataInput>>;
  paymentMethodId: Scalars['ID']['input'];
  where: OrderUniqueWhereInput;
};


export type MutationOrderSetShippingAddressArgs = {
  addressId: Scalars['ID']['input'];
  where: OrderUniqueWhereInput;
};


export type MutationOrderSetShippingMethodArgs = {
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
  shippingData?: InputMaybe<Array<OrderDataInput>>;
  shippingMethodId: Scalars['ID']['input'];
  where: OrderUniqueWhereInput;
};


export type MutationOrderUndoFinalizeArgs = {
  where: OrderUniqueWhereInput;
};


export type MutationOrderUpdateArgs = {
  input: OrderUpdateInput;
  where: OrderUniqueWhereInput;
};


export type MutationOutletCreateArgs = {
  input: OutletCreateInput;
};


export type MutationOutletDeleteArgs = {
  where: OutletUniqueWhereInput;
};


export type MutationOutletUpdateArgs = {
  input: OutletUpdateInput;
  where: OutletUniqueWhereInput;
};


export type MutationPaymentMethodCreateArgs = {
  input: PaymentMethodCreateInput;
};


export type MutationPaymentMethodDeleteArgs = {
  where: PaymentMethodUniqueWhereInput;
};


export type MutationPaymentMethodGroupAddPaymentMethodsArgs = {
  paymentMethodGroupId: Scalars['ID']['input'];
  paymentMethodIds: Array<Scalars['ID']['input']>;
};


export type MutationPaymentMethodGroupCreateArgs = {
  input: PaymentMethodGroupCreateInput;
};


export type MutationPaymentMethodGroupDeleteArgs = {
  where: PaymentMethodGroupUniqueWhereInput;
};


export type MutationPaymentMethodGroupRemovePaymentMethodsArgs = {
  paymentMethodGroupId: Scalars['ID']['input'];
  paymentMethodIds: Array<Scalars['ID']['input']>;
};


export type MutationPaymentMethodGroupReorderArgs = {
  order: Array<ReorderInput>;
};


export type MutationPaymentMethodGroupReorderPaymentMethodsArgs = {
  order: Array<ReorderInput>;
  where: PaymentMethodGroupUniqueWhereInput;
};


export type MutationPaymentMethodGroupUpdateArgs = {
  input: PaymentMethodGroupUpdateInput;
  where: PaymentMethodGroupUniqueWhereInput;
};


export type MutationPaymentMethodReorderArgs = {
  order: Array<ReorderInput>;
};


export type MutationPaymentMethodUpdateArgs = {
  input: PaymentMethodUpdateInput;
  where: PaymentMethodUniqueWhereInput;
};


export type MutationPriceTypeCreateArgs = {
  input: PriceTypeCreateInput;
};


export type MutationPriceTypeDeleteArgs = {
  where: PriceTypeUniqueWhereInput;
};


export type MutationPriceTypeUpdateArgs = {
  input: PriceTypeUpdateInput;
  where: PriceTypeUniqueWhereInput;
};


export type MutationProductAddCategoriesArgs = {
  categoryIds: Array<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
};


export type MutationProductAssetsCreateArgs = {
  input: ProductAssetCreateInput;
};


export type MutationProductAssetsDeleteArgs = {
  where: ProductAssetUniqueWhereInput;
};


export type MutationProductAssetsUpdateArgs = {
  input: ProductAssetUpdateInput;
  where: ProductAssetUniqueWhereInput;
};


export type MutationProductBadgeCreateArgs = {
  input: ProductBadgeCreateInput;
};


export type MutationProductBadgeDeleteArgs = {
  where: ProductBadgeUniqueWhereInput;
};


export type MutationProductBadgeDuplicateArgs = {
  where: ProductBadgeUniqueWhereInput;
};


export type MutationProductBadgeSetRulesetArgs = {
  rulesetId?: InputMaybe<Scalars['ID']['input']>;
  where: ProductBadgeUniqueWhereInput;
};


export type MutationProductBadgeUpdateArgs = {
  input: ProductBadgeUpdateInput;
  where: ProductBadgeUniqueWhereInput;
};


export type MutationProductClassCreateArgs = {
  input: ProductClassCreateInput;
};


export type MutationProductClassDeleteArgs = {
  where: ProductClassUniqueWhereInput;
};


export type MutationProductClassUpdateArgs = {
  input: ProductClassUpdateInput;
  where: ProductClassUniqueWhereInput;
};


export type MutationProductClearStocksArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationProductCollectionAddProductsArgs = {
  productCollectionId: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationProductCollectionCreateArgs = {
  input: ProductCollectionCreateInput;
};


export type MutationProductCollectionDeleteArgs = {
  where: ProductCollectionUniqueWhereInput;
};


export type MutationProductCollectionDuplicateArgs = {
  where: ProductCollectionUniqueWhereInput;
};


export type MutationProductCollectionRemoveProductsArgs = {
  productCollectionId: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationProductCollectionSetRulesetArgs = {
  rulesetId?: InputMaybe<Scalars['ID']['input']>;
  where: ProductCollectionUniqueWhereInput;
};


export type MutationProductCollectionUpdateArgs = {
  input: ProductCollectionUpdateInput;
  where: ProductCollectionUniqueWhereInput;
};


export type MutationProductCreateArgs = {
  input: ProductCreateInput;
};


export type MutationProductDeleteArgs = {
  where: ProductUniqueWhereInput;
};


export type MutationProductDisclaimerCreateArgs = {
  input: ProductDisclaimerCreateInput;
};


export type MutationProductDisclaimerDeleteArgs = {
  where: ProductDisclaimerUniqueWhereInput;
};


export type MutationProductDisclaimerDuplicateArgs = {
  where: ProductDisclaimerUniqueWhereInput;
};


export type MutationProductDisclaimerSetRulesetArgs = {
  rulesetId?: InputMaybe<Scalars['ID']['input']>;
  where: ProductDisclaimerUniqueWhereInput;
};


export type MutationProductDisclaimerUpdateArgs = {
  input: ProductDisclaimerUpdateInput;
  where: ProductDisclaimerUniqueWhereInput;
};


export type MutationProductDuplicateArgs = {
  where: ProductUniqueWhereInput;
};


export type MutationProductExportCreateArgs = {
  input: ProductExportCreateInput;
};


export type MutationProductExportDeleteArgs = {
  where: ProductExportUniqueWhereInput;
};


export type MutationProductExportUpdateArgs = {
  input: ProductExportUpdateInput;
  where: ProductExportUniqueWhereInput;
};


export type MutationProductGroupAddAttributesArgs = {
  attributeIds: Array<Scalars['ID']['input']>;
  productGroupId: Scalars['ID']['input'];
};


export type MutationProductGroupCreateArgs = {
  input: ProductGroupCreateInput;
};


export type MutationProductGroupDeleteArgs = {
  where: ProductGroupUniqueWhereInput;
};


export type MutationProductGroupRemoveAttributesArgs = {
  attributeIds: Array<Scalars['ID']['input']>;
  productGroupId: Scalars['ID']['input'];
};


export type MutationProductGroupUpdateArgs = {
  input: ProductGroupUpdateInput;
  where: ProductGroupUniqueWhereInput;
};


export type MutationProductImportCreateArgs = {
  input: ProductImportCreateInput;
};


export type MutationProductImportDeleteArgs = {
  where: ProductImportUniqueWhereInput;
};


export type MutationProductImportExecuteArgs = {
  where: ProductImportUniqueWhereInput;
};


export type MutationProductImportUpdateArgs = {
  input: ProductImportUpdateInput;
  where: ProductImportUniqueWhereInput;
};


export type MutationProductMaskMediaCreateArgs = {
  input: ProductMaskMediaCreateInput;
};


export type MutationProductMaskMediaDeleteArgs = {
  where: ProductMaskMediaUniqueWhereInput;
};


export type MutationProductMaskMediaUpdateArgs = {
  input: ProductMaskMediaUpdateInput;
  where: ProductMaskMediaUniqueWhereInput;
};


export type MutationProductMediasCreateArgs = {
  input: ProductMediaCreateInput;
};


export type MutationProductMediasDeleteArgs = {
  where: ProductMediaUniqueWhereInput;
};


export type MutationProductMediasUpdateArgs = {
  input: ProductMediaUpdateInput;
  where: ProductMediaUniqueWhereInput;
};


export type MutationProductParcelCreateArgs = {
  input: ProductParcelCreateInput;
};


export type MutationProductParcelDeleteArgs = {
  where: ProductParcelUniqueWhereInput;
};


export type MutationProductParcelUpdateArgs = {
  input: ProductParcelUpdateInput;
  where: ProductParcelUniqueWhereInput;
};


export type MutationProductPriceTypeCreateArgs = {
  input: ProductPriceTypeCreateInput;
};


export type MutationProductPriceTypeDeleteArgs = {
  where: ProductPriceTypeUniqueWhereInput;
};


export type MutationProductPriceTypeUpdateArgs = {
  input: ProductPriceTypeUpdateInput;
  where: ProductPriceTypeUniqueWhereInput;
};


export type MutationProductPropertyCreateArgs = {
  input: ProductPropertyCreateInput;
};


export type MutationProductPropertyDeleteArgs = {
  where: ProductPropertyUniqueWhereInput;
};


export type MutationProductPropertyOptionCreateArgs = {
  input: ProductPropertyOptionCreateInput;
};


export type MutationProductPropertyOptionDeleteArgs = {
  where: ProductPropertyOptionUniqueWhereInput;
};


export type MutationProductPropertyOptionUpdateArgs = {
  input: ProductPropertyOptionUpdateInput;
  where: ProductPropertyOptionUniqueWhereInput;
};


export type MutationProductPropertyReorderOptionsArgs = {
  order: Array<ReorderInput>;
  where: ProductPropertyUniqueWhereInput;
};


export type MutationProductPropertyUpdateArgs = {
  input: ProductPropertyUpdateInput;
  where: ProductPropertyUniqueWhereInput;
};


export type MutationProductRelationAddProductsArgs = {
  productIds: Array<Scalars['ID']['input']>;
  productRelationId: Scalars['ID']['input'];
  type: ProductRelationProductType;
};


export type MutationProductRelationCreateArgs = {
  input: ProductRelationCreateInput;
};


export type MutationProductRelationDeleteArgs = {
  where: ProductRelationUniqueWhereInput;
};


export type MutationProductRelationRemoveProductsArgs = {
  productIds: Array<Scalars['ID']['input']>;
  productRelationId: Scalars['ID']['input'];
  type: ProductRelationProductType;
};


export type MutationProductRelationSetRulesetArgs = {
  rulesetId: Scalars['ID']['input'];
  type: ProductRelationProductType;
  where: ProductRelationUniqueWhereInput;
};


export type MutationProductRelationUpdateArgs = {
  input: ProductRelationUpdateInput;
  where: ProductRelationUniqueWhereInput;
};


export type MutationProductRemoveCategoriesArgs = {
  categoryIds: Array<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
};


export type MutationProductReorderAssetsArgs = {
  order: Array<ReorderInput>;
  where: ProductUniqueWhereInput;
};


export type MutationProductReorderMediasArgs = {
  order: Array<ReorderInput>;
  where: ProductUniqueWhereInput;
};


export type MutationProductReorderPropertiesArgs = {
  order: Array<ReorderInput>;
  where: ProductUniqueWhereInput;
};


export type MutationProductSetBrandArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  where: ProductUniqueWhereInput;
};


export type MutationProductSetDefaultMediaArgs = {
  mediaId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationProductSetMeasurementAssetArgs = {
  assetId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationProductSetProductClassArgs = {
  productClassId?: InputMaybe<Scalars['ID']['input']>;
  where: ProductUniqueWhereInput;
};


export type MutationProductSetProductGroupArgs = {
  productGroupId?: InputMaybe<Scalars['ID']['input']>;
  where: ProductUniqueWhereInput;
};


export type MutationProductSetPromotionGroupArgs = {
  promotionGroupId?: InputMaybe<Scalars['ID']['input']>;
  where: ProductUniqueWhereInput;
};


export type MutationProductSetTaxClassArgs = {
  taxClassId: Scalars['ID']['input'];
  where: ProductUniqueWhereInput;
};


export type MutationProductUpdateArgs = {
  input: ProductUpdateInput;
  where: ProductUniqueWhereInput;
};


export type MutationProductUpdateAttributesArgs = {
  values: Array<ProductUpdateAttributeInput>;
  where: ProductUniqueWhereInput;
};


export type MutationProductUpdateCartArgs = {
  input: ProductUpdateCartInput;
  where: ProductUniqueWhereInput;
};


export type MutationProductUpdateConfigurableDataArgs = {
  attributes: Array<ProductUpdateConfigurableDataAttributeInput>;
  childProductIds: Array<Scalars['ID']['input']>;
  defaultChildProductId?: InputMaybe<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
};


export type MutationProductUpdateDimensionsArgs = {
  input: ProductUpdateDimensionsInput;
  where: ProductUniqueWhereInput;
};


export type MutationProductUpdateInventoryArgs = {
  input: ProductUpdateInventoryInput;
  where: ProductUniqueWhereInput;
};


export type MutationProductUpdateOutletsArgs = {
  input: ProductUpdateOutletsInput;
};


export type MutationProductUpdatePricingArgs = {
  input: ProductUpdatePricingInput;
  where: ProductUniqueWhereInput;
};


export type MutationProductUpdateSeoArgs = {
  input: ProductUpdateSeoInput;
  where: ProductUniqueWhereInput;
};


export type MutationProductValueCollectionAddProductsArgs = {
  productIds: Array<Scalars['ID']['input']>;
  productValueCollectionId: Scalars['ID']['input'];
};


export type MutationProductValueCollectionCreateArgs = {
  input: ProductValueCollectionCreateInput;
};


export type MutationProductValueCollectionDeleteArgs = {
  where: ProductValueCollectionUniqueWhereInput;
};


export type MutationProductValueCollectionRemoveProductsArgs = {
  productIds: Array<Scalars['ID']['input']>;
  productValueCollectionId: Scalars['ID']['input'];
};


export type MutationProductValueCollectionSetRulesetArgs = {
  rulesetId?: InputMaybe<Scalars['ID']['input']>;
  where: ProductValueCollectionUniqueWhereInput;
};


export type MutationProductValueCollectionUpdateArgs = {
  input: ProductValueCollectionUpdateInput;
  where: ProductValueCollectionUniqueWhereInput;
};


export type MutationPromotionAddCodesArgs = {
  codes: Array<Scalars['String']['input']>;
  where: PromotionUniqueWhereInput;
};


export type MutationPromotionCodeDeleteArgs = {
  where: PromotionCodeUniqueWhereInput;
};


export type MutationPromotionCreateArgs = {
  input: PromotionCreateInput;
};


export type MutationPromotionDeleteArgs = {
  where: PromotionUniqueWhereInput;
};


export type MutationPromotionDeleteCodesArgs = {
  codeIds: Array<Scalars['ID']['input']>;
  where: PromotionUniqueWhereInput;
};


export type MutationPromotionDuplicateArgs = {
  where: PromotionUniqueWhereInput;
};


export type MutationPromotionGenerateCodesArgs = {
  input: PromotionGenerateCodesInput;
  where: PromotionUniqueWhereInput;
};


export type MutationPromotionGroupCreateArgs = {
  input: PromotionGroupCreateInput;
};


export type MutationPromotionGroupDeleteArgs = {
  where: PromotionGroupUniqueWhereInput;
};


export type MutationPromotionGroupUpdateArgs = {
  input: PromotionGroupUpdateInput;
  where: PromotionGroupUniqueWhereInput;
};


export type MutationPromotionSetFilterRulesetArgs = {
  rulesetId?: InputMaybe<Scalars['ID']['input']>;
  where: PromotionUniqueWhereInput;
};


export type MutationPromotionSetMatchRulesetArgs = {
  rulesetId?: InputMaybe<Scalars['ID']['input']>;
  where: PromotionUniqueWhereInput;
};


export type MutationPromotionSetPriceTypeArgs = {
  priceTypeId?: InputMaybe<Scalars['ID']['input']>;
  where: PromotionUniqueWhereInput;
};


export type MutationPromotionSetStyleArgs = {
  promotionStyleId?: InputMaybe<Scalars['ID']['input']>;
  where: PromotionUniqueWhereInput;
};


export type MutationPromotionStyleCreateArgs = {
  input: PromotionStyleCreateInput;
};


export type MutationPromotionStyleDeleteArgs = {
  where: PromotionStyleUniqueWhereInput;
};


export type MutationPromotionStyleDuplicateArgs = {
  where: PromotionStyleUniqueWhereInput;
};


export type MutationPromotionStyleUpdateArgs = {
  input: PromotionStyleUpdateInput;
  where: PromotionStyleUniqueWhereInput;
};


export type MutationPromotionUpdateArgs = {
  input: PromotionUpdateInput;
  where: PromotionUniqueWhereInput;
};


export type MutationRulesetCreateArgs = {
  input: RulesetCreateInput;
};


export type MutationRulesetDeleteArgs = {
  where: RulesetUniqueWhereInput;
};


export type MutationRulesetRefreshArgs = {
  where: RulesetUniqueWhereInput;
};


export type MutationRulesetUpdateArgs = {
  input: RulesetUpdateInput;
  where: RulesetUniqueWhereInput;
};


export type MutationShippingAreaCreateArgs = {
  input: ShippingAreaCreateInput;
};


export type MutationShippingAreaDeleteArgs = {
  where: ShippingAreaUniqueWhereInput;
};


export type MutationShippingAreaUpdateArgs = {
  input: ShippingAreaUpdateInput;
  where: ShippingAreaUniqueWhereInput;
};


export type MutationShippingMethodAreaCreateArgs = {
  input: ShippingMethodAreaCreateInput;
};


export type MutationShippingMethodAreaDeleteArgs = {
  where: ShippingMethodAreaUniqueWhereInput;
};


export type MutationShippingMethodAreaUpdateArgs = {
  input: ShippingMethodAreaUpdateInput;
  where: ShippingMethodAreaUniqueWhereInput;
};


export type MutationShippingMethodCreateArgs = {
  input: ShippingMethodCreateInput;
};


export type MutationShippingMethodDeleteArgs = {
  where: ShippingMethodUniqueWhereInput;
};


export type MutationShippingMethodDuplicateArgs = {
  where: ShippingMethodUniqueWhereInput;
};


export type MutationShippingMethodGroupAddShippingMethodsArgs = {
  shippingMethodGroupId: Scalars['ID']['input'];
  shippingMethodIds: Array<Scalars['ID']['input']>;
};


export type MutationShippingMethodGroupCreateArgs = {
  input: ShippingMethodGroupCreateInput;
};


export type MutationShippingMethodGroupDeleteArgs = {
  where: ShippingMethodGroupUniqueWhereInput;
};


export type MutationShippingMethodGroupRemoveShippingMethodsArgs = {
  shippingMethodGroupId: Scalars['ID']['input'];
  shippingMethodIds: Array<Scalars['ID']['input']>;
};


export type MutationShippingMethodGroupReorderArgs = {
  order: Array<ReorderInput>;
};


export type MutationShippingMethodGroupReorderShippingMethodsArgs = {
  order: Array<ReorderInput>;
  where: ShippingMethodGroupUniqueWhereInput;
};


export type MutationShippingMethodGroupUpdateArgs = {
  input: ShippingMethodGroupUpdateInput;
  where: ShippingMethodGroupUniqueWhereInput;
};


export type MutationShippingMethodServiceCreateArgs = {
  input: ShippingMethodServiceCreateInput;
};


export type MutationShippingMethodServiceDeleteArgs = {
  where: ShippingMethodServiceUniqueWhereInput;
};


export type MutationShippingMethodServiceUpdateArgs = {
  input: ShippingMethodServiceUpdateInput;
  where: ShippingMethodServiceUniqueWhereInput;
};


export type MutationShippingMethodSetTaxClassArgs = {
  taxClassId: Scalars['ID']['input'];
  where: ShippingMethodUniqueWhereInput;
};


export type MutationShippingMethodUpdateArgs = {
  input: ShippingMethodUpdateInput;
  where: ShippingMethodUniqueWhereInput;
};


export type MutationStoreCreateArgs = {
  input: StoreCreateInput;
};


export type MutationStoreDeleteArgs = {
  where: StoreUniqueWhereInput;
};


export type MutationStoreUpdateArgs = {
  input: StoreUpdateInput;
};


export type MutationTaxClassCreateArgs = {
  input: TaxClassCreateInput;
};


export type MutationTaxClassDeleteArgs = {
  where: TaxClassUniqueWhereInput;
};


export type MutationTaxClassUpdateArgs = {
  input: TaxClassUpdateInput;
  where: TaxClassUniqueWhereInput;
};


export type MutationUserSetRolesArgs = {
  roleIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationUserUpdateArgs = {
  input: UserUpdateInput;
  where: UserUniqueWhereInput;
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type NodeInput = {
  id: Scalars['ID']['input'];
};

export type Notification = Node & {
  __typename: 'Notification';
  attachments: Array<NotificationAttachment>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  item: Node;
  readAt: Maybe<Scalars['DateTime']['output']>;
  type: NotificationType;
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationAttachment = Node & {
  __typename: 'NotificationAttachment';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['URL']['output'];
};

export type NotificationMarkAsReadPayload = {
  __typename: 'NotificationMarkAsReadPayload';
  notifications: Array<Notification>;
};

export type NotificationMarkAsReadUnion = EntityNotFoundError | NotificationMarkAsReadPayload;

export enum NotificationOrderByField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type NotificationOrderByInput = {
  direction: OrderByDirection;
  field: NotificationOrderByField;
};

export type NotificationTemplate = {
  contentType: NotificationTemplateContentType;
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  id: Scalars['ID']['output'];
  state: NotificationTemplateState;
  title: Scalars['NonEmptyString']['output'];
  type: NotificationTemplateType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum NotificationTemplateContentType {
  Email = 'EMAIL',
  Webhook = 'WEBHOOK'
}

export type NotificationTemplateCreateInput = {
  content?: InputMaybe<Scalars['NonEmptyString']['input']>;
  contentType: NotificationTemplateContentType;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  from?: InputMaybe<Scalars['NonEmptyString']['input']>;
  location?: InputMaybe<Scalars['NonEmptyString']['input']>;
  receivers?: InputMaybe<Scalars['NonEmptyString']['input']>;
  state: NotificationTemplateState;
  subject?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title: Scalars['NonEmptyString']['input'];
  type: NotificationTemplateType;
};

export type NotificationTemplateCreatePayload = {
  __typename: 'NotificationTemplateCreatePayload';
  notificationTemplate: NotificationTemplate;
};

export type NotificationTemplateCreateUnion = InvalidInputError | NotificationTemplateCreatePayload;

export type NotificationTemplateDeletePayload = {
  __typename: 'NotificationTemplateDeletePayload';
  notificationTemplate: NotificationTemplate;
};

export type NotificationTemplateDeleteUnion = EntityNotFoundError | NotificationTemplateDeletePayload;

export enum NotificationTemplateOrderByField {
  CreatedAt = 'CREATED_AT',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type NotificationTemplateOrderByInput = {
  direction: OrderByDirection;
  field: NotificationTemplateOrderByField;
};

export type NotificationTemplatePreviewInput = {
  content?: InputMaybe<Scalars['NonEmptyString']['input']>;
  orderId: Scalars['ID']['input'];
};

export type NotificationTemplatePreviewPayload = {
  __typename: 'NotificationTemplatePreviewPayload';
  content: Maybe<Scalars['String']['output']>;
  orderData: Scalars['JSONObject']['output'];
};

export type NotificationTemplatePreviewUnion = InvalidInputError | NotificationTemplatePreviewPayload;

export type NotificationTemplateResultUnion = EmailNotificationTemplate | EntityNotFoundError | WebhookNotificationTemplate;

export enum NotificationTemplateState {
  Active = 'ACTIVE',
  Disabled = 'DISABLED'
}

export enum NotificationTemplateType {
  GiftCardOrderProcessed = 'GIFT_CARD_ORDER_PROCESSED',
  OrderProcessed = 'ORDER_PROCESSED',
  OrderReceived = 'ORDER_RECEIVED'
}

export type NotificationTemplateUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type NotificationTemplateUpdateInput = {
  content?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  from?: InputMaybe<Scalars['NonEmptyString']['input']>;
  location?: InputMaybe<Scalars['NonEmptyString']['input']>;
  receivers?: InputMaybe<Scalars['NonEmptyString']['input']>;
  state?: InputMaybe<NotificationTemplateState>;
  subject?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type NotificationTemplateUpdatePayload = {
  __typename: 'NotificationTemplateUpdatePayload';
  notificationTemplate: NotificationTemplate;
};

export type NotificationTemplateUpdateUnion = EntityNotFoundError | NotificationTemplateUpdatePayload;

export type NotificationTemplateWhereInput = {
  AND?: InputMaybe<Array<NotificationTemplateWhereSubInput>>;
  OR?: InputMaybe<Array<NotificationTemplateWhereSubInput>>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type NotificationTemplateWhereSubInput = {
  AND?: InputMaybe<Array<NotificationTemplateWhereSubInput>>;
  OR?: InputMaybe<Array<NotificationTemplateWhereSubInput>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type NotificationTemplatesConnection = {
  __typename: 'NotificationTemplatesConnection';
  edges: Array<NotificationTemplatesEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type NotificationTemplatesEdge = {
  __typename: 'NotificationTemplatesEdge';
  cursor: Scalars['String']['output'];
  node: NotificationTemplate;
};

export enum NotificationType {
  EditorFailed = 'EDITOR_FAILED',
  EditorSuccessful = 'EDITOR_SUCCESSFUL',
  ExportFailed = 'EXPORT_FAILED',
  ExportSuccessful = 'EXPORT_SUCCESSFUL',
  ImportFailed = 'IMPORT_FAILED',
  ImportSuccessful = 'IMPORT_SUCCESSFUL'
}

export type NotificationWhereInput = {
  AND?: InputMaybe<Array<NotificationWhereSubInput>>;
  OR?: InputMaybe<Array<NotificationWhereSubInput>>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type?: InputMaybe<NotificationType>;
};

export type NotificationWhereSubInput = {
  AND?: InputMaybe<Array<NotificationWhereSubInput>>;
  OR?: InputMaybe<Array<NotificationWhereSubInput>>;
  type?: InputMaybe<NotificationType>;
};

export type NotificationsConnection = {
  __typename: 'NotificationsConnection';
  edges: Array<NotificationsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type NotificationsEdge = {
  __typename: 'NotificationsEdge';
  cursor: Scalars['String']['output'];
  node: Notification;
};

export type Order = Node & {
  __typename: 'Order';
  availablePaymentMethods: Array<PaymentMethod>;
  availableShippingMethods: Array<ShippingMethod>;
  billingAddress: Maybe<OrderAddress>;
  company: Maybe<Company>;
  createdAt: Scalars['DateTime']['output'];
  customer: Maybe<Customer>;
  deliveryEstimate: Maybe<OrderDeliveryEstimate>;
  deliveryInfo: Maybe<Scalars['NonEmptyString']['output']>;
  giftCardOrders: Array<GiftCardOrder>;
  handler: Maybe<User>;
  hasFreeShipping: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  ipAddress: Maybe<Scalars['IP']['output']>;
  number: Scalars['SafeInt']['output'];
  orderLevelDiscountsAmount: Money;
  originalDeliveryEstimate: Maybe<OrderDeliveryEstimate>;
  payment: Maybe<OrderPaymentInfo>;
  paymentMethod: Maybe<PaymentMethod>;
  products: Array<OrderProduct>;
  productsAmount: Money;
  promotionCode: Maybe<PromotionCode>;
  promotions: Array<Promotion>;
  saleNumber: Maybe<Scalars['NonEmptyString']['output']>;
  shipping: Maybe<OrderShippingInfo>;
  shippingAddress: Maybe<OrderAddress>;
  state: OrderState;
  taxLines: Array<OrderTaxLine>;
  totalAmount: Maybe<Money>;
  totalDiscountsAmount: Money;
  totalValue: Maybe<Money>;
  updatedAt: Scalars['DateTime']['output'];
  wasLoggedIn: Scalars['Boolean']['output'];
};


export type OrderAvailableShippingMethodsArgs = {
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
};

export type OrderAddress = Node & {
  __typename: 'OrderAddress';
  address: Maybe<Scalars['NonEmptyString']['output']>;
  businessIdentityCode: Maybe<Scalars['NonEmptyString']['output']>;
  city: Maybe<Scalars['NonEmptyString']['output']>;
  companyName: Maybe<Scalars['NonEmptyString']['output']>;
  countryCode: Scalars['CountryCode']['output'];
  createdAt: Scalars['DateTime']['output'];
  firstName: Maybe<Scalars['NonEmptyString']['output']>;
  id: Scalars['ID']['output'];
  lastName: Maybe<Scalars['NonEmptyString']['output']>;
  phone: Maybe<Scalars['PhoneNumber']['output']>;
  postalCode: Scalars['PostalCode']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderAddressCreateInput = {
  address?: InputMaybe<Scalars['NonEmptyString']['input']>;
  businessIdentityCode?: InputMaybe<Scalars['NonEmptyString']['input']>;
  city?: InputMaybe<Scalars['NonEmptyString']['input']>;
  companyName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  firstName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  lastName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  postalCode: Scalars['PostalCode']['input'];
};

export type OrderAddressCreatePayload = {
  __typename: 'OrderAddressCreatePayload';
  orderAddress: OrderAddress;
};

export type OrderAddressCreateUnion = EntityNotFoundError | OrderAddressCreatePayload;

export type OrderAddressUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type OrderAddressUpdateInput = {
  address?: InputMaybe<Scalars['NonEmptyString']['input']>;
  businessIdentityCode?: InputMaybe<Scalars['NonEmptyString']['input']>;
  city?: InputMaybe<Scalars['NonEmptyString']['input']>;
  companyName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  firstName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  lastName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
};

export type OrderAddressUpdatePayload = {
  __typename: 'OrderAddressUpdatePayload';
  order: Maybe<Order>;
  orderAddress: OrderAddress;
};

export type OrderAddressUpdateUnion = EntityNotFoundError | OrderAddressUpdatePayload;

export enum OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrderCancelPayload = {
  __typename: 'OrderCancelPayload';
  order: Order;
};

export type OrderCancelUnion = EntityNotFoundError | OrderCancelPayload;

export type OrderCompletePayload = {
  __typename: 'OrderCompletePayload';
  order: Order;
};

export type OrderCompleteUnion = EntityNotFoundError | InvalidInputError | OrderCompletePayload;

export type OrderCreatePayload = {
  __typename: 'OrderCreatePayload';
  order: Order;
};

export type OrderCreateUnion = InvalidInputError | OrderCreatePayload;

export enum OrderCustomerType {
  Company = 'COMPANY',
  Private = 'PRIVATE'
}

export type OrderData = {
  __typename: 'OrderData';
  key: Scalars['NonEmptyString']['output'];
  value: Maybe<Scalars['NonEmptyString']['output']>;
};

export type OrderDataInput = {
  key: Scalars['NonEmptyString']['input'];
  value?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type OrderDeletePayload = {
  __typename: 'OrderDeletePayload';
  order: Order;
};

export type OrderDeleteUnion = EntityNotFoundError | OrderDeletePayload;

export enum OrderDeliveryEstimate {
  Between_1To_2Days = 'BETWEEN_1_TO_2_DAYS',
  Between_1To_2Weeks = 'BETWEEN_1_TO_2_WEEKS',
  Between_3To_5Weeks = 'BETWEEN_3_TO_5_WEEKS',
  Between_3To_8Days = 'BETWEEN_3_TO_8_DAYS',
  Between_6To_8Weeks = 'BETWEEN_6_TO_8_WEEKS',
  Between_9To_12Weeks = 'BETWEEN_9_TO_12_WEEKS',
  Immediate = 'IMMEDIATE',
  Over_12Weeks = 'OVER_12_WEEKS'
}

export type OrderEvent = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  orderState: OrderState;
  type: OrderEventType;
  updatedAt: Scalars['DateTime']['output'];
  user: Maybe<User>;
};

export enum OrderEventOrderByField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT'
}

export type OrderEventOrderByInput = {
  direction: OrderByDirection;
  field: OrderEventOrderByField;
};

export enum OrderEventType {
  HandlerCleared = 'HANDLER_CLEARED',
  HandlerSet = 'HANDLER_SET',
  NotificationSent = 'NOTIFICATION_SENT',
  OrderCanceled = 'ORDER_CANCELED',
  OrderCreated = 'ORDER_CREATED',
  OrderFinalized = 'ORDER_FINALIZED',
  OrderProcessed = 'ORDER_PROCESSED',
  OrderReceived = 'ORDER_RECEIVED',
  OrderTimedOut = 'ORDER_TIMED_OUT',
  PaymentCanceled = 'PAYMENT_CANCELED',
  PaymentCompleted = 'PAYMENT_COMPLETED',
  PaymentCompleteCalled = 'PAYMENT_COMPLETE_CALLED',
  PaymentCreated = 'PAYMENT_CREATED',
  PaymentNotified = 'PAYMENT_NOTIFIED',
  PaymentProcessing = 'PAYMENT_PROCESSING',
  PaymentRefunded = 'PAYMENT_REFUNDED',
  PaymentRejected = 'PAYMENT_REJECTED'
}

export type OrderEventWhereInput = {
  orderId: Scalars['ID']['input'];
};

export type OrderEventsConnection = {
  __typename: 'OrderEventsConnection';
  edges: Array<OrderEventsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type OrderEventsEdge = {
  __typename: 'OrderEventsEdge';
  cursor: Scalars['String']['output'];
  node: OrderEvent;
};

export type OrderFinalizePayload = {
  __typename: 'OrderFinalizePayload';
  order: Order;
};

export type OrderFinalizeUnion = EntityNotFoundError | InvalidInputError | OrderFinalizePayload;

export type OrderHandlerEvent = Node & OrderEvent & {
  __typename: 'OrderHandlerEvent';
  createdAt: Scalars['DateTime']['output'];
  handler: Maybe<User>;
  id: Scalars['ID']['output'];
  orderState: OrderState;
  type: OrderEventType;
  updatedAt: Scalars['DateTime']['output'];
  user: Maybe<User>;
};

export type OrderNotificationEvent = Node & OrderEvent & {
  __typename: 'OrderNotificationEvent';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  notificationTemplate: NotificationTemplate;
  orderState: OrderState;
  type: OrderEventType;
  updatedAt: Scalars['DateTime']['output'];
  user: Maybe<User>;
};

export enum OrderOrderByField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type OrderOrderByInput = {
  direction: OrderByDirection;
  field: OrderOrderByField;
};

export type OrderPayment = Node & {
  __typename: 'OrderPayment';
  createdAt: Scalars['DateTime']['output'];
  fingerprint: Scalars['UUID']['output'];
  id: Scalars['ID']['output'];
  paymentMethod: PaymentMethod;
  state: OrderPaymentState;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderPaymentAvarda = {
  __typename: 'OrderPaymentAvarda';
  purchaseId: Scalars['NonEmptyString']['output'];
  token: Scalars['NonEmptyString']['output'];
};

export type OrderPaymentAvardaEstonia = {
  __typename: 'OrderPaymentAvardaEstonia';
  purchaseId: Scalars['NonEmptyString']['output'];
  redirectUrl: Scalars['URL']['output'];
};

export type OrderPaymentCancelPayload = {
  __typename: 'OrderPaymentCancelPayload';
  order: Order;
  orderPayment: OrderPayment;
};

export type OrderPaymentCancelUnion = EntityNotFoundError | OrderPaymentCancelPayload;

export type OrderPaymentCompletePayload = {
  __typename: 'OrderPaymentCompletePayload';
  order: Order;
  orderPayment: OrderPayment;
  paymentStatus: OrderPaymentVerificationStatus;
};

export type OrderPaymentCompleteUnion = EntityNotFoundError | OrderPaymentCompletePayload;

export type OrderPaymentCreateInput = {
  orderId: Scalars['ID']['input'];
};

export type OrderPaymentCreatePayload = {
  __typename: 'OrderPaymentCreatePayload';
  order: Order;
  orderPayment: OrderPayment;
};

export type OrderPaymentCreateUnion = EntityNotFoundError | InvalidInputError | OrderPaymentCreatePayload;

export type OrderPaymentData = Node & {
  __typename: 'OrderPaymentData';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['NonEmptyString']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Maybe<Scalars['NonEmptyString']['output']>;
};

export type OrderPaymentEsto = {
  __typename: 'OrderPaymentEsto';
  redirectUrl: Scalars['URL']['output'];
};

export type OrderPaymentEvent = Node & OrderEvent & {
  __typename: 'OrderPaymentEvent';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  orderPayment: OrderPayment;
  orderState: OrderState;
  type: OrderEventType;
  updatedAt: Scalars['DateTime']['output'];
  user: Maybe<User>;
};

export type OrderPaymentExecuteInput = {
  cancelUrl: Scalars['NonEmptyString']['input'];
  locale?: InputMaybe<OrderPaymentLocale>;
  notifyUrl: Scalars['NonEmptyString']['input'];
  successUrl: Scalars['NonEmptyString']['input'];
};

export type OrderPaymentExecutePayload = {
  __typename: 'OrderPaymentExecutePayload';
  order: Order;
  orderPayment: OrderPayment;
  paymentAction: OrderPaymentExecutionUnion;
};

export type OrderPaymentExecuteUnion = EntityNotFoundError | OrderPaymentExecutePayload;

export type OrderPaymentExecutionUnion = OrderPaymentAvarda | OrderPaymentAvardaEstonia | OrderPaymentEsto | OrderPaymentHolmbank | OrderPaymentInbank | OrderPaymentMaksekeskus | OrderPaymentMontonio | OrderPaymentPaytrail | OrderPaymentPaywerk;

export type OrderPaymentExternalIdWhereInput = {
  id: Scalars['String']['input'];
  provider: PaymentMethodType;
};

export type OrderPaymentFingerprintWhereInput = {
  fingerprint: Scalars['UUID']['input'];
};

export type OrderPaymentHolmbank = {
  __typename: 'OrderPaymentHolmbank';
  redirectUrl: Scalars['URL']['output'];
};

export type OrderPaymentInbank = {
  __typename: 'OrderPaymentInbank';
  purchaseId: Scalars['NonEmptyString']['output'];
  redirectUrl: Scalars['URL']['output'];
};

export type OrderPaymentInfo = {
  data: Array<OrderData>;
  method: PaymentMethod;
};

export type OrderPaymentInfoAvarda = OrderPaymentInfo & {
  __typename: 'OrderPaymentInfoAvarda';
  data: Array<OrderData>;
  method: PaymentMethod;
  paymentType: Maybe<AvardaPaymentMethodType>;
};

export type OrderPaymentInfoAvardaEstonia = OrderPaymentInfo & {
  __typename: 'OrderPaymentInfoAvardaEstonia';
  data: Array<OrderData>;
  method: PaymentMethod;
};

export type OrderPaymentInfoEsto = OrderPaymentInfo & {
  __typename: 'OrderPaymentInfoEsto';
  data: Array<OrderData>;
  method: PaymentMethod;
};

export type OrderPaymentInfoInbank = OrderPaymentInfo & {
  __typename: 'OrderPaymentInfoInbank';
  data: Array<OrderData>;
  method: PaymentMethod;
};

export type OrderPaymentInfoMaksekeskus = OrderPaymentInfo & {
  __typename: 'OrderPaymentInfoMaksekeskus';
  data: Array<OrderData>;
  method: PaymentMethod;
};

export type OrderPaymentInfoMontonio = OrderPaymentInfo & {
  __typename: 'OrderPaymentInfoMontonio';
  data: Array<OrderData>;
  method: PaymentMethod;
};

export type OrderPaymentInfoPaytrail = OrderPaymentInfo & {
  __typename: 'OrderPaymentInfoPaytrail';
  data: Array<OrderData>;
  method: PaymentMethod;
};

export type OrderPaymentInfoPaywerk = OrderPaymentInfo & {
  __typename: 'OrderPaymentInfoPaywerk';
  data: Array<OrderData>;
  method: PaymentMethod;
};

export enum OrderPaymentLocale {
  Ee = 'EE',
  En = 'EN',
  Fi = 'FI',
  Sv = 'SV'
}

export type OrderPaymentMaksekeskus = {
  __typename: 'OrderPaymentMaksekeskus';
  redirectUrl: Scalars['URL']['output'];
};

export type OrderPaymentMontonio = {
  __typename: 'OrderPaymentMontonio';
  redirectUrl: Scalars['URL']['output'];
};

export type OrderPaymentNotifyPayload = {
  __typename: 'OrderPaymentNotifyPayload';
  order: Order;
  orderPayment: OrderPayment;
};

export type OrderPaymentNotifyUnion = EntityNotFoundError | OrderPaymentNotifyPayload;

export type OrderPaymentPaytrail = {
  __typename: 'OrderPaymentPaytrail';
  fields: Array<OrderPaymentPaytrailFormField>;
  formActionUrl: Scalars['URL']['output'];
};

export type OrderPaymentPaytrailFormField = {
  __typename: 'OrderPaymentPaytrailFormField';
  key: Scalars['NonEmptyString']['output'];
  value: Maybe<Scalars['NonEmptyString']['output']>;
};

export type OrderPaymentPaywerk = {
  __typename: 'OrderPaymentPaywerk';
  paywerkId: Scalars['NonEmptyString']['output'];
};

export type OrderPaymentResponseDataInput = {
  key: Scalars['NonEmptyString']['input'];
  value?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type OrderPaymentResultUnion = EntityNotFoundError | OrderPayment;

export type OrderPaymentReturnResponseInput = {
  response?: InputMaybe<Array<OrderPaymentResponseDataInput>>;
};

export enum OrderPaymentState {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED',
  Rejected = 'REJECTED'
}

export type OrderPaymentUniqueWhereInputWithFingerprint = {
  externalId?: InputMaybe<OrderPaymentExternalIdWhereInput>;
  fingerprint?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type OrderPaymentUpdateInput = {
  state: OrderPaymentState;
};

export type OrderPaymentUpdatePayload = {
  __typename: 'OrderPaymentUpdatePayload';
  order: Order;
  orderPayment: OrderPayment;
};

export type OrderPaymentUpdateUnion = EntityNotFoundError | OrderPaymentUpdatePayload;

export enum OrderPaymentVerificationStatus {
  CheckError = 'CHECK_ERROR',
  Error = 'ERROR',
  Ok = 'OK',
  Pending = 'PENDING'
}

export type OrderProduct = Node & {
  __typename: 'OrderProduct';
  createdAt: Scalars['DateTime']['output'];
  discounts: Array<OrderProductDiscount>;
  id: Scalars['ID']['output'];
  order: Order;
  originalPrice: Money;
  originalUnitPrice: Money;
  price: Money;
  product: SimpleProduct;
  promotions: Array<Promotion>;
  quantity: Scalars['PositiveInt']['output'];
  taxRate: Scalars['PositiveFloat']['output'];
  unitPrice: Money;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderProductDiscount = Node & {
  __typename: 'OrderProductDiscount';
  amount: Money;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  promotion: Promotion;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderProductProperty = Node & {
  __typename: 'OrderProductProperty';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderReceivePayload = {
  __typename: 'OrderReceivePayload';
  order: Order;
};

export type OrderReceiveUnion = EntityNotFoundError | InvalidInputError | OrderReceivePayload;

export type OrderResultUnion = EntityNotFoundError | Order;

export type OrderShippingInfo = {
  data: Array<OrderData>;
  method: ShippingMethod;
  originalPrice: Maybe<Money>;
  price: Maybe<Money>;
  taxRate: Maybe<Scalars['PositiveFloat']['output']>;
};

export type OrderShippingInfoEmail = OrderShippingInfo & {
  __typename: 'OrderShippingInfoEmail';
  data: Array<OrderData>;
  method: ShippingMethod;
  originalPrice: Maybe<Money>;
  price: Maybe<Money>;
  taxRate: Maybe<Scalars['PositiveFloat']['output']>;
};

export type OrderShippingInfoHakonen = OrderShippingInfo & {
  __typename: 'OrderShippingInfoHakonen';
  data: Array<OrderData>;
  method: ShippingMethod;
  originalPrice: Maybe<Money>;
  price: Maybe<Money>;
  taxRate: Maybe<Scalars['PositiveFloat']['output']>;
};

export type OrderShippingInfoLocalDelivery = OrderShippingInfo & {
  __typename: 'OrderShippingInfoLocalDelivery';
  data: Array<OrderData>;
  method: ShippingMethod;
  originalPrice: Maybe<Money>;
  price: Maybe<Money>;
  taxRate: Maybe<Scalars['PositiveFloat']['output']>;
};

export type OrderShippingInfoMatkahuolto = OrderShippingInfo & {
  __typename: 'OrderShippingInfoMatkahuolto';
  data: Array<OrderData>;
  method: ShippingMethod;
  office: Maybe<ShippingMethodMatkahuoltoOffice>;
  originalPrice: Maybe<Money>;
  price: Maybe<Money>;
  taxRate: Maybe<Scalars['PositiveFloat']['output']>;
};

export type OrderShippingInfoOmniva = OrderShippingInfo & {
  __typename: 'OrderShippingInfoOmniva';
  data: Array<OrderData>;
  method: ShippingMethod;
  originalPrice: Maybe<Money>;
  pickupPointCode: Maybe<Scalars['NonEmptyString']['output']>;
  price: Maybe<Money>;
  taxRate: Maybe<Scalars['PositiveFloat']['output']>;
};

export type OrderShippingInfoPickUpFromStore = OrderShippingInfo & {
  __typename: 'OrderShippingInfoPickUpFromStore';
  data: Array<OrderData>;
  method: ShippingMethod;
  originalPrice: Maybe<Money>;
  outlet: Maybe<Outlet>;
  price: Maybe<Money>;
  taxRate: Maybe<Scalars['PositiveFloat']['output']>;
};

export type OrderShippingInfoPosti = OrderShippingInfo & {
  __typename: 'OrderShippingInfoPosti';
  data: Array<OrderData>;
  method: ShippingMethod;
  originalPrice: Maybe<Money>;
  price: Maybe<Money>;
  taxRate: Maybe<Scalars['PositiveFloat']['output']>;
};

export enum OrderState {
  Aborted = 'ABORTED',
  Canceled = 'CANCELED',
  Draft = 'DRAFT',
  PaymentPending = 'PAYMENT_PENDING',
  Processed = 'PROCESSED',
  Received = 'RECEIVED'
}

export type OrderStateEvent = Node & OrderEvent & {
  __typename: 'OrderStateEvent';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  orderState: OrderState;
  type: OrderEventType;
  updatedAt: Scalars['DateTime']['output'];
  user: Maybe<User>;
};

export type OrderStatistics = {
  __typename: 'OrderStatistics';
  date: Scalars['Date']['output'];
  totalAmount: Money;
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type OrderStatisticsRangeInput = {
  from: Scalars['Date']['input'];
  interval: OrderStatisticsRangeInterval;
  to: Scalars['Date']['input'];
};

export enum OrderStatisticsRangeInterval {
  Day = 'DAY',
  Month = 'MONTH'
}

export type OrderTaxLine = {
  __typename: 'OrderTaxLine';
  amount: Money;
  rate: Scalars['PositiveFloat']['output'];
  taxClass: TaxClass;
};

export type OrderUndoFinalizePayload = {
  __typename: 'OrderUndoFinalizePayload';
  order: Order;
};

export type OrderUndoFinalizeUnion = EntityNotFoundError | InvalidInputError | OrderUndoFinalizePayload;

export type OrderUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type OrderUpdateInput = {
  deliveryEstimate?: InputMaybe<OrderDeliveryEstimate>;
  deliveryInfo?: InputMaybe<Scalars['NonEmptyString']['input']>;
  saleNumber?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type OrderUpdatePayload = {
  __typename: 'OrderUpdatePayload';
  order: Order;
};

export type OrderUpdateUnion = EntityNotFoundError | OrderUpdatePayload;

export type OrderWhereInput = {
  AND?: InputMaybe<Array<OrderWhereSubInput>>;
  OR?: InputMaybe<Array<OrderWhereSubInput>>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  customerType?: InputMaybe<OrderCustomerType>;
  handlerId?: InputMaybe<Scalars['ID']['input']>;
  hasHandler?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  shippingMethodId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<OrderState>;
};

export type OrderWhereSubInput = {
  AND?: InputMaybe<Array<OrderWhereSubInput>>;
  OR?: InputMaybe<Array<OrderWhereSubInput>>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  handlerId?: InputMaybe<Scalars['ID']['input']>;
  hasHandler?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  shippingMethodId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<OrderState>;
};

export type OrdersConnection = {
  __typename: 'OrdersConnection';
  edges: Array<OrdersEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type OrdersEdge = {
  __typename: 'OrdersEdge';
  cursor: Scalars['String']['output'];
  node: Order;
};

export type Outlet = Node & {
  __typename: 'Outlet';
  address: Scalars['NonEmptyString']['output'];
  city: Scalars['NonEmptyString']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  location: Maybe<Scalars['Point']['output']>;
  number: Maybe<Scalars['NonNegativeInt']['output']>;
  pickupAvailable: Scalars['Boolean']['output'];
  pickupInstructions: Maybe<Scalars['NonEmptyString']['output']>;
  postalCode: Scalars['PostalCode']['output'];
  state: OutletState;
  title: Scalars['NonEmptyString']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OutletCreateInput = {
  address: Scalars['NonEmptyString']['input'];
  city: Scalars['NonEmptyString']['input'];
  location?: InputMaybe<Scalars['Point']['input']>;
  number?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pickupAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  pickupInstructions?: InputMaybe<Scalars['NonEmptyString']['input']>;
  postalCode: Scalars['PostalCode']['input'];
  state?: InputMaybe<OutletState>;
  title: Scalars['NonEmptyString']['input'];
};

export type OutletCreatePayload = {
  __typename: 'OutletCreatePayload';
  outlet: Outlet;
};

export type OutletCreateUnion = InvalidInputError | OutletCreatePayload;

export type OutletDeletePayload = {
  __typename: 'OutletDeletePayload';
  outlet: Outlet;
};

export type OutletDeleteUnion = EntityNotFoundError | OutletDeletePayload;

export enum OutletOrderByField {
  CreatedAt = 'CREATED_AT',
  Number = 'NUMBER',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type OutletOrderByInput = {
  direction: OrderByDirection;
  field: OutletOrderByField;
};

export type OutletResultUnion = EntityNotFoundError | Outlet;

export enum OutletState {
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED'
}

export type OutletUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type OutletUpdateInput = {
  address?: InputMaybe<Scalars['NonEmptyString']['input']>;
  city?: InputMaybe<Scalars['NonEmptyString']['input']>;
  location?: InputMaybe<Scalars['Point']['input']>;
  number?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pickupAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  pickupInstructions?: InputMaybe<Scalars['NonEmptyString']['input']>;
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
  state?: InputMaybe<OutletState>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type OutletUpdatePayload = {
  __typename: 'OutletUpdatePayload';
  outlet: Outlet;
};

export type OutletUpdateUnion = EntityNotFoundError | OutletUpdatePayload;

export type OutletWhereInput = {
  AND?: InputMaybe<Array<OutletWhereSubInput>>;
  OR?: InputMaybe<Array<OutletWhereSubInput>>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type OutletWhereSubInput = {
  AND?: InputMaybe<Array<OutletWhereSubInput>>;
  OR?: InputMaybe<Array<OutletWhereSubInput>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type OutletsConnection = {
  __typename: 'OutletsConnection';
  edges: Array<OutletsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type OutletsEdge = {
  __typename: 'OutletsEdge';
  cursor: Scalars['String']['output'];
  node: Outlet;
};

export type PageInfo = {
  __typename: 'PageInfo';
  endCursor: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Maybe<Scalars['String']['output']>;
};

export type PaymentMethod = {
  createdAt: Scalars['DateTime']['output'];
  data: Array<PaymentMethodData>;
  description: Maybe<Scalars['NonEmptyString']['output']>;
  environment: PaymentMethodEnvironment;
  group: Maybe<PaymentMethodGroup>;
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['URL']['output']>;
  position: Scalars['NonNegativeInt']['output'];
  ruleset: Maybe<Ruleset>;
  state: PaymentMethodState;
  title: Scalars['NonEmptyString']['output'];
  type: PaymentMethodType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentMethodAvarda = Node & PaymentMethod & {
  __typename: 'PaymentMethodAvarda';
  createdAt: Scalars['DateTime']['output'];
  data: Array<PaymentMethodData>;
  description: Maybe<Scalars['NonEmptyString']['output']>;
  environment: PaymentMethodEnvironment;
  group: Maybe<PaymentMethodGroup>;
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['URL']['output']>;
  paymentType: AvardaPaymentMethodType;
  position: Scalars['NonNegativeInt']['output'];
  ruleset: Maybe<Ruleset>;
  state: PaymentMethodState;
  title: Scalars['NonEmptyString']['output'];
  type: PaymentMethodType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentMethodAvardaEstonia = Node & PaymentMethod & {
  __typename: 'PaymentMethodAvardaEstonia';
  createdAt: Scalars['DateTime']['output'];
  data: Array<PaymentMethodData>;
  description: Maybe<Scalars['NonEmptyString']['output']>;
  environment: PaymentMethodEnvironment;
  group: Maybe<PaymentMethodGroup>;
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['URL']['output']>;
  position: Scalars['NonNegativeInt']['output'];
  ruleset: Maybe<Ruleset>;
  state: PaymentMethodState;
  title: Scalars['NonEmptyString']['output'];
  type: PaymentMethodType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentMethodCreateInput = {
  data?: InputMaybe<Array<PaymentMethodDataInput>>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  environment?: InputMaybe<PaymentMethodEnvironment>;
  logo?: InputMaybe<Scalars['NonEmptyString']['input']>;
  position?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  state?: InputMaybe<PaymentMethodState>;
  title: Scalars['NonEmptyString']['input'];
  type: PaymentMethodType;
};

export type PaymentMethodCreatePayload = {
  __typename: 'PaymentMethodCreatePayload';
  paymentMethod: PaymentMethod;
};

export type PaymentMethodCreateUnion = InvalidInputError | PaymentMethodCreatePayload;

export type PaymentMethodData = Node & {
  __typename: 'PaymentMethodData';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['NonEmptyString']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Maybe<Scalars['NonEmptyString']['output']>;
};

export type PaymentMethodDataInput = {
  key: Scalars['NonEmptyString']['input'];
  value?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type PaymentMethodDeletePayload = {
  __typename: 'PaymentMethodDeletePayload';
  paymentMethod: PaymentMethod;
};

export type PaymentMethodDeleteUnion = EntityNotFoundError | PaymentMethodDeletePayload;

export enum PaymentMethodEnvironment {
  Production = 'PRODUCTION',
  Testing = 'TESTING'
}

export type PaymentMethodEsto = Node & PaymentMethod & {
  __typename: 'PaymentMethodEsto';
  createdAt: Scalars['DateTime']['output'];
  data: Array<PaymentMethodData>;
  description: Maybe<Scalars['NonEmptyString']['output']>;
  environment: PaymentMethodEnvironment;
  group: Maybe<PaymentMethodGroup>;
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['URL']['output']>;
  position: Scalars['NonNegativeInt']['output'];
  ruleset: Maybe<Ruleset>;
  state: PaymentMethodState;
  title: Scalars['NonEmptyString']['output'];
  type: PaymentMethodType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentMethodGroup = Node & {
  __typename: 'PaymentMethodGroup';
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  id: Scalars['ID']['output'];
  paymentMethods: Array<PaymentMethod>;
  position: Scalars['NonNegativeInt']['output'];
  title: Scalars['NonEmptyString']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentMethodGroupAddPaymentMethodsPayload = {
  __typename: 'PaymentMethodGroupAddPaymentMethodsPayload';
  paymentMethodGroup: PaymentMethodGroup;
  paymentMethods: Array<PaymentMethod>;
};

export type PaymentMethodGroupAddPaymentMethodsUnion = EntityNotFoundError | PaymentMethodGroupAddPaymentMethodsPayload;

export type PaymentMethodGroupCreateInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title: Scalars['NonEmptyString']['input'];
};

export type PaymentMethodGroupCreatePayload = {
  __typename: 'PaymentMethodGroupCreatePayload';
  paymentMethodGroup: PaymentMethodGroup;
};

export type PaymentMethodGroupCreateUnion = InvalidInputError | PaymentMethodGroupCreatePayload;

export type PaymentMethodGroupDeletePayload = {
  __typename: 'PaymentMethodGroupDeletePayload';
  paymentMethodGroup: PaymentMethodGroup;
};

export type PaymentMethodGroupDeleteUnion = EntityNotFoundError | PaymentMethodGroupDeletePayload;

export enum PaymentMethodGroupOrderByField {
  CreatedAt = 'CREATED_AT',
  Position = 'POSITION',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type PaymentMethodGroupOrderByInput = {
  direction: OrderByDirection;
  field: PaymentMethodGroupOrderByField;
};

export type PaymentMethodGroupRemovePaymentMethodsPayload = {
  __typename: 'PaymentMethodGroupRemovePaymentMethodsPayload';
  paymentMethodGroup: PaymentMethodGroup;
  paymentMethods: Array<PaymentMethod>;
};

export type PaymentMethodGroupRemovePaymentMethodsUnion = EntityNotFoundError | PaymentMethodGroupRemovePaymentMethodsPayload;

export type PaymentMethodGroupReorderPayload = {
  __typename: 'PaymentMethodGroupReorderPayload';
  paymentMethodGroups: Array<PaymentMethodGroup>;
};

export type PaymentMethodGroupReorderPaymentMethodsPayload = {
  __typename: 'PaymentMethodGroupReorderPaymentMethodsPayload';
  paymentMethodGroup: PaymentMethodGroup;
};

export type PaymentMethodGroupReorderPaymentMethodsUnion = EntityNotFoundError | PaymentMethodGroupReorderPaymentMethodsPayload;

export type PaymentMethodGroupReorderUnion = InvalidInputError | PaymentMethodGroupReorderPayload;

export type PaymentMethodGroupResultUnion = EntityNotFoundError | PaymentMethodGroup;

export type PaymentMethodGroupUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type PaymentMethodGroupUpdateInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type PaymentMethodGroupUpdatePayload = {
  __typename: 'PaymentMethodGroupUpdatePayload';
  paymentMethodGroup: PaymentMethodGroup;
};

export type PaymentMethodGroupUpdateUnion = EntityNotFoundError | PaymentMethodGroupUpdatePayload;

export type PaymentMethodGroupWhereInput = {
  AND?: InputMaybe<Array<PaymentMethodGroupWhereSubInput>>;
  OR?: InputMaybe<Array<PaymentMethodGroupWhereSubInput>>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type PaymentMethodGroupWhereSubInput = {
  AND?: InputMaybe<Array<PaymentMethodGroupWhereSubInput>>;
  OR?: InputMaybe<Array<PaymentMethodGroupWhereSubInput>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type PaymentMethodGroupsConnection = {
  __typename: 'PaymentMethodGroupsConnection';
  edges: Array<PaymentMethodGroupsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type PaymentMethodGroupsEdge = {
  __typename: 'PaymentMethodGroupsEdge';
  cursor: Scalars['String']['output'];
  node: PaymentMethodGroup;
};

export type PaymentMethodHolmbank = Node & PaymentMethod & {
  __typename: 'PaymentMethodHolmbank';
  createdAt: Scalars['DateTime']['output'];
  data: Array<PaymentMethodData>;
  description: Maybe<Scalars['NonEmptyString']['output']>;
  environment: PaymentMethodEnvironment;
  group: Maybe<PaymentMethodGroup>;
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['URL']['output']>;
  position: Scalars['NonNegativeInt']['output'];
  ruleset: Maybe<Ruleset>;
  state: PaymentMethodState;
  title: Scalars['NonEmptyString']['output'];
  type: PaymentMethodType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentMethodInbank = Node & PaymentMethod & {
  __typename: 'PaymentMethodInbank';
  createdAt: Scalars['DateTime']['output'];
  data: Array<PaymentMethodData>;
  description: Maybe<Scalars['NonEmptyString']['output']>;
  environment: PaymentMethodEnvironment;
  group: Maybe<PaymentMethodGroup>;
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['URL']['output']>;
  position: Scalars['NonNegativeInt']['output'];
  ruleset: Maybe<Ruleset>;
  state: PaymentMethodState;
  title: Scalars['NonEmptyString']['output'];
  type: PaymentMethodType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentMethodMaksekeskus = Node & PaymentMethod & {
  __typename: 'PaymentMethodMaksekeskus';
  createdAt: Scalars['DateTime']['output'];
  data: Array<PaymentMethodData>;
  description: Maybe<Scalars['NonEmptyString']['output']>;
  environment: PaymentMethodEnvironment;
  group: Maybe<PaymentMethodGroup>;
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['URL']['output']>;
  position: Scalars['NonNegativeInt']['output'];
  providers: Array<PaymentMethodMaksekeskusProvider>;
  ruleset: Maybe<Ruleset>;
  state: PaymentMethodState;
  title: Scalars['NonEmptyString']['output'];
  type: PaymentMethodType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentMethodMaksekeskusProvider = {
  __typename: 'PaymentMethodMaksekeskusProvider';
  id: Scalars['NonEmptyString']['output'];
  name: Scalars['NonEmptyString']['output'];
};

export type PaymentMethodMontonio = Node & PaymentMethod & {
  __typename: 'PaymentMethodMontonio';
  countries: Array<Scalars['CountryCode']['output']>;
  createdAt: Scalars['DateTime']['output'];
  data: Array<PaymentMethodData>;
  description: Maybe<Scalars['NonEmptyString']['output']>;
  environment: PaymentMethodEnvironment;
  group: Maybe<PaymentMethodGroup>;
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['URL']['output']>;
  position: Scalars['NonNegativeInt']['output'];
  providers: Array<PaymentMethodMontonioProvider>;
  ruleset: Maybe<Ruleset>;
  state: PaymentMethodState;
  title: Scalars['NonEmptyString']['output'];
  type: PaymentMethodType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentMethodMontonioProvider = {
  __typename: 'PaymentMethodMontonioProvider';
  id: Scalars['NonEmptyString']['output'];
  name: Scalars['NonEmptyString']['output'];
};

export enum PaymentMethodOrderByField {
  CreatedAt = 'CREATED_AT',
  Position = 'POSITION',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type PaymentMethodOrderByInput = {
  direction: OrderByDirection;
  field: PaymentMethodOrderByField;
};

export type PaymentMethodPaytrail = Node & PaymentMethod & {
  __typename: 'PaymentMethodPaytrail';
  createdAt: Scalars['DateTime']['output'];
  data: Array<PaymentMethodData>;
  description: Maybe<Scalars['NonEmptyString']['output']>;
  environment: PaymentMethodEnvironment;
  group: Maybe<PaymentMethodGroup>;
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['URL']['output']>;
  position: Scalars['NonNegativeInt']['output'];
  providers: Array<PaymentMethodPaytrailProvider>;
  ruleset: Maybe<Ruleset>;
  state: PaymentMethodState;
  title: Scalars['NonEmptyString']['output'];
  type: PaymentMethodType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentMethodPaytrailProvider = {
  __typename: 'PaymentMethodPaytrailProvider';
  id: Scalars['NonEmptyString']['output'];
  name: Scalars['NonEmptyString']['output'];
};

export type PaymentMethodPaywerk = Node & PaymentMethod & {
  __typename: 'PaymentMethodPaywerk';
  createdAt: Scalars['DateTime']['output'];
  data: Array<PaymentMethodData>;
  description: Maybe<Scalars['NonEmptyString']['output']>;
  environment: PaymentMethodEnvironment;
  group: Maybe<PaymentMethodGroup>;
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['URL']['output']>;
  position: Scalars['NonNegativeInt']['output'];
  ruleset: Maybe<Ruleset>;
  state: PaymentMethodState;
  title: Scalars['NonEmptyString']['output'];
  type: PaymentMethodType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentMethodReorderPayload = {
  __typename: 'PaymentMethodReorderPayload';
  paymentMethods: Array<PaymentMethod>;
};

export type PaymentMethodReorderUnion = InvalidInputError | PaymentMethodReorderPayload;

export type PaymentMethodResultUnion = EntityNotFoundError | PaymentMethodAvarda | PaymentMethodAvardaEstonia | PaymentMethodEsto | PaymentMethodHolmbank | PaymentMethodInbank | PaymentMethodMaksekeskus | PaymentMethodMontonio | PaymentMethodPaytrail | PaymentMethodPaywerk;

export enum PaymentMethodState {
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED'
}

export enum PaymentMethodType {
  Avarda = 'AVARDA',
  AvardaEstonia = 'AVARDA_ESTONIA',
  Esto = 'ESTO',
  Holmbank = 'HOLMBANK',
  Inbank = 'INBANK',
  Maksekeskus = 'MAKSEKESKUS',
  Montonio = 'MONTONIO',
  Paytrail = 'PAYTRAIL',
  Paywerk = 'PAYWERK'
}

export type PaymentMethodUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type PaymentMethodUpdateInput = {
  data?: InputMaybe<Array<PaymentMethodDataInput>>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  environment?: InputMaybe<PaymentMethodEnvironment>;
  logo?: InputMaybe<Scalars['NonEmptyString']['input']>;
  position?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  state?: InputMaybe<PaymentMethodState>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type PaymentMethodUpdatePayload = {
  __typename: 'PaymentMethodUpdatePayload';
  paymentMethod: PaymentMethod;
};

export type PaymentMethodUpdateUnion = EntityNotFoundError | PaymentMethodUpdatePayload;

export type PaymentMethodWhereInput = {
  AND?: InputMaybe<Array<PaymentMethodWhereSubInput>>;
  OR?: InputMaybe<Array<PaymentMethodWhereSubInput>>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type PaymentMethodWhereSubInput = {
  AND?: InputMaybe<Array<PaymentMethodWhereSubInput>>;
  OR?: InputMaybe<Array<PaymentMethodWhereSubInput>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type PaymentMethodsConnection = {
  __typename: 'PaymentMethodsConnection';
  edges: Array<PaymentMethodsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type PaymentMethodsEdge = {
  __typename: 'PaymentMethodsEdge';
  cursor: Scalars['String']['output'];
  node: PaymentMethod;
};

export type PriceType = Node & {
  __typename: 'PriceType';
  code: Scalars['NonEmptyString']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['NonEmptyString']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PriceTypeCreateInput = {
  code: Scalars['NonEmptyString']['input'];
  title: Scalars['NonEmptyString']['input'];
};

export type PriceTypeCreatePayload = {
  __typename: 'PriceTypeCreatePayload';
  priceType: PriceType;
};

export type PriceTypeCreateUnion = InvalidInputError | PriceTypeCreatePayload;

export type PriceTypeDeletePayload = {
  __typename: 'PriceTypeDeletePayload';
  priceType: PriceType;
};

export type PriceTypeDeleteUnion = EntityNotFoundError | PriceTypeDeletePayload;

export enum PriceTypeOrderByField {
  CreatedAt = 'CREATED_AT',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type PriceTypeOrderByInput = {
  direction: OrderByDirection;
  field: PriceTypeOrderByField;
};

export type PriceTypeResultUnion = EntityNotFoundError | PriceType;

export type PriceTypeUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type PriceTypeUpdateInput = {
  code?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type PriceTypeUpdatePayload = {
  __typename: 'PriceTypeUpdatePayload';
  priceType: PriceType;
};

export type PriceTypeUpdateUnion = EntityNotFoundError | PriceTypeUpdatePayload;

export type PriceTypeWhereInput = {
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type PriceTypesConnection = {
  __typename: 'PriceTypesConnection';
  edges: Array<PriceTypesEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type PriceTypesEdge = {
  __typename: 'PriceTypesEdge';
  cursor: Scalars['String']['output'];
  node: PriceType;
};

export type Product = {
  assets: Array<ProductAsset>;
  attributes: Array<ProductAttributeValue>;
  brand: Maybe<Brand>;
  brandLogo: Maybe<Scalars['String']['output']>;
  brandTitle: Maybe<Scalars['String']['output']>;
  cartRecommendations: Array<CartRecommendation>;
  categories: Array<Category>;
  collections: Array<ProductCollection>;
  configurationErrors: Array<ProductConfigurationErrorType>;
  createdAt: Scalars['DateTime']['output'];
  crossellProducts: ProductsConnection;
  description: Maybe<Scalars['NonEmptyString']['output']>;
  dimensions: ProductDimensions;
  disclaimers: Array<ProductDisclaimer>;
  fetchRelations: Array<ProductRelation>;
  group: ProductGroup;
  hasCustomName: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  internalIdentifier: Maybe<Scalars['NonEmptyString']['output']>;
  isGiftCard: Scalars['Boolean']['output'];
  listingImage: Maybe<ProductImage>;
  mainCategory: Maybe<Category>;
  matchRelations: Array<ProductRelation>;
  measurementImage: Maybe<ProductAsset>;
  medias: Array<ProductMedia>;
  name: Scalars['NonEmptyString']['output'];
  parcels: Array<ProductParcel>;
  productBadges: Array<ProductBadge>;
  productClass: Maybe<ProductClass>;
  properties: Array<ProductProperty>;
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  qaItems: Maybe<Array<QuestionAndAnswer>>;
  relatedProducts: ProductsConnection;
  seo: ProductSeo;
  shortDescription: Maybe<Scalars['NonEmptyString']['output']>;
  sku: Maybe<Scalars['NonEmptyString']['output']>;
  specification: Maybe<Scalars['NonEmptyString']['output']>;
  state: ProductState;
  title: Maybe<Scalars['NonEmptyString']['output']>;
  type: ProductType;
  updatedAt: Scalars['DateTime']['output'];
  upsellProducts: ProductsConnection;
};


export type ProductAttributesArgs = {
  attributeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  code?: InputMaybe<Scalars['NonEmptyString']['input']>;
  showInProductListing?: InputMaybe<Scalars['Boolean']['input']>;
  showInProductPage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductCrossellProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductDisclaimersArgs = {
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductRelatedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductUpsellProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductAddCategoriesPayload = {
  __typename: 'ProductAddCategoriesPayload';
  categories: Array<Category>;
  product: Product;
};

export type ProductAddCategoriesUnion = EntityNotFoundError | ProductAddCategoriesPayload;

export type ProductAsset = Node & {
  __typename: 'ProductAsset';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isMeasurement: Scalars['Boolean']['output'];
  position: Scalars['NonNegativeInt']['output'];
  title: Maybe<Scalars['NonEmptyString']['output']>;
  type: ProductAssetType;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['URL']['output'];
};

export type ProductAssetCreateInput = {
  position?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  productId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  url: Scalars['NonEmptyString']['input'];
};

export type ProductAssetCreatePayload = {
  __typename: 'ProductAssetCreatePayload';
  product: Product;
  productAsset: ProductAsset;
};

export type ProductAssetCreateUnion = InvalidInputError | ProductAssetCreatePayload;

export type ProductAssetDeletePayload = {
  __typename: 'ProductAssetDeletePayload';
  product: Product;
  productAsset: ProductAsset;
};

export type ProductAssetDeleteUnion = EntityNotFoundError | ProductAssetDeletePayload;

export enum ProductAssetOrderByField {
  CreatedAt = 'CREATED_AT',
  Position = 'POSITION',
  UpdatedAt = 'UPDATED_AT'
}

export type ProductAssetOrderByInput = {
  direction: OrderByDirection;
  field: ProductAssetOrderByField;
};

export type ProductAssetResultUnion = EntityNotFoundError | ProductAsset;

export enum ProductAssetType {
  File = 'FILE',
  Image = 'IMAGE',
  Pdf = 'PDF'
}

export type ProductAssetUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type ProductAssetUpdateInput = {
  position?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  url?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductAssetUpdatePayload = {
  __typename: 'ProductAssetUpdatePayload';
  product: Product;
  productAsset: ProductAsset;
};

export type ProductAssetUpdateUnion = EntityNotFoundError | ProductAssetUpdatePayload;

export type ProductAssetWhereInput = {
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductAssetsConnection = {
  __typename: 'ProductAssetsConnection';
  edges: Array<ProductAssetsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type ProductAssetsEdge = {
  __typename: 'ProductAssetsEdge';
  cursor: Scalars['String']['output'];
  node: ProductAsset;
};

export type ProductAttributeValue = {
  attribute: Attribute;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductAttributeValueFilterInput = {
  attributeId: Scalars['ID']['input'];
  between?: InputMaybe<ProductUpdateAttributeBetweenInput>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['PositiveFloat']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['PositiveFloat']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lessThan?: InputMaybe<Scalars['PositiveFloat']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['PositiveFloat']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notEquals?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProductBadge = Node & {
  __typename: 'ProductBadge';
  backgroundColor: Scalars['HexColorCode']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  icon: Maybe<ProductBadgeIcon>;
  id: Scalars['ID']['output'];
  listingTitle: Maybe<Scalars['NonEmptyString']['output']>;
  position: Maybe<ProductBadgePosition>;
  priority: Scalars['NonNegativeInt']['output'];
  ruleset: Maybe<Ruleset>;
  textColor: Scalars['HexColorCode']['output'];
  title: Scalars['NonEmptyString']['output'];
  transparentBackground: Scalars['Boolean']['output'];
  type: ProductBadgeType;
  updatedAt: Scalars['DateTime']['output'];
  url: Maybe<Scalars['URL']['output']>;
};

export type ProductBadgeConnection = {
  __typename: 'ProductBadgeConnection';
  edges: Array<ProductBadgeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type ProductBadgeCreateInput = {
  backgroundColor?: InputMaybe<Scalars['HexColorCode']['input']>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  icon?: InputMaybe<ProductBadgeIcon>;
  listingTitle?: InputMaybe<Scalars['NonEmptyString']['input']>;
  position?: InputMaybe<ProductBadgePosition>;
  priority?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  rulesetId?: InputMaybe<Scalars['ID']['input']>;
  textColor?: InputMaybe<Scalars['HexColorCode']['input']>;
  title: Scalars['NonEmptyString']['input'];
  transparentBackground?: InputMaybe<Scalars['Boolean']['input']>;
  type: ProductBadgeType;
  url?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductBadgeCreatePayload = {
  __typename: 'ProductBadgeCreatePayload';
  productBadge: ProductBadge;
};

export type ProductBadgeCreateUnion = InvalidInputError | ProductBadgeCreatePayload;

export type ProductBadgeDeletePayload = {
  __typename: 'ProductBadgeDeletePayload';
  productBadge: ProductBadge;
};

export type ProductBadgeDeleteUnion = EntityNotFoundError | ProductBadgeDeletePayload;

export type ProductBadgeDuplicatePayload = {
  __typename: 'ProductBadgeDuplicatePayload';
  productBadge: ProductBadge;
};

export type ProductBadgeDuplicateUnion = EntityNotFoundError | InvalidInputError | ProductBadgeDuplicatePayload;

export type ProductBadgeEdge = {
  __typename: 'ProductBadgeEdge';
  cursor: Scalars['String']['output'];
  node: ProductBadge;
};

export enum ProductBadgeIcon {
  GiftCard = 'GIFT_CARD',
  Inbank = 'INBANK',
  PercentAlt = 'PERCENT_ALT',
  PriceGuarantee = 'PRICE_GUARANTEE',
  QualityGuarantee = 'QUALITY_GUARANTEE',
  Shipping = 'SHIPPING',
  Shirt = 'SHIRT',
  ShoppingBag = 'SHOPPING_BAG',
  ShoppingCart = 'SHOPPING_CART',
  ShopSolidFull = 'SHOP_SOLID_FULL'
}

export enum ProductBadgeOrderByField {
  CreatedAt = 'CREATED_AT',
  Priority = 'PRIORITY',
  UpdatedAt = 'UPDATED_AT'
}

export type ProductBadgeOrderByInput = {
  direction: OrderByDirection;
  field: ProductBadgeOrderByField;
};

export enum ProductBadgePosition {
  BottomLeft = 'BOTTOM_LEFT',
  BottomRight = 'BOTTOM_RIGHT',
  TopLeft = 'TOP_LEFT',
  TopRight = 'TOP_RIGHT'
}

export type ProductBadgeResultUnion = EntityNotFoundError | ProductBadge;

export enum ProductBadgeType {
  Logo = 'LOGO',
  Text = 'TEXT'
}

export type ProductBadgeUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type ProductBadgeUpdateInput = {
  backgroundColor?: InputMaybe<Scalars['HexColorCode']['input']>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  icon?: InputMaybe<ProductBadgeIcon>;
  listingTitle?: InputMaybe<Scalars['NonEmptyString']['input']>;
  position?: InputMaybe<ProductBadgePosition>;
  priority?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  rulesetId?: InputMaybe<Scalars['ID']['input']>;
  textColor?: InputMaybe<Scalars['HexColorCode']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  transparentBackground?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ProductBadgeType>;
  url?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductBadgeUpdatePayload = {
  __typename: 'ProductBadgeUpdatePayload';
  productBadge: ProductBadge;
};

export type ProductBadgeUpdateUnion = EntityNotFoundError | ProductBadgeUpdatePayload;

export type ProductBadgeWhereInput = {
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductCart = {
  __typename: 'ProductCart';
  maxAmount: Maybe<Scalars['PositiveInt']['output']>;
  minAmount: Maybe<Scalars['PositiveInt']['output']>;
  multiplier: Maybe<Scalars['PositiveInt']['output']>;
};

export type ProductClass = Node & {
  __typename: 'ProductClass';
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  id: Scalars['ID']['output'];
  productCount: Scalars['NonNegativeInt']['output'];
  title: Scalars['NonEmptyString']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductClassCreateInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title: Scalars['NonEmptyString']['input'];
};

export type ProductClassCreatePayload = {
  __typename: 'ProductClassCreatePayload';
  productClass: ProductClass;
};

export type ProductClassCreateUnion = InvalidInputError | ProductClassCreatePayload;

export type ProductClassDeletePayload = {
  __typename: 'ProductClassDeletePayload';
  productClass: ProductClass;
};

export type ProductClassDeleteUnion = EntityNotFoundError | ProductClassDeletePayload;

export enum ProductClassOrderByField {
  CreatedAt = 'CREATED_AT',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type ProductClassOrderByInput = {
  direction: OrderByDirection;
  field: ProductClassOrderByField;
};

export type ProductClassResultUnion = EntityNotFoundError | ProductClass;

export type ProductClassUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type ProductClassUpdateInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductClassUpdatePayload = {
  __typename: 'ProductClassUpdatePayload';
  productClass: ProductClass;
};

export type ProductClassUpdateUnion = EntityNotFoundError | ProductClassUpdatePayload;

export type ProductClassWhereInput = {
  AND?: InputMaybe<Array<ProductClassWhereSubInput>>;
  OR?: InputMaybe<Array<ProductClassWhereSubInput>>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductClassWhereSubInput = {
  AND?: InputMaybe<Array<ProductClassWhereSubInput>>;
  OR?: InputMaybe<Array<ProductClassWhereSubInput>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductClassesConnection = {
  __typename: 'ProductClassesConnection';
  edges: Array<ProductClassesEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type ProductClassesEdge = {
  __typename: 'ProductClassesEdge';
  cursor: Scalars['String']['output'];
  node: ProductClass;
};

export type ProductClearStocksPayload = {
  __typename: 'ProductClearStocksPayload';
  message: Scalars['String']['output'];
};

export type ProductClearStocksUnion = EntityNotFoundError | ProductClearStocksPayload;

export type ProductCollection = Node & {
  __typename: 'ProductCollection';
  code: Maybe<Scalars['NonEmptyString']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  id: Scalars['ID']['output'];
  productCount: Scalars['NonNegativeInt']['output'];
  ruleset: Maybe<Ruleset>;
  title: Scalars['NonEmptyString']['output'];
  type: ProductCollectionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductCollectionAddProductsPayload = {
  __typename: 'ProductCollectionAddProductsPayload';
  productCollection: ProductCollection;
  products: Array<Product>;
};

export type ProductCollectionAddProductsUnion = EntityNotFoundError | ProductCollectionAddProductsPayload;

export type ProductCollectionCreateInput = {
  code?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  rulesetId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['NonEmptyString']['input'];
  type?: InputMaybe<ProductCollectionType>;
};

export type ProductCollectionCreatePayload = {
  __typename: 'ProductCollectionCreatePayload';
  productCollection: ProductCollection;
};

export type ProductCollectionCreateUnion = InvalidInputError | ProductCollectionCreatePayload;

export type ProductCollectionDeletePayload = {
  __typename: 'ProductCollectionDeletePayload';
  productCollection: ProductCollection;
};

export type ProductCollectionDeleteUnion = EntityNotFoundError | ProductCollectionDeletePayload;

export type ProductCollectionDuplicatePayload = {
  __typename: 'ProductCollectionDuplicatePayload';
  productCollection: ProductCollection;
};

export type ProductCollectionDuplicateUnion = EntityNotFoundError | InvalidInputError | ProductCollectionDuplicatePayload;

export enum ProductCollectionOrderByField {
  CreatedAt = 'CREATED_AT',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type ProductCollectionOrderByInput = {
  direction: OrderByDirection;
  field: ProductCollectionOrderByField;
};

export type ProductCollectionRemoveProductsPayload = {
  __typename: 'ProductCollectionRemoveProductsPayload';
  productCollection: ProductCollection;
  products: Array<Product>;
};

export type ProductCollectionRemoveProductsUnion = EntityNotFoundError | ProductCollectionRemoveProductsPayload;

export type ProductCollectionResultUnion = EntityNotFoundError | ProductCollection;

export enum ProductCollectionType {
  Dynamic = 'DYNAMIC',
  Static = 'STATIC'
}

export type ProductCollectionUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type ProductCollectionUpdateInput = {
  code?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  rulesetId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type?: InputMaybe<ProductCollectionType>;
};

export type ProductCollectionUpdatePayload = {
  __typename: 'ProductCollectionUpdatePayload';
  productCollection: ProductCollection;
};

export type ProductCollectionUpdateUnion = EntityNotFoundError | ProductCollectionUpdatePayload;

export type ProductCollectionWhereInput = {
  AND?: InputMaybe<Array<ProductCollectionWhereSubInput>>;
  OR?: InputMaybe<Array<ProductCollectionWhereSubInput>>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductCollectionWhereSubInput = {
  AND?: InputMaybe<Array<ProductCollectionWhereSubInput>>;
  OR?: InputMaybe<Array<ProductCollectionWhereSubInput>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductCollectionsConnection = {
  __typename: 'ProductCollectionsConnection';
  edges: Array<ProductCollectionsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type ProductCollectionsEdge = {
  __typename: 'ProductCollectionsEdge';
  cursor: Scalars['String']['output'];
  node: ProductCollection;
};

export type ProductColorValue = Node & ProductAttributeValue & {
  __typename: 'ProductColorValue';
  attribute: Attribute;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Maybe<Scalars['HexColorCode']['output']>;
};

export type ProductConfigurableAttribute = Node & {
  __typename: 'ProductConfigurableAttribute';
  attribute: Attribute;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  options: Array<ProductConfigurableAttributeOption>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductConfigurableAttributeOption = {
  __typename: 'ProductConfigurableAttributeOption';
  option: AttributeOption;
  products: Array<SimpleProduct>;
};

export type ProductConfiguration = {
  __typename: 'ProductConfiguration';
  attributes: Array<ProductConfigurableAttribute>;
  defaultProduct: Maybe<SimpleProduct>;
  products: Array<SimpleProduct>;
  productsConnection: ProductsConnection;
};


export type ProductConfigurationDefaultProductArgs = {
  compute?: Scalars['Boolean']['input'];
};


export type ProductConfigurationProductsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum ProductConfigurationErrorType {
  MissingDescription = 'MISSING_DESCRIPTION',
  MissingImage = 'MISSING_IMAGE',
  MissingShortDescription = 'MISSING_SHORT_DESCRIPTION',
  MissingVariant = 'MISSING_VARIANT'
}

export type ProductCreateInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  groupId: Scalars['ID']['input'];
  internalIdentifier?: InputMaybe<Scalars['NonEmptyString']['input']>;
  name?: InputMaybe<Scalars['NonEmptyString']['input']>;
  parcelsAreVisible?: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription?: InputMaybe<Scalars['NonEmptyString']['input']>;
  sku?: InputMaybe<Scalars['NonEmptyString']['input']>;
  specification: Scalars['NonEmptyString']['input'];
  state?: InputMaybe<ProductState>;
  taxClassId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['NonEmptyString']['input'];
  type: ProductType;
};

export type ProductCreatePayload = {
  __typename: 'ProductCreatePayload';
  product: Product;
};

export type ProductCreateUnion = InvalidInputError | ProductCreatePayload;

export type ProductDateValue = Node & ProductAttributeValue & {
  __typename: 'ProductDateValue';
  attribute: Attribute;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Maybe<Scalars['DateTime']['output']>;
};

export type ProductDeletePayload = {
  __typename: 'ProductDeletePayload';
  product: Product;
};

export type ProductDeleteUnion = EntityNotFoundError | ProductDeletePayload;

export type ProductDimensions = {
  __typename: 'ProductDimensions';
  assemblyTime: Maybe<Scalars['PositiveInt']['output']>;
  depth: Maybe<Scalars['PositiveInt']['output']>;
  diameter: Maybe<Scalars['PositiveInt']['output']>;
  height: Maybe<Scalars['PositiveInt']['output']>;
  volume: Maybe<Scalars['PositiveInt']['output']>;
  weight: Maybe<Scalars['PositiveFloat']['output']>;
  width: Maybe<Scalars['PositiveInt']['output']>;
};

export type ProductDisclaimer = Node & {
  __typename: 'ProductDisclaimer';
  backgroundColor: Maybe<Scalars['HexColorCode']['output']>;
  content: Maybe<Scalars['NonEmptyString']['output']>;
  contentTitle: Maybe<Scalars['NonEmptyString']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  id: Scalars['ID']['output'];
  link: Maybe<Scalars['NonEmptyString']['output']>;
  priority: Scalars['NonNegativeInt']['output'];
  publishedFrom: Maybe<Scalars['DateTime']['output']>;
  publishedTo: Maybe<Scalars['DateTime']['output']>;
  ruleset: Maybe<Ruleset>;
  state: ProductDisclaimerState;
  textColor: Maybe<Scalars['HexColorCode']['output']>;
  title: Scalars['NonEmptyString']['output'];
  titleColor: Maybe<Scalars['HexColorCode']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductDisclaimerCreateInput = {
  backgroundColor?: InputMaybe<Scalars['HexColorCode']['input']>;
  content?: InputMaybe<Scalars['NonEmptyString']['input']>;
  contentTitle?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  link?: InputMaybe<Scalars['NonEmptyString']['input']>;
  priority?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  publishedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  publishedTo?: InputMaybe<Scalars['DateTime']['input']>;
  rulesetId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<ProductDisclaimerState>;
  textColor?: InputMaybe<Scalars['HexColorCode']['input']>;
  title: Scalars['NonEmptyString']['input'];
  titleColor?: InputMaybe<Scalars['HexColorCode']['input']>;
};

export type ProductDisclaimerCreatePayload = {
  __typename: 'ProductDisclaimerCreatePayload';
  productDisclaimer: ProductDisclaimer;
};

export type ProductDisclaimerCreateUnion = InvalidInputError | ProductDisclaimerCreatePayload;

export type ProductDisclaimerDeletePayload = {
  __typename: 'ProductDisclaimerDeletePayload';
  productDisclaimer: ProductDisclaimer;
};

export type ProductDisclaimerDeleteUnion = EntityNotFoundError | ProductDisclaimerDeletePayload;

export type ProductDisclaimerDuplicatePayload = {
  __typename: 'ProductDisclaimerDuplicatePayload';
  productDisclaimer: ProductDisclaimer;
};

export type ProductDisclaimerDuplicateUnion = EntityNotFoundError | InvalidInputError | ProductDisclaimerDuplicatePayload;

export enum ProductDisclaimerOrderByField {
  CreatedAt = 'CREATED_AT',
  State = 'STATE',
  UpdatedAt = 'UPDATED_AT'
}

export type ProductDisclaimerOrderByInput = {
  direction: OrderByDirection;
  field: ProductDisclaimerOrderByField;
};

export type ProductDisclaimerResultUnion = EntityNotFoundError | ProductDisclaimer;

export enum ProductDisclaimerState {
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED',
  Scheduled = 'SCHEDULED'
}

export type ProductDisclaimerUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type ProductDisclaimerUpdateInput = {
  backgroundColor?: InputMaybe<Scalars['HexColorCode']['input']>;
  content?: InputMaybe<Scalars['NonEmptyString']['input']>;
  contentTitle?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  link?: InputMaybe<Scalars['NonEmptyString']['input']>;
  priority?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  publishedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  publishedTo?: InputMaybe<Scalars['DateTime']['input']>;
  rulesetId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<ProductDisclaimerState>;
  textColor?: InputMaybe<Scalars['HexColorCode']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  titleColor?: InputMaybe<Scalars['HexColorCode']['input']>;
};

export type ProductDisclaimerUpdatePayload = {
  __typename: 'ProductDisclaimerUpdatePayload';
  productDisclaimer: ProductDisclaimer;
};

export type ProductDisclaimerUpdateUnion = EntityNotFoundError | ProductDisclaimerUpdatePayload;

export type ProductDisclaimerWhereInput = {
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductDisclaimersConnection = {
  __typename: 'ProductDisclaimersConnection';
  edges: Array<ProductDisclaimersEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type ProductDisclaimersEdge = {
  __typename: 'ProductDisclaimersEdge';
  cursor: Scalars['String']['output'];
  node: ProductDisclaimer;
};

export type ProductDropdownValue = Node & ProductAttributeValue & {
  __typename: 'ProductDropdownValue';
  attribute: Attribute;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Maybe<AttributeOption>;
};

export type ProductDuplicatePayload = {
  __typename: 'ProductDuplicatePayload';
  product: Product;
};

export type ProductDuplicateUnion = EntityNotFoundError | InvalidInputError | ProductDuplicatePayload;

export type ProductExport = Node & {
  __typename: 'ProductExport';
  createdAt: Scalars['DateTime']['output'];
  fields: Maybe<Scalars['JSONObject']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  notifyToEmail: Maybe<Scalars['EmailAddress']['output']>;
  state: ProductExportState;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductExportCreateInput = {
  fields?: InputMaybe<Scalars['JSONObject']['input']>;
  notifyToEmail?: InputMaybe<Scalars['EmailAddress']['input']>;
  state?: InputMaybe<ProductExportState>;
};

export type ProductExportCreatePayload = {
  __typename: 'ProductExportCreatePayload';
  productExport: ProductExport;
};

export type ProductExportCreateUnion = InvalidInputError | ProductExportCreatePayload;

export type ProductExportDeletePayload = {
  __typename: 'ProductExportDeletePayload';
  productExport: ProductExport;
};

export type ProductExportDeleteUnion = EntityNotFoundError | ProductExportDeletePayload;

export enum ProductExportOrderByField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type ProductExportOrderByInput = {
  direction: OrderByDirection;
  field: ProductExportOrderByField;
};

export type ProductExportResultUnion = EntityNotFoundError | ProductExport;

export enum ProductExportState {
  Configured = 'CONFIGURED',
  Created = 'CREATED',
  Failed = 'FAILED',
  Finished = 'FINISHED',
  Processing = 'PROCESSING'
}

export type ProductExportUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type ProductExportUpdateInput = {
  fields?: InputMaybe<Scalars['JSONObject']['input']>;
  notifyToEmail?: InputMaybe<Scalars['EmailAddress']['input']>;
  state?: InputMaybe<ProductExportState>;
};

export type ProductExportUpdatePayload = {
  __typename: 'ProductExportUpdatePayload';
  productExport: ProductExport;
};

export type ProductExportUpdateUnion = EntityNotFoundError | ProductExportUpdatePayload;

export type ProductExportWhereInput = {
  state?: InputMaybe<ProductExportState>;
};

export type ProductExportsConnection = {
  __typename: 'ProductExportsConnection';
  edges: Array<ProductExportsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type ProductExportsEdge = {
  __typename: 'ProductExportsEdge';
  cursor: Scalars['String']['output'];
  node: ProductExport;
};

export type ProductGroup = Node & {
  __typename: 'ProductGroup';
  attributes: Array<Attribute>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  productCount: Scalars['NonNegativeInt']['output'];
  title: Scalars['NonEmptyString']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductGroupAddAttributesPayload = {
  __typename: 'ProductGroupAddAttributesPayload';
  attributes: Array<Attribute>;
  productGroup: ProductGroup;
};

export type ProductGroupAddAttributesUnion = EntityNotFoundError | ProductGroupAddAttributesPayload;

export type ProductGroupCreateInput = {
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['NonEmptyString']['input'];
};

export type ProductGroupCreatePayload = {
  __typename: 'ProductGroupCreatePayload';
  productGroup: ProductGroup;
};

export type ProductGroupCreateUnion = InvalidInputError | ProductGroupCreatePayload;

export type ProductGroupDeletePayload = {
  __typename: 'ProductGroupDeletePayload';
  productGroup: ProductGroup;
};

export type ProductGroupDeleteUnion = EntityNotFoundError | ProductGroupDeletePayload;

export enum ProductGroupOrderByField {
  CreatedAt = 'CREATED_AT',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type ProductGroupOrderByInput = {
  direction: OrderByDirection;
  field: ProductGroupOrderByField;
};

export type ProductGroupRemoveAttributesPayload = {
  __typename: 'ProductGroupRemoveAttributesPayload';
  attributes: Array<Attribute>;
  productGroup: ProductGroup;
};

export type ProductGroupRemoveAttributesUnion = EntityNotFoundError | ProductGroupRemoveAttributesPayload;

export type ProductGroupResultUnion = EntityNotFoundError | ProductGroup;

export type ProductGroupStatistics = {
  __typename: 'ProductGroupStatistics';
  date: Scalars['Date']['output'];
  groups: Array<ProductGroupStatisticsGroup>;
};

export type ProductGroupStatisticsGroup = {
  __typename: 'ProductGroupStatisticsGroup';
  productGroup: ProductGroup;
  totalAmount: Money;
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type ProductGroupStatisticsRangeInput = {
  from: Scalars['Date']['input'];
  interval: ProductGroupStatisticsRangeInterval;
  to: Scalars['Date']['input'];
};

export enum ProductGroupStatisticsRangeInterval {
  Day = 'DAY',
  Month = 'MONTH'
}

export type ProductGroupUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type ProductGroupUpdateInput = {
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductGroupUpdatePayload = {
  __typename: 'ProductGroupUpdatePayload';
  productGroup: ProductGroup;
};

export type ProductGroupUpdateUnion = EntityNotFoundError | ProductGroupUpdatePayload;

export type ProductGroupWhereInput = {
  AND?: InputMaybe<Array<ProductGroupWhereSubInput>>;
  OR?: InputMaybe<Array<ProductGroupWhereSubInput>>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductGroupWhereSubInput = {
  AND?: InputMaybe<Array<ProductGroupWhereSubInput>>;
  OR?: InputMaybe<Array<ProductGroupWhereSubInput>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export enum ProductGroupingCategory {
  Accessories = 'ACCESSORIES',
  CareProducts = 'CARE_PRODUCTS',
  ExtendedWarranty = 'EXTENDED_WARRANTY',
  Uncategorized = 'UNCATEGORIZED'
}

export type ProductGroupsConnection = {
  __typename: 'ProductGroupsConnection';
  edges: Array<ProductGroupsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type ProductGroupsEdge = {
  __typename: 'ProductGroupsEdge';
  cursor: Scalars['String']['output'];
  node: ProductGroup;
};

export type ProductImage = Node & ProductMedia & {
  __typename: 'ProductImage';
  createdAt: Scalars['DateTime']['output'];
  height: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  orientation: ProductMediaOrientation;
  position: Scalars['NonNegativeInt']['output'];
  shotType: ProductMediaShotType;
  title: Maybe<Scalars['NonEmptyString']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['URL']['output'];
  width: Maybe<Scalars['PositiveInt']['output']>;
};

export type ProductImport = Node & {
  __typename: 'ProductImport';
  columns: Array<ProductImportColumn>;
  configuration: Maybe<Array<ProductImportConfigurationField>>;
  createNewProducts: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  defaultProductGroup: Maybe<ProductGroup>;
  defaultTaxClass: Maybe<TaxClass>;
  fieldMapping: Maybe<Array<ProductImportMappingField>>;
  hasHeader: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isExported: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type ProductImportColumnsArgs = {
  count?: Scalars['PositiveInt']['input'];
};

export type ProductImportAttributeConfigurationField = ProductImportConfigurationField & {
  __typename: 'ProductImportAttributeConfigurationField';
  attribute: Attribute;
  position: Scalars['NonNegativeInt']['output'];
};

export type ProductImportAttributeMappingField = ProductImportMappingField & {
  __typename: 'ProductImportAttributeMappingField';
  attribute: Attribute;
  position: Scalars['NonNegativeInt']['output'];
};

export type ProductImportColumn = {
  __typename: 'ProductImportColumn';
  isHidden: Scalars['Boolean']['output'];
  values: Maybe<Array<Scalars['String']['output']>>;
};

export type ProductImportConfigurationField = {
  position: Scalars['NonNegativeInt']['output'];
};

export type ProductImportCreateInput = {
  url: Scalars['String']['input'];
};

export type ProductImportCreatePayload = {
  __typename: 'ProductImportCreatePayload';
  productImport: ProductImport;
};

export type ProductImportCreateUnion = InvalidInputError | ProductImportCreatePayload;

export type ProductImportDeletePayload = {
  __typename: 'ProductImportDeletePayload';
  productImport: ProductImport;
};

export type ProductImportDeleteUnion = EntityNotFoundError | ProductImportDeletePayload;

export type ProductImportEmptyConfigurationField = ProductImportConfigurationField & {
  __typename: 'ProductImportEmptyConfigurationField';
  position: Scalars['NonNegativeInt']['output'];
};

export type ProductImportEmptyMappingField = ProductImportMappingField & {
  __typename: 'ProductImportEmptyMappingField';
  position: Scalars['NonNegativeInt']['output'];
};

export type ProductImportExecutePayload = {
  __typename: 'ProductImportExecutePayload';
  productImport: ProductImport;
};

export type ProductImportExecuteUnion = EntityNotFoundError | ProductImportExecutePayload;

export type ProductImportFieldMappingInput = {
  attributeId?: InputMaybe<Scalars['ID']['input']>;
  priceTypeId?: InputMaybe<Scalars['ID']['input']>;
  property?: InputMaybe<EditorFieldProperty>;
};

export type ProductImportMappingField = {
  position: Scalars['NonNegativeInt']['output'];
};

export type ProductImportPriceTypeConfigurationField = ProductImportConfigurationField & {
  __typename: 'ProductImportPriceTypeConfigurationField';
  position: Scalars['NonNegativeInt']['output'];
  priceType: PriceType;
};

export type ProductImportPriceTypeMappingField = ProductImportMappingField & {
  __typename: 'ProductImportPriceTypeMappingField';
  position: Scalars['NonNegativeInt']['output'];
  priceType: PriceType;
};

export type ProductImportPropertyConfigurationField = ProductImportConfigurationField & {
  __typename: 'ProductImportPropertyConfigurationField';
  position: Scalars['NonNegativeInt']['output'];
  property: EditorFieldProperty;
};

export type ProductImportPropertyMappingField = ProductImportMappingField & {
  __typename: 'ProductImportPropertyMappingField';
  position: Scalars['NonNegativeInt']['output'];
  property: EditorFieldProperty;
};

export type ProductImportResultUnion = EntityNotFoundError | ProductImport;

export type ProductImportUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type ProductImportUpdateInput = {
  createNewProducts?: InputMaybe<Scalars['Boolean']['input']>;
  defaultProductGroupId?: InputMaybe<Scalars['ID']['input']>;
  defaultTaxClassId?: InputMaybe<Scalars['ID']['input']>;
  fieldMapping?: InputMaybe<Array<ProductImportFieldMappingInput>>;
  hasHeader?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductImportUpdatePayload = {
  __typename: 'ProductImportUpdatePayload';
  productImport: ProductImport;
};

export type ProductImportUpdateUnion = EntityNotFoundError | ProductImportUpdatePayload;

export type ProductInventory = {
  __typename: 'ProductInventory';
  alertQuantity: Maybe<Scalars['PositiveInt']['output']>;
  availableFromNextShipment: Maybe<Scalars['SafeInt']['output']>;
  availableQuantity: Maybe<Scalars['SafeInt']['output']>;
  deliveryEstimateDays: Maybe<Scalars['PositiveInt']['output']>;
  expectedShipmentDate: Maybe<Scalars['Date']['output']>;
  isAvailableForPurchase: Scalars['Boolean']['output'];
  isGiftCard: Scalars['Boolean']['output'];
  state: Maybe<ProductInventoryState>;
  useInventoryTracking: Scalars['Boolean']['output'];
};

export enum ProductInventoryState {
  AvailableInOutlet = 'AVAILABLE_IN_OUTLET',
  AvailableToOrder = 'AVAILABLE_TO_ORDER',
  InStock = 'IN_STOCK',
  OutOfStock = 'OUT_OF_STOCK'
}

export type ProductMaskMedia = Node & {
  __typename: 'ProductMaskMedia';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  linkedOptions: Array<AttributeOption>;
  specifier: Scalars['NonEmptyString']['output'];
  title: Maybe<Scalars['NonEmptyString']['output']>;
  type: ProductMaskMediaType;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['URL']['output'];
};

export type ProductMaskMediaCreateInput = {
  linkedOptions?: InputMaybe<Array<NodeInput>>;
  mainProductId: Scalars['ID']['input'];
  specifier: Scalars['NonEmptyString']['input'];
  type: ProductMaskMediaType;
  url: Scalars['NonEmptyString']['input'];
};

export type ProductMaskMediaCreatePayload = {
  __typename: 'ProductMaskMediaCreatePayload';
  mainProduct: Product;
  productMaskMedia: ProductMaskMedia;
};

export type ProductMaskMediaCreateUnion = InvalidInputError | ProductMaskMediaCreatePayload;

export type ProductMaskMediaDeletePayload = {
  __typename: 'ProductMaskMediaDeletePayload';
  mainProduct: Product;
  productMaskMedia: ProductMaskMedia;
};

export type ProductMaskMediaDeleteUnion = EntityNotFoundError | ProductMaskMediaDeletePayload;

export enum ProductMaskMediaType {
  Base = 'BASE',
  ColorMask = 'COLOR_MASK',
  Overlay = 'OVERLAY'
}

export type ProductMaskMediaUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type ProductMaskMediaUpdateInput = {
  linkedOptions?: InputMaybe<Array<NodeInput>>;
  specifier?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type?: InputMaybe<ProductMaskMediaType>;
  url?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductMaskMediaUpdatePayload = {
  __typename: 'ProductMaskMediaUpdatePayload';
  mainProduct: Product;
  productMaskMedia: ProductMaskMedia;
};

export type ProductMaskMediaUpdateUnion = EntityNotFoundError | InvalidInputError | ProductMaskMediaUpdatePayload;

export type ProductMedia = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  position: Scalars['NonNegativeInt']['output'];
  title: Maybe<Scalars['NonEmptyString']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['URL']['output'];
};

export type ProductMediaCreateInput = {
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  productId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type: ProductMediaType;
  url: Scalars['NonEmptyString']['input'];
};

export type ProductMediaCreatePayload = {
  __typename: 'ProductMediaCreatePayload';
  product: Product;
  productMedia: ProductMedia;
};

export type ProductMediaCreateUnion = InvalidInputError | ProductMediaCreatePayload;

export type ProductMediaDeletePayload = {
  __typename: 'ProductMediaDeletePayload';
  product: Product;
  productMedia: ProductMedia;
};

export type ProductMediaDeleteUnion = EntityNotFoundError | ProductMediaDeletePayload;

export enum ProductMediaOrderByField {
  CreatedAt = 'CREATED_AT',
  Position = 'POSITION',
  UpdatedAt = 'UPDATED_AT'
}

export type ProductMediaOrderByInput = {
  direction: OrderByDirection;
  field: ProductMediaOrderByField;
};

export enum ProductMediaOrientation {
  Landscape = 'LANDSCAPE',
  Portrait = 'PORTRAIT'
}

export type ProductMediaResultUnion = EntityNotFoundError | ProductImage | ProductModel | ProductVideo;

export enum ProductMediaShotType {
  Lifestyle = 'LIFESTYLE',
  WhiteBackground = 'WHITE_BACKGROUND'
}

export enum ProductMediaType {
  Image = 'IMAGE',
  Model = 'MODEL',
  Video = 'VIDEO'
}

export type ProductMediaUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type ProductMediaUpdateInput = {
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  url?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductMediaUpdatePayload = {
  __typename: 'ProductMediaUpdatePayload';
  product: Product;
  productMedia: ProductMedia;
};

export type ProductMediaUpdateUnion = EntityNotFoundError | ProductMediaUpdatePayload;

export type ProductMediaWhereInput = {
  AND?: InputMaybe<Array<ProductMediaWhereSubInput>>;
  OR?: InputMaybe<Array<ProductMediaWhereSubInput>>;
  query?: InputMaybe<ProductMediaType>;
  type?: InputMaybe<ProductMediaType>;
};

export type ProductMediaWhereSubInput = {
  AND?: InputMaybe<Array<ProductMediaWhereSubInput>>;
  OR?: InputMaybe<Array<ProductMediaWhereSubInput>>;
  type?: InputMaybe<ProductMediaType>;
};

export type ProductMediasConnection = {
  __typename: 'ProductMediasConnection';
  edges: Array<ProductMediasEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type ProductMediasEdge = {
  __typename: 'ProductMediasEdge';
  cursor: Scalars['String']['output'];
  node: ProductMedia;
};

export type ProductModel = Node & ProductMedia & {
  __typename: 'ProductModel';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  position: Scalars['NonNegativeInt']['output'];
  title: Maybe<Scalars['NonEmptyString']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['URL']['output'];
};

export type ProductMultiselectValue = Node & ProductAttributeValue & {
  __typename: 'ProductMultiselectValue';
  attribute: Attribute;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Array<AttributeOption>;
};

export type ProductNumberValue = Node & ProductAttributeValue & {
  __typename: 'ProductNumberValue';
  attribute: Attribute;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Maybe<Scalars['UnsignedFloat']['output']>;
};

export enum ProductOrderByField {
  ClubPrice = 'CLUB_PRICE',
  CreatedAt = 'CREATED_AT',
  Price = 'PRICE',
  PromotionPrice = 'PROMOTION_PRICE',
  PurchasePrice = 'PURCHASE_PRICE',
  Quantity = 'QUANTITY',
  RetailPrice = 'RETAIL_PRICE',
  Specification = 'SPECIFICATION',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type ProductOrderByInput = {
  direction: OrderByDirection;
  field: ProductOrderByField;
};

export type ProductOutlet = Node & {
  __typename: 'ProductOutlet';
  availableQuantity: Scalars['NonNegativeInt']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  modelQuantity: Scalars['NonNegativeInt']['output'];
  outlet: Outlet;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductOutletInput = {
  availableQuantity: Scalars['NonNegativeInt']['input'];
  modelQuantity: Scalars['NonNegativeInt']['input'];
  outletId: Scalars['ID']['input'];
};

export type ProductOutletStock = {
  __typename: 'ProductOutletStock';
  availableQuantity: Scalars['NonNegativeInt']['output'];
  modelQuantity: Scalars['NonNegativeInt']['output'];
  outlet: ProductOutletStockOutlet;
};

export type ProductOutletStockOutlet = {
  __typename: 'ProductOutletStockOutlet';
  id: Scalars['ID']['output'];
  number: Maybe<Scalars['NonNegativeInt']['output']>;
  title: Scalars['NonEmptyString']['output'];
};

export type ProductParcel = Node & {
  __typename: 'ProductParcel';
  createdAt: Scalars['DateTime']['output'];
  depth: Maybe<Scalars['PositiveInt']['output']>;
  externalId: Maybe<Scalars['NonEmptyString']['output']>;
  height: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  number: Scalars['PositiveInt']['output'];
  productQuantity: Maybe<Scalars['PositiveInt']['output']>;
  quantity: Maybe<Scalars['PositiveInt']['output']>;
  tareWeight: Maybe<Scalars['PositiveFloat']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  volume: Maybe<Scalars['PositiveFloat']['output']>;
  weight: Maybe<Scalars['PositiveFloat']['output']>;
  width: Maybe<Scalars['PositiveInt']['output']>;
};

export type ProductParcelCreateInput = {
  depth?: InputMaybe<Scalars['PositiveInt']['input']>;
  externalId?: InputMaybe<Scalars['NonEmptyString']['input']>;
  height?: InputMaybe<Scalars['PositiveInt']['input']>;
  number: Scalars['PositiveInt']['input'];
  productId: Scalars['ID']['input'];
  productQuantity?: InputMaybe<Scalars['PositiveInt']['input']>;
  quantity?: InputMaybe<Scalars['PositiveInt']['input']>;
  tareWeight?: InputMaybe<Scalars['PositiveFloat']['input']>;
  volume?: InputMaybe<Scalars['PositiveFloat']['input']>;
  weight?: InputMaybe<Scalars['PositiveFloat']['input']>;
  width?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type ProductParcelCreatePayload = {
  __typename: 'ProductParcelCreatePayload';
  product: Product;
  productParcel: ProductParcel;
};

export type ProductParcelCreateUnion = InvalidInputError | ProductParcelCreatePayload;

export type ProductParcelDeletePayload = {
  __typename: 'ProductParcelDeletePayload';
  product: Product;
  productParcel: ProductParcel;
};

export type ProductParcelDeleteUnion = EntityNotFoundError | ProductParcelDeletePayload;

export enum ProductParcelOrderByField {
  CreatedAt = 'CREATED_AT',
  Number = 'NUMBER',
  UpdatedAt = 'UPDATED_AT'
}

export type ProductParcelOrderByInput = {
  direction: OrderByDirection;
  field: ProductParcelOrderByField;
};

export type ProductParcelResultUnion = EntityNotFoundError | ProductParcel;

export type ProductParcelUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type ProductParcelUpdateInput = {
  depth?: InputMaybe<Scalars['PositiveInt']['input']>;
  externalId?: InputMaybe<Scalars['NonEmptyString']['input']>;
  height?: InputMaybe<Scalars['PositiveInt']['input']>;
  number?: InputMaybe<Scalars['PositiveInt']['input']>;
  productQuantity?: InputMaybe<Scalars['PositiveInt']['input']>;
  quantity?: InputMaybe<Scalars['PositiveInt']['input']>;
  tareWeight?: InputMaybe<Scalars['PositiveFloat']['input']>;
  volume?: InputMaybe<Scalars['PositiveFloat']['input']>;
  weight?: InputMaybe<Scalars['PositiveFloat']['input']>;
  width?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type ProductParcelUpdatePayload = {
  __typename: 'ProductParcelUpdatePayload';
  product: Product;
  productParcel: ProductParcel;
};

export type ProductParcelUpdateUnion = EntityNotFoundError | ProductParcelUpdatePayload;

export type ProductParcelWhereInput = {
  productId: Scalars['ID']['input'];
};

export type ProductParcelsConnection = {
  __typename: 'ProductParcelsConnection';
  edges: Array<ProductParcelsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type ProductParcelsEdge = {
  __typename: 'ProductParcelsEdge';
  cursor: Scalars['String']['output'];
  node: ProductParcel;
};

export type ProductPrice = {
  __typename: 'ProductPrice';
  date: Scalars['Date']['output'];
  price: Maybe<Money>;
};

export type ProductPriceType = Node & {
  __typename: 'ProductPriceType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  price: Money;
  priceType: PriceType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductPriceTypeCreateInput = {
  price: Scalars['Decimal']['input'];
  priceTypeId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};

export type ProductPriceTypeCreatePayload = {
  __typename: 'ProductPriceTypeCreatePayload';
  productPriceType: ProductPriceType;
};

export type ProductPriceTypeCreateUnion = InvalidInputError | ProductPriceTypeCreatePayload;

export type ProductPriceTypeDeletePayload = {
  __typename: 'ProductPriceTypeDeletePayload';
  productPriceType: ProductPriceType;
};

export type ProductPriceTypeDeleteUnion = EntityNotFoundError | ProductPriceTypeDeletePayload;

export type ProductPriceTypeUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type ProductPriceTypeUpdateInput = {
  price?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ProductPriceTypeUpdatePayload = {
  __typename: 'ProductPriceTypeUpdatePayload';
  productPriceType: ProductPriceType;
};

export type ProductPriceTypeUpdateUnion = EntityNotFoundError | ProductPriceTypeUpdatePayload;

export type ProductPricesRangeInput = {
  from: Scalars['Date']['input'];
  interval: ProductPricesRangeInterval;
  to: Scalars['Date']['input'];
};

export enum ProductPricesRangeInterval {
  Day = 'DAY',
  Month = 'MONTH'
}

export type ProductPricing = {
  __typename: 'ProductPricing';
  cartPromotionPrice: Maybe<Money>;
  clubPrice: Maybe<Money>;
  includeInPromotions: Scalars['Boolean']['output'];
  isMarginOk: Scalars['Boolean']['output'];
  lowestPrice: Money;
  originalPrice: Maybe<Money>;
  price: Maybe<Money>;
  priceTypes: Array<ProductPriceType>;
  promotionGroup: Maybe<PromotionGroup>;
  promotionPrice: Maybe<Money>;
  purchasePrice: Maybe<Money>;
  skipMarginCalculation: Scalars['Boolean']['output'];
  suggestedRetailPrice: Maybe<Money>;
  taxClass: TaxClass;
};

export type ProductPropertiesConnection = {
  __typename: 'ProductPropertiesConnection';
  edges: Array<ProductPropertiesEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type ProductPropertiesEdge = {
  __typename: 'ProductPropertiesEdge';
  cursor: Scalars['String']['output'];
  node: ProductProperty;
};

export type ProductProperty = Node & {
  __typename: 'ProductProperty';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  options: Array<ProductPropertyOption>;
  position: Scalars['NonNegativeInt']['output'];
  title: Scalars['NonEmptyString']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductPropertyCreateInput = {
  isRequired: Scalars['Boolean']['input'];
  position: Scalars['NonNegativeInt']['input'];
  productId: Scalars['ID']['input'];
  title: Scalars['NonEmptyString']['input'];
};

export type ProductPropertyCreatePayload = {
  __typename: 'ProductPropertyCreatePayload';
  product: Product;
  productProperty: ProductProperty;
};

export type ProductPropertyCreateUnion = InvalidInputError | ProductPropertyCreatePayload;

export type ProductPropertyDeletePayload = {
  __typename: 'ProductPropertyDeletePayload';
  product: Product;
  productProperty: ProductProperty;
};

export type ProductPropertyDeleteUnion = EntityNotFoundError | ProductPropertyDeletePayload;

export type ProductPropertyOption = Node & {
  __typename: 'ProductPropertyOption';
  color: Maybe<Scalars['NonEmptyString']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  id: Scalars['ID']['output'];
  image: Maybe<Scalars['URL']['output']>;
  position: Scalars['NonNegativeInt']['output'];
  title: Scalars['NonEmptyString']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductPropertyOptionCreateInput = {
  color?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  image?: InputMaybe<Scalars['NonEmptyString']['input']>;
  position: Scalars['NonNegativeInt']['input'];
  propertyId: Scalars['ID']['input'];
  title: Scalars['NonEmptyString']['input'];
};

export type ProductPropertyOptionCreatePayload = {
  __typename: 'ProductPropertyOptionCreatePayload';
  product: Product;
  productProperty: ProductProperty;
  productPropertyOption: ProductPropertyOption;
};

export type ProductPropertyOptionCreateUnion = InvalidInputError | ProductPropertyOptionCreatePayload;

export type ProductPropertyOptionDeletePayload = {
  __typename: 'ProductPropertyOptionDeletePayload';
  product: Product;
  productProperty: ProductProperty;
  productPropertyOption: ProductPropertyOption;
};

export type ProductPropertyOptionDeleteUnion = EntityNotFoundError | ProductPropertyOptionDeletePayload;

export enum ProductPropertyOptionOrderByField {
  CreatedAt = 'CREATED_AT',
  Position = 'POSITION',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type ProductPropertyOptionOrderByInput = {
  direction: OrderByDirection;
  field: ProductPropertyOptionOrderByField;
};

export type ProductPropertyOptionResultUnion = EntityNotFoundError | ProductPropertyOption;

export type ProductPropertyOptionUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type ProductPropertyOptionUpdateInput = {
  color?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  image?: InputMaybe<Scalars['NonEmptyString']['input']>;
  position?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductPropertyOptionUpdatePayload = {
  __typename: 'ProductPropertyOptionUpdatePayload';
  product: Product;
  productProperty: ProductProperty;
  productPropertyOption: ProductPropertyOption;
};

export type ProductPropertyOptionUpdateUnion = EntityNotFoundError | ProductPropertyOptionUpdatePayload;

export type ProductPropertyOptionWhereInput = {
  AND?: InputMaybe<Array<ProductPropertyOptionWhereSubInput>>;
  OR?: InputMaybe<Array<ProductPropertyOptionWhereSubInput>>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductPropertyOptionWhereSubInput = {
  AND?: InputMaybe<Array<ProductPropertyOptionWhereSubInput>>;
  OR?: InputMaybe<Array<ProductPropertyOptionWhereSubInput>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductPropertyOptionsConnection = {
  __typename: 'ProductPropertyOptionsConnection';
  edges: Array<ProductPropertyOptionsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type ProductPropertyOptionsEdge = {
  __typename: 'ProductPropertyOptionsEdge';
  cursor: Scalars['String']['output'];
  node: ProductPropertyOption;
};

export enum ProductPropertyOrderByField {
  CreatedAt = 'CREATED_AT',
  Position = 'POSITION',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type ProductPropertyOrderByInput = {
  direction: OrderByDirection;
  field: ProductPropertyOrderByField;
};

export type ProductPropertyReorderOptionsPayload = {
  __typename: 'ProductPropertyReorderOptionsPayload';
  product: Product;
  productProperty: ProductProperty;
};

export type ProductPropertyReorderOptionsUnion = EntityNotFoundError | ProductPropertyReorderOptionsPayload;

export type ProductPropertyResultUnion = EntityNotFoundError | ProductProperty;

export type ProductPropertyUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type ProductPropertyUpdateInput = {
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductPropertyUpdatePayload = {
  __typename: 'ProductPropertyUpdatePayload';
  product: Product;
  productProperty: ProductProperty;
};

export type ProductPropertyUpdateUnion = EntityNotFoundError | ProductPropertyUpdatePayload;

export type ProductPropertyWhereInput = {
  AND?: InputMaybe<Array<ProductPropertyWhereSubInput>>;
  OR?: InputMaybe<Array<ProductPropertyWhereSubInput>>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductPropertyWhereSubInput = {
  AND?: InputMaybe<Array<ProductPropertyWhereSubInput>>;
  OR?: InputMaybe<Array<ProductPropertyWhereSubInput>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductRelation = Node & {
  __typename: 'ProductRelation';
  category: ProductGroupingCategory;
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  fetchRuleset: Maybe<Ruleset>;
  fetchType: ProductRelationFetchType;
  id: Scalars['ID']['output'];
  matchRuleset: Maybe<Ruleset>;
  matchType: ProductRelationMatchType;
  priority: Scalars['NonNegativeInt']['output'];
  state: ProductRelationState;
  title: Scalars['NonEmptyString']['output'];
  type: ProductRelationType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductRelationAddProductsPayload = {
  __typename: 'ProductRelationAddProductsPayload';
  productRelation: ProductRelation;
  products: Array<Product>;
};

export type ProductRelationAddProductsUnion = EntityNotFoundError | ProductRelationAddProductsPayload;

export type ProductRelationCreateInput = {
  category: ProductGroupingCategory;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  fetchRulesetId?: InputMaybe<Scalars['ID']['input']>;
  fetchType?: InputMaybe<ProductRelationFetchType>;
  matchRulesetId?: InputMaybe<Scalars['ID']['input']>;
  matchType?: InputMaybe<ProductRelationMatchType>;
  priority?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  state?: InputMaybe<ProductRelationState>;
  title: Scalars['NonEmptyString']['input'];
  type: ProductRelationType;
};

export type ProductRelationCreatePayload = {
  __typename: 'ProductRelationCreatePayload';
  productRelation: ProductRelation;
};

export type ProductRelationCreateUnion = InvalidInputError | ProductRelationCreatePayload;

export type ProductRelationDeletePayload = {
  __typename: 'ProductRelationDeletePayload';
  productRelation: ProductRelation;
};

export type ProductRelationDeleteUnion = EntityNotFoundError | ProductRelationDeletePayload;

export enum ProductRelationFetchType {
  Dynamic = 'DYNAMIC',
  Static = 'STATIC'
}

export enum ProductRelationMatchType {
  Dynamic = 'DYNAMIC',
  Static = 'STATIC'
}

export enum ProductRelationOrderByField {
  CreatedAt = 'CREATED_AT',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type ProductRelationOrderByInput = {
  direction: OrderByDirection;
  field: ProductRelationOrderByField;
};

export enum ProductRelationProductType {
  Fetch = 'FETCH',
  Match = 'MATCH'
}

export type ProductRelationRemoveProductsPayload = {
  __typename: 'ProductRelationRemoveProductsPayload';
  productRelation: ProductRelation;
  products: Array<Product>;
};

export type ProductRelationRemoveProductsUnion = EntityNotFoundError | ProductRelationRemoveProductsPayload;

export type ProductRelationResultUnion = EntityNotFoundError | ProductRelation;

export enum ProductRelationState {
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED'
}

export enum ProductRelationType {
  CrossSell = 'CROSS_SELL',
  Related = 'RELATED',
  Upsell = 'UPSELL'
}

export type ProductRelationUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type ProductRelationUpdateInput = {
  category?: InputMaybe<ProductGroupingCategory>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  fetchType?: InputMaybe<ProductRelationFetchType>;
  matchType?: InputMaybe<ProductRelationMatchType>;
  priority?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  state?: InputMaybe<ProductRelationState>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type?: InputMaybe<ProductRelationType>;
};

export type ProductRelationUpdatePayload = {
  __typename: 'ProductRelationUpdatePayload';
  productRelation: ProductRelation;
};

export type ProductRelationUpdateUnion = EntityNotFoundError | ProductRelationUpdatePayload;

export type ProductRelationWhereInput = {
  AND?: InputMaybe<Array<ProductRelationWhereSubInput>>;
  OR?: InputMaybe<Array<ProductRelationWhereSubInput>>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type?: InputMaybe<ProductRelationType>;
};

export type ProductRelationWhereSubInput = {
  AND?: InputMaybe<Array<ProductRelationWhereSubInput>>;
  OR?: InputMaybe<Array<ProductRelationWhereSubInput>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type?: InputMaybe<ProductRelationType>;
};

export type ProductRelationsConnection = {
  __typename: 'ProductRelationsConnection';
  edges: Array<ProductRelationsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type ProductRelationsEdge = {
  __typename: 'ProductRelationsEdge';
  cursor: Scalars['String']['output'];
  node: ProductRelation;
};

export type ProductRemoveCategoriesPayload = {
  __typename: 'ProductRemoveCategoriesPayload';
  categories: Array<Category>;
  product: Product;
};

export type ProductRemoveCategoriesUnion = EntityNotFoundError | ProductRemoveCategoriesPayload;

export type ProductReorderAssetsPayload = {
  __typename: 'ProductReorderAssetsPayload';
  product: Product;
};

export type ProductReorderAssetsUnion = EntityNotFoundError | ProductReorderAssetsPayload;

export type ProductReorderMediasPayload = {
  __typename: 'ProductReorderMediasPayload';
  product: Product;
};

export type ProductReorderMediasUnion = EntityNotFoundError | ProductReorderMediasPayload;

export type ProductReorderPropertiesPayload = {
  __typename: 'ProductReorderPropertiesPayload';
  product: Product;
};

export type ProductReorderPropertiesUnion = EntityNotFoundError | ProductReorderPropertiesPayload;

export type ProductResultUnion = ConfigurableProduct | EntityNotFoundError | SimpleProduct;

export type ProductSeo = {
  __typename: 'ProductSeo';
  description: Maybe<Scalars['NonEmptyString']['output']>;
  hasCustomSlug: Scalars['Boolean']['output'];
  keywords: Maybe<Scalars['NonEmptyString']['output']>;
  slug: Maybe<Scalars['NonEmptyString']['output']>;
  title: Maybe<Scalars['NonEmptyString']['output']>;
};

export type ProductSetDefaultMediaPayload = {
  __typename: 'ProductSetDefaultMediaPayload';
  product: Product;
};

export type ProductSetDefaultMediaUnion = EntityNotFoundError | ProductSetDefaultMediaPayload;

export type ProductSetMeasurementAssetPayload = {
  __typename: 'ProductSetMeasurementAssetPayload';
  product: Product;
};

export type ProductSetMeasurementAssetUnion = EntityNotFoundError | ProductSetMeasurementAssetPayload;

export enum ProductState {
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED'
}

export type ProductTagsValue = Node & ProductAttributeValue & {
  __typename: 'ProductTagsValue';
  attribute: Attribute;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Array<Scalars['NonEmptyString']['output']>;
};

export type ProductTextValue = Node & ProductAttributeValue & {
  __typename: 'ProductTextValue';
  attribute: Attribute;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Maybe<Scalars['NonEmptyString']['output']>;
};

export type ProductTextareaValue = Node & ProductAttributeValue & {
  __typename: 'ProductTextareaValue';
  attribute: Attribute;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Maybe<Scalars['NonEmptyString']['output']>;
};

export type ProductToggleValue = Node & ProductAttributeValue & {
  __typename: 'ProductToggleValue';
  attribute: Attribute;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Maybe<Scalars['Boolean']['output']>;
};

export enum ProductType {
  Configurable = 'CONFIGURABLE',
  Simple = 'SIMPLE'
}

export type ProductUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type ProductUniqueWhereInputWithSlug = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductUpdateAttributeBetweenInput = {
  max: Scalars['PositiveFloat']['input'];
  min: Scalars['PositiveFloat']['input'];
};

export type ProductUpdateAttributeInput = {
  attributeId: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ProductUpdateAttributesPayload = {
  __typename: 'ProductUpdateAttributesPayload';
  product: Product;
};

export type ProductUpdateAttributesUnion = EntityNotFoundError | ProductUpdateAttributesPayload;

export type ProductUpdateCartInput = {
  maxAmount?: InputMaybe<Scalars['PositiveInt']['input']>;
  minAmount?: InputMaybe<Scalars['PositiveInt']['input']>;
  multiplier?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type ProductUpdateConfigurableDataAttributeInput = {
  attributeId: Scalars['ID']['input'];
  position: Scalars['NonNegativeInt']['input'];
};

export type ProductUpdateConfigurableDataPayload = {
  __typename: 'ProductUpdateConfigurableDataPayload';
  product: ConfigurableProduct;
};

export type ProductUpdateConfigurableDataUnion = EntityNotFoundError | ProductUpdateConfigurableDataPayload;

export type ProductUpdateDimensionsInput = {
  assemblyTime?: InputMaybe<Scalars['PositiveInt']['input']>;
  depth?: InputMaybe<Scalars['PositiveInt']['input']>;
  diameter?: InputMaybe<Scalars['PositiveInt']['input']>;
  height?: InputMaybe<Scalars['PositiveInt']['input']>;
  volume?: InputMaybe<Scalars['PositiveInt']['input']>;
  weight?: InputMaybe<Scalars['PositiveFloat']['input']>;
  width?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type ProductUpdateInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  internalIdentifier?: InputMaybe<Scalars['NonEmptyString']['input']>;
  isGiftCard?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['NonEmptyString']['input']>;
  parcelsAreVisible?: InputMaybe<Scalars['Boolean']['input']>;
  qaItems?: InputMaybe<Array<QuestionAndAnswerInput>>;
  shortDescription?: InputMaybe<Scalars['NonEmptyString']['input']>;
  sku?: InputMaybe<Scalars['NonEmptyString']['input']>;
  specification?: InputMaybe<Scalars['NonEmptyString']['input']>;
  state?: InputMaybe<ProductState>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductUpdateInventoryInput = {
  alertQuantity?: InputMaybe<Scalars['PositiveInt']['input']>;
  availableFromNextShipment?: InputMaybe<Scalars['SafeInt']['input']>;
  availableQuantity?: InputMaybe<Scalars['SafeInt']['input']>;
  deliveryEstimateDays?: InputMaybe<Scalars['PositiveInt']['input']>;
  expectedShipmentDate?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<ProductInventoryState>;
  useInventoryTracking?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductUpdateOutletsInput = {
  outlets: Array<ProductOutletInput>;
  productId: Scalars['ID']['input'];
};

export type ProductUpdatePayload = {
  __typename: 'ProductUpdatePayload';
  product: Product;
};

export type ProductUpdatePricingInput = {
  cartPromotionPrice?: InputMaybe<Scalars['Decimal']['input']>;
  clubPrice?: InputMaybe<Scalars['Decimal']['input']>;
  includeInPromotions?: InputMaybe<Scalars['Boolean']['input']>;
  originalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  promotionPrice?: InputMaybe<Scalars['Decimal']['input']>;
  purchasePrice?: InputMaybe<Scalars['Decimal']['input']>;
  skipMarginCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  suggestedRetailPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ProductUpdateSeoInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  keywords?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductUpdateUnion = EntityNotFoundError | ProductUpdatePayload;

export type ProductValueCollection = Node & {
  __typename: 'ProductValueCollection';
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  id: Scalars['ID']['output'];
  productBrandImage: Maybe<Scalars['URL']['output']>;
  productBrandName: Maybe<Scalars['NonEmptyString']['output']>;
  productCount: Scalars['NonNegativeInt']['output'];
  ruleset: Maybe<Ruleset>;
  title: Scalars['NonEmptyString']['output'];
  type: ProductCollectionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductValueCollectionAddProductsPayload = {
  __typename: 'ProductValueCollectionAddProductsPayload';
  productValueCollection: ProductValueCollection;
  products: Array<Product>;
};

export type ProductValueCollectionAddProductsUnion = EntityNotFoundError | ProductValueCollectionAddProductsPayload;

export type ProductValueCollectionCreateInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  productBrandImage?: InputMaybe<Scalars['NonEmptyString']['input']>;
  productBrandName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  rulesetId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['NonEmptyString']['input'];
  type?: InputMaybe<ProductCollectionType>;
};

export type ProductValueCollectionCreatePayload = {
  __typename: 'ProductValueCollectionCreatePayload';
  productValueCollection: ProductValueCollection;
};

export type ProductValueCollectionCreateUnion = InvalidInputError | ProductValueCollectionCreatePayload;

export type ProductValueCollectionDeletePayload = {
  __typename: 'ProductValueCollectionDeletePayload';
  productValueCollection: ProductValueCollection;
};

export type ProductValueCollectionDeleteUnion = EntityNotFoundError | ProductValueCollectionDeletePayload;

export type ProductValueCollectionOrderByInput = {
  direction: OrderByDirection;
  field: ProductCollectionOrderByField;
};

export type ProductValueCollectionRemoveProductsPayload = {
  __typename: 'ProductValueCollectionRemoveProductsPayload';
  productValueCollection: ProductValueCollection;
  products: Array<Product>;
};

export type ProductValueCollectionRemoveProductsUnion = EntityNotFoundError | ProductValueCollectionRemoveProductsPayload;

export type ProductValueCollectionResultUnion = EntityNotFoundError | ProductValueCollection;

export type ProductValueCollectionUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type ProductValueCollectionUpdateInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  productBrandImage?: InputMaybe<Scalars['NonEmptyString']['input']>;
  productBrandName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  rulesetId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type?: InputMaybe<ProductCollectionType>;
};

export type ProductValueCollectionUpdatePayload = {
  __typename: 'ProductValueCollectionUpdatePayload';
  productValueCollection: ProductValueCollection;
};

export type ProductValueCollectionUpdateUnion = EntityNotFoundError | ProductValueCollectionUpdatePayload;

export type ProductValueCollectionWhereInput = {
  AND?: InputMaybe<Array<ProductValueCollectionWhereSubInput>>;
  OR?: InputMaybe<Array<ProductValueCollectionWhereSubInput>>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductValueCollectionWhereSubInput = {
  AND?: InputMaybe<Array<ProductValueCollectionWhereSubInput>>;
  OR?: InputMaybe<Array<ProductValueCollectionWhereSubInput>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ProductValueCollectionsConnection = {
  __typename: 'ProductValueCollectionsConnection';
  edges: Array<ProductValueCollectionsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type ProductValueCollectionsEdge = {
  __typename: 'ProductValueCollectionsEdge';
  cursor: Scalars['String']['output'];
  node: ProductValueCollection;
};

export type ProductVideo = Node & ProductMedia & {
  __typename: 'ProductVideo';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  position: Scalars['NonNegativeInt']['output'];
  title: Maybe<Scalars['NonEmptyString']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['URL']['output'];
};

export type ProductWhereInput = {
  AND?: InputMaybe<Array<ProductWhereSubInput>>;
  OR?: InputMaybe<Array<ProductWhereSubInput>>;
  anyState?: InputMaybe<ProductState>;
  anyUpdatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  anyUpdatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  attributes?: InputMaybe<Array<ProductAttributeValueFilterInput>>;
  availableQuantity_gte?: InputMaybe<Scalars['SafeInt']['input']>;
  availableQuantity_lte?: InputMaybe<Scalars['SafeInt']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  cartRecommendationId?: InputMaybe<Scalars['ID']['input']>;
  catalogPromotionId?: InputMaybe<Scalars['ID']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryEstimateDays_gte?: InputMaybe<Scalars['SafeInt']['input']>;
  deliveryEstimateDays_lte?: InputMaybe<Scalars['SafeInt']['input']>;
  editorId?: InputMaybe<Scalars['ID']['input']>;
  fetchRelationId?: InputMaybe<Scalars['ID']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  hasChildProducts?: InputMaybe<Scalars['Boolean']['input']>;
  hasConfigurationErrors?: InputMaybe<Scalars['Boolean']['input']>;
  hasExpectedShipmentDate?: InputMaybe<Scalars['Boolean']['input']>;
  hasInventoryTrackingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  hasMedia?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentProduct?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  inventoryState?: InputMaybe<ProductInventoryState>;
  inventoryState_in?: InputMaybe<Array<ProductInventoryState>>;
  inventoryState_notin?: InputMaybe<Array<ProductInventoryState>>;
  isMainProduct?: InputMaybe<Scalars['Boolean']['input']>;
  matchRelationId?: InputMaybe<Scalars['ID']['input']>;
  productBadgeId?: InputMaybe<Scalars['ID']['input']>;
  productClassId?: InputMaybe<Scalars['ID']['input']>;
  productDisclaimerId?: InputMaybe<Scalars['ID']['input']>;
  promotionGroupId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  sku?: InputMaybe<Scalars['NonEmptyString']['input']>;
  sku_in?: InputMaybe<Array<Scalars['NonEmptyString']['input']>>;
  state?: InputMaybe<ProductState>;
  state_in?: InputMaybe<Array<ProductState>>;
  state_neq?: InputMaybe<ProductState>;
  state_notin?: InputMaybe<Array<ProductState>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type?: InputMaybe<ProductType>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  valueCollectionId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProductWhereSubInput = {
  AND?: InputMaybe<Array<ProductWhereSubInput>>;
  OR?: InputMaybe<Array<ProductWhereSubInput>>;
  anyState?: InputMaybe<ProductState>;
  anyUpdatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  anyUpdatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  attributes?: InputMaybe<Array<ProductAttributeValueFilterInput>>;
  availableQuantity_gte?: InputMaybe<Scalars['SafeInt']['input']>;
  availableQuantity_lte?: InputMaybe<Scalars['SafeInt']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  cartRecommendationId?: InputMaybe<Scalars['ID']['input']>;
  catalogPromotionId?: InputMaybe<Scalars['ID']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryEstimateDays_gte?: InputMaybe<Scalars['SafeInt']['input']>;
  deliveryEstimateDays_lte?: InputMaybe<Scalars['SafeInt']['input']>;
  editorId?: InputMaybe<Scalars['ID']['input']>;
  fetchRelationId?: InputMaybe<Scalars['ID']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  hasChildProducts?: InputMaybe<Scalars['Boolean']['input']>;
  hasConfigurationErrors?: InputMaybe<Scalars['Boolean']['input']>;
  hasExpectedShipmentDate?: InputMaybe<Scalars['Boolean']['input']>;
  hasInventoryTrackingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  hasMedia?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentProduct?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  inventoryState?: InputMaybe<ProductInventoryState>;
  inventoryState_in?: InputMaybe<Array<ProductInventoryState>>;
  inventoryState_notin?: InputMaybe<Array<ProductInventoryState>>;
  isMainProduct?: InputMaybe<Scalars['Boolean']['input']>;
  matchRelationId?: InputMaybe<Scalars['ID']['input']>;
  productBadgeId?: InputMaybe<Scalars['ID']['input']>;
  productClassId?: InputMaybe<Scalars['ID']['input']>;
  productDisclaimerId?: InputMaybe<Scalars['ID']['input']>;
  promotionGroupId?: InputMaybe<Scalars['ID']['input']>;
  sku?: InputMaybe<Scalars['NonEmptyString']['input']>;
  sku_in?: InputMaybe<Array<Scalars['NonEmptyString']['input']>>;
  state?: InputMaybe<ProductState>;
  state_in?: InputMaybe<Array<ProductState>>;
  state_neq?: InputMaybe<ProductState>;
  state_notin?: InputMaybe<Array<ProductState>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type?: InputMaybe<ProductType>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  valueCollectionId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProductsConnection = {
  __typename: 'ProductsConnection';
  edges: Array<ProductsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type ProductsEdge = {
  __typename: 'ProductsEdge';
  cursor: Scalars['String']['output'];
  node: Product;
};

export type Promotion = {
  activeFrom: Maybe<Scalars['DateTime']['output']>;
  activeTo: Maybe<Scalars['DateTime']['output']>;
  continueProcessing: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  id: Scalars['ID']['output'];
  isSticky: Scalars['Boolean']['output'];
  matchRuleset: Maybe<Ruleset>;
  name: Scalars['NonEmptyString']['output'];
  priority: Scalars['NonNegativeInt']['output'];
  state: PromotionState;
  title: Maybe<Scalars['NonEmptyString']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PromotionAddCodesPayload = {
  __typename: 'PromotionAddCodesPayload';
  codes: Array<PromotionCode>;
  promotion: Promotion;
};

export type PromotionAddCodesUnion = EntityNotFoundError | PromotionAddCodesPayload;

export type PromotionCode = Node & {
  __typename: 'PromotionCode';
  code: Scalars['NonEmptyString']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  orderCount: Scalars['NonNegativeInt']['output'];
  promotion: Promotion;
  updatedAt: Scalars['DateTime']['output'];
};

export type PromotionCodeDeletePayload = {
  __typename: 'PromotionCodeDeletePayload';
  promotionCode: PromotionCode;
};

export type PromotionCodeDeleteUnion = EntityNotFoundError | PromotionCodeDeletePayload;

export enum PromotionCodeOrderByField {
  Code = 'CODE',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type PromotionCodeOrderByInput = {
  direction: OrderByDirection;
  field: PromotionCodeOrderByField;
};

export enum PromotionCodeType {
  Alphabetical = 'ALPHABETICAL',
  Alphanumerical = 'ALPHANUMERICAL',
  Numerical = 'NUMERICAL'
}

export type PromotionCodeUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type PromotionCodeWhereInput = {
  AND?: InputMaybe<Array<PromotionCodeWhereSubInput>>;
  OR?: InputMaybe<Array<PromotionCodeWhereSubInput>>;
  code?: InputMaybe<Scalars['NonEmptyString']['input']>;
  promotionId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type PromotionCodeWhereSubInput = {
  AND?: InputMaybe<Array<PromotionCodeWhereSubInput>>;
  OR?: InputMaybe<Array<PromotionCodeWhereSubInput>>;
  code?: InputMaybe<Scalars['NonEmptyString']['input']>;
  promotionId?: InputMaybe<Scalars['ID']['input']>;
};

export type PromotionCodesConnection = {
  __typename: 'PromotionCodesConnection';
  edges: Array<PromotionCodesEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type PromotionCodesEdge = {
  __typename: 'PromotionCodesEdge';
  cursor: Scalars['String']['output'];
  node: PromotionCode;
};

export type PromotionCreateInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  continueProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  discountAmount?: InputMaybe<Scalars['PositiveFloat']['input']>;
  discountDivider?: InputMaybe<Scalars['PositiveFloat']['input']>;
  discountQuantityPerCart?: InputMaybe<Scalars['PositiveFloat']['input']>;
  discountQuantityPerProductRow?: InputMaybe<Scalars['PositiveFloat']['input']>;
  discountType?: InputMaybe<PromotionDiscountType>;
  filterRulesetId?: InputMaybe<Scalars['ID']['input']>;
  isSticky?: InputMaybe<Scalars['Boolean']['input']>;
  matchRulesetId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['NonEmptyString']['input'];
  priceTypeId?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  promotionStyleId?: InputMaybe<Scalars['ID']['input']>;
  requiresLogin?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<PromotionState>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type: PromotionType;
  usesPerCode?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type PromotionCreatePayload = {
  __typename: 'PromotionCreatePayload';
  promotion: Promotion;
};

export type PromotionCreateUnion = InvalidInputError | PromotionCreatePayload;

export type PromotionDeleteCodesPayload = {
  __typename: 'PromotionDeleteCodesPayload';
  codes: Array<PromotionCode>;
  promotion: Promotion;
};

export type PromotionDeleteCodesUnion = EntityNotFoundError | PromotionDeleteCodesPayload;

export type PromotionDeletePayload = {
  __typename: 'PromotionDeletePayload';
  promotion: Promotion;
};

export type PromotionDeleteUnion = EntityNotFoundError | PromotionDeletePayload;

export enum PromotionDiscountType {
  ClubPrice = 'CLUB_PRICE',
  FixedAmount = 'FIXED_AMOUNT',
  FixedAmountFromCart = 'FIXED_AMOUNT_FROM_CART',
  FixedAmountFromProduct = 'FIXED_AMOUNT_FROM_PRODUCT',
  Freebie = 'FREEBIE',
  FreeShipping = 'FREE_SHIPPING',
  Percent = 'PERCENT',
  ProductCartPromotionPrice = 'PRODUCT_CART_PROMOTION_PRICE',
  ProductPromotionPrice = 'PRODUCT_PROMOTION_PRICE'
}

export type PromotionDuplicatePayload = {
  __typename: 'PromotionDuplicatePayload';
  promotion: Promotion;
};

export type PromotionDuplicateUnion = EntityNotFoundError | InvalidInputError | PromotionDuplicatePayload;

export type PromotionGenerateCodesInput = {
  chunkLength?: InputMaybe<Scalars['PositiveInt']['input']>;
  count: Scalars['PositiveInt']['input'];
  length: Scalars['PositiveInt']['input'];
  prefix?: InputMaybe<Scalars['NonEmptyString']['input']>;
  suffix?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type: PromotionCodeType;
};

export type PromotionGenerateCodesPayload = {
  __typename: 'PromotionGenerateCodesPayload';
  codes: Array<PromotionCode>;
  promotion: Promotion;
};

export type PromotionGenerateCodesUnion = EntityNotFoundError | PromotionGenerateCodesPayload;

export type PromotionGroup = Node & {
  __typename: 'PromotionGroup';
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['NonEmptyString']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PromotionGroupCreateInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title: Scalars['NonEmptyString']['input'];
};

export type PromotionGroupCreatePayload = {
  __typename: 'PromotionGroupCreatePayload';
  promotionGroup: PromotionGroup;
};

export type PromotionGroupCreateUnion = InvalidInputError | PromotionGroupCreatePayload;

export type PromotionGroupDeletePayload = {
  __typename: 'PromotionGroupDeletePayload';
  promotionGroup: PromotionGroup;
};

export type PromotionGroupDeleteUnion = EntityNotFoundError | PromotionGroupDeletePayload;

export enum PromotionGroupOrderByField {
  CreatedAt = 'CREATED_AT',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type PromotionGroupOrderByInput = {
  direction: OrderByDirection;
  field: PromotionGroupOrderByField;
};

export type PromotionGroupResultUnion = EntityNotFoundError | PromotionGroup;

export type PromotionGroupUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type PromotionGroupUpdateInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type PromotionGroupUpdatePayload = {
  __typename: 'PromotionGroupUpdatePayload';
  promotionGroup: PromotionGroup;
};

export type PromotionGroupUpdateUnion = EntityNotFoundError | PromotionGroupUpdatePayload;

export type PromotionGroupWhereInput = {
  AND?: InputMaybe<Array<PromotionGroupWhereSubInput>>;
  OR?: InputMaybe<Array<PromotionGroupWhereSubInput>>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type PromotionGroupWhereSubInput = {
  AND?: InputMaybe<Array<PromotionGroupWhereSubInput>>;
  OR?: InputMaybe<Array<PromotionGroupWhereSubInput>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type PromotionGroupsConnection = {
  __typename: 'PromotionGroupsConnection';
  edges: Array<PromotionGroupsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type PromotionGroupsEdge = {
  __typename: 'PromotionGroupsEdge';
  cursor: Scalars['String']['output'];
  node: PromotionGroup;
};

export enum PromotionOrderByField {
  ActiveFrom = 'ACTIVE_FROM',
  ActiveTo = 'ACTIVE_TO',
  CreatedAt = 'CREATED_AT',
  IsSticky = 'IS_STICKY',
  Priority = 'PRIORITY',
  State = 'STATE',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type PromotionOrderByInput = {
  direction: OrderByDirection;
  field: PromotionOrderByField;
};

export type PromotionResultUnion = CartPromotionClubPrice | CartPromotionFixedAmountFromCart | CartPromotionFixedAmountFromProduct | CartPromotionFreeShipping | CartPromotionFreebie | CartPromotionPercent | CartPromotionProductCartPromotionPrice | CatalogPromotionFixedAmount | CatalogPromotionPercent | CatalogPromotionProductPromotionPrice | EntityNotFoundError;

export enum PromotionState {
  Disabled = 'DISABLED',
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED',
  Scheduled = 'SCHEDULED'
}

export type PromotionStyle = Node & {
  __typename: 'PromotionStyle';
  altContent: Maybe<Scalars['NonEmptyString']['output']>;
  altTheme: Maybe<PromotionStyleTheme>;
  content: Maybe<Scalars['NonEmptyString']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deliveryPricingInfoOverride: Maybe<Scalars['NonEmptyString']['output']>;
  description: Maybe<Scalars['NonEmptyString']['output']>;
  id: Scalars['ID']['output'];
  isCampaignModalEnabled: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  isTimedVisibility: Scalars['Boolean']['output'];
  mainTheme: PromotionStyleTheme;
  mirrored: Scalars['Boolean']['output'];
  productPage: PromotionStyleProductPage;
  title: Scalars['NonEmptyString']['output'];
  type: PromotionStyleType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum PromotionStyleColor {
  Black = 'BLACK',
  Custom = 'CUSTOM',
  Orange = 'ORANGE',
  Red = 'RED',
  White = 'WHITE',
  Yellow = 'YELLOW'
}

export type PromotionStyleColorInfo = {
  __typename: 'PromotionStyleColorInfo';
  color: PromotionStyleColor;
  customColor: Maybe<Scalars['HexColorCode']['output']>;
};

export type PromotionStyleColorInput = {
  color: PromotionStyleColor;
  customColor?: InputMaybe<Scalars['HexColorCode']['input']>;
};

export type PromotionStyleCreateInput = {
  altContent?: InputMaybe<Scalars['NonEmptyString']['input']>;
  altTheme?: InputMaybe<PromotionStyleThemeInput>;
  content?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  mainTheme: PromotionStyleThemeInput;
  mirrored?: InputMaybe<Scalars['Boolean']['input']>;
  productPage: PromotionStyleProductPageInput;
  title: Scalars['NonEmptyString']['input'];
  type: PromotionStyleType;
};

export type PromotionStyleCreatePayload = {
  __typename: 'PromotionStyleCreatePayload';
  promotionStyle: PromotionStyle;
};

export type PromotionStyleCreateUnion = InvalidInputError | PromotionStyleCreatePayload;

export type PromotionStyleDeletePayload = {
  __typename: 'PromotionStyleDeletePayload';
  promotionStyle: PromotionStyle;
};

export type PromotionStyleDeleteUnion = EntityNotFoundError | PromotionStyleDeletePayload;

export type PromotionStyleDuplicatePayload = {
  __typename: 'PromotionStyleDuplicatePayload';
  promotionStyle: PromotionStyle;
};

export type PromotionStyleDuplicateUnion = EntityNotFoundError | InvalidInputError | PromotionStyleDuplicatePayload;

export enum PromotionStyleFont {
  PrentonCond = 'PRENTON_COND',
  SansCaption = 'SANS_CAPTION',
  SansNarrow = 'SANS_NARROW'
}

export type PromotionStyleFontInfo = {
  __typename: 'PromotionStyleFontInfo';
  customSize: Maybe<Scalars['PositiveInt']['output']>;
  family: Maybe<PromotionStyleFont>;
  size: Maybe<PromotionStyleFontSize>;
};

export type PromotionStyleFontInput = {
  customSize?: InputMaybe<Scalars['PositiveInt']['input']>;
  family: PromotionStyleFont;
  size: PromotionStyleFontSize;
};

export enum PromotionStyleFontSize {
  Custom = 'CUSTOM',
  ExtraLarge = 'EXTRA_LARGE',
  ExtraSmall = 'EXTRA_SMALL',
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL'
}

export enum PromotionStyleOrderByField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type PromotionStyleOrderByInput = {
  direction: OrderByDirection;
  field: PromotionStyleOrderByField;
};

export type PromotionStyleProductPage = {
  __typename: 'PromotionStyleProductPage';
  campaignModalContent: Maybe<Scalars['NonEmptyString']['output']>;
  deliveryPricingInfoOverride: Maybe<Scalars['NonEmptyString']['output']>;
  hidePriceHistory: Scalars['Boolean']['output'];
  isCampaignModalEnabled: Maybe<Scalars['Boolean']['output']>;
  isTimedVisibility: Scalars['Boolean']['output'];
  omnibusContent: Maybe<Scalars['NonEmptyString']['output']>;
  promotionTimerContent: Maybe<Scalars['NonEmptyString']['output']>;
  showCountdownTextContent: Scalars['Boolean']['output'];
  showPromotionEndingTimer: Scalars['Boolean']['output'];
};

export type PromotionStyleProductPageInput = {
  campaignModalContent?: InputMaybe<Scalars['NonEmptyString']['input']>;
  deliveryPricingInfoOverride?: InputMaybe<Scalars['NonEmptyString']['input']>;
  hidePriceHistory?: InputMaybe<Scalars['Boolean']['input']>;
  isCampaignModalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isTimedVisibility?: InputMaybe<Scalars['Boolean']['input']>;
  omnibusContent?: InputMaybe<Scalars['NonEmptyString']['input']>;
  promotionTimerContent?: InputMaybe<Scalars['NonEmptyString']['input']>;
  showCountdownTextContent?: InputMaybe<Scalars['Boolean']['input']>;
  showPromotionEndingTimer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PromotionStyleResultUnion = EntityNotFoundError | PromotionStyle;

export type PromotionStyleTheme = {
  __typename: 'PromotionStyleTheme';
  background: PromotionStyleColorInfo;
  font: PromotionStyleFontInfo;
  text: PromotionStyleColorInfo;
};

export type PromotionStyleThemeInput = {
  background: PromotionStyleColorInput;
  font: PromotionStyleFontInput;
  text: PromotionStyleColorInput;
};

export enum PromotionStyleType {
  ClubPercentWithText = 'CLUB_PERCENT_WITH_TEXT',
  Omnibus = 'OMNIBUS',
  Percent = 'PERCENT',
  PercentWithAmount = 'PERCENT_WITH_AMOUNT',
  PercentWithText = 'PERCENT_WITH_TEXT',
  Text = 'TEXT'
}

export type PromotionStyleUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type PromotionStyleUpdateInput = {
  altContent?: InputMaybe<Scalars['NonEmptyString']['input']>;
  altTheme?: InputMaybe<PromotionStyleThemeInput>;
  content?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  mainTheme?: InputMaybe<PromotionStyleThemeInput>;
  mirrored?: InputMaybe<Scalars['Boolean']['input']>;
  productPage?: InputMaybe<PromotionStyleProductPageInput>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type?: InputMaybe<PromotionStyleType>;
};

export type PromotionStyleUpdatePayload = {
  __typename: 'PromotionStyleUpdatePayload';
  promotionStyle: PromotionStyle;
};

export type PromotionStyleUpdateUnion = EntityNotFoundError | PromotionStyleUpdatePayload;

export type PromotionStyleWhereInput = {
  AND?: InputMaybe<Array<PromotionStyleWhereSubInput>>;
  OR?: InputMaybe<Array<PromotionStyleWhereSubInput>>;
  code?: InputMaybe<Scalars['NonEmptyString']['input']>;
  promotionId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type PromotionStyleWhereSubInput = {
  AND?: InputMaybe<Array<PromotionStyleWhereSubInput>>;
  OR?: InputMaybe<Array<PromotionStyleWhereSubInput>>;
  code?: InputMaybe<Scalars['NonEmptyString']['input']>;
  promotionId?: InputMaybe<Scalars['ID']['input']>;
};

export type PromotionStylesConnection = {
  __typename: 'PromotionStylesConnection';
  edges: Array<PromotionStylesEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type PromotionStylesEdge = {
  __typename: 'PromotionStylesEdge';
  cursor: Scalars['String']['output'];
  node: PromotionStyle;
};

export enum PromotionType {
  Cart = 'CART',
  Catalog = 'CATALOG'
}

export type PromotionUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type PromotionUpdateInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  continueProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  discountAmount?: InputMaybe<Scalars['PositiveFloat']['input']>;
  discountDivider?: InputMaybe<Scalars['PositiveFloat']['input']>;
  discountQuantityPerCart?: InputMaybe<Scalars['PositiveFloat']['input']>;
  discountQuantityPerProductRow?: InputMaybe<Scalars['PositiveFloat']['input']>;
  discountType?: InputMaybe<PromotionDiscountType>;
  isSticky?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['NonEmptyString']['input']>;
  priority?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  requiresLogin?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<PromotionState>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  usesPerCode?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type PromotionUpdatePayload = {
  __typename: 'PromotionUpdatePayload';
  promotion: Promotion;
};

export type PromotionUpdateUnion = EntityNotFoundError | PromotionUpdatePayload;

export type PromotionWhereInput = {
  AND?: InputMaybe<Array<PromotionWhereSubInput>>;
  OR?: InputMaybe<Array<PromotionWhereSubInput>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isSticky?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  state?: InputMaybe<PromotionState>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type?: InputMaybe<PromotionType>;
};

export type PromotionWhereSubInput = {
  AND?: InputMaybe<Array<PromotionWhereSubInput>>;
  OR?: InputMaybe<Array<PromotionWhereSubInput>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isSticky?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<PromotionState>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type?: InputMaybe<PromotionType>;
};

export type PromotionsConnection = {
  __typename: 'PromotionsConnection';
  edges: Array<PromotionsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type PromotionsEdge = {
  __typename: 'PromotionsEdge';
  cursor: Scalars['String']['output'];
  node: Promotion;
};

export type Query = {
  __typename: 'Query';
  attribute: AttributeResultUnion;
  attributeGroup: AttributeGroupResultUnion;
  attributeGroups: AttributeGroupsConnection;
  attributeOption: AttributeOptionResultUnion;
  attributeOptions: AttributeOptionsConnection;
  attributes: AttributesConnection;
  audits: AuditsConnection;
  brand: BrandResultUnion;
  brands: BrandsConnection;
  cart: CartResultUnion;
  cartRecommendation: CartRecommendationResultUnion;
  cartRecommendations: CartRecommendationsConnection;
  categories: CategoriesConnection;
  category: CategoryResultUnion;
  companies: CompaniesConnection;
  company: CompanyResultUnion;
  companyAddress: CompanyAddressResultUnion;
  companyAddresses: CompanyAddressesConnection;
  currentStore: Maybe<Store>;
  customer: CustomerResultUnion;
  customerAddress: CustomerAddressResultUnion;
  customerAddresses: CustomerAddressesConnection;
  customerStatistics: Array<CustomerStatistics>;
  customers: CustomersConnection;
  defaultProductGroup: ProductGroupResultUnion;
  defaultPromotionStyle: PromotionStyleResultUnion;
  editor: EditorResultUnion;
  editorUpdates: EditorUpdatesConnection;
  editors: EditorsConnection;
  giftCard: GiftCardResultUnion;
  giftCards: GiftCardsConnection;
  me: Maybe<User>;
  node: Maybe<Node>;
  notificationTemplate: NotificationTemplateResultUnion;
  notificationTemplates: NotificationTemplatesConnection;
  notifications: NotificationsConnection;
  order: OrderResultUnion;
  orderEvents: OrderEventsConnection;
  orderPayment: OrderPaymentResultUnion;
  orderStatistics: Array<OrderStatistics>;
  orders: OrdersConnection;
  outlet: OutletResultUnion;
  outlets: OutletsConnection;
  paymentMethod: PaymentMethodResultUnion;
  paymentMethodGroup: PaymentMethodGroupResultUnion;
  paymentMethodGroups: PaymentMethodGroupsConnection;
  paymentMethods: PaymentMethodsConnection;
  priceType: PriceTypeResultUnion;
  priceTypes: PriceTypesConnection;
  product: ProductResultUnion;
  productAsset: ProductAssetResultUnion;
  productAssets: ProductAssetsConnection;
  productBadge: ProductBadgeResultUnion;
  productBadges: ProductBadgeConnection;
  productClass: ProductClassResultUnion;
  productClasses: ProductClassesConnection;
  productCollection: ProductCollectionResultUnion;
  productCollections: ProductCollectionsConnection;
  productDisclaimer: ProductDisclaimerResultUnion;
  productDisclaimers: ProductDisclaimersConnection;
  productExport: ProductExportResultUnion;
  productExports: ProductExportsConnection;
  productGroup: ProductGroupResultUnion;
  productGroupStatistics: Array<ProductGroupStatistics>;
  productGroups: ProductGroupsConnection;
  productImport: ProductImportResultUnion;
  productMedia: ProductMediaResultUnion;
  productMedias: ProductMediasConnection;
  productParcel: ProductParcelResultUnion;
  productParcels: ProductParcelsConnection;
  productProperties: ProductPropertiesConnection;
  productProperty: ProductPropertyResultUnion;
  productPropertyOption: ProductPropertyOptionResultUnion;
  productPropertyOptions: ProductPropertyOptionsConnection;
  productRelation: ProductRelationResultUnion;
  productRelations: ProductRelationsConnection;
  productValueCollection: ProductValueCollectionResultUnion;
  productValueCollections: ProductValueCollectionsConnection;
  products: ProductsConnection;
  promotion: PromotionResultUnion;
  promotionCodes: PromotionCodesConnection;
  promotionGroup: PromotionGroupResultUnion;
  promotionGroups: PromotionGroupsConnection;
  promotionStyle: PromotionStyleResultUnion;
  promotionStyles: PromotionStylesConnection;
  promotions: PromotionsConnection;
  role: Maybe<Role>;
  roles: RolesResult;
  ruleset: RulesetResultUnion;
  search: SearchConnection;
  shippingArea: ShippingAreaResultUnion;
  shippingAreas: ShippingAreasConnection;
  shippingMethod: ShippingMethodResultUnion;
  shippingMethodArea: ShippingMethodAreaResultUnion;
  shippingMethodAreas: ShippingMethodAreasConnection;
  shippingMethodGroup: ShippingMethodGroupResultUnion;
  shippingMethodGroups: ShippingMethodGroupsConnection;
  shippingMethodService: ShippingMethodServiceResultUnion;
  shippingMethodServices: ShippingMethodServicesConnection;
  shippingMethods: ShippingMethodsConnection;
  store: StoreResultUnion;
  stores: StoresConnection;
  taxClass: TaxClassResultUnion;
  taxClasses: TaxClassesConnection;
  user: Maybe<User>;
  users: UsersResult;
};


export type QueryAttributeArgs = {
  where: AttributeUniqueWhereInput;
};


export type QueryAttributeGroupArgs = {
  where: AttributeGroupUniqueWhereInput;
};


export type QueryAttributeGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AttributeGroupOrderByInput>>;
  where?: InputMaybe<AttributeGroupWhereInput>;
};


export type QueryAttributeOptionArgs = {
  where: AttributeOptionUniqueWhereInput;
};


export type QueryAttributeOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AttributeOptionOrderByInput>>;
  where?: InputMaybe<AttributeOptionWhereInput>;
};


export type QueryAttributesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AttributeOrderByInput>>;
  where?: InputMaybe<AttributeWhereInput>;
};


export type QueryAuditsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuditOrderByInput>>;
  where?: InputMaybe<AuditWhereInput>;
};


export type QueryBrandArgs = {
  where: BrandUniqueWhereInput;
};


export type QueryBrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrandOrderByInput>>;
  where?: InputMaybe<BrandWhereInput>;
};


export type QueryCartArgs = {
  where: CartUniqueWhereInput;
};


export type QueryCartRecommendationArgs = {
  where: CartRecommendationUniqueWhereInput;
};


export type QueryCartRecommendationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CartRecommendationOrderByInput>>;
  where?: InputMaybe<CartRecommendationWhereInput>;
};


export type QueryCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoryOrderByInput>>;
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryCategoryArgs = {
  where: CategoryUniqueWhereInput;
};


export type QueryCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompanyOrderByInput>>;
  where?: InputMaybe<CompanyWhereInput>;
};


export type QueryCompanyArgs = {
  where: CompanyUniqueWhereInput;
};


export type QueryCompanyAddressArgs = {
  where: CompanyAddressUniqueWhereInput;
};


export type QueryCompanyAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompanyAddressOrderByInput>>;
  where?: InputMaybe<CompanyAddressWhereInput>;
};


export type QueryCustomerArgs = {
  where: CustomerUniqueWhereInput;
};


export type QueryCustomerAddressArgs = {
  where: CustomerAddressUniqueWhereInput;
};


export type QueryCustomerAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomerAddressOrderByInput>>;
  where?: InputMaybe<CustomerAddressWhereInput>;
};


export type QueryCustomerStatisticsArgs = {
  range: CustomerStatisticsRangeInput;
};


export type QueryCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomerOrderByInput>>;
  where?: InputMaybe<CustomerWhereInput>;
};


export type QueryEditorArgs = {
  where: EditorUniqueWhereInput;
};


export type QueryEditorUpdatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where: EditorUpdateWhereInput;
};


export type QueryEditorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EditorOrderByInput>>;
  where?: InputMaybe<EditorWhereInput>;
};


export type QueryGiftCardArgs = {
  where: GiftCardUniqueWhereInput;
};


export type QueryGiftCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GiftCardOrderByInput>>;
  where?: InputMaybe<GiftCardWhereInput>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotificationTemplateArgs = {
  where: NotificationTemplateUniqueWhereInput;
};


export type QueryNotificationTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationTemplateOrderByInput>>;
  where?: InputMaybe<NotificationTemplateWhereInput>;
};


export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationOrderByInput>>;
  where?: InputMaybe<NotificationWhereInput>;
};


export type QueryOrderArgs = {
  where: OrderUniqueWhereInput;
};


export type QueryOrderEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderEventOrderByInput>>;
  where: OrderEventWhereInput;
};


export type QueryOrderPaymentArgs = {
  where: OrderPaymentUniqueWhereInputWithFingerprint;
};


export type QueryOrderStatisticsArgs = {
  range: OrderStatisticsRangeInput;
};


export type QueryOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderOrderByInput>>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryOutletArgs = {
  where: OutletUniqueWhereInput;
};


export type QueryOutletsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OutletOrderByInput>>;
  where?: InputMaybe<OutletWhereInput>;
};


export type QueryPaymentMethodArgs = {
  where: PaymentMethodUniqueWhereInput;
};


export type QueryPaymentMethodGroupArgs = {
  where: PaymentMethodGroupUniqueWhereInput;
};


export type QueryPaymentMethodGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PaymentMethodGroupOrderByInput>>;
  where?: InputMaybe<PaymentMethodGroupWhereInput>;
};


export type QueryPaymentMethodsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PaymentMethodOrderByInput>>;
  where?: InputMaybe<PaymentMethodWhereInput>;
};


export type QueryPriceTypeArgs = {
  where: PriceTypeUniqueWhereInput;
};


export type QueryPriceTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PriceTypeOrderByInput>>;
  where?: InputMaybe<PriceTypeWhereInput>;
};


export type QueryProductArgs = {
  where: ProductUniqueWhereInputWithSlug;
};


export type QueryProductAssetArgs = {
  where: ProductAssetUniqueWhereInput;
};


export type QueryProductAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductAssetOrderByInput>>;
  where?: InputMaybe<ProductAssetWhereInput>;
};


export type QueryProductBadgeArgs = {
  where: ProductBadgeUniqueWhereInput;
};


export type QueryProductBadgesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductBadgeOrderByInput>>;
  where?: InputMaybe<ProductBadgeWhereInput>;
};


export type QueryProductClassArgs = {
  where: ProductClassUniqueWhereInput;
};


export type QueryProductClassesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductClassOrderByInput>>;
  where?: InputMaybe<ProductClassWhereInput>;
};


export type QueryProductCollectionArgs = {
  where: ProductCollectionUniqueWhereInput;
};


export type QueryProductCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductCollectionOrderByInput>>;
  where?: InputMaybe<ProductCollectionWhereInput>;
};


export type QueryProductDisclaimerArgs = {
  where: ProductDisclaimerUniqueWhereInput;
};


export type QueryProductDisclaimersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductDisclaimerOrderByInput>>;
  where?: InputMaybe<ProductDisclaimerWhereInput>;
};


export type QueryProductExportArgs = {
  where: ProductExportUniqueWhereInput;
};


export type QueryProductExportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductExportOrderByInput>>;
  where?: InputMaybe<ProductExportWhereInput>;
};


export type QueryProductGroupArgs = {
  where: ProductGroupUniqueWhereInput;
};


export type QueryProductGroupStatisticsArgs = {
  range: ProductGroupStatisticsRangeInput;
};


export type QueryProductGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductGroupOrderByInput>>;
  where?: InputMaybe<ProductGroupWhereInput>;
};


export type QueryProductImportArgs = {
  where: ProductImportUniqueWhereInput;
};


export type QueryProductMediaArgs = {
  where: ProductMediaUniqueWhereInput;
};


export type QueryProductMediasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductMediaOrderByInput>>;
  where?: InputMaybe<ProductMediaWhereInput>;
};


export type QueryProductParcelArgs = {
  where: ProductParcelUniqueWhereInput;
};


export type QueryProductParcelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductParcelOrderByInput>>;
  where: ProductParcelWhereInput;
};


export type QueryProductPropertiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductPropertyOrderByInput>>;
  where?: InputMaybe<ProductPropertyWhereInput>;
};


export type QueryProductPropertyArgs = {
  where: ProductPropertyUniqueWhereInput;
};


export type QueryProductPropertyOptionArgs = {
  where: ProductPropertyOptionUniqueWhereInput;
};


export type QueryProductPropertyOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductPropertyOptionOrderByInput>>;
  where?: InputMaybe<ProductPropertyOptionWhereInput>;
};


export type QueryProductRelationArgs = {
  where: ProductRelationUniqueWhereInput;
};


export type QueryProductRelationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductRelationOrderByInput>>;
  where?: InputMaybe<ProductRelationWhereInput>;
};


export type QueryProductValueCollectionArgs = {
  where: ProductValueCollectionUniqueWhereInput;
};


export type QueryProductValueCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductValueCollectionOrderByInput>>;
  where?: InputMaybe<ProductValueCollectionWhereInput>;
};


export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductOrderByInput>>;
  where?: InputMaybe<ProductWhereInput>;
};


export type QueryPromotionArgs = {
  where: PromotionUniqueWhereInput;
};


export type QueryPromotionCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PromotionCodeOrderByInput>>;
  where?: InputMaybe<PromotionCodeWhereInput>;
};


export type QueryPromotionGroupArgs = {
  where: PromotionGroupUniqueWhereInput;
};


export type QueryPromotionGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PromotionGroupOrderByInput>>;
  where?: InputMaybe<PromotionGroupWhereInput>;
};


export type QueryPromotionStyleArgs = {
  where: PromotionStyleUniqueWhereInput;
};


export type QueryPromotionStylesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PromotionStyleOrderByInput>>;
  where?: InputMaybe<PromotionStyleWhereInput>;
};


export type QueryPromotionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PromotionOrderByInput>>;
  where?: InputMaybe<PromotionWhereInput>;
};


export type QueryRoleArgs = {
  where: RoleUniqueWhereInput;
};


export type QueryRolesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RoleWhereInput>;
};


export type QueryRulesetArgs = {
  where: RulesetUniqueWhereInput;
};


export type QuerySearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where: SearchWhereInput;
};


export type QueryShippingAreaArgs = {
  where: ShippingAreaUniqueWhereInput;
};


export type QueryShippingAreasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShippingAreaOrderByInput>>;
  where?: InputMaybe<ShippingAreaWhereInput>;
};


export type QueryShippingMethodArgs = {
  where: ShippingMethodUniqueWhereInput;
};


export type QueryShippingMethodAreaArgs = {
  where: ShippingMethodAreaUniqueWhereInput;
};


export type QueryShippingMethodAreasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShippingMethodAreaOrderByInput>>;
  where?: InputMaybe<ShippingMethodAreaWhereInput>;
};


export type QueryShippingMethodGroupArgs = {
  where: ShippingMethodGroupUniqueWhereInput;
};


export type QueryShippingMethodGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShippingMethodGroupOrderByInput>>;
  where?: InputMaybe<ShippingMethodGroupWhereInput>;
};


export type QueryShippingMethodServiceArgs = {
  where: ShippingMethodServiceUniqueWhereInput;
};


export type QueryShippingMethodServicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShippingMethodServiceOrderByInput>>;
  where?: InputMaybe<ShippingMethodServiceWhereInput>;
};


export type QueryShippingMethodsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShippingMethodOrderByInput>>;
  where?: InputMaybe<ShippingMethodWhereInput>;
};


export type QueryStoreArgs = {
  where: StoreUniqueWhereInput;
};


export type QueryStoresArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StoreOrderByInput>>;
  where?: InputMaybe<StoreWhereInput>;
};


export type QueryTaxClassArgs = {
  where: TaxClassUniqueWhereInput;
};


export type QueryTaxClassesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaxClassOrderByInput>>;
  where?: InputMaybe<TaxClassWhereInput>;
};


export type QueryUserArgs = {
  where: UserUniqueWhereInput;
};


export type QueryUsersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};

export type QuestionAndAnswer = {
  __typename: 'QuestionAndAnswer';
  answer: Scalars['NonEmptyString']['output'];
  question: Scalars['NonEmptyString']['output'];
};

export type QuestionAndAnswerInput = {
  answer: Scalars['NonEmptyString']['input'];
  question: Scalars['NonEmptyString']['input'];
};

export type ReorderInput = {
  id: Scalars['ID']['input'];
  position: Scalars['NonNegativeInt']['input'];
};

export type Role = {
  __typename: 'Role';
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type RoleUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type RoleWhereInput = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type RolesResult = {
  __typename: 'RolesResult';
  items: Array<Role>;
  totalCount: Scalars['Int']['output'];
};

export type Ruleset = Node & {
  __typename: 'Ruleset';
  createdAt: Scalars['DateTime']['output'];
  groups: Array<RulesetGroup>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RulesetBrandRule = Node & RulesetRule & {
  __typename: 'RulesetBrandRule';
  brands: Array<Brand>;
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  subject: RulesetRuleSubject;
  updatedAt: Scalars['DateTime']['output'];
};

export type RulesetCartProductAttributeValueRule = Node & RulesetRule & {
  __typename: 'RulesetCartProductAttributeValueRule';
  attribute: Attribute;
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  option: Maybe<AttributeOption>;
  options: Array<AttributeOption>;
  subject: RulesetRuleSubject;
  updatedAt: Scalars['DateTime']['output'];
  value: Maybe<Scalars['String']['output']>;
};

export type RulesetCreateInput = {
  groups?: InputMaybe<Array<RulesetGroupInput>>;
  parentId: Scalars['ID']['input'];
  parentType: RulesetParentType;
};

export type RulesetCreatePayload = {
  __typename: 'RulesetCreatePayload';
  ruleset: Ruleset;
};

export type RulesetCreateUnion = InvalidInputError | RulesetCreatePayload;

export type RulesetCustomerLoginStateRule = Node & RulesetRule & {
  __typename: 'RulesetCustomerLoginStateRule';
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  state: RulesetRuleCustomerLoginState;
  subject: RulesetRuleSubject;
  updatedAt: Scalars['DateTime']['output'];
};

export type RulesetCustomerTypeRule = Node & RulesetRule & {
  __typename: 'RulesetCustomerTypeRule';
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  subject: RulesetRuleSubject;
  type: OrderCustomerType;
  updatedAt: Scalars['DateTime']['output'];
};

export type RulesetDeletePayload = {
  __typename: 'RulesetDeletePayload';
  ruleset: Ruleset;
};

export type RulesetDeleteUnion = EntityNotFoundError | RulesetDeletePayload;

export type RulesetGroup = Node & {
  __typename: 'RulesetGroup';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  items: Array<RulesetGroupItem>;
  position: Scalars['NonNegativeInt']['output'];
  type: RulesetGroupType;
  updatedAt: Scalars['DateTime']['output'];
};

export type RulesetGroupInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  items: Array<RulesetGroupItemInput>;
};

export type RulesetGroupItem = Node & {
  __typename: 'RulesetGroupItem';
  createdAt: Scalars['DateTime']['output'];
  group: Maybe<RulesetGroup>;
  id: Scalars['ID']['output'];
  position: Scalars['NonNegativeInt']['output'];
  rule: Maybe<RulesetRule>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RulesetGroupItemInput = {
  group?: InputMaybe<RulesetGroupInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  rule?: InputMaybe<RulesetRuleInput>;
};

export enum RulesetGroupType {
  And = 'AND',
  Or = 'OR'
}

export type RulesetNumericRule = Node & RulesetRule & {
  __typename: 'RulesetNumericRule';
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  subject: RulesetRuleSubject;
  updatedAt: Scalars['DateTime']['output'];
  value: Maybe<Scalars['Float']['output']>;
};

export type RulesetOrderPaymentMethodRule = Node & RulesetRule & {
  __typename: 'RulesetOrderPaymentMethodRule';
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  paymentMethods: Array<PaymentMethod>;
  subject: RulesetRuleSubject;
  updatedAt: Scalars['DateTime']['output'];
};

export type RulesetOrderShippingMethodRule = Node & RulesetRule & {
  __typename: 'RulesetOrderShippingMethodRule';
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  shippingMethods: Array<ShippingMethod>;
  subject: RulesetRuleSubject;
  updatedAt: Scalars['DateTime']['output'];
};

export enum RulesetParentType {
  CartRecommendation = 'CART_RECOMMENDATION',
  CartRecommendationProducts = 'CART_RECOMMENDATION_PRODUCTS',
  Category = 'CATEGORY',
  Editor = 'EDITOR',
  PaymentMethod = 'PAYMENT_METHOD',
  ProductBadge = 'PRODUCT_BADGE',
  ProductCollection = 'PRODUCT_COLLECTION',
  ProductDisclaimer = 'PRODUCT_DISCLAIMER',
  ProductRelationFetch = 'PRODUCT_RELATION_FETCH',
  ProductRelationMatch = 'PRODUCT_RELATION_MATCH',
  ProductValueCollection = 'PRODUCT_VALUE_COLLECTION',
  PromotionFilter = 'PROMOTION_FILTER',
  PromotionMatch = 'PROMOTION_MATCH',
  ShippingMethod = 'SHIPPING_METHOD'
}

export type RulesetProductAttributeValueRule = Node & RulesetRule & {
  __typename: 'RulesetProductAttributeValueRule';
  attribute: Attribute;
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  option: Maybe<AttributeOption>;
  options: Array<AttributeOption>;
  subject: RulesetRuleSubject;
  updatedAt: Scalars['DateTime']['output'];
  value: Maybe<Scalars['String']['output']>;
};

export type RulesetProductCategoriesRule = Node & RulesetRule & {
  __typename: 'RulesetProductCategoriesRule';
  categories: Array<Category>;
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  subject: RulesetRuleSubject;
  updatedAt: Scalars['DateTime']['output'];
};

export type RulesetProductClassRule = Node & RulesetRule & {
  __typename: 'RulesetProductClassRule';
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  productClasses: Array<ProductClass>;
  subject: RulesetRuleSubject;
  updatedAt: Scalars['DateTime']['output'];
};

export type RulesetProductCollectionsRule = Node & RulesetRule & {
  __typename: 'RulesetProductCollectionsRule';
  collections: Array<ProductCollection>;
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  subject: RulesetRuleSubject;
  updatedAt: Scalars['DateTime']['output'];
};

export type RulesetProductCreatedAtRule = Node & RulesetRule & {
  __typename: 'RulesetProductCreatedAtRule';
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  subject: RulesetRuleSubject;
  updatedAt: Scalars['DateTime']['output'];
  value: RulesetRuleProductCreatedAt;
};

export type RulesetProductGroupRule = Node & RulesetRule & {
  __typename: 'RulesetProductGroupRule';
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  groups: Array<ProductGroup>;
  id: Scalars['ID']['output'];
  subject: RulesetRuleSubject;
  updatedAt: Scalars['DateTime']['output'];
};

export type RulesetProductIdRule = Node & RulesetRule & {
  __typename: 'RulesetProductIdRule';
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  products: Array<Product>;
  subject: RulesetRuleSubject;
  updatedAt: Scalars['DateTime']['output'];
};

export type RulesetProductInventoryStateRule = Node & RulesetRule & {
  __typename: 'RulesetProductInventoryStateRule';
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  state: ProductInventoryState;
  subject: RulesetRuleSubject;
  updatedAt: Scalars['DateTime']['output'];
};

export type RulesetProductOutletQuantityRule = Node & RulesetRule & {
  __typename: 'RulesetProductOutletQuantityRule';
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  outlet: Maybe<Outlet>;
  quantity: Maybe<Scalars['Float']['output']>;
  subject: RulesetRuleSubject;
  updatedAt: Scalars['DateTime']['output'];
};

export type RulesetProductPromotionGroupRule = Node & RulesetRule & {
  __typename: 'RulesetProductPromotionGroupRule';
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  promotionGroups: Array<PromotionGroup>;
  subject: RulesetRuleSubject;
  updatedAt: Scalars['DateTime']['output'];
};

export type RulesetProductStateRule = Node & RulesetRule & {
  __typename: 'RulesetProductStateRule';
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  state: ProductState;
  subject: RulesetRuleSubject;
  updatedAt: Scalars['DateTime']['output'];
};

export type RulesetProductTypeRule = Node & RulesetRule & {
  __typename: 'RulesetProductTypeRule';
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  subject: RulesetRuleSubject;
  type: ProductType;
  updatedAt: Scalars['DateTime']['output'];
};

export type RulesetProductValueCollectionsRule = Node & RulesetRule & {
  __typename: 'RulesetProductValueCollectionsRule';
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  subject: RulesetRuleSubject;
  updatedAt: Scalars['DateTime']['output'];
  valueCollections: Array<ProductValueCollection>;
};

export type RulesetRefreshPayload = {
  __typename: 'RulesetRefreshPayload';
  ruleset: Ruleset;
};

export type RulesetRefreshUnion = EntityNotFoundError | RulesetRefreshPayload;

export type RulesetResultUnion = EntityNotFoundError | Ruleset;

export type RulesetRule = {
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  subject: RulesetRuleSubject;
  updatedAt: Scalars['DateTime']['output'];
};

export enum RulesetRuleComparator {
  DoesNotHave = 'DOES_NOT_HAVE',
  Empty = 'EMPTY',
  Equals = 'EQUALS',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  Has = 'HAS',
  In = 'IN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  NotEmpty = 'NOT_EMPTY',
  NotEquals = 'NOT_EQUALS',
  NotIn = 'NOT_IN'
}

export enum RulesetRuleCustomerLoginState {
  LoggedIn = 'LOGGED_IN',
  LoggedOut = 'LOGGED_OUT'
}

export enum RulesetRuleGroupSelector {
  All = 'ALL',
  Any = 'ANY',
  Equals = 'EQUALS',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO'
}

export type RulesetRuleInput = {
  attributeId?: InputMaybe<Scalars['ID']['input']>;
  comparator: RulesetRuleComparator;
  groupSelector?: InputMaybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity?: InputMaybe<Scalars['PositiveInt']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  subject: RulesetRuleSubject;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum RulesetRuleProductCreatedAt {
  Last_1Months = 'LAST_1_MONTHS',
  Last_2Months = 'LAST_2_MONTHS',
  Last_3Months = 'LAST_3_MONTHS',
  Last_4Months = 'LAST_4_MONTHS',
  Last_5Months = 'LAST_5_MONTHS',
  Last_6Months = 'LAST_6_MONTHS',
  Last_7Months = 'LAST_7_MONTHS',
  Last_8Months = 'LAST_8_MONTHS',
  Last_9Months = 'LAST_9_MONTHS',
  Last_10Months = 'LAST_10_MONTHS',
  Last_11Months = 'LAST_11_MONTHS',
  Last_12Months = 'LAST_12_MONTHS'
}

export enum RulesetRuleSubject {
  CartAssemblyTimeTotal = 'CART_ASSEMBLY_TIME_TOTAL',
  CartPriceTotal = 'CART_PRICE_TOTAL',
  CartProductAttributeValue = 'CART_PRODUCT_ATTRIBUTE_VALUE',
  CartProductPrice = 'CART_PRODUCT_PRICE',
  CartProductQuantity = 'CART_PRODUCT_QUANTITY',
  CartProductTotalPrice = 'CART_PRODUCT_TOTAL_PRICE',
  CartQuantityTotal = 'CART_QUANTITY_TOTAL',
  CustomerLoginState = 'CUSTOMER_LOGIN_STATE',
  CustomerType = 'CUSTOMER_TYPE',
  OrderPaymentMethod = 'ORDER_PAYMENT_METHOD',
  OrderShippingMethod = 'ORDER_SHIPPING_METHOD',
  ParcelsMaxDepth = 'PARCELS_MAX_DEPTH',
  ParcelsMaxHeight = 'PARCELS_MAX_HEIGHT',
  ParcelsMaxWeight = 'PARCELS_MAX_WEIGHT',
  ParcelsMaxWidth = 'PARCELS_MAX_WIDTH',
  ParcelsTotalQuantity = 'PARCELS_TOTAL_QUANTITY',
  ParcelsTotalVolume = 'PARCELS_TOTAL_VOLUME',
  ParcelsTotalWeight = 'PARCELS_TOTAL_WEIGHT',
  ProductAssemblyTime = 'PRODUCT_ASSEMBLY_TIME',
  ProductAttributeValue = 'PRODUCT_ATTRIBUTE_VALUE',
  ProductBrand = 'PRODUCT_BRAND',
  ProductCartPromotionPrice = 'PRODUCT_CART_PROMOTION_PRICE',
  ProductCategories = 'PRODUCT_CATEGORIES',
  ProductClass = 'PRODUCT_CLASS',
  ProductClubPrice = 'PRODUCT_CLUB_PRICE',
  ProductCollections = 'PRODUCT_COLLECTIONS',
  ProductCreatedAt = 'PRODUCT_CREATED_AT',
  ProductDeliveryEstimate = 'PRODUCT_DELIVERY_ESTIMATE',
  ProductDepth = 'PRODUCT_DEPTH',
  ProductDescription = 'PRODUCT_DESCRIPTION',
  ProductDiameter = 'PRODUCT_DIAMETER',
  ProductGroup = 'PRODUCT_GROUP',
  ProductHeight = 'PRODUCT_HEIGHT',
  ProductId = 'PRODUCT_ID',
  ProductInternalIdentifier = 'PRODUCT_INTERNAL_IDENTIFIER',
  ProductInventoryState = 'PRODUCT_INVENTORY_STATE',
  ProductName = 'PRODUCT_NAME',
  ProductOutletQuantity = 'PRODUCT_OUTLET_QUANTITY',
  ProductPrice = 'PRODUCT_PRICE',
  ProductPromotionGroup = 'PRODUCT_PROMOTION_GROUP',
  ProductPromotionPrice = 'PRODUCT_PROMOTION_PRICE',
  ProductPublishedAt = 'PRODUCT_PUBLISHED_AT',
  ProductPurchasePrice = 'PRODUCT_PURCHASE_PRICE',
  ProductQuantity = 'PRODUCT_QUANTITY',
  ProductRetailPrice = 'PRODUCT_RETAIL_PRICE',
  ProductSeoDescription = 'PRODUCT_SEO_DESCRIPTION',
  ProductSeoTitle = 'PRODUCT_SEO_TITLE',
  ProductShortDescription = 'PRODUCT_SHORT_DESCRIPTION',
  ProductSpecification = 'PRODUCT_SPECIFICATION',
  ProductState = 'PRODUCT_STATE',
  ProductTitle = 'PRODUCT_TITLE',
  ProductType = 'PRODUCT_TYPE',
  ProductValueCollections = 'PRODUCT_VALUE_COLLECTIONS',
  ProductVolume = 'PRODUCT_VOLUME',
  ProductWeight = 'PRODUCT_WEIGHT',
  ProductWidth = 'PRODUCT_WIDTH',
  ShippingAddressPostCode = 'SHIPPING_ADDRESS_POST_CODE',
  ShippingAddressShippingArea = 'SHIPPING_ADDRESS_SHIPPING_AREA'
}

export type RulesetShippingAddressPostCodeRule = Node & RulesetRule & {
  __typename: 'RulesetShippingAddressPostCodeRule';
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  subject: RulesetRuleSubject;
  updatedAt: Scalars['DateTime']['output'];
  value: Array<Scalars['PostalCode']['output']>;
};

export type RulesetShippingAddressShippingAreaRule = Node & RulesetRule & {
  __typename: 'RulesetShippingAddressShippingAreaRule';
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  subject: RulesetRuleSubject;
  updatedAt: Scalars['DateTime']['output'];
  value: Array<ShippingArea>;
};

export type RulesetTextRule = Node & RulesetRule & {
  __typename: 'RulesetTextRule';
  comparator: RulesetRuleComparator;
  createdAt: Scalars['DateTime']['output'];
  groupSelector: Maybe<RulesetRuleGroupSelector>;
  groupSelectorQuantity: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  subject: RulesetRuleSubject;
  updatedAt: Scalars['DateTime']['output'];
  value: Maybe<Scalars['String']['output']>;
};

export type RulesetUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type RulesetUpdateInput = {
  groups: Array<RulesetGroupInput>;
};

export type RulesetUpdatePayload = {
  __typename: 'RulesetUpdatePayload';
  ruleset: Ruleset;
};

export type RulesetUpdateUnion = EntityNotFoundError | RulesetUpdatePayload;

export type SearchConnection = {
  __typename: 'SearchConnection';
  edges: Array<SearchEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type SearchEdge = {
  __typename: 'SearchEdge';
  cursor: Scalars['String']['output'];
  node: Node;
};

export type SearchWhereInput = {
  query: Scalars['NonEmptyString']['input'];
};

export type ShippingArea = Node & {
  __typename: 'ShippingArea';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  postalCodes: Array<Scalars['NonEmptyString']['output']>;
  title: Scalars['NonEmptyString']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ShippingAreaCreateInput = {
  postalCodes: Array<Scalars['NonEmptyString']['input']>;
  title: Scalars['NonEmptyString']['input'];
};

export type ShippingAreaCreatePayload = {
  __typename: 'ShippingAreaCreatePayload';
  shippingArea: ShippingArea;
};

export type ShippingAreaCreateUnion = InvalidInputError | ShippingAreaCreatePayload;

export type ShippingAreaDeletePayload = {
  __typename: 'ShippingAreaDeletePayload';
  shippingArea: ShippingArea;
};

export type ShippingAreaDeleteUnion = EntityNotFoundError | ShippingAreaDeletePayload;

export enum ShippingAreaOrderByField {
  CreatedAt = 'CREATED_AT',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type ShippingAreaOrderByInput = {
  direction: OrderByDirection;
  field: ShippingAreaOrderByField;
};

export type ShippingAreaResultUnion = EntityNotFoundError | ShippingArea;

export type ShippingAreaUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type ShippingAreaUpdateInput = {
  postalCodes?: InputMaybe<Array<Scalars['NonEmptyString']['input']>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ShippingAreaUpdatePayload = {
  __typename: 'ShippingAreaUpdatePayload';
  shippingArea: ShippingArea;
};

export type ShippingAreaUpdateUnion = EntityNotFoundError | ShippingAreaUpdatePayload;

export type ShippingAreaWhereInput = {
  AND?: InputMaybe<Array<ShippingAreaWhereSubInput>>;
  OR?: InputMaybe<Array<ShippingAreaWhereSubInput>>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ShippingAreaWhereSubInput = {
  AND?: InputMaybe<Array<ShippingAreaWhereSubInput>>;
  OR?: InputMaybe<Array<ShippingAreaWhereSubInput>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ShippingAreasConnection = {
  __typename: 'ShippingAreasConnection';
  edges: Array<ShippingAreasEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type ShippingAreasEdge = {
  __typename: 'ShippingAreasEdge';
  cursor: Scalars['String']['output'];
  node: ShippingArea;
};

export type ShippingMethod = {
  createdAt: Scalars['DateTime']['output'];
  data: Array<ShippingMethodData>;
  description: Maybe<Scalars['NonEmptyString']['output']>;
  freeShippingPrice: Maybe<Money>;
  freeShippingPriceWithServices: Money;
  group: Maybe<ShippingMethodGroup>;
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['URL']['output']>;
  originalPriceWithServices: Money;
  position: Scalars['NonNegativeInt']['output'];
  price: Money;
  priceWithServices: Money;
  ruleset: Maybe<Ruleset>;
  services: Array<ShippingMethodService>;
  state: ShippingMethodState;
  taxClass: TaxClass;
  title: Scalars['NonEmptyString']['output'];
  type: ShippingMethodType;
  updatedAt: Scalars['DateTime']['output'];
};


export type ShippingMethodOriginalPriceWithServicesArgs = {
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
};


export type ShippingMethodPriceWithServicesArgs = {
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
};

export type ShippingMethodArea = Node & {
  __typename: 'ShippingMethodArea';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  price: Money;
  shippingArea: ShippingArea;
  updatedAt: Scalars['DateTime']['output'];
};

export type ShippingMethodAreaCreateInput = {
  price: Scalars['Decimal']['input'];
  shippingAreaId: Scalars['ID']['input'];
  shippingMethodId: Scalars['ID']['input'];
};

export type ShippingMethodAreaCreatePayload = {
  __typename: 'ShippingMethodAreaCreatePayload';
  shippingMethod: ShippingMethod;
  shippingMethodArea: ShippingMethodArea;
};

export type ShippingMethodAreaCreateUnion = InvalidInputError | ShippingMethodAreaCreatePayload;

export type ShippingMethodAreaDeletePayload = {
  __typename: 'ShippingMethodAreaDeletePayload';
  shippingMethod: ShippingMethod;
  shippingMethodArea: ShippingMethodArea;
};

export type ShippingMethodAreaDeleteUnion = EntityNotFoundError | ShippingMethodAreaDeletePayload;

export enum ShippingMethodAreaOrderByField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type ShippingMethodAreaOrderByInput = {
  direction: OrderByDirection;
  field: ShippingMethodAreaOrderByField;
};

export type ShippingMethodAreaResultUnion = EntityNotFoundError | ShippingMethodArea;

export type ShippingMethodAreaUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type ShippingMethodAreaUpdateInput = {
  price?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ShippingMethodAreaUpdatePayload = {
  __typename: 'ShippingMethodAreaUpdatePayload';
  shippingMethod: ShippingMethod;
  shippingMethodArea: ShippingMethodArea;
};

export type ShippingMethodAreaUpdateUnion = EntityNotFoundError | ShippingMethodAreaUpdatePayload;

export type ShippingMethodAreaWhereInput = {
  shippingMethodId: Scalars['ID']['input'];
};

export type ShippingMethodAreasConnection = {
  __typename: 'ShippingMethodAreasConnection';
  edges: Array<ShippingMethodAreasEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type ShippingMethodAreasEdge = {
  __typename: 'ShippingMethodAreasEdge';
  cursor: Scalars['String']['output'];
  node: ShippingMethodArea;
};

export type ShippingMethodCreateInput = {
  data?: InputMaybe<Array<ShippingMethodDataInput>>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  freeShippingPrice?: InputMaybe<Scalars['Decimal']['input']>;
  logo?: InputMaybe<Scalars['NonEmptyString']['input']>;
  position?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  state?: InputMaybe<ShippingMethodState>;
  taxClassId: Scalars['ID']['input'];
  title: Scalars['NonEmptyString']['input'];
  type: ShippingMethodType;
};

export type ShippingMethodCreatePayload = {
  __typename: 'ShippingMethodCreatePayload';
  shippingMethod: ShippingMethod;
};

export type ShippingMethodCreateUnion = InvalidInputError | ShippingMethodCreatePayload;

export type ShippingMethodData = Node & {
  __typename: 'ShippingMethodData';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['NonEmptyString']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Maybe<Scalars['NonEmptyString']['output']>;
};

export type ShippingMethodDataInput = {
  key: Scalars['NonEmptyString']['input'];
  value?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ShippingMethodDeletePayload = {
  __typename: 'ShippingMethodDeletePayload';
  shippingMethod: ShippingMethod;
};

export type ShippingMethodDeleteUnion = EntityNotFoundError | ShippingMethodDeletePayload;

export type ShippingMethodDuplicatePayload = {
  __typename: 'ShippingMethodDuplicatePayload';
  shippingMethod: ShippingMethod;
};

export type ShippingMethodDuplicateUnion = EntityNotFoundError | InvalidInputError | ShippingMethodDuplicatePayload;

export type ShippingMethodEmail = Node & ShippingMethod & {
  __typename: 'ShippingMethodEmail';
  createdAt: Scalars['DateTime']['output'];
  data: Array<ShippingMethodData>;
  description: Maybe<Scalars['NonEmptyString']['output']>;
  freeShippingPrice: Maybe<Money>;
  freeShippingPriceWithServices: Money;
  group: Maybe<ShippingMethodGroup>;
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['URL']['output']>;
  originalPriceWithServices: Money;
  position: Scalars['NonNegativeInt']['output'];
  price: Money;
  priceWithServices: Money;
  ruleset: Maybe<Ruleset>;
  services: Array<ShippingMethodService>;
  state: ShippingMethodState;
  taxClass: TaxClass;
  title: Scalars['NonEmptyString']['output'];
  type: ShippingMethodType;
  updatedAt: Scalars['DateTime']['output'];
};


export type ShippingMethodEmailOriginalPriceWithServicesArgs = {
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
};


export type ShippingMethodEmailPriceWithServicesArgs = {
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
};

export type ShippingMethodGroup = Node & {
  __typename: 'ShippingMethodGroup';
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  id: Scalars['ID']['output'];
  position: Scalars['NonNegativeInt']['output'];
  shippingMethods: Array<ShippingMethod>;
  title: Scalars['NonEmptyString']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ShippingMethodGroupAddShippingMethodsPayload = {
  __typename: 'ShippingMethodGroupAddShippingMethodsPayload';
  shippingMethodGroup: ShippingMethodGroup;
  shippingMethods: Array<ShippingMethod>;
};

export type ShippingMethodGroupAddShippingMethodsUnion = EntityNotFoundError | ShippingMethodGroupAddShippingMethodsPayload;

export type ShippingMethodGroupCreateInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title: Scalars['NonEmptyString']['input'];
};

export type ShippingMethodGroupCreatePayload = {
  __typename: 'ShippingMethodGroupCreatePayload';
  shippingMethodGroup: ShippingMethodGroup;
};

export type ShippingMethodGroupCreateUnion = InvalidInputError | ShippingMethodGroupCreatePayload;

export type ShippingMethodGroupDeletePayload = {
  __typename: 'ShippingMethodGroupDeletePayload';
  shippingMethodGroup: ShippingMethodGroup;
};

export type ShippingMethodGroupDeleteUnion = EntityNotFoundError | ShippingMethodGroupDeletePayload;

export enum ShippingMethodGroupOrderByField {
  CreatedAt = 'CREATED_AT',
  Position = 'POSITION',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type ShippingMethodGroupOrderByInput = {
  direction: OrderByDirection;
  field: ShippingMethodGroupOrderByField;
};

export type ShippingMethodGroupRemoveShippingMethodsPayload = {
  __typename: 'ShippingMethodGroupRemoveShippingMethodsPayload';
  shippingMethodGroup: ShippingMethodGroup;
  shippingMethods: Array<ShippingMethod>;
};

export type ShippingMethodGroupRemoveShippingMethodsUnion = EntityNotFoundError | ShippingMethodGroupRemoveShippingMethodsPayload;

export type ShippingMethodGroupReorderPayload = {
  __typename: 'ShippingMethodGroupReorderPayload';
  shippingMethodGroups: Array<ShippingMethodGroup>;
};

export type ShippingMethodGroupReorderShippingMethodsPayload = {
  __typename: 'ShippingMethodGroupReorderShippingMethodsPayload';
  shippingMethodGroup: ShippingMethodGroup;
};

export type ShippingMethodGroupReorderShippingMethodsUnion = EntityNotFoundError | ShippingMethodGroupReorderShippingMethodsPayload;

export type ShippingMethodGroupReorderUnion = InvalidInputError | ShippingMethodGroupReorderPayload;

export type ShippingMethodGroupResultUnion = EntityNotFoundError | ShippingMethodGroup;

export type ShippingMethodGroupUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type ShippingMethodGroupUpdateInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ShippingMethodGroupUpdatePayload = {
  __typename: 'ShippingMethodGroupUpdatePayload';
  shippingMethodGroup: ShippingMethodGroup;
};

export type ShippingMethodGroupUpdateUnion = EntityNotFoundError | ShippingMethodGroupUpdatePayload;

export type ShippingMethodGroupWhereInput = {
  AND?: InputMaybe<Array<ShippingMethodGroupWhereSubInput>>;
  OR?: InputMaybe<Array<ShippingMethodGroupWhereSubInput>>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ShippingMethodGroupWhereSubInput = {
  AND?: InputMaybe<Array<ShippingMethodGroupWhereSubInput>>;
  OR?: InputMaybe<Array<ShippingMethodGroupWhereSubInput>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ShippingMethodGroupsConnection = {
  __typename: 'ShippingMethodGroupsConnection';
  edges: Array<ShippingMethodGroupsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type ShippingMethodGroupsEdge = {
  __typename: 'ShippingMethodGroupsEdge';
  cursor: Scalars['String']['output'];
  node: ShippingMethodGroup;
};

export type ShippingMethodHakonen = Node & ShippingMethod & {
  __typename: 'ShippingMethodHakonen';
  createdAt: Scalars['DateTime']['output'];
  data: Array<ShippingMethodData>;
  description: Maybe<Scalars['NonEmptyString']['output']>;
  freeShippingPrice: Maybe<Money>;
  freeShippingPriceWithServices: Money;
  group: Maybe<ShippingMethodGroup>;
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['URL']['output']>;
  originalPriceWithServices: Money;
  position: Scalars['NonNegativeInt']['output'];
  price: Money;
  priceWithServices: Money;
  ruleset: Maybe<Ruleset>;
  services: Array<ShippingMethodService>;
  state: ShippingMethodState;
  taxClass: TaxClass;
  title: Scalars['NonEmptyString']['output'];
  type: ShippingMethodType;
  updatedAt: Scalars['DateTime']['output'];
};


export type ShippingMethodHakonenOriginalPriceWithServicesArgs = {
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
};


export type ShippingMethodHakonenPriceWithServicesArgs = {
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
};

export type ShippingMethodLocalDelivery = Node & ShippingMethod & {
  __typename: 'ShippingMethodLocalDelivery';
  createdAt: Scalars['DateTime']['output'];
  data: Array<ShippingMethodData>;
  description: Maybe<Scalars['NonEmptyString']['output']>;
  freeShippingPrice: Maybe<Money>;
  freeShippingPriceWithServices: Money;
  group: Maybe<ShippingMethodGroup>;
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['URL']['output']>;
  originalPriceWithServices: Money;
  position: Scalars['NonNegativeInt']['output'];
  price: Money;
  priceWithServices: Money;
  ruleset: Maybe<Ruleset>;
  services: Array<ShippingMethodService>;
  state: ShippingMethodState;
  taxClass: TaxClass;
  title: Scalars['NonEmptyString']['output'];
  type: ShippingMethodType;
  updatedAt: Scalars['DateTime']['output'];
};


export type ShippingMethodLocalDeliveryOriginalPriceWithServicesArgs = {
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
};


export type ShippingMethodLocalDeliveryPriceWithServicesArgs = {
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
};

export type ShippingMethodMatkahuolto = Node & ShippingMethod & {
  __typename: 'ShippingMethodMatkahuolto';
  createdAt: Scalars['DateTime']['output'];
  data: Array<ShippingMethodData>;
  description: Maybe<Scalars['NonEmptyString']['output']>;
  freeShippingPrice: Maybe<Money>;
  freeShippingPriceWithServices: Money;
  group: Maybe<ShippingMethodGroup>;
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['URL']['output']>;
  offices: Array<ShippingMethodMatkahuoltoOffice>;
  originalPriceWithServices: Money;
  position: Scalars['NonNegativeInt']['output'];
  price: Money;
  priceWithServices: Money;
  ruleset: Maybe<Ruleset>;
  services: Array<ShippingMethodService>;
  state: ShippingMethodState;
  taxClass: TaxClass;
  title: Scalars['NonEmptyString']['output'];
  type: ShippingMethodType;
  updatedAt: Scalars['DateTime']['output'];
};


export type ShippingMethodMatkahuoltoOfficesArgs = {
  countryCode: Scalars['CountryCode']['input'];
  postalCode: Scalars['PostalCode']['input'];
  type?: InputMaybe<ShippingMethodMatkahuoltoOfficeRequestType>;
};


export type ShippingMethodMatkahuoltoOriginalPriceWithServicesArgs = {
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
};


export type ShippingMethodMatkahuoltoPriceWithServicesArgs = {
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
};

export type ShippingMethodMatkahuoltoOffice = {
  __typename: 'ShippingMethodMatkahuoltoOffice';
  address: Scalars['NonEmptyString']['output'];
  city: Scalars['NonEmptyString']['output'];
  countryCode: Scalars['CountryCode']['output'];
  distance: Scalars['NonNegativeFloat']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['NonEmptyString']['output'];
  postalCode: Scalars['NonEmptyString']['output'];
  type: ShippingMethodMatkahuoltoOfficeType;
};

export enum ShippingMethodMatkahuoltoOfficeRequestType {
  A = 'A',
  Lq = 'LQ',
  M = 'M',
  Mha = 'MHA',
  Mhm = 'MHM',
  N = 'N',
  P = 'P',
  R = 'R',
  T = 'T',
  U = 'U'
}

export enum ShippingMethodMatkahuoltoOfficeType {
  Mha = 'MHA',
  Mhe = 'MHE',
  Mhm = 'MHM',
  Mhn = 'MHN',
  Mht = 'MHT',
  Mhx = 'MHX'
}

export type ShippingMethodOmniva = Node & ShippingMethod & {
  __typename: 'ShippingMethodOmniva';
  createdAt: Scalars['DateTime']['output'];
  data: Array<ShippingMethodData>;
  description: Maybe<Scalars['NonEmptyString']['output']>;
  freeShippingPrice: Maybe<Money>;
  freeShippingPriceWithServices: Money;
  group: Maybe<ShippingMethodGroup>;
  id: Scalars['ID']['output'];
  locations: Array<ShippingMethodOmnivaLocation>;
  logo: Maybe<Scalars['URL']['output']>;
  originalPriceWithServices: Money;
  position: Scalars['NonNegativeInt']['output'];
  price: Money;
  priceWithServices: Money;
  ruleset: Maybe<Ruleset>;
  services: Array<ShippingMethodService>;
  state: ShippingMethodState;
  taxClass: TaxClass;
  title: Scalars['NonEmptyString']['output'];
  type: ShippingMethodType;
  updatedAt: Scalars['DateTime']['output'];
};


export type ShippingMethodOmnivaLocationsArgs = {
  countryCode: Scalars['CountryCode']['input'];
  postalCode: Scalars['PostalCode']['input'];
  type?: InputMaybe<ShippingMethodOmnivaLocationType>;
};


export type ShippingMethodOmnivaOriginalPriceWithServicesArgs = {
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
};


export type ShippingMethodOmnivaPriceWithServicesArgs = {
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
};

export type ShippingMethodOmnivaLocation = {
  __typename: 'ShippingMethodOmnivaLocation';
  approximateDistance: Scalars['NonNegativeInt']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notes: Maybe<Scalars['NonEmptyString']['output']>;
  serviceHours: Maybe<Scalars['NonEmptyString']['output']>;
  type: ShippingMethodOmnivaLocationType;
};

export enum ShippingMethodOmnivaLocationType {
  Locker = 'LOCKER',
  Office = 'OFFICE'
}

export enum ShippingMethodOrderByField {
  CreatedAt = 'CREATED_AT',
  Position = 'POSITION',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type ShippingMethodOrderByInput = {
  direction: OrderByDirection;
  field: ShippingMethodOrderByField;
};

export type ShippingMethodPickUpFromStore = Node & ShippingMethod & {
  __typename: 'ShippingMethodPickUpFromStore';
  createdAt: Scalars['DateTime']['output'];
  data: Array<ShippingMethodData>;
  description: Maybe<Scalars['NonEmptyString']['output']>;
  freeShippingPrice: Maybe<Money>;
  freeShippingPriceWithServices: Money;
  group: Maybe<ShippingMethodGroup>;
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['URL']['output']>;
  originalPriceWithServices: Money;
  outlets: Array<Outlet>;
  position: Scalars['NonNegativeInt']['output'];
  price: Money;
  priceWithServices: Money;
  ruleset: Maybe<Ruleset>;
  services: Array<ShippingMethodService>;
  state: ShippingMethodState;
  taxClass: TaxClass;
  title: Scalars['NonEmptyString']['output'];
  type: ShippingMethodType;
  updatedAt: Scalars['DateTime']['output'];
};


export type ShippingMethodPickUpFromStoreOriginalPriceWithServicesArgs = {
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
};


export type ShippingMethodPickUpFromStorePriceWithServicesArgs = {
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
};

export type ShippingMethodPosti = Node & ShippingMethod & {
  __typename: 'ShippingMethodPosti';
  createdAt: Scalars['DateTime']['output'];
  data: Array<ShippingMethodData>;
  description: Maybe<Scalars['NonEmptyString']['output']>;
  freeShippingPrice: Maybe<Money>;
  freeShippingPriceWithServices: Money;
  group: Maybe<ShippingMethodGroup>;
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['URL']['output']>;
  originalPriceWithServices: Money;
  position: Scalars['NonNegativeInt']['output'];
  price: Money;
  priceWithServices: Money;
  ruleset: Maybe<Ruleset>;
  services: Array<ShippingMethodService>;
  state: ShippingMethodState;
  taxClass: TaxClass;
  title: Scalars['NonEmptyString']['output'];
  type: ShippingMethodType;
  updatedAt: Scalars['DateTime']['output'];
};


export type ShippingMethodPostiOriginalPriceWithServicesArgs = {
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
};


export type ShippingMethodPostiPriceWithServicesArgs = {
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
};

export type ShippingMethodResultUnion = EntityNotFoundError | ShippingMethodEmail | ShippingMethodHakonen | ShippingMethodLocalDelivery | ShippingMethodMatkahuolto | ShippingMethodOmniva | ShippingMethodPickUpFromStore | ShippingMethodPosti;

export type ShippingMethodService = Node & {
  __typename: 'ShippingMethodService';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['NonEmptyString']['output'];
  price: Money;
  promotionPrice: Maybe<Money>;
  sku: Maybe<Scalars['NonEmptyString']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ShippingMethodServiceCreateInput = {
  name: Scalars['NonEmptyString']['input'];
  price: Scalars['Decimal']['input'];
  promotionPrice?: InputMaybe<Scalars['Decimal']['input']>;
  shippingMethodId: Scalars['ID']['input'];
  sku?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ShippingMethodServiceCreatePayload = {
  __typename: 'ShippingMethodServiceCreatePayload';
  shippingMethod: ShippingMethod;
  shippingMethodService: ShippingMethodService;
};

export type ShippingMethodServiceCreateUnion = InvalidInputError | ShippingMethodServiceCreatePayload;

export type ShippingMethodServiceDeletePayload = {
  __typename: 'ShippingMethodServiceDeletePayload';
  shippingMethod: ShippingMethod;
  shippingMethodService: ShippingMethodService;
};

export type ShippingMethodServiceDeleteUnion = EntityNotFoundError | ShippingMethodServiceDeletePayload;

export enum ShippingMethodServiceOrderByField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type ShippingMethodServiceOrderByInput = {
  direction: OrderByDirection;
  field: ShippingMethodServiceOrderByField;
};

export type ShippingMethodServiceResultUnion = EntityNotFoundError | ShippingMethodService;

export type ShippingMethodServiceUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type ShippingMethodServiceUpdateInput = {
  name?: InputMaybe<Scalars['NonEmptyString']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  promotionPrice?: InputMaybe<Scalars['Decimal']['input']>;
  sku?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ShippingMethodServiceUpdatePayload = {
  __typename: 'ShippingMethodServiceUpdatePayload';
  shippingMethod: ShippingMethod;
  shippingMethodService: ShippingMethodService;
};

export type ShippingMethodServiceUpdateUnion = EntityNotFoundError | ShippingMethodServiceUpdatePayload;

export type ShippingMethodServiceWhereInput = {
  shippingMethodId: Scalars['ID']['input'];
};

export type ShippingMethodServicesConnection = {
  __typename: 'ShippingMethodServicesConnection';
  edges: Array<ShippingMethodServicesEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type ShippingMethodServicesEdge = {
  __typename: 'ShippingMethodServicesEdge';
  cursor: Scalars['String']['output'];
  node: ShippingMethodService;
};

export enum ShippingMethodState {
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED'
}

export enum ShippingMethodType {
  Email = 'EMAIL',
  Hakonen = 'HAKONEN',
  LocalDelivery = 'LOCAL_DELIVERY',
  Matkahuolto = 'MATKAHUOLTO',
  Omniva = 'OMNIVA',
  PickUpFromStore = 'PICK_UP_FROM_STORE',
  Posti = 'POSTI'
}

export type ShippingMethodUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type ShippingMethodUpdateInput = {
  data?: InputMaybe<Array<ShippingMethodDataInput>>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  freeShippingPrice?: InputMaybe<Scalars['Decimal']['input']>;
  logo?: InputMaybe<Scalars['NonEmptyString']['input']>;
  position?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  state?: InputMaybe<ShippingMethodState>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ShippingMethodUpdatePayload = {
  __typename: 'ShippingMethodUpdatePayload';
  shippingMethod: ShippingMethod;
};

export type ShippingMethodUpdateUnion = EntityNotFoundError | ShippingMethodUpdatePayload;

export type ShippingMethodWhereInput = {
  AND?: InputMaybe<Array<ShippingMethodWhereSubInput>>;
  OR?: InputMaybe<Array<ShippingMethodWhereSubInput>>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ShippingMethodWhereSubInput = {
  AND?: InputMaybe<Array<ShippingMethodWhereSubInput>>;
  OR?: InputMaybe<Array<ShippingMethodWhereSubInput>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ShippingMethodsConnection = {
  __typename: 'ShippingMethodsConnection';
  edges: Array<ShippingMethodsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type ShippingMethodsEdge = {
  __typename: 'ShippingMethodsEdge';
  cursor: Scalars['String']['output'];
  node: ShippingMethod;
};

export type SimpleProduct = Node & Product & {
  __typename: 'SimpleProduct';
  assets: Array<ProductAsset>;
  attributes: Array<ProductAttributeValue>;
  availableShippingMethods: Array<ShippingMethod>;
  brand: Maybe<Brand>;
  brandLogo: Maybe<Scalars['String']['output']>;
  brandTitle: Maybe<Scalars['String']['output']>;
  cart: ProductCart;
  cartPromotions: Array<CartPromotion>;
  cartRecommendations: Array<CartRecommendation>;
  categories: Array<Category>;
  collections: Array<ProductCollection>;
  configurationErrors: Array<ProductConfigurationErrorType>;
  createdAt: Scalars['DateTime']['output'];
  crossellProducts: ProductsConnection;
  description: Maybe<Scalars['NonEmptyString']['output']>;
  dimensions: ProductDimensions;
  disclaimers: Array<ProductDisclaimer>;
  estimatedShippingPriceRange: MoneyRange;
  fetchRelations: Array<ProductRelation>;
  group: ProductGroup;
  hasAnyStock: Scalars['Boolean']['output'];
  hasCustomName: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  internalIdentifier: Maybe<Scalars['NonEmptyString']['output']>;
  inventory: ProductInventory;
  isEligibleForFreeShipping: Scalars['Boolean']['output'];
  isGiftCard: Scalars['Boolean']['output'];
  listingImage: Maybe<ProductImage>;
  mainCategory: Maybe<Category>;
  matchRelations: Array<ProductRelation>;
  measurementImage: Maybe<ProductAsset>;
  medias: Array<ProductMedia>;
  name: Scalars['NonEmptyString']['output'];
  outlets: Array<ProductOutlet>;
  outletsWithBundling: Array<ProductOutletStock>;
  parcels: Array<ProductParcel>;
  parcelsAreVisible: Scalars['Boolean']['output'];
  parentProduct: Maybe<ConfigurableProduct>;
  priceHistory: Array<ProductPrice>;
  pricing: ProductPricing;
  productBadges: Array<ProductBadge>;
  productClass: Maybe<ProductClass>;
  promotions: Array<CatalogPromotion>;
  properties: Array<ProductProperty>;
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  qaItems: Maybe<Array<QuestionAndAnswer>>;
  relatedProducts: ProductsConnection;
  seo: ProductSeo;
  shortDescription: Maybe<Scalars['NonEmptyString']['output']>;
  sku: Maybe<Scalars['NonEmptyString']['output']>;
  specification: Maybe<Scalars['NonEmptyString']['output']>;
  state: ProductState;
  title: Maybe<Scalars['NonEmptyString']['output']>;
  type: ProductType;
  updatedAt: Scalars['DateTime']['output'];
  upsellProducts: ProductsConnection;
};


export type SimpleProductAttributesArgs = {
  attributeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  code?: InputMaybe<Scalars['NonEmptyString']['input']>;
  showInProductListing?: InputMaybe<Scalars['Boolean']['input']>;
  showInProductPage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SimpleProductAvailableShippingMethodsArgs = {
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
};


export type SimpleProductCrossellProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SimpleProductDisclaimersArgs = {
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SimpleProductEstimatedShippingPriceRangeArgs = {
  cache?: Scalars['Boolean']['input'];
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
};


export type SimpleProductPriceHistoryArgs = {
  range: ProductPricesRangeInput;
};


export type SimpleProductPromotionsArgs = {
  isActive?: Scalars['Boolean']['input'];
};


export type SimpleProductRelatedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SimpleProductUpsellProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Store = Node & {
  __typename: 'Store';
  address: Maybe<Scalars['NonEmptyString']['output']>;
  businessIdentityCode: Maybe<Scalars['BusinessIdentityCode']['output']>;
  city: Maybe<Scalars['NonEmptyString']['output']>;
  contactEmail: Maybe<Scalars['EmailAddress']['output']>;
  contactName: Maybe<Scalars['NonEmptyString']['output']>;
  countryCode: Scalars['CountryCode']['output'];
  createdAt: Scalars['DateTime']['output'];
  domain: Scalars['URL']['output'];
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['NonEmptyString']['output']>;
  postalCode: Maybe<Scalars['PostalCode']['output']>;
  state: StoreState;
  timezone: Scalars['TimeZone']['output'];
  title: Scalars['NonEmptyString']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type StoreCreateInput = {
  address?: InputMaybe<Scalars['NonEmptyString']['input']>;
  businessIdentityCode?: InputMaybe<Scalars['BusinessIdentityCode']['input']>;
  city?: InputMaybe<Scalars['NonEmptyString']['input']>;
  contactEmail?: InputMaybe<Scalars['EmailAddress']['input']>;
  contactName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  domain: Scalars['NonEmptyString']['input'];
  logo?: InputMaybe<Scalars['NonEmptyString']['input']>;
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
  state?: InputMaybe<StoreState>;
  timezone?: InputMaybe<Scalars['TimeZone']['input']>;
  title: Scalars['NonEmptyString']['input'];
};

export type StoreCreatePayload = {
  __typename: 'StoreCreatePayload';
  store: Store;
};

export type StoreCreateUnion = InvalidInputError | StoreCreatePayload;

export type StoreDeletePayload = {
  __typename: 'StoreDeletePayload';
  store: Store;
};

export type StoreDeleteUnion = EntityNotFoundError | StoreDeletePayload;

export enum StoreOrderByField {
  CreatedAt = 'CREATED_AT',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type StoreOrderByInput = {
  direction: OrderByDirection;
  field: StoreOrderByField;
};

export type StoreResultUnion = EntityNotFoundError | Store;

export enum StoreState {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type StoreUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type StoreUpdateInput = {
  address?: InputMaybe<Scalars['NonEmptyString']['input']>;
  businessIdentityCode?: InputMaybe<Scalars['BusinessIdentityCode']['input']>;
  city?: InputMaybe<Scalars['NonEmptyString']['input']>;
  contactEmail?: InputMaybe<Scalars['EmailAddress']['input']>;
  contactName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  domain?: InputMaybe<Scalars['NonEmptyString']['input']>;
  logo?: InputMaybe<Scalars['NonEmptyString']['input']>;
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
  state?: InputMaybe<StoreState>;
  timezone?: InputMaybe<Scalars['TimeZone']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type StoreUpdatePayload = {
  __typename: 'StoreUpdatePayload';
  store: Store;
};

export type StoreUpdateUnion = EntityNotFoundError | StoreUpdatePayload;

export type StoreWhereInput = {
  AND?: InputMaybe<Array<StoreWhereSubInput>>;
  OR?: InputMaybe<Array<StoreWhereSubInput>>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type StoreWhereSubInput = {
  AND?: InputMaybe<Array<StoreWhereSubInput>>;
  OR?: InputMaybe<Array<StoreWhereSubInput>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type StoresConnection = {
  __typename: 'StoresConnection';
  edges: Array<StoresEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type StoresEdge = {
  __typename: 'StoresEdge';
  cursor: Scalars['String']['output'];
  node: Store;
};

export type Subscription = {
  __typename: 'Subscription';
  notificationCreated: Notification;
};

export type TaxClass = Node & {
  __typename: 'TaxClass';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  rate: Scalars['PositiveFloat']['output'];
  title: Scalars['NonEmptyString']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TaxClassCreateInput = {
  rate: Scalars['PositiveFloat']['input'];
  title: Scalars['NonEmptyString']['input'];
};

export type TaxClassCreatePayload = {
  __typename: 'TaxClassCreatePayload';
  taxClass: TaxClass;
};

export type TaxClassCreateUnion = InvalidInputError | TaxClassCreatePayload;

export type TaxClassDeletePayload = {
  __typename: 'TaxClassDeletePayload';
  taxClass: TaxClass;
};

export type TaxClassDeleteUnion = EntityNotFoundError | TaxClassDeletePayload;

export enum TaxClassOrderByField {
  CreatedAt = 'CREATED_AT',
  Position = 'POSITION',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type TaxClassOrderByInput = {
  direction: OrderByDirection;
  field: TaxClassOrderByField;
};

export type TaxClassResultUnion = EntityNotFoundError | TaxClass;

export type TaxClassUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type TaxClassUpdateInput = {
  rate?: InputMaybe<Scalars['PositiveFloat']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type TaxClassUpdatePayload = {
  __typename: 'TaxClassUpdatePayload';
  taxClass: TaxClass;
};

export type TaxClassUpdateUnion = EntityNotFoundError | TaxClassUpdatePayload;

export type TaxClassWhereInput = {
  AND?: InputMaybe<Array<TaxClassWhereSubInput>>;
  OR?: InputMaybe<Array<TaxClassWhereSubInput>>;
  query?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type TaxClassWhereSubInput = {
  AND?: InputMaybe<Array<TaxClassWhereSubInput>>;
  OR?: InputMaybe<Array<TaxClassWhereSubInput>>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type TaxClassesConnection = {
  __typename: 'TaxClassesConnection';
  edges: Array<TaxClassesEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type TaxClassesEdge = {
  __typename: 'TaxClassesEdge';
  cursor: Scalars['String']['output'];
  node: TaxClass;
};

export type User = {
  __typename: 'User';
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isSocialLogin: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  picture: Maybe<Scalars['URL']['output']>;
  roles: RolesResult;
  updatedAt: Scalars['DateTime']['output'];
};


export type UserRolesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RoleWhereInput>;
};

export type UserSetRolesPayload = {
  __typename: 'UserSetRolesPayload';
  user: User;
};

export type UserUniqueWhereInput = {
  id: Scalars['ID']['input'];
};

export type UserUpdateInput = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  name?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type UserUpdatePayload = {
  __typename: 'UserUpdatePayload';
  user: User;
};

export type UserWhereInput = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type UsersResult = {
  __typename: 'UsersResult';
  items: Array<User>;
  totalCount: Scalars['Int']['output'];
};

export type WebhookNotificationTemplate = Node & NotificationTemplate & {
  __typename: 'WebhookNotificationTemplate';
  contentType: NotificationTemplateContentType;
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['NonEmptyString']['output']>;
  id: Scalars['ID']['output'];
  location: Maybe<Scalars['URL']['output']>;
  state: NotificationTemplateState;
  title: Scalars['NonEmptyString']['output'];
  type: NotificationTemplateType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ListFilterableAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListFilterableAttributesQuery = (
  { __typename: 'Query' }
  & { attributes: (
    { __typename: 'AttributesConnection' }
    & { pageInfo: (
      { __typename: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage'>
    ), edges: Array<(
      { __typename: 'AttributesEdge' }
      & { node: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'name'>
      ) }
    )> }
  ) }
);

export type ListBrandProductsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  brandId: Scalars['ID']['input'];
}>;


export type ListBrandProductsQuery = (
  { __typename: 'Query' }
  & { products: (
    { __typename: 'ProductsConnection' }
    & Pick<ProductsConnection, 'totalCount'>
    & { pageInfo: (
      { __typename: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'endCursor'>
    ), edges: Array<(
      { __typename: 'ProductsEdge' }
      & { node: (
        { __typename: 'ConfigurableProduct' }
        & Pick<ConfigurableProduct, 'id' | 'name' | 'title' | 'specification'>
        & { configuration: (
          { __typename: 'ProductConfiguration' }
          & { defaultProduct: Maybe<(
            { __typename: 'SimpleProduct' }
            & Pick<SimpleProduct, 'id'>
            & { listingImage: Maybe<(
              { __typename: 'ProductImage' }
              & Pick<ProductImage, 'id' | 'url'>
            )>, pricing: (
              { __typename: 'ProductPricing' }
              & { price: Maybe<(
                { __typename: 'Money' }
                & Pick<Money, 'amount'>
              )>, originalPrice: Maybe<(
                { __typename: 'Money' }
                & Pick<Money, 'amount'>
              )> }
            ), inventory: (
              { __typename: 'ProductInventory' }
              & Pick<ProductInventory, 'availableQuantity'>
            ), promotions: Array<(
              { __typename: 'CatalogPromotionFixedAmount' }
              & Pick<CatalogPromotionFixedAmount, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
              & { catalogDiscountType: CatalogPromotionFixedAmount['discountType'] }
              & { style: Maybe<(
                { __typename: 'PromotionStyle' }
                & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
                & { mainTheme: (
                  { __typename: 'PromotionStyleTheme' }
                  & { background: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), text: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), font: (
                    { __typename: 'PromotionStyleFontInfo' }
                    & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                  ) }
                ), altTheme: Maybe<(
                  { __typename: 'PromotionStyleTheme' }
                  & { background: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), text: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), font: (
                    { __typename: 'PromotionStyleFontInfo' }
                    & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                  ) }
                )>, productPage: (
                  { __typename: 'PromotionStyleProductPage' }
                  & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
                ) }
              )>, catalogFixedAmountDiscount: (
                { __typename: 'CatalogPromotionFixedAmountDiscount' }
                & Pick<CatalogPromotionFixedAmountDiscount, 'amount'>
              ) }
            ) | (
              { __typename: 'CatalogPromotionPercent' }
              & Pick<CatalogPromotionPercent, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
              & { catalogDiscountType: CatalogPromotionPercent['discountType'] }
              & { style: Maybe<(
                { __typename: 'PromotionStyle' }
                & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
                & { mainTheme: (
                  { __typename: 'PromotionStyleTheme' }
                  & { background: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), text: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), font: (
                    { __typename: 'PromotionStyleFontInfo' }
                    & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                  ) }
                ), altTheme: Maybe<(
                  { __typename: 'PromotionStyleTheme' }
                  & { background: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), text: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), font: (
                    { __typename: 'PromotionStyleFontInfo' }
                    & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                  ) }
                )>, productPage: (
                  { __typename: 'PromotionStyleProductPage' }
                  & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
                ) }
              )>, catalogPercentDiscount: (
                { __typename: 'CatalogPromotionPercentDiscount' }
                & Pick<CatalogPromotionPercentDiscount, 'percent'>
              ) }
            ) | (
              { __typename: 'CatalogPromotionProductPromotionPrice' }
              & Pick<CatalogPromotionProductPromotionPrice, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
              & { catalogDiscountType: CatalogPromotionProductPromotionPrice['discountType'] }
              & { style: Maybe<(
                { __typename: 'PromotionStyle' }
                & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
                & { mainTheme: (
                  { __typename: 'PromotionStyleTheme' }
                  & { background: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), text: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), font: (
                    { __typename: 'PromotionStyleFontInfo' }
                    & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                  ) }
                ), altTheme: Maybe<(
                  { __typename: 'PromotionStyleTheme' }
                  & { background: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), text: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), font: (
                    { __typename: 'PromotionStyleFontInfo' }
                    & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                  ) }
                )>, productPage: (
                  { __typename: 'PromotionStyleProductPage' }
                  & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
                ) }
              )> }
            )> }
          )> }
        ), seo: (
          { __typename: 'ProductSeo' }
          & Pick<ProductSeo, 'slug'>
        ), listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )> }
      ) | (
        { __typename: 'SimpleProduct' }
        & Pick<SimpleProduct, 'id' | 'name' | 'title' | 'specification'>
        & { pricing: (
          { __typename: 'ProductPricing' }
          & { price: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )>, originalPrice: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )> }
        ), inventory: (
          { __typename: 'ProductInventory' }
          & Pick<ProductInventory, 'availableQuantity'>
        ), promotions: Array<(
          { __typename: 'CatalogPromotionFixedAmount' }
          & Pick<CatalogPromotionFixedAmount, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
          & { catalogDiscountType: CatalogPromotionFixedAmount['discountType'] }
          & { style: Maybe<(
            { __typename: 'PromotionStyle' }
            & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
            & { mainTheme: (
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            ), altTheme: Maybe<(
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            )>, productPage: (
              { __typename: 'PromotionStyleProductPage' }
              & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
            ) }
          )>, catalogFixedAmountDiscount: (
            { __typename: 'CatalogPromotionFixedAmountDiscount' }
            & Pick<CatalogPromotionFixedAmountDiscount, 'amount'>
          ) }
        ) | (
          { __typename: 'CatalogPromotionPercent' }
          & Pick<CatalogPromotionPercent, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
          & { catalogDiscountType: CatalogPromotionPercent['discountType'] }
          & { style: Maybe<(
            { __typename: 'PromotionStyle' }
            & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
            & { mainTheme: (
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            ), altTheme: Maybe<(
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            )>, productPage: (
              { __typename: 'PromotionStyleProductPage' }
              & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
            ) }
          )>, catalogPercentDiscount: (
            { __typename: 'CatalogPromotionPercentDiscount' }
            & Pick<CatalogPromotionPercentDiscount, 'percent'>
          ) }
        ) | (
          { __typename: 'CatalogPromotionProductPromotionPrice' }
          & Pick<CatalogPromotionProductPromotionPrice, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
          & { catalogDiscountType: CatalogPromotionProductPromotionPrice['discountType'] }
          & { style: Maybe<(
            { __typename: 'PromotionStyle' }
            & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
            & { mainTheme: (
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            ), altTheme: Maybe<(
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            )>, productPage: (
              { __typename: 'PromotionStyleProductPage' }
              & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
            ) }
          )> }
        )>, seo: (
          { __typename: 'ProductSeo' }
          & Pick<ProductSeo, 'slug'>
        ), listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )> }
      ) }
    )> }
  ) }
);

export type CartCreateMutationVariables = Exact<{
  input: CartCreateInput;
}>;


export type CartCreateMutation = (
  { __typename: 'Mutation' }
  & { cartCreate: (
    { __typename: 'CartCreatePayload' }
    & { cart: (
      { __typename: 'Cart' }
      & Pick<Cart, 'id' | 'productCount'>
      & { price: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), promotionCode: Maybe<(
        { __typename: 'PromotionCode' }
        & Pick<PromotionCode, 'id' | 'code'>
        & { promotion: (
          { __typename: 'CartPromotionClubPrice' }
          & Pick<CartPromotionClubPrice, 'id'>
        ) | (
          { __typename: 'CartPromotionFixedAmountFromCart' }
          & Pick<CartPromotionFixedAmountFromCart, 'id'>
        ) | (
          { __typename: 'CartPromotionFixedAmountFromProduct' }
          & Pick<CartPromotionFixedAmountFromProduct, 'id'>
        ) | (
          { __typename: 'CartPromotionFreeShipping' }
          & Pick<CartPromotionFreeShipping, 'id'>
        ) | (
          { __typename: 'CartPromotionFreebie' }
          & Pick<CartPromotionFreebie, 'id'>
        ) | (
          { __typename: 'CartPromotionPercent' }
          & Pick<CartPromotionPercent, 'id'>
        ) | (
          { __typename: 'CartPromotionProductCartPromotionPrice' }
          & Pick<CartPromotionProductCartPromotionPrice, 'id'>
        ) | (
          { __typename: 'CatalogPromotionFixedAmount' }
          & Pick<CatalogPromotionFixedAmount, 'id'>
        ) | (
          { __typename: 'CatalogPromotionPercent' }
          & Pick<CatalogPromotionPercent, 'id'>
        ) | (
          { __typename: 'CatalogPromotionProductPromotionPrice' }
          & Pick<CatalogPromotionProductPromotionPrice, 'id'>
        ) }
      )>, giftCard: Maybe<(
        { __typename: 'GiftCard' }
        & Pick<GiftCard, 'id' | 'code'>
        & { remainingAmount: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )> }
      )>, relatedProductsByCategory: Array<(
        { __typename: 'CartRelatedProductGroup' }
        & Pick<CartRelatedProductGroup, 'category'>
        & { products: (
          { __typename: 'CartRelatedProductsConnection' }
          & { edges: Array<(
            { __typename: 'CartRelatedProductsEdge' }
            & { node: (
              { __typename: 'ConfigurableProduct' }
              & Pick<ConfigurableProduct, 'id' | 'sku' | 'name' | 'title' | 'specification'>
              & { listingImage: Maybe<(
                { __typename: 'ProductImage' }
                & Pick<ProductImage, 'id' | 'url'>
              )>, seo: (
                { __typename: 'ProductSeo' }
                & Pick<ProductSeo, 'slug'>
              ), brand: Maybe<(
                { __typename: 'Brand' }
                & Pick<Brand, 'id' | 'title'>
              )>, productClass: Maybe<(
                { __typename: 'ProductClass' }
                & Pick<ProductClass, 'id' | 'title'>
              )> }
            ) | (
              { __typename: 'SimpleProduct' }
              & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'specification'>
              & { pricing: (
                { __typename: 'ProductPricing' }
                & { price: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount'>
                )>, originalPrice: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount'>
                )>, clubPrice: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount'>
                )> }
              ), cart: (
                { __typename: 'ProductCart' }
                & Pick<ProductCart, 'multiplier'>
              ), listingImage: Maybe<(
                { __typename: 'ProductImage' }
                & Pick<ProductImage, 'id' | 'url'>
              )>, seo: (
                { __typename: 'ProductSeo' }
                & Pick<ProductSeo, 'slug'>
              ), brand: Maybe<(
                { __typename: 'Brand' }
                & Pick<Brand, 'id' | 'title'>
              )>, productClass: Maybe<(
                { __typename: 'ProductClass' }
                & Pick<ProductClass, 'id' | 'title'>
              )>, cartPromotions: Array<(
                { __typename: 'CartPromotionClubPrice' }
                & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFixedAmountFromCart' }
                & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFixedAmountFromProduct' }
                & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFreeShipping' }
                & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFreebie' }
                & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionPercent' }
                & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
                & { percentDiscount: (
                  { __typename: 'CartPromotionPercentDiscount' }
                  & Pick<CartPromotionPercentDiscount, 'percent'>
                ) }
              ) | (
                { __typename: 'CartPromotionProductCartPromotionPrice' }
                & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
              )>, inventory: (
                { __typename: 'ProductInventory' }
                & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
              ) }
            ) }
          )> }
        ) }
      )>, recommendedProducts: Array<(
        { __typename: 'ConfigurableProduct' }
        & Pick<ConfigurableProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
        & { listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )>, brand: Maybe<(
          { __typename: 'Brand' }
          & Pick<Brand, 'id' | 'title'>
        )> }
      ) | (
        { __typename: 'SimpleProduct' }
        & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
        & { cart: (
          { __typename: 'ProductCart' }
          & Pick<ProductCart, 'minAmount' | 'maxAmount' | 'multiplier'>
        ), inventory: (
          { __typename: 'ProductInventory' }
          & Pick<ProductInventory, 'isAvailableForPurchase'>
        ), pricing: (
          { __typename: 'ProductPricing' }
          & { price: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )> }
        ), listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )>, brand: Maybe<(
          { __typename: 'Brand' }
          & Pick<Brand, 'id' | 'title'>
        )> }
      )>, products: Array<(
        { __typename: 'CartProduct' }
        & Pick<CartProduct, 'id' | 'quantity'>
        & { price: (
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        ), unitPrice: (
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        ), discounts: Array<(
          { __typename: 'CartProductDiscount' }
          & { promotion: (
            { __typename: 'CartPromotionClubPrice' }
            & Pick<CartPromotionClubPrice, 'id'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromCart' }
            & Pick<CartPromotionFixedAmountFromCart, 'id'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromProduct' }
            & Pick<CartPromotionFixedAmountFromProduct, 'id'>
          ) | (
            { __typename: 'CartPromotionFreeShipping' }
            & Pick<CartPromotionFreeShipping, 'id'>
          ) | (
            { __typename: 'CartPromotionFreebie' }
            & Pick<CartPromotionFreebie, 'id'>
          ) | (
            { __typename: 'CartPromotionPercent' }
            & Pick<CartPromotionPercent, 'id'>
          ) | (
            { __typename: 'CartPromotionProductCartPromotionPrice' }
            & Pick<CartPromotionProductCartPromotionPrice, 'id'>
          ) | (
            { __typename: 'CatalogPromotionFixedAmount' }
            & Pick<CatalogPromotionFixedAmount, 'id'>
          ) | (
            { __typename: 'CatalogPromotionPercent' }
            & Pick<CatalogPromotionPercent, 'id'>
          ) | (
            { __typename: 'CatalogPromotionProductPromotionPrice' }
            & Pick<CatalogPromotionProductPromotionPrice, 'id'>
          ), amount: (
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          ) }
        )>, product: (
          { __typename: 'SimpleProduct' }
          & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
          & { medias: Array<(
            { __typename: 'ProductImage' }
            & Pick<ProductImage, 'id' | 'url' | 'position'>
          ) | (
            { __typename: 'ProductModel' }
            & Pick<ProductModel, 'id' | 'url' | 'position'>
          ) | (
            { __typename: 'ProductVideo' }
            & Pick<ProductVideo, 'id' | 'url' | 'position'>
          )>, parentProduct: Maybe<(
            { __typename: 'ConfigurableProduct' }
            & Pick<ConfigurableProduct, 'id'>
            & { medias: Array<(
              { __typename: 'ProductImage' }
              & Pick<ProductImage, 'id' | 'url' | 'position'>
            ) | (
              { __typename: 'ProductModel' }
              & Pick<ProductModel, 'id' | 'url' | 'position'>
            ) | (
              { __typename: 'ProductVideo' }
              & Pick<ProductVideo, 'id' | 'url' | 'position'>
            )> }
          )>, listingImage: Maybe<(
            { __typename: 'ProductImage' }
            & Pick<ProductImage, 'id' | 'url'>
          )>, cart: (
            { __typename: 'ProductCart' }
            & Pick<ProductCart, 'minAmount' | 'maxAmount' | 'multiplier'>
          ), seo: (
            { __typename: 'ProductSeo' }
            & Pick<ProductSeo, 'slug'>
          ), pricing: (
            { __typename: 'ProductPricing' }
            & { price: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, originalPrice: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, clubPrice: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, taxClass: (
              { __typename: 'TaxClass' }
              & Pick<TaxClass, 'id' | 'rate'>
            ) }
          ), brand: Maybe<(
            { __typename: 'Brand' }
            & Pick<Brand, 'id' | 'title'>
          )>, productClass: Maybe<(
            { __typename: 'ProductClass' }
            & Pick<ProductClass, 'id' | 'title'>
          )>, cartPromotions: Array<(
            { __typename: 'CartPromotionClubPrice' }
            & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromCart' }
            & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromProduct' }
            & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFreeShipping' }
            & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFreebie' }
            & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionPercent' }
            & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
            & { percentDiscount: (
              { __typename: 'CartPromotionPercentDiscount' }
              & Pick<CartPromotionPercentDiscount, 'percent'>
            ) }
          ) | (
            { __typename: 'CartPromotionProductCartPromotionPrice' }
            & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
          )>, inventory: (
            { __typename: 'ProductInventory' }
            & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
          ) }
        ) }
      )> }
    ) }
  ) | (
    { __typename: 'InvalidInputError' }
    & Pick<InvalidInputError, 'message'>
  ) }
);

export type CartDataFragment = (
  { __typename: 'Cart' }
  & Pick<Cart, 'id' | 'productCount'>
  & { price: (
    { __typename: 'Money' }
    & Pick<Money, 'amount'>
  ), promotionCode: Maybe<(
    { __typename: 'PromotionCode' }
    & Pick<PromotionCode, 'id' | 'code'>
    & { promotion: (
      { __typename: 'CartPromotionClubPrice' }
      & Pick<CartPromotionClubPrice, 'id'>
    ) | (
      { __typename: 'CartPromotionFixedAmountFromCart' }
      & Pick<CartPromotionFixedAmountFromCart, 'id'>
    ) | (
      { __typename: 'CartPromotionFixedAmountFromProduct' }
      & Pick<CartPromotionFixedAmountFromProduct, 'id'>
    ) | (
      { __typename: 'CartPromotionFreeShipping' }
      & Pick<CartPromotionFreeShipping, 'id'>
    ) | (
      { __typename: 'CartPromotionFreebie' }
      & Pick<CartPromotionFreebie, 'id'>
    ) | (
      { __typename: 'CartPromotionPercent' }
      & Pick<CartPromotionPercent, 'id'>
    ) | (
      { __typename: 'CartPromotionProductCartPromotionPrice' }
      & Pick<CartPromotionProductCartPromotionPrice, 'id'>
    ) | (
      { __typename: 'CatalogPromotionFixedAmount' }
      & Pick<CatalogPromotionFixedAmount, 'id'>
    ) | (
      { __typename: 'CatalogPromotionPercent' }
      & Pick<CatalogPromotionPercent, 'id'>
    ) | (
      { __typename: 'CatalogPromotionProductPromotionPrice' }
      & Pick<CatalogPromotionProductPromotionPrice, 'id'>
    ) }
  )>, giftCard: Maybe<(
    { __typename: 'GiftCard' }
    & Pick<GiftCard, 'id' | 'code'>
    & { remainingAmount: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount' | 'currencyCode'>
    )> }
  )>, relatedProductsByCategory: Array<(
    { __typename: 'CartRelatedProductGroup' }
    & Pick<CartRelatedProductGroup, 'category'>
    & { products: (
      { __typename: 'CartRelatedProductsConnection' }
      & { edges: Array<(
        { __typename: 'CartRelatedProductsEdge' }
        & { node: (
          { __typename: 'ConfigurableProduct' }
          & Pick<ConfigurableProduct, 'id' | 'sku' | 'name' | 'title' | 'specification'>
          & { listingImage: Maybe<(
            { __typename: 'ProductImage' }
            & Pick<ProductImage, 'id' | 'url'>
          )>, seo: (
            { __typename: 'ProductSeo' }
            & Pick<ProductSeo, 'slug'>
          ), brand: Maybe<(
            { __typename: 'Brand' }
            & Pick<Brand, 'id' | 'title'>
          )>, productClass: Maybe<(
            { __typename: 'ProductClass' }
            & Pick<ProductClass, 'id' | 'title'>
          )> }
        ) | (
          { __typename: 'SimpleProduct' }
          & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'specification'>
          & { pricing: (
            { __typename: 'ProductPricing' }
            & { price: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, originalPrice: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, clubPrice: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )> }
          ), cart: (
            { __typename: 'ProductCart' }
            & Pick<ProductCart, 'multiplier'>
          ), listingImage: Maybe<(
            { __typename: 'ProductImage' }
            & Pick<ProductImage, 'id' | 'url'>
          )>, seo: (
            { __typename: 'ProductSeo' }
            & Pick<ProductSeo, 'slug'>
          ), brand: Maybe<(
            { __typename: 'Brand' }
            & Pick<Brand, 'id' | 'title'>
          )>, productClass: Maybe<(
            { __typename: 'ProductClass' }
            & Pick<ProductClass, 'id' | 'title'>
          )>, cartPromotions: Array<(
            { __typename: 'CartPromotionClubPrice' }
            & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromCart' }
            & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromProduct' }
            & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFreeShipping' }
            & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFreebie' }
            & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionPercent' }
            & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
            & { percentDiscount: (
              { __typename: 'CartPromotionPercentDiscount' }
              & Pick<CartPromotionPercentDiscount, 'percent'>
            ) }
          ) | (
            { __typename: 'CartPromotionProductCartPromotionPrice' }
            & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
          )>, inventory: (
            { __typename: 'ProductInventory' }
            & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
          ) }
        ) }
      )> }
    ) }
  )>, recommendedProducts: Array<(
    { __typename: 'ConfigurableProduct' }
    & Pick<ConfigurableProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
    & { listingImage: Maybe<(
      { __typename: 'ProductImage' }
      & Pick<ProductImage, 'id' | 'url'>
    )>, brand: Maybe<(
      { __typename: 'Brand' }
      & Pick<Brand, 'id' | 'title'>
    )> }
  ) | (
    { __typename: 'SimpleProduct' }
    & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
    & { cart: (
      { __typename: 'ProductCart' }
      & Pick<ProductCart, 'minAmount' | 'maxAmount' | 'multiplier'>
    ), inventory: (
      { __typename: 'ProductInventory' }
      & Pick<ProductInventory, 'isAvailableForPurchase'>
    ), pricing: (
      { __typename: 'ProductPricing' }
      & { price: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      )> }
    ), listingImage: Maybe<(
      { __typename: 'ProductImage' }
      & Pick<ProductImage, 'id' | 'url'>
    )>, brand: Maybe<(
      { __typename: 'Brand' }
      & Pick<Brand, 'id' | 'title'>
    )> }
  )>, products: Array<(
    { __typename: 'CartProduct' }
    & Pick<CartProduct, 'id' | 'quantity'>
    & { price: (
      { __typename: 'Money' }
      & Pick<Money, 'amount'>
    ), unitPrice: (
      { __typename: 'Money' }
      & Pick<Money, 'amount'>
    ), discounts: Array<(
      { __typename: 'CartProductDiscount' }
      & { promotion: (
        { __typename: 'CartPromotionClubPrice' }
        & Pick<CartPromotionClubPrice, 'id'>
      ) | (
        { __typename: 'CartPromotionFixedAmountFromCart' }
        & Pick<CartPromotionFixedAmountFromCart, 'id'>
      ) | (
        { __typename: 'CartPromotionFixedAmountFromProduct' }
        & Pick<CartPromotionFixedAmountFromProduct, 'id'>
      ) | (
        { __typename: 'CartPromotionFreeShipping' }
        & Pick<CartPromotionFreeShipping, 'id'>
      ) | (
        { __typename: 'CartPromotionFreebie' }
        & Pick<CartPromotionFreebie, 'id'>
      ) | (
        { __typename: 'CartPromotionPercent' }
        & Pick<CartPromotionPercent, 'id'>
      ) | (
        { __typename: 'CartPromotionProductCartPromotionPrice' }
        & Pick<CartPromotionProductCartPromotionPrice, 'id'>
      ) | (
        { __typename: 'CatalogPromotionFixedAmount' }
        & Pick<CatalogPromotionFixedAmount, 'id'>
      ) | (
        { __typename: 'CatalogPromotionPercent' }
        & Pick<CatalogPromotionPercent, 'id'>
      ) | (
        { __typename: 'CatalogPromotionProductPromotionPrice' }
        & Pick<CatalogPromotionProductPromotionPrice, 'id'>
      ), amount: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ) }
    )>, product: (
      { __typename: 'SimpleProduct' }
      & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
      & { medias: Array<(
        { __typename: 'ProductImage' }
        & Pick<ProductImage, 'id' | 'url' | 'position'>
      ) | (
        { __typename: 'ProductModel' }
        & Pick<ProductModel, 'id' | 'url' | 'position'>
      ) | (
        { __typename: 'ProductVideo' }
        & Pick<ProductVideo, 'id' | 'url' | 'position'>
      )>, parentProduct: Maybe<(
        { __typename: 'ConfigurableProduct' }
        & Pick<ConfigurableProduct, 'id'>
        & { medias: Array<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url' | 'position'>
        ) | (
          { __typename: 'ProductModel' }
          & Pick<ProductModel, 'id' | 'url' | 'position'>
        ) | (
          { __typename: 'ProductVideo' }
          & Pick<ProductVideo, 'id' | 'url' | 'position'>
        )> }
      )>, listingImage: Maybe<(
        { __typename: 'ProductImage' }
        & Pick<ProductImage, 'id' | 'url'>
      )>, cart: (
        { __typename: 'ProductCart' }
        & Pick<ProductCart, 'minAmount' | 'maxAmount' | 'multiplier'>
      ), seo: (
        { __typename: 'ProductSeo' }
        & Pick<ProductSeo, 'slug'>
      ), pricing: (
        { __typename: 'ProductPricing' }
        & { price: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )>, originalPrice: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )>, clubPrice: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )>, taxClass: (
          { __typename: 'TaxClass' }
          & Pick<TaxClass, 'id' | 'rate'>
        ) }
      ), brand: Maybe<(
        { __typename: 'Brand' }
        & Pick<Brand, 'id' | 'title'>
      )>, productClass: Maybe<(
        { __typename: 'ProductClass' }
        & Pick<ProductClass, 'id' | 'title'>
      )>, cartPromotions: Array<(
        { __typename: 'CartPromotionClubPrice' }
        & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
      ) | (
        { __typename: 'CartPromotionFixedAmountFromCart' }
        & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
      ) | (
        { __typename: 'CartPromotionFixedAmountFromProduct' }
        & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
      ) | (
        { __typename: 'CartPromotionFreeShipping' }
        & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
      ) | (
        { __typename: 'CartPromotionFreebie' }
        & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
      ) | (
        { __typename: 'CartPromotionPercent' }
        & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
        & { percentDiscount: (
          { __typename: 'CartPromotionPercentDiscount' }
          & Pick<CartPromotionPercentDiscount, 'percent'>
        ) }
      ) | (
        { __typename: 'CartPromotionProductCartPromotionPrice' }
        & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
      )>, inventory: (
        { __typename: 'ProductInventory' }
        & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
      ) }
    ) }
  )> }
);

export type CartUpdateGiftCardMutationVariables = Exact<{
  giftCardCode?: InputMaybe<Scalars['NonEmptyString']['input']>;
  id: Scalars['ID']['input'];
}>;


export type CartUpdateGiftCardMutation = (
  { __typename: 'Mutation' }
  & { cartUpdateGiftCard: (
    { __typename: 'CartUpdatePayload' }
    & { cart: (
      { __typename: 'Cart' }
      & Pick<Cart, 'id' | 'productCount'>
      & { price: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), promotionCode: Maybe<(
        { __typename: 'PromotionCode' }
        & Pick<PromotionCode, 'id' | 'code'>
        & { promotion: (
          { __typename: 'CartPromotionClubPrice' }
          & Pick<CartPromotionClubPrice, 'id'>
        ) | (
          { __typename: 'CartPromotionFixedAmountFromCart' }
          & Pick<CartPromotionFixedAmountFromCart, 'id'>
        ) | (
          { __typename: 'CartPromotionFixedAmountFromProduct' }
          & Pick<CartPromotionFixedAmountFromProduct, 'id'>
        ) | (
          { __typename: 'CartPromotionFreeShipping' }
          & Pick<CartPromotionFreeShipping, 'id'>
        ) | (
          { __typename: 'CartPromotionFreebie' }
          & Pick<CartPromotionFreebie, 'id'>
        ) | (
          { __typename: 'CartPromotionPercent' }
          & Pick<CartPromotionPercent, 'id'>
        ) | (
          { __typename: 'CartPromotionProductCartPromotionPrice' }
          & Pick<CartPromotionProductCartPromotionPrice, 'id'>
        ) | (
          { __typename: 'CatalogPromotionFixedAmount' }
          & Pick<CatalogPromotionFixedAmount, 'id'>
        ) | (
          { __typename: 'CatalogPromotionPercent' }
          & Pick<CatalogPromotionPercent, 'id'>
        ) | (
          { __typename: 'CatalogPromotionProductPromotionPrice' }
          & Pick<CatalogPromotionProductPromotionPrice, 'id'>
        ) }
      )>, giftCard: Maybe<(
        { __typename: 'GiftCard' }
        & Pick<GiftCard, 'id' | 'code'>
        & { remainingAmount: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )> }
      )>, relatedProductsByCategory: Array<(
        { __typename: 'CartRelatedProductGroup' }
        & Pick<CartRelatedProductGroup, 'category'>
        & { products: (
          { __typename: 'CartRelatedProductsConnection' }
          & { edges: Array<(
            { __typename: 'CartRelatedProductsEdge' }
            & { node: (
              { __typename: 'ConfigurableProduct' }
              & Pick<ConfigurableProduct, 'id' | 'sku' | 'name' | 'title' | 'specification'>
              & { listingImage: Maybe<(
                { __typename: 'ProductImage' }
                & Pick<ProductImage, 'id' | 'url'>
              )>, seo: (
                { __typename: 'ProductSeo' }
                & Pick<ProductSeo, 'slug'>
              ), brand: Maybe<(
                { __typename: 'Brand' }
                & Pick<Brand, 'id' | 'title'>
              )>, productClass: Maybe<(
                { __typename: 'ProductClass' }
                & Pick<ProductClass, 'id' | 'title'>
              )> }
            ) | (
              { __typename: 'SimpleProduct' }
              & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'specification'>
              & { pricing: (
                { __typename: 'ProductPricing' }
                & { price: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount'>
                )>, originalPrice: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount'>
                )>, clubPrice: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount'>
                )> }
              ), cart: (
                { __typename: 'ProductCart' }
                & Pick<ProductCart, 'multiplier'>
              ), listingImage: Maybe<(
                { __typename: 'ProductImage' }
                & Pick<ProductImage, 'id' | 'url'>
              )>, seo: (
                { __typename: 'ProductSeo' }
                & Pick<ProductSeo, 'slug'>
              ), brand: Maybe<(
                { __typename: 'Brand' }
                & Pick<Brand, 'id' | 'title'>
              )>, productClass: Maybe<(
                { __typename: 'ProductClass' }
                & Pick<ProductClass, 'id' | 'title'>
              )>, cartPromotions: Array<(
                { __typename: 'CartPromotionClubPrice' }
                & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFixedAmountFromCart' }
                & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFixedAmountFromProduct' }
                & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFreeShipping' }
                & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFreebie' }
                & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionPercent' }
                & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
                & { percentDiscount: (
                  { __typename: 'CartPromotionPercentDiscount' }
                  & Pick<CartPromotionPercentDiscount, 'percent'>
                ) }
              ) | (
                { __typename: 'CartPromotionProductCartPromotionPrice' }
                & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
              )>, inventory: (
                { __typename: 'ProductInventory' }
                & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
              ) }
            ) }
          )> }
        ) }
      )>, recommendedProducts: Array<(
        { __typename: 'ConfigurableProduct' }
        & Pick<ConfigurableProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
        & { listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )>, brand: Maybe<(
          { __typename: 'Brand' }
          & Pick<Brand, 'id' | 'title'>
        )> }
      ) | (
        { __typename: 'SimpleProduct' }
        & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
        & { cart: (
          { __typename: 'ProductCart' }
          & Pick<ProductCart, 'minAmount' | 'maxAmount' | 'multiplier'>
        ), inventory: (
          { __typename: 'ProductInventory' }
          & Pick<ProductInventory, 'isAvailableForPurchase'>
        ), pricing: (
          { __typename: 'ProductPricing' }
          & { price: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )> }
        ), listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )>, brand: Maybe<(
          { __typename: 'Brand' }
          & Pick<Brand, 'id' | 'title'>
        )> }
      )>, products: Array<(
        { __typename: 'CartProduct' }
        & Pick<CartProduct, 'id' | 'quantity'>
        & { price: (
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        ), unitPrice: (
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        ), discounts: Array<(
          { __typename: 'CartProductDiscount' }
          & { promotion: (
            { __typename: 'CartPromotionClubPrice' }
            & Pick<CartPromotionClubPrice, 'id'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromCart' }
            & Pick<CartPromotionFixedAmountFromCart, 'id'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromProduct' }
            & Pick<CartPromotionFixedAmountFromProduct, 'id'>
          ) | (
            { __typename: 'CartPromotionFreeShipping' }
            & Pick<CartPromotionFreeShipping, 'id'>
          ) | (
            { __typename: 'CartPromotionFreebie' }
            & Pick<CartPromotionFreebie, 'id'>
          ) | (
            { __typename: 'CartPromotionPercent' }
            & Pick<CartPromotionPercent, 'id'>
          ) | (
            { __typename: 'CartPromotionProductCartPromotionPrice' }
            & Pick<CartPromotionProductCartPromotionPrice, 'id'>
          ) | (
            { __typename: 'CatalogPromotionFixedAmount' }
            & Pick<CatalogPromotionFixedAmount, 'id'>
          ) | (
            { __typename: 'CatalogPromotionPercent' }
            & Pick<CatalogPromotionPercent, 'id'>
          ) | (
            { __typename: 'CatalogPromotionProductPromotionPrice' }
            & Pick<CatalogPromotionProductPromotionPrice, 'id'>
          ), amount: (
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          ) }
        )>, product: (
          { __typename: 'SimpleProduct' }
          & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
          & { medias: Array<(
            { __typename: 'ProductImage' }
            & Pick<ProductImage, 'id' | 'url' | 'position'>
          ) | (
            { __typename: 'ProductModel' }
            & Pick<ProductModel, 'id' | 'url' | 'position'>
          ) | (
            { __typename: 'ProductVideo' }
            & Pick<ProductVideo, 'id' | 'url' | 'position'>
          )>, parentProduct: Maybe<(
            { __typename: 'ConfigurableProduct' }
            & Pick<ConfigurableProduct, 'id'>
            & { medias: Array<(
              { __typename: 'ProductImage' }
              & Pick<ProductImage, 'id' | 'url' | 'position'>
            ) | (
              { __typename: 'ProductModel' }
              & Pick<ProductModel, 'id' | 'url' | 'position'>
            ) | (
              { __typename: 'ProductVideo' }
              & Pick<ProductVideo, 'id' | 'url' | 'position'>
            )> }
          )>, listingImage: Maybe<(
            { __typename: 'ProductImage' }
            & Pick<ProductImage, 'id' | 'url'>
          )>, cart: (
            { __typename: 'ProductCart' }
            & Pick<ProductCart, 'minAmount' | 'maxAmount' | 'multiplier'>
          ), seo: (
            { __typename: 'ProductSeo' }
            & Pick<ProductSeo, 'slug'>
          ), pricing: (
            { __typename: 'ProductPricing' }
            & { price: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, originalPrice: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, clubPrice: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, taxClass: (
              { __typename: 'TaxClass' }
              & Pick<TaxClass, 'id' | 'rate'>
            ) }
          ), brand: Maybe<(
            { __typename: 'Brand' }
            & Pick<Brand, 'id' | 'title'>
          )>, productClass: Maybe<(
            { __typename: 'ProductClass' }
            & Pick<ProductClass, 'id' | 'title'>
          )>, cartPromotions: Array<(
            { __typename: 'CartPromotionClubPrice' }
            & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromCart' }
            & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromProduct' }
            & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFreeShipping' }
            & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFreebie' }
            & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionPercent' }
            & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
            & { percentDiscount: (
              { __typename: 'CartPromotionPercentDiscount' }
              & Pick<CartPromotionPercentDiscount, 'percent'>
            ) }
          ) | (
            { __typename: 'CartPromotionProductCartPromotionPrice' }
            & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
          )>, inventory: (
            { __typename: 'ProductInventory' }
            & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
          ) }
        ) }
      )> }
    ) }
  ) | (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message' | 'detailedMessage'>
  ) }
);

export type CartProductCreateMutationVariables = Exact<{
  input: CartProductCreateInput;
}>;


export type CartProductCreateMutation = (
  { __typename: 'Mutation' }
  & { cartProductCreate: (
    { __typename: 'CartProductCreatePayload' }
    & { cartProduct: (
      { __typename: 'CartProduct' }
      & Pick<CartProduct, 'id'>
    ), cart: (
      { __typename: 'Cart' }
      & Pick<Cart, 'id' | 'productCount'>
      & { price: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), promotionCode: Maybe<(
        { __typename: 'PromotionCode' }
        & Pick<PromotionCode, 'id' | 'code'>
        & { promotion: (
          { __typename: 'CartPromotionClubPrice' }
          & Pick<CartPromotionClubPrice, 'id'>
        ) | (
          { __typename: 'CartPromotionFixedAmountFromCart' }
          & Pick<CartPromotionFixedAmountFromCart, 'id'>
        ) | (
          { __typename: 'CartPromotionFixedAmountFromProduct' }
          & Pick<CartPromotionFixedAmountFromProduct, 'id'>
        ) | (
          { __typename: 'CartPromotionFreeShipping' }
          & Pick<CartPromotionFreeShipping, 'id'>
        ) | (
          { __typename: 'CartPromotionFreebie' }
          & Pick<CartPromotionFreebie, 'id'>
        ) | (
          { __typename: 'CartPromotionPercent' }
          & Pick<CartPromotionPercent, 'id'>
        ) | (
          { __typename: 'CartPromotionProductCartPromotionPrice' }
          & Pick<CartPromotionProductCartPromotionPrice, 'id'>
        ) | (
          { __typename: 'CatalogPromotionFixedAmount' }
          & Pick<CatalogPromotionFixedAmount, 'id'>
        ) | (
          { __typename: 'CatalogPromotionPercent' }
          & Pick<CatalogPromotionPercent, 'id'>
        ) | (
          { __typename: 'CatalogPromotionProductPromotionPrice' }
          & Pick<CatalogPromotionProductPromotionPrice, 'id'>
        ) }
      )>, giftCard: Maybe<(
        { __typename: 'GiftCard' }
        & Pick<GiftCard, 'id' | 'code'>
        & { remainingAmount: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )> }
      )>, relatedProductsByCategory: Array<(
        { __typename: 'CartRelatedProductGroup' }
        & Pick<CartRelatedProductGroup, 'category'>
        & { products: (
          { __typename: 'CartRelatedProductsConnection' }
          & { edges: Array<(
            { __typename: 'CartRelatedProductsEdge' }
            & { node: (
              { __typename: 'ConfigurableProduct' }
              & Pick<ConfigurableProduct, 'id' | 'sku' | 'name' | 'title' | 'specification'>
              & { listingImage: Maybe<(
                { __typename: 'ProductImage' }
                & Pick<ProductImage, 'id' | 'url'>
              )>, seo: (
                { __typename: 'ProductSeo' }
                & Pick<ProductSeo, 'slug'>
              ), brand: Maybe<(
                { __typename: 'Brand' }
                & Pick<Brand, 'id' | 'title'>
              )>, productClass: Maybe<(
                { __typename: 'ProductClass' }
                & Pick<ProductClass, 'id' | 'title'>
              )> }
            ) | (
              { __typename: 'SimpleProduct' }
              & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'specification'>
              & { pricing: (
                { __typename: 'ProductPricing' }
                & { price: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount'>
                )>, originalPrice: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount'>
                )>, clubPrice: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount'>
                )> }
              ), cart: (
                { __typename: 'ProductCart' }
                & Pick<ProductCart, 'multiplier'>
              ), listingImage: Maybe<(
                { __typename: 'ProductImage' }
                & Pick<ProductImage, 'id' | 'url'>
              )>, seo: (
                { __typename: 'ProductSeo' }
                & Pick<ProductSeo, 'slug'>
              ), brand: Maybe<(
                { __typename: 'Brand' }
                & Pick<Brand, 'id' | 'title'>
              )>, productClass: Maybe<(
                { __typename: 'ProductClass' }
                & Pick<ProductClass, 'id' | 'title'>
              )>, cartPromotions: Array<(
                { __typename: 'CartPromotionClubPrice' }
                & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFixedAmountFromCart' }
                & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFixedAmountFromProduct' }
                & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFreeShipping' }
                & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFreebie' }
                & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionPercent' }
                & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
                & { percentDiscount: (
                  { __typename: 'CartPromotionPercentDiscount' }
                  & Pick<CartPromotionPercentDiscount, 'percent'>
                ) }
              ) | (
                { __typename: 'CartPromotionProductCartPromotionPrice' }
                & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
              )>, inventory: (
                { __typename: 'ProductInventory' }
                & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
              ) }
            ) }
          )> }
        ) }
      )>, recommendedProducts: Array<(
        { __typename: 'ConfigurableProduct' }
        & Pick<ConfigurableProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
        & { listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )>, brand: Maybe<(
          { __typename: 'Brand' }
          & Pick<Brand, 'id' | 'title'>
        )> }
      ) | (
        { __typename: 'SimpleProduct' }
        & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
        & { cart: (
          { __typename: 'ProductCart' }
          & Pick<ProductCart, 'minAmount' | 'maxAmount' | 'multiplier'>
        ), inventory: (
          { __typename: 'ProductInventory' }
          & Pick<ProductInventory, 'isAvailableForPurchase'>
        ), pricing: (
          { __typename: 'ProductPricing' }
          & { price: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )> }
        ), listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )>, brand: Maybe<(
          { __typename: 'Brand' }
          & Pick<Brand, 'id' | 'title'>
        )> }
      )>, products: Array<(
        { __typename: 'CartProduct' }
        & Pick<CartProduct, 'id' | 'quantity'>
        & { price: (
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        ), unitPrice: (
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        ), discounts: Array<(
          { __typename: 'CartProductDiscount' }
          & { promotion: (
            { __typename: 'CartPromotionClubPrice' }
            & Pick<CartPromotionClubPrice, 'id'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromCart' }
            & Pick<CartPromotionFixedAmountFromCart, 'id'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromProduct' }
            & Pick<CartPromotionFixedAmountFromProduct, 'id'>
          ) | (
            { __typename: 'CartPromotionFreeShipping' }
            & Pick<CartPromotionFreeShipping, 'id'>
          ) | (
            { __typename: 'CartPromotionFreebie' }
            & Pick<CartPromotionFreebie, 'id'>
          ) | (
            { __typename: 'CartPromotionPercent' }
            & Pick<CartPromotionPercent, 'id'>
          ) | (
            { __typename: 'CartPromotionProductCartPromotionPrice' }
            & Pick<CartPromotionProductCartPromotionPrice, 'id'>
          ) | (
            { __typename: 'CatalogPromotionFixedAmount' }
            & Pick<CatalogPromotionFixedAmount, 'id'>
          ) | (
            { __typename: 'CatalogPromotionPercent' }
            & Pick<CatalogPromotionPercent, 'id'>
          ) | (
            { __typename: 'CatalogPromotionProductPromotionPrice' }
            & Pick<CatalogPromotionProductPromotionPrice, 'id'>
          ), amount: (
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          ) }
        )>, product: (
          { __typename: 'SimpleProduct' }
          & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
          & { medias: Array<(
            { __typename: 'ProductImage' }
            & Pick<ProductImage, 'id' | 'url' | 'position'>
          ) | (
            { __typename: 'ProductModel' }
            & Pick<ProductModel, 'id' | 'url' | 'position'>
          ) | (
            { __typename: 'ProductVideo' }
            & Pick<ProductVideo, 'id' | 'url' | 'position'>
          )>, parentProduct: Maybe<(
            { __typename: 'ConfigurableProduct' }
            & Pick<ConfigurableProduct, 'id'>
            & { medias: Array<(
              { __typename: 'ProductImage' }
              & Pick<ProductImage, 'id' | 'url' | 'position'>
            ) | (
              { __typename: 'ProductModel' }
              & Pick<ProductModel, 'id' | 'url' | 'position'>
            ) | (
              { __typename: 'ProductVideo' }
              & Pick<ProductVideo, 'id' | 'url' | 'position'>
            )> }
          )>, listingImage: Maybe<(
            { __typename: 'ProductImage' }
            & Pick<ProductImage, 'id' | 'url'>
          )>, cart: (
            { __typename: 'ProductCart' }
            & Pick<ProductCart, 'minAmount' | 'maxAmount' | 'multiplier'>
          ), seo: (
            { __typename: 'ProductSeo' }
            & Pick<ProductSeo, 'slug'>
          ), pricing: (
            { __typename: 'ProductPricing' }
            & { price: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, originalPrice: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, clubPrice: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, taxClass: (
              { __typename: 'TaxClass' }
              & Pick<TaxClass, 'id' | 'rate'>
            ) }
          ), brand: Maybe<(
            { __typename: 'Brand' }
            & Pick<Brand, 'id' | 'title'>
          )>, productClass: Maybe<(
            { __typename: 'ProductClass' }
            & Pick<ProductClass, 'id' | 'title'>
          )>, cartPromotions: Array<(
            { __typename: 'CartPromotionClubPrice' }
            & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromCart' }
            & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromProduct' }
            & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFreeShipping' }
            & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFreebie' }
            & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionPercent' }
            & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
            & { percentDiscount: (
              { __typename: 'CartPromotionPercentDiscount' }
              & Pick<CartPromotionPercentDiscount, 'percent'>
            ) }
          ) | (
            { __typename: 'CartPromotionProductCartPromotionPrice' }
            & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
          )>, inventory: (
            { __typename: 'ProductInventory' }
            & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
          ) }
        ) }
      )> }
    ) }
  ) | (
    { __typename: 'CartProductOutOfBoundsError' }
    & Pick<CartProductOutOfBoundsError, 'message'>
  ) | (
    { __typename: 'InvalidInputError' }
    & Pick<InvalidInputError, 'message' | 'detailedMessage'>
  ) }
);

export type CartProductDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CartProductDeleteMutation = (
  { __typename: 'Mutation' }
  & { cartProductDelete: (
    { __typename: 'CartProductDeletePayload' }
    & { cart: (
      { __typename: 'Cart' }
      & Pick<Cart, 'id' | 'productCount'>
      & { price: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), promotionCode: Maybe<(
        { __typename: 'PromotionCode' }
        & Pick<PromotionCode, 'id' | 'code'>
        & { promotion: (
          { __typename: 'CartPromotionClubPrice' }
          & Pick<CartPromotionClubPrice, 'id'>
        ) | (
          { __typename: 'CartPromotionFixedAmountFromCart' }
          & Pick<CartPromotionFixedAmountFromCart, 'id'>
        ) | (
          { __typename: 'CartPromotionFixedAmountFromProduct' }
          & Pick<CartPromotionFixedAmountFromProduct, 'id'>
        ) | (
          { __typename: 'CartPromotionFreeShipping' }
          & Pick<CartPromotionFreeShipping, 'id'>
        ) | (
          { __typename: 'CartPromotionFreebie' }
          & Pick<CartPromotionFreebie, 'id'>
        ) | (
          { __typename: 'CartPromotionPercent' }
          & Pick<CartPromotionPercent, 'id'>
        ) | (
          { __typename: 'CartPromotionProductCartPromotionPrice' }
          & Pick<CartPromotionProductCartPromotionPrice, 'id'>
        ) | (
          { __typename: 'CatalogPromotionFixedAmount' }
          & Pick<CatalogPromotionFixedAmount, 'id'>
        ) | (
          { __typename: 'CatalogPromotionPercent' }
          & Pick<CatalogPromotionPercent, 'id'>
        ) | (
          { __typename: 'CatalogPromotionProductPromotionPrice' }
          & Pick<CatalogPromotionProductPromotionPrice, 'id'>
        ) }
      )>, giftCard: Maybe<(
        { __typename: 'GiftCard' }
        & Pick<GiftCard, 'id' | 'code'>
        & { remainingAmount: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )> }
      )>, relatedProductsByCategory: Array<(
        { __typename: 'CartRelatedProductGroup' }
        & Pick<CartRelatedProductGroup, 'category'>
        & { products: (
          { __typename: 'CartRelatedProductsConnection' }
          & { edges: Array<(
            { __typename: 'CartRelatedProductsEdge' }
            & { node: (
              { __typename: 'ConfigurableProduct' }
              & Pick<ConfigurableProduct, 'id' | 'sku' | 'name' | 'title' | 'specification'>
              & { listingImage: Maybe<(
                { __typename: 'ProductImage' }
                & Pick<ProductImage, 'id' | 'url'>
              )>, seo: (
                { __typename: 'ProductSeo' }
                & Pick<ProductSeo, 'slug'>
              ), brand: Maybe<(
                { __typename: 'Brand' }
                & Pick<Brand, 'id' | 'title'>
              )>, productClass: Maybe<(
                { __typename: 'ProductClass' }
                & Pick<ProductClass, 'id' | 'title'>
              )> }
            ) | (
              { __typename: 'SimpleProduct' }
              & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'specification'>
              & { pricing: (
                { __typename: 'ProductPricing' }
                & { price: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount'>
                )>, originalPrice: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount'>
                )>, clubPrice: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount'>
                )> }
              ), cart: (
                { __typename: 'ProductCart' }
                & Pick<ProductCart, 'multiplier'>
              ), listingImage: Maybe<(
                { __typename: 'ProductImage' }
                & Pick<ProductImage, 'id' | 'url'>
              )>, seo: (
                { __typename: 'ProductSeo' }
                & Pick<ProductSeo, 'slug'>
              ), brand: Maybe<(
                { __typename: 'Brand' }
                & Pick<Brand, 'id' | 'title'>
              )>, productClass: Maybe<(
                { __typename: 'ProductClass' }
                & Pick<ProductClass, 'id' | 'title'>
              )>, cartPromotions: Array<(
                { __typename: 'CartPromotionClubPrice' }
                & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFixedAmountFromCart' }
                & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFixedAmountFromProduct' }
                & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFreeShipping' }
                & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFreebie' }
                & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionPercent' }
                & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
                & { percentDiscount: (
                  { __typename: 'CartPromotionPercentDiscount' }
                  & Pick<CartPromotionPercentDiscount, 'percent'>
                ) }
              ) | (
                { __typename: 'CartPromotionProductCartPromotionPrice' }
                & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
              )>, inventory: (
                { __typename: 'ProductInventory' }
                & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
              ) }
            ) }
          )> }
        ) }
      )>, recommendedProducts: Array<(
        { __typename: 'ConfigurableProduct' }
        & Pick<ConfigurableProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
        & { listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )>, brand: Maybe<(
          { __typename: 'Brand' }
          & Pick<Brand, 'id' | 'title'>
        )> }
      ) | (
        { __typename: 'SimpleProduct' }
        & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
        & { cart: (
          { __typename: 'ProductCart' }
          & Pick<ProductCart, 'minAmount' | 'maxAmount' | 'multiplier'>
        ), inventory: (
          { __typename: 'ProductInventory' }
          & Pick<ProductInventory, 'isAvailableForPurchase'>
        ), pricing: (
          { __typename: 'ProductPricing' }
          & { price: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )> }
        ), listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )>, brand: Maybe<(
          { __typename: 'Brand' }
          & Pick<Brand, 'id' | 'title'>
        )> }
      )>, products: Array<(
        { __typename: 'CartProduct' }
        & Pick<CartProduct, 'id' | 'quantity'>
        & { price: (
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        ), unitPrice: (
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        ), discounts: Array<(
          { __typename: 'CartProductDiscount' }
          & { promotion: (
            { __typename: 'CartPromotionClubPrice' }
            & Pick<CartPromotionClubPrice, 'id'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromCart' }
            & Pick<CartPromotionFixedAmountFromCart, 'id'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromProduct' }
            & Pick<CartPromotionFixedAmountFromProduct, 'id'>
          ) | (
            { __typename: 'CartPromotionFreeShipping' }
            & Pick<CartPromotionFreeShipping, 'id'>
          ) | (
            { __typename: 'CartPromotionFreebie' }
            & Pick<CartPromotionFreebie, 'id'>
          ) | (
            { __typename: 'CartPromotionPercent' }
            & Pick<CartPromotionPercent, 'id'>
          ) | (
            { __typename: 'CartPromotionProductCartPromotionPrice' }
            & Pick<CartPromotionProductCartPromotionPrice, 'id'>
          ) | (
            { __typename: 'CatalogPromotionFixedAmount' }
            & Pick<CatalogPromotionFixedAmount, 'id'>
          ) | (
            { __typename: 'CatalogPromotionPercent' }
            & Pick<CatalogPromotionPercent, 'id'>
          ) | (
            { __typename: 'CatalogPromotionProductPromotionPrice' }
            & Pick<CatalogPromotionProductPromotionPrice, 'id'>
          ), amount: (
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          ) }
        )>, product: (
          { __typename: 'SimpleProduct' }
          & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
          & { medias: Array<(
            { __typename: 'ProductImage' }
            & Pick<ProductImage, 'id' | 'url' | 'position'>
          ) | (
            { __typename: 'ProductModel' }
            & Pick<ProductModel, 'id' | 'url' | 'position'>
          ) | (
            { __typename: 'ProductVideo' }
            & Pick<ProductVideo, 'id' | 'url' | 'position'>
          )>, parentProduct: Maybe<(
            { __typename: 'ConfigurableProduct' }
            & Pick<ConfigurableProduct, 'id'>
            & { medias: Array<(
              { __typename: 'ProductImage' }
              & Pick<ProductImage, 'id' | 'url' | 'position'>
            ) | (
              { __typename: 'ProductModel' }
              & Pick<ProductModel, 'id' | 'url' | 'position'>
            ) | (
              { __typename: 'ProductVideo' }
              & Pick<ProductVideo, 'id' | 'url' | 'position'>
            )> }
          )>, listingImage: Maybe<(
            { __typename: 'ProductImage' }
            & Pick<ProductImage, 'id' | 'url'>
          )>, cart: (
            { __typename: 'ProductCart' }
            & Pick<ProductCart, 'minAmount' | 'maxAmount' | 'multiplier'>
          ), seo: (
            { __typename: 'ProductSeo' }
            & Pick<ProductSeo, 'slug'>
          ), pricing: (
            { __typename: 'ProductPricing' }
            & { price: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, originalPrice: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, clubPrice: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, taxClass: (
              { __typename: 'TaxClass' }
              & Pick<TaxClass, 'id' | 'rate'>
            ) }
          ), brand: Maybe<(
            { __typename: 'Brand' }
            & Pick<Brand, 'id' | 'title'>
          )>, productClass: Maybe<(
            { __typename: 'ProductClass' }
            & Pick<ProductClass, 'id' | 'title'>
          )>, cartPromotions: Array<(
            { __typename: 'CartPromotionClubPrice' }
            & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromCart' }
            & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromProduct' }
            & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFreeShipping' }
            & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFreebie' }
            & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionPercent' }
            & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
            & { percentDiscount: (
              { __typename: 'CartPromotionPercentDiscount' }
              & Pick<CartPromotionPercentDiscount, 'percent'>
            ) }
          ) | (
            { __typename: 'CartPromotionProductCartPromotionPrice' }
            & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
          )>, inventory: (
            { __typename: 'ProductInventory' }
            & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
          ) }
        ) }
      )> }
    ) }
  ) | (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message' | 'detailedMessage'>
  ) }
);

export type CartProductUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  quantity: Scalars['PositiveInt']['input'];
}>;


export type CartProductUpdateMutation = (
  { __typename: 'Mutation' }
  & { cartProductUpdate: { __typename: 'CartProductOutOfBoundsError' } | (
    { __typename: 'CartProductUpdatePayload' }
    & { cart: (
      { __typename: 'Cart' }
      & Pick<Cart, 'id' | 'productCount'>
      & { price: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), promotionCode: Maybe<(
        { __typename: 'PromotionCode' }
        & Pick<PromotionCode, 'id' | 'code'>
        & { promotion: (
          { __typename: 'CartPromotionClubPrice' }
          & Pick<CartPromotionClubPrice, 'id'>
        ) | (
          { __typename: 'CartPromotionFixedAmountFromCart' }
          & Pick<CartPromotionFixedAmountFromCart, 'id'>
        ) | (
          { __typename: 'CartPromotionFixedAmountFromProduct' }
          & Pick<CartPromotionFixedAmountFromProduct, 'id'>
        ) | (
          { __typename: 'CartPromotionFreeShipping' }
          & Pick<CartPromotionFreeShipping, 'id'>
        ) | (
          { __typename: 'CartPromotionFreebie' }
          & Pick<CartPromotionFreebie, 'id'>
        ) | (
          { __typename: 'CartPromotionPercent' }
          & Pick<CartPromotionPercent, 'id'>
        ) | (
          { __typename: 'CartPromotionProductCartPromotionPrice' }
          & Pick<CartPromotionProductCartPromotionPrice, 'id'>
        ) | (
          { __typename: 'CatalogPromotionFixedAmount' }
          & Pick<CatalogPromotionFixedAmount, 'id'>
        ) | (
          { __typename: 'CatalogPromotionPercent' }
          & Pick<CatalogPromotionPercent, 'id'>
        ) | (
          { __typename: 'CatalogPromotionProductPromotionPrice' }
          & Pick<CatalogPromotionProductPromotionPrice, 'id'>
        ) }
      )>, giftCard: Maybe<(
        { __typename: 'GiftCard' }
        & Pick<GiftCard, 'id' | 'code'>
        & { remainingAmount: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )> }
      )>, relatedProductsByCategory: Array<(
        { __typename: 'CartRelatedProductGroup' }
        & Pick<CartRelatedProductGroup, 'category'>
        & { products: (
          { __typename: 'CartRelatedProductsConnection' }
          & { edges: Array<(
            { __typename: 'CartRelatedProductsEdge' }
            & { node: (
              { __typename: 'ConfigurableProduct' }
              & Pick<ConfigurableProduct, 'id' | 'sku' | 'name' | 'title' | 'specification'>
              & { listingImage: Maybe<(
                { __typename: 'ProductImage' }
                & Pick<ProductImage, 'id' | 'url'>
              )>, seo: (
                { __typename: 'ProductSeo' }
                & Pick<ProductSeo, 'slug'>
              ), brand: Maybe<(
                { __typename: 'Brand' }
                & Pick<Brand, 'id' | 'title'>
              )>, productClass: Maybe<(
                { __typename: 'ProductClass' }
                & Pick<ProductClass, 'id' | 'title'>
              )> }
            ) | (
              { __typename: 'SimpleProduct' }
              & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'specification'>
              & { pricing: (
                { __typename: 'ProductPricing' }
                & { price: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount'>
                )>, originalPrice: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount'>
                )>, clubPrice: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount'>
                )> }
              ), cart: (
                { __typename: 'ProductCart' }
                & Pick<ProductCart, 'multiplier'>
              ), listingImage: Maybe<(
                { __typename: 'ProductImage' }
                & Pick<ProductImage, 'id' | 'url'>
              )>, seo: (
                { __typename: 'ProductSeo' }
                & Pick<ProductSeo, 'slug'>
              ), brand: Maybe<(
                { __typename: 'Brand' }
                & Pick<Brand, 'id' | 'title'>
              )>, productClass: Maybe<(
                { __typename: 'ProductClass' }
                & Pick<ProductClass, 'id' | 'title'>
              )>, cartPromotions: Array<(
                { __typename: 'CartPromotionClubPrice' }
                & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFixedAmountFromCart' }
                & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFixedAmountFromProduct' }
                & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFreeShipping' }
                & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFreebie' }
                & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionPercent' }
                & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
                & { percentDiscount: (
                  { __typename: 'CartPromotionPercentDiscount' }
                  & Pick<CartPromotionPercentDiscount, 'percent'>
                ) }
              ) | (
                { __typename: 'CartPromotionProductCartPromotionPrice' }
                & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
              )>, inventory: (
                { __typename: 'ProductInventory' }
                & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
              ) }
            ) }
          )> }
        ) }
      )>, recommendedProducts: Array<(
        { __typename: 'ConfigurableProduct' }
        & Pick<ConfigurableProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
        & { listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )>, brand: Maybe<(
          { __typename: 'Brand' }
          & Pick<Brand, 'id' | 'title'>
        )> }
      ) | (
        { __typename: 'SimpleProduct' }
        & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
        & { cart: (
          { __typename: 'ProductCart' }
          & Pick<ProductCart, 'minAmount' | 'maxAmount' | 'multiplier'>
        ), inventory: (
          { __typename: 'ProductInventory' }
          & Pick<ProductInventory, 'isAvailableForPurchase'>
        ), pricing: (
          { __typename: 'ProductPricing' }
          & { price: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )> }
        ), listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )>, brand: Maybe<(
          { __typename: 'Brand' }
          & Pick<Brand, 'id' | 'title'>
        )> }
      )>, products: Array<(
        { __typename: 'CartProduct' }
        & Pick<CartProduct, 'id' | 'quantity'>
        & { price: (
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        ), unitPrice: (
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        ), discounts: Array<(
          { __typename: 'CartProductDiscount' }
          & { promotion: (
            { __typename: 'CartPromotionClubPrice' }
            & Pick<CartPromotionClubPrice, 'id'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromCart' }
            & Pick<CartPromotionFixedAmountFromCart, 'id'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromProduct' }
            & Pick<CartPromotionFixedAmountFromProduct, 'id'>
          ) | (
            { __typename: 'CartPromotionFreeShipping' }
            & Pick<CartPromotionFreeShipping, 'id'>
          ) | (
            { __typename: 'CartPromotionFreebie' }
            & Pick<CartPromotionFreebie, 'id'>
          ) | (
            { __typename: 'CartPromotionPercent' }
            & Pick<CartPromotionPercent, 'id'>
          ) | (
            { __typename: 'CartPromotionProductCartPromotionPrice' }
            & Pick<CartPromotionProductCartPromotionPrice, 'id'>
          ) | (
            { __typename: 'CatalogPromotionFixedAmount' }
            & Pick<CatalogPromotionFixedAmount, 'id'>
          ) | (
            { __typename: 'CatalogPromotionPercent' }
            & Pick<CatalogPromotionPercent, 'id'>
          ) | (
            { __typename: 'CatalogPromotionProductPromotionPrice' }
            & Pick<CatalogPromotionProductPromotionPrice, 'id'>
          ), amount: (
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          ) }
        )>, product: (
          { __typename: 'SimpleProduct' }
          & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
          & { medias: Array<(
            { __typename: 'ProductImage' }
            & Pick<ProductImage, 'id' | 'url' | 'position'>
          ) | (
            { __typename: 'ProductModel' }
            & Pick<ProductModel, 'id' | 'url' | 'position'>
          ) | (
            { __typename: 'ProductVideo' }
            & Pick<ProductVideo, 'id' | 'url' | 'position'>
          )>, parentProduct: Maybe<(
            { __typename: 'ConfigurableProduct' }
            & Pick<ConfigurableProduct, 'id'>
            & { medias: Array<(
              { __typename: 'ProductImage' }
              & Pick<ProductImage, 'id' | 'url' | 'position'>
            ) | (
              { __typename: 'ProductModel' }
              & Pick<ProductModel, 'id' | 'url' | 'position'>
            ) | (
              { __typename: 'ProductVideo' }
              & Pick<ProductVideo, 'id' | 'url' | 'position'>
            )> }
          )>, listingImage: Maybe<(
            { __typename: 'ProductImage' }
            & Pick<ProductImage, 'id' | 'url'>
          )>, cart: (
            { __typename: 'ProductCart' }
            & Pick<ProductCart, 'minAmount' | 'maxAmount' | 'multiplier'>
          ), seo: (
            { __typename: 'ProductSeo' }
            & Pick<ProductSeo, 'slug'>
          ), pricing: (
            { __typename: 'ProductPricing' }
            & { price: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, originalPrice: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, clubPrice: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, taxClass: (
              { __typename: 'TaxClass' }
              & Pick<TaxClass, 'id' | 'rate'>
            ) }
          ), brand: Maybe<(
            { __typename: 'Brand' }
            & Pick<Brand, 'id' | 'title'>
          )>, productClass: Maybe<(
            { __typename: 'ProductClass' }
            & Pick<ProductClass, 'id' | 'title'>
          )>, cartPromotions: Array<(
            { __typename: 'CartPromotionClubPrice' }
            & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromCart' }
            & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromProduct' }
            & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFreeShipping' }
            & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFreebie' }
            & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionPercent' }
            & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
            & { percentDiscount: (
              { __typename: 'CartPromotionPercentDiscount' }
              & Pick<CartPromotionPercentDiscount, 'percent'>
            ) }
          ) | (
            { __typename: 'CartPromotionProductCartPromotionPrice' }
            & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
          )>, inventory: (
            { __typename: 'ProductInventory' }
            & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
          ) }
        ) }
      )> }
    ), cartProduct: (
      { __typename: 'CartProduct' }
      & Pick<CartProduct, 'id' | 'quantity'>
      & { price: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ) }
    ) }
  ) | (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message' | 'detailedMessage'>
  ) }
);

export type CartUpdatePromotionCodeMutationVariables = Exact<{
  promotionCode?: InputMaybe<Scalars['NonEmptyString']['input']>;
  id: Scalars['ID']['input'];
}>;


export type CartUpdatePromotionCodeMutation = (
  { __typename: 'Mutation' }
  & { cartUpdatePromotionCode: (
    { __typename: 'CartUpdatePayload' }
    & { cart: (
      { __typename: 'Cart' }
      & Pick<Cart, 'id' | 'productCount'>
      & { price: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), promotionCode: Maybe<(
        { __typename: 'PromotionCode' }
        & Pick<PromotionCode, 'id' | 'code'>
        & { promotion: (
          { __typename: 'CartPromotionClubPrice' }
          & Pick<CartPromotionClubPrice, 'id'>
        ) | (
          { __typename: 'CartPromotionFixedAmountFromCart' }
          & Pick<CartPromotionFixedAmountFromCart, 'id'>
        ) | (
          { __typename: 'CartPromotionFixedAmountFromProduct' }
          & Pick<CartPromotionFixedAmountFromProduct, 'id'>
        ) | (
          { __typename: 'CartPromotionFreeShipping' }
          & Pick<CartPromotionFreeShipping, 'id'>
        ) | (
          { __typename: 'CartPromotionFreebie' }
          & Pick<CartPromotionFreebie, 'id'>
        ) | (
          { __typename: 'CartPromotionPercent' }
          & Pick<CartPromotionPercent, 'id'>
        ) | (
          { __typename: 'CartPromotionProductCartPromotionPrice' }
          & Pick<CartPromotionProductCartPromotionPrice, 'id'>
        ) | (
          { __typename: 'CatalogPromotionFixedAmount' }
          & Pick<CatalogPromotionFixedAmount, 'id'>
        ) | (
          { __typename: 'CatalogPromotionPercent' }
          & Pick<CatalogPromotionPercent, 'id'>
        ) | (
          { __typename: 'CatalogPromotionProductPromotionPrice' }
          & Pick<CatalogPromotionProductPromotionPrice, 'id'>
        ) }
      )>, giftCard: Maybe<(
        { __typename: 'GiftCard' }
        & Pick<GiftCard, 'id' | 'code'>
        & { remainingAmount: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )> }
      )>, relatedProductsByCategory: Array<(
        { __typename: 'CartRelatedProductGroup' }
        & Pick<CartRelatedProductGroup, 'category'>
        & { products: (
          { __typename: 'CartRelatedProductsConnection' }
          & { edges: Array<(
            { __typename: 'CartRelatedProductsEdge' }
            & { node: (
              { __typename: 'ConfigurableProduct' }
              & Pick<ConfigurableProduct, 'id' | 'sku' | 'name' | 'title' | 'specification'>
              & { listingImage: Maybe<(
                { __typename: 'ProductImage' }
                & Pick<ProductImage, 'id' | 'url'>
              )>, seo: (
                { __typename: 'ProductSeo' }
                & Pick<ProductSeo, 'slug'>
              ), brand: Maybe<(
                { __typename: 'Brand' }
                & Pick<Brand, 'id' | 'title'>
              )>, productClass: Maybe<(
                { __typename: 'ProductClass' }
                & Pick<ProductClass, 'id' | 'title'>
              )> }
            ) | (
              { __typename: 'SimpleProduct' }
              & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'specification'>
              & { pricing: (
                { __typename: 'ProductPricing' }
                & { price: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount'>
                )>, originalPrice: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount'>
                )>, clubPrice: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount'>
                )> }
              ), cart: (
                { __typename: 'ProductCart' }
                & Pick<ProductCart, 'multiplier'>
              ), listingImage: Maybe<(
                { __typename: 'ProductImage' }
                & Pick<ProductImage, 'id' | 'url'>
              )>, seo: (
                { __typename: 'ProductSeo' }
                & Pick<ProductSeo, 'slug'>
              ), brand: Maybe<(
                { __typename: 'Brand' }
                & Pick<Brand, 'id' | 'title'>
              )>, productClass: Maybe<(
                { __typename: 'ProductClass' }
                & Pick<ProductClass, 'id' | 'title'>
              )>, cartPromotions: Array<(
                { __typename: 'CartPromotionClubPrice' }
                & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFixedAmountFromCart' }
                & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFixedAmountFromProduct' }
                & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFreeShipping' }
                & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFreebie' }
                & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionPercent' }
                & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
                & { percentDiscount: (
                  { __typename: 'CartPromotionPercentDiscount' }
                  & Pick<CartPromotionPercentDiscount, 'percent'>
                ) }
              ) | (
                { __typename: 'CartPromotionProductCartPromotionPrice' }
                & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
              )>, inventory: (
                { __typename: 'ProductInventory' }
                & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
              ) }
            ) }
          )> }
        ) }
      )>, recommendedProducts: Array<(
        { __typename: 'ConfigurableProduct' }
        & Pick<ConfigurableProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
        & { listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )>, brand: Maybe<(
          { __typename: 'Brand' }
          & Pick<Brand, 'id' | 'title'>
        )> }
      ) | (
        { __typename: 'SimpleProduct' }
        & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
        & { cart: (
          { __typename: 'ProductCart' }
          & Pick<ProductCart, 'minAmount' | 'maxAmount' | 'multiplier'>
        ), inventory: (
          { __typename: 'ProductInventory' }
          & Pick<ProductInventory, 'isAvailableForPurchase'>
        ), pricing: (
          { __typename: 'ProductPricing' }
          & { price: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )> }
        ), listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )>, brand: Maybe<(
          { __typename: 'Brand' }
          & Pick<Brand, 'id' | 'title'>
        )> }
      )>, products: Array<(
        { __typename: 'CartProduct' }
        & Pick<CartProduct, 'id' | 'quantity'>
        & { price: (
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        ), unitPrice: (
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        ), discounts: Array<(
          { __typename: 'CartProductDiscount' }
          & { promotion: (
            { __typename: 'CartPromotionClubPrice' }
            & Pick<CartPromotionClubPrice, 'id'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromCart' }
            & Pick<CartPromotionFixedAmountFromCart, 'id'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromProduct' }
            & Pick<CartPromotionFixedAmountFromProduct, 'id'>
          ) | (
            { __typename: 'CartPromotionFreeShipping' }
            & Pick<CartPromotionFreeShipping, 'id'>
          ) | (
            { __typename: 'CartPromotionFreebie' }
            & Pick<CartPromotionFreebie, 'id'>
          ) | (
            { __typename: 'CartPromotionPercent' }
            & Pick<CartPromotionPercent, 'id'>
          ) | (
            { __typename: 'CartPromotionProductCartPromotionPrice' }
            & Pick<CartPromotionProductCartPromotionPrice, 'id'>
          ) | (
            { __typename: 'CatalogPromotionFixedAmount' }
            & Pick<CatalogPromotionFixedAmount, 'id'>
          ) | (
            { __typename: 'CatalogPromotionPercent' }
            & Pick<CatalogPromotionPercent, 'id'>
          ) | (
            { __typename: 'CatalogPromotionProductPromotionPrice' }
            & Pick<CatalogPromotionProductPromotionPrice, 'id'>
          ), amount: (
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          ) }
        )>, product: (
          { __typename: 'SimpleProduct' }
          & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
          & { medias: Array<(
            { __typename: 'ProductImage' }
            & Pick<ProductImage, 'id' | 'url' | 'position'>
          ) | (
            { __typename: 'ProductModel' }
            & Pick<ProductModel, 'id' | 'url' | 'position'>
          ) | (
            { __typename: 'ProductVideo' }
            & Pick<ProductVideo, 'id' | 'url' | 'position'>
          )>, parentProduct: Maybe<(
            { __typename: 'ConfigurableProduct' }
            & Pick<ConfigurableProduct, 'id'>
            & { medias: Array<(
              { __typename: 'ProductImage' }
              & Pick<ProductImage, 'id' | 'url' | 'position'>
            ) | (
              { __typename: 'ProductModel' }
              & Pick<ProductModel, 'id' | 'url' | 'position'>
            ) | (
              { __typename: 'ProductVideo' }
              & Pick<ProductVideo, 'id' | 'url' | 'position'>
            )> }
          )>, listingImage: Maybe<(
            { __typename: 'ProductImage' }
            & Pick<ProductImage, 'id' | 'url'>
          )>, cart: (
            { __typename: 'ProductCart' }
            & Pick<ProductCart, 'minAmount' | 'maxAmount' | 'multiplier'>
          ), seo: (
            { __typename: 'ProductSeo' }
            & Pick<ProductSeo, 'slug'>
          ), pricing: (
            { __typename: 'ProductPricing' }
            & { price: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, originalPrice: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, clubPrice: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, taxClass: (
              { __typename: 'TaxClass' }
              & Pick<TaxClass, 'id' | 'rate'>
            ) }
          ), brand: Maybe<(
            { __typename: 'Brand' }
            & Pick<Brand, 'id' | 'title'>
          )>, productClass: Maybe<(
            { __typename: 'ProductClass' }
            & Pick<ProductClass, 'id' | 'title'>
          )>, cartPromotions: Array<(
            { __typename: 'CartPromotionClubPrice' }
            & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromCart' }
            & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromProduct' }
            & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFreeShipping' }
            & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFreebie' }
            & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionPercent' }
            & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
            & { percentDiscount: (
              { __typename: 'CartPromotionPercentDiscount' }
              & Pick<CartPromotionPercentDiscount, 'percent'>
            ) }
          ) | (
            { __typename: 'CartPromotionProductCartPromotionPrice' }
            & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
          )>, inventory: (
            { __typename: 'ProductInventory' }
            & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
          ) }
        ) }
      )> }
    ) }
  ) | (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message' | 'detailedMessage'>
  ) }
);

export type ViewCartQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ViewCartQuery = (
  { __typename: 'Query' }
  & { cart: (
    { __typename: 'Cart' }
    & Pick<Cart, 'id' | 'productCount'>
    & { price: (
      { __typename: 'Money' }
      & Pick<Money, 'amount'>
    ), promotionCode: Maybe<(
      { __typename: 'PromotionCode' }
      & Pick<PromotionCode, 'id' | 'code'>
      & { promotion: (
        { __typename: 'CartPromotionClubPrice' }
        & Pick<CartPromotionClubPrice, 'id'>
      ) | (
        { __typename: 'CartPromotionFixedAmountFromCart' }
        & Pick<CartPromotionFixedAmountFromCart, 'id'>
      ) | (
        { __typename: 'CartPromotionFixedAmountFromProduct' }
        & Pick<CartPromotionFixedAmountFromProduct, 'id'>
      ) | (
        { __typename: 'CartPromotionFreeShipping' }
        & Pick<CartPromotionFreeShipping, 'id'>
      ) | (
        { __typename: 'CartPromotionFreebie' }
        & Pick<CartPromotionFreebie, 'id'>
      ) | (
        { __typename: 'CartPromotionPercent' }
        & Pick<CartPromotionPercent, 'id'>
      ) | (
        { __typename: 'CartPromotionProductCartPromotionPrice' }
        & Pick<CartPromotionProductCartPromotionPrice, 'id'>
      ) | (
        { __typename: 'CatalogPromotionFixedAmount' }
        & Pick<CatalogPromotionFixedAmount, 'id'>
      ) | (
        { __typename: 'CatalogPromotionPercent' }
        & Pick<CatalogPromotionPercent, 'id'>
      ) | (
        { __typename: 'CatalogPromotionProductPromotionPrice' }
        & Pick<CatalogPromotionProductPromotionPrice, 'id'>
      ) }
    )>, giftCard: Maybe<(
      { __typename: 'GiftCard' }
      & Pick<GiftCard, 'id' | 'code'>
      & { remainingAmount: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )> }
    )>, relatedProductsByCategory: Array<(
      { __typename: 'CartRelatedProductGroup' }
      & Pick<CartRelatedProductGroup, 'category'>
      & { products: (
        { __typename: 'CartRelatedProductsConnection' }
        & { edges: Array<(
          { __typename: 'CartRelatedProductsEdge' }
          & { node: (
            { __typename: 'ConfigurableProduct' }
            & Pick<ConfigurableProduct, 'id' | 'sku' | 'name' | 'title' | 'specification'>
            & { listingImage: Maybe<(
              { __typename: 'ProductImage' }
              & Pick<ProductImage, 'id' | 'url'>
            )>, seo: (
              { __typename: 'ProductSeo' }
              & Pick<ProductSeo, 'slug'>
            ), brand: Maybe<(
              { __typename: 'Brand' }
              & Pick<Brand, 'id' | 'title'>
            )>, productClass: Maybe<(
              { __typename: 'ProductClass' }
              & Pick<ProductClass, 'id' | 'title'>
            )> }
          ) | (
            { __typename: 'SimpleProduct' }
            & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'specification'>
            & { pricing: (
              { __typename: 'ProductPricing' }
              & { price: Maybe<(
                { __typename: 'Money' }
                & Pick<Money, 'amount'>
              )>, originalPrice: Maybe<(
                { __typename: 'Money' }
                & Pick<Money, 'amount'>
              )>, clubPrice: Maybe<(
                { __typename: 'Money' }
                & Pick<Money, 'amount'>
              )> }
            ), cart: (
              { __typename: 'ProductCart' }
              & Pick<ProductCart, 'multiplier'>
            ), listingImage: Maybe<(
              { __typename: 'ProductImage' }
              & Pick<ProductImage, 'id' | 'url'>
            )>, seo: (
              { __typename: 'ProductSeo' }
              & Pick<ProductSeo, 'slug'>
            ), brand: Maybe<(
              { __typename: 'Brand' }
              & Pick<Brand, 'id' | 'title'>
            )>, productClass: Maybe<(
              { __typename: 'ProductClass' }
              & Pick<ProductClass, 'id' | 'title'>
            )>, cartPromotions: Array<(
              { __typename: 'CartPromotionClubPrice' }
              & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
            ) | (
              { __typename: 'CartPromotionFixedAmountFromCart' }
              & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
            ) | (
              { __typename: 'CartPromotionFixedAmountFromProduct' }
              & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
            ) | (
              { __typename: 'CartPromotionFreeShipping' }
              & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
            ) | (
              { __typename: 'CartPromotionFreebie' }
              & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
            ) | (
              { __typename: 'CartPromotionPercent' }
              & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
              & { percentDiscount: (
                { __typename: 'CartPromotionPercentDiscount' }
                & Pick<CartPromotionPercentDiscount, 'percent'>
              ) }
            ) | (
              { __typename: 'CartPromotionProductCartPromotionPrice' }
              & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
            )>, inventory: (
              { __typename: 'ProductInventory' }
              & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
            ) }
          ) }
        )> }
      ) }
    )>, recommendedProducts: Array<(
      { __typename: 'ConfigurableProduct' }
      & Pick<ConfigurableProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
      & { listingImage: Maybe<(
        { __typename: 'ProductImage' }
        & Pick<ProductImage, 'id' | 'url'>
      )>, brand: Maybe<(
        { __typename: 'Brand' }
        & Pick<Brand, 'id' | 'title'>
      )> }
    ) | (
      { __typename: 'SimpleProduct' }
      & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
      & { cart: (
        { __typename: 'ProductCart' }
        & Pick<ProductCart, 'minAmount' | 'maxAmount' | 'multiplier'>
      ), inventory: (
        { __typename: 'ProductInventory' }
        & Pick<ProductInventory, 'isAvailableForPurchase'>
      ), pricing: (
        { __typename: 'ProductPricing' }
        & { price: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )> }
      ), listingImage: Maybe<(
        { __typename: 'ProductImage' }
        & Pick<ProductImage, 'id' | 'url'>
      )>, brand: Maybe<(
        { __typename: 'Brand' }
        & Pick<Brand, 'id' | 'title'>
      )> }
    )>, products: Array<(
      { __typename: 'CartProduct' }
      & Pick<CartProduct, 'id' | 'quantity'>
      & { price: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), unitPrice: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), discounts: Array<(
        { __typename: 'CartProductDiscount' }
        & { promotion: (
          { __typename: 'CartPromotionClubPrice' }
          & Pick<CartPromotionClubPrice, 'id'>
        ) | (
          { __typename: 'CartPromotionFixedAmountFromCart' }
          & Pick<CartPromotionFixedAmountFromCart, 'id'>
        ) | (
          { __typename: 'CartPromotionFixedAmountFromProduct' }
          & Pick<CartPromotionFixedAmountFromProduct, 'id'>
        ) | (
          { __typename: 'CartPromotionFreeShipping' }
          & Pick<CartPromotionFreeShipping, 'id'>
        ) | (
          { __typename: 'CartPromotionFreebie' }
          & Pick<CartPromotionFreebie, 'id'>
        ) | (
          { __typename: 'CartPromotionPercent' }
          & Pick<CartPromotionPercent, 'id'>
        ) | (
          { __typename: 'CartPromotionProductCartPromotionPrice' }
          & Pick<CartPromotionProductCartPromotionPrice, 'id'>
        ) | (
          { __typename: 'CatalogPromotionFixedAmount' }
          & Pick<CatalogPromotionFixedAmount, 'id'>
        ) | (
          { __typename: 'CatalogPromotionPercent' }
          & Pick<CatalogPromotionPercent, 'id'>
        ) | (
          { __typename: 'CatalogPromotionProductPromotionPrice' }
          & Pick<CatalogPromotionProductPromotionPrice, 'id'>
        ), amount: (
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        ) }
      )>, product: (
        { __typename: 'SimpleProduct' }
        & Pick<SimpleProduct, 'id' | 'sku' | 'name' | 'title' | 'state' | 'specification'>
        & { medias: Array<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url' | 'position'>
        ) | (
          { __typename: 'ProductModel' }
          & Pick<ProductModel, 'id' | 'url' | 'position'>
        ) | (
          { __typename: 'ProductVideo' }
          & Pick<ProductVideo, 'id' | 'url' | 'position'>
        )>, parentProduct: Maybe<(
          { __typename: 'ConfigurableProduct' }
          & Pick<ConfigurableProduct, 'id'>
          & { medias: Array<(
            { __typename: 'ProductImage' }
            & Pick<ProductImage, 'id' | 'url' | 'position'>
          ) | (
            { __typename: 'ProductModel' }
            & Pick<ProductModel, 'id' | 'url' | 'position'>
          ) | (
            { __typename: 'ProductVideo' }
            & Pick<ProductVideo, 'id' | 'url' | 'position'>
          )> }
        )>, listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )>, cart: (
          { __typename: 'ProductCart' }
          & Pick<ProductCart, 'minAmount' | 'maxAmount' | 'multiplier'>
        ), seo: (
          { __typename: 'ProductSeo' }
          & Pick<ProductSeo, 'slug'>
        ), pricing: (
          { __typename: 'ProductPricing' }
          & { price: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )>, originalPrice: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )>, clubPrice: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )>, taxClass: (
            { __typename: 'TaxClass' }
            & Pick<TaxClass, 'id' | 'rate'>
          ) }
        ), brand: Maybe<(
          { __typename: 'Brand' }
          & Pick<Brand, 'id' | 'title'>
        )>, productClass: Maybe<(
          { __typename: 'ProductClass' }
          & Pick<ProductClass, 'id' | 'title'>
        )>, cartPromotions: Array<(
          { __typename: 'CartPromotionClubPrice' }
          & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
        ) | (
          { __typename: 'CartPromotionFixedAmountFromCart' }
          & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
        ) | (
          { __typename: 'CartPromotionFixedAmountFromProduct' }
          & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
        ) | (
          { __typename: 'CartPromotionFreeShipping' }
          & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
        ) | (
          { __typename: 'CartPromotionFreebie' }
          & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
        ) | (
          { __typename: 'CartPromotionPercent' }
          & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
          & { percentDiscount: (
            { __typename: 'CartPromotionPercentDiscount' }
            & Pick<CartPromotionPercentDiscount, 'percent'>
          ) }
        ) | (
          { __typename: 'CartPromotionProductCartPromotionPrice' }
          & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
        )>, inventory: (
          { __typename: 'ProductInventory' }
          & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
        ) }
      ) }
    )> }
  ) | (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) }
);

export type CategoryProductPickerSearchQueryVariables = Exact<{
  where: ProductWhereInput;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CategoryProductPickerSearchQuery = (
  { __typename: 'Query' }
  & { products: (
    { __typename: 'ProductsConnection' }
    & Pick<ProductsConnection, 'totalCount'>
    & { pageInfo: (
      { __typename: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage'>
    ), edges: Array<(
      { __typename: 'ProductsEdge' }
      & { node: (
        { __typename: 'ConfigurableProduct' }
        & Pick<ConfigurableProduct, 'id' | 'name'>
        & { categories: Array<(
          { __typename: 'Category' }
          & Pick<Category, 'id'>
        )>, listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )> }
      ) | (
        { __typename: 'SimpleProduct' }
        & Pick<SimpleProduct, 'sku' | 'description' | 'id' | 'name'>
        & { pricing: (
          { __typename: 'ProductPricing' }
          & { price: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount' | 'currencyCode'>
          )> }
        ), inventory: (
          { __typename: 'ProductInventory' }
          & Pick<ProductInventory, 'availableQuantity'>
        ), categories: Array<(
          { __typename: 'Category' }
          & Pick<Category, 'id'>
        )>, listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )> }
      ) }
    )> }
  ) }
);

export type ListCategoryProductsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['ID']['input'];
}>;


export type ListCategoryProductsQuery = (
  { __typename: 'Query' }
  & { products: (
    { __typename: 'ProductsConnection' }
    & Pick<ProductsConnection, 'totalCount'>
    & { pageInfo: (
      { __typename: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'endCursor'>
    ), edges: Array<(
      { __typename: 'ProductsEdge' }
      & { node: (
        { __typename: 'ConfigurableProduct' }
        & Pick<ConfigurableProduct, 'id' | 'name' | 'title' | 'specification'>
        & { configuration: (
          { __typename: 'ProductConfiguration' }
          & { defaultProduct: Maybe<(
            { __typename: 'SimpleProduct' }
            & Pick<SimpleProduct, 'id'>
            & { listingImage: Maybe<(
              { __typename: 'ProductImage' }
              & Pick<ProductImage, 'id' | 'url'>
            )>, pricing: (
              { __typename: 'ProductPricing' }
              & { price: Maybe<(
                { __typename: 'Money' }
                & Pick<Money, 'amount'>
              )>, originalPrice: Maybe<(
                { __typename: 'Money' }
                & Pick<Money, 'amount'>
              )> }
            ), inventory: (
              { __typename: 'ProductInventory' }
              & Pick<ProductInventory, 'availableQuantity'>
            ), promotions: Array<(
              { __typename: 'CatalogPromotionFixedAmount' }
              & Pick<CatalogPromotionFixedAmount, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
              & { catalogDiscountType: CatalogPromotionFixedAmount['discountType'] }
              & { style: Maybe<(
                { __typename: 'PromotionStyle' }
                & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
                & { mainTheme: (
                  { __typename: 'PromotionStyleTheme' }
                  & { background: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), text: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), font: (
                    { __typename: 'PromotionStyleFontInfo' }
                    & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                  ) }
                ), altTheme: Maybe<(
                  { __typename: 'PromotionStyleTheme' }
                  & { background: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), text: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), font: (
                    { __typename: 'PromotionStyleFontInfo' }
                    & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                  ) }
                )>, productPage: (
                  { __typename: 'PromotionStyleProductPage' }
                  & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
                ) }
              )>, catalogFixedAmountDiscount: (
                { __typename: 'CatalogPromotionFixedAmountDiscount' }
                & Pick<CatalogPromotionFixedAmountDiscount, 'amount'>
              ) }
            ) | (
              { __typename: 'CatalogPromotionPercent' }
              & Pick<CatalogPromotionPercent, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
              & { catalogDiscountType: CatalogPromotionPercent['discountType'] }
              & { style: Maybe<(
                { __typename: 'PromotionStyle' }
                & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
                & { mainTheme: (
                  { __typename: 'PromotionStyleTheme' }
                  & { background: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), text: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), font: (
                    { __typename: 'PromotionStyleFontInfo' }
                    & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                  ) }
                ), altTheme: Maybe<(
                  { __typename: 'PromotionStyleTheme' }
                  & { background: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), text: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), font: (
                    { __typename: 'PromotionStyleFontInfo' }
                    & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                  ) }
                )>, productPage: (
                  { __typename: 'PromotionStyleProductPage' }
                  & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
                ) }
              )>, catalogPercentDiscount: (
                { __typename: 'CatalogPromotionPercentDiscount' }
                & Pick<CatalogPromotionPercentDiscount, 'percent'>
              ) }
            ) | (
              { __typename: 'CatalogPromotionProductPromotionPrice' }
              & Pick<CatalogPromotionProductPromotionPrice, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
              & { catalogDiscountType: CatalogPromotionProductPromotionPrice['discountType'] }
              & { style: Maybe<(
                { __typename: 'PromotionStyle' }
                & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
                & { mainTheme: (
                  { __typename: 'PromotionStyleTheme' }
                  & { background: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), text: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), font: (
                    { __typename: 'PromotionStyleFontInfo' }
                    & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                  ) }
                ), altTheme: Maybe<(
                  { __typename: 'PromotionStyleTheme' }
                  & { background: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), text: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), font: (
                    { __typename: 'PromotionStyleFontInfo' }
                    & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                  ) }
                )>, productPage: (
                  { __typename: 'PromotionStyleProductPage' }
                  & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
                ) }
              )> }
            )> }
          )> }
        ), seo: (
          { __typename: 'ProductSeo' }
          & Pick<ProductSeo, 'slug'>
        ), listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )> }
      ) | (
        { __typename: 'SimpleProduct' }
        & Pick<SimpleProduct, 'id' | 'name' | 'title' | 'specification'>
        & { pricing: (
          { __typename: 'ProductPricing' }
          & { price: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )>, originalPrice: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )> }
        ), inventory: (
          { __typename: 'ProductInventory' }
          & Pick<ProductInventory, 'availableQuantity'>
        ), promotions: Array<(
          { __typename: 'CatalogPromotionFixedAmount' }
          & Pick<CatalogPromotionFixedAmount, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
          & { catalogDiscountType: CatalogPromotionFixedAmount['discountType'] }
          & { style: Maybe<(
            { __typename: 'PromotionStyle' }
            & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
            & { mainTheme: (
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            ), altTheme: Maybe<(
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            )>, productPage: (
              { __typename: 'PromotionStyleProductPage' }
              & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
            ) }
          )>, catalogFixedAmountDiscount: (
            { __typename: 'CatalogPromotionFixedAmountDiscount' }
            & Pick<CatalogPromotionFixedAmountDiscount, 'amount'>
          ) }
        ) | (
          { __typename: 'CatalogPromotionPercent' }
          & Pick<CatalogPromotionPercent, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
          & { catalogDiscountType: CatalogPromotionPercent['discountType'] }
          & { style: Maybe<(
            { __typename: 'PromotionStyle' }
            & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
            & { mainTheme: (
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            ), altTheme: Maybe<(
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            )>, productPage: (
              { __typename: 'PromotionStyleProductPage' }
              & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
            ) }
          )>, catalogPercentDiscount: (
            { __typename: 'CatalogPromotionPercentDiscount' }
            & Pick<CatalogPromotionPercentDiscount, 'percent'>
          ) }
        ) | (
          { __typename: 'CatalogPromotionProductPromotionPrice' }
          & Pick<CatalogPromotionProductPromotionPrice, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
          & { catalogDiscountType: CatalogPromotionProductPromotionPrice['discountType'] }
          & { style: Maybe<(
            { __typename: 'PromotionStyle' }
            & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
            & { mainTheme: (
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            ), altTheme: Maybe<(
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            )>, productPage: (
              { __typename: 'PromotionStyleProductPage' }
              & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
            ) }
          )> }
        )>, seo: (
          { __typename: 'ProductSeo' }
          & Pick<ProductSeo, 'slug'>
        ), listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )> }
      ) }
    )> }
  ) }
);

export type ViewCategoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ViewCategoryQuery = (
  { __typename: 'Query' }
  & { category: (
    { __typename: 'Category' }
    & Pick<Category, 'id' | 'title' | 'description' | 'state' | 'type' | 'publishedFrom' | 'publishedTo' | 'position' | 'image' | 'productCount'>
    & { parent: Maybe<(
      { __typename: 'Category' }
      & Pick<Category, 'id'>
    )> }
  ) | (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) }
);

type ListProductData_ConfigurableProduct_Fragment = (
  { __typename: 'ConfigurableProduct' }
  & Pick<ConfigurableProduct, 'id' | 'name' | 'title' | 'specification'>
  & { configuration: (
    { __typename: 'ProductConfiguration' }
    & { defaultProduct: Maybe<(
      { __typename: 'SimpleProduct' }
      & Pick<SimpleProduct, 'id'>
      & { listingImage: Maybe<(
        { __typename: 'ProductImage' }
        & Pick<ProductImage, 'id' | 'url'>
      )>, pricing: (
        { __typename: 'ProductPricing' }
        & { price: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )>, originalPrice: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )> }
      ), inventory: (
        { __typename: 'ProductInventory' }
        & Pick<ProductInventory, 'availableQuantity'>
      ), promotions: Array<(
        { __typename: 'CatalogPromotionFixedAmount' }
        & Pick<CatalogPromotionFixedAmount, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
        & { catalogDiscountType: CatalogPromotionFixedAmount['discountType'] }
        & { style: Maybe<(
          { __typename: 'PromotionStyle' }
          & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
          & { mainTheme: (
            { __typename: 'PromotionStyleTheme' }
            & { background: (
              { __typename: 'PromotionStyleColorInfo' }
              & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
            ), text: (
              { __typename: 'PromotionStyleColorInfo' }
              & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
            ), font: (
              { __typename: 'PromotionStyleFontInfo' }
              & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
            ) }
          ), altTheme: Maybe<(
            { __typename: 'PromotionStyleTheme' }
            & { background: (
              { __typename: 'PromotionStyleColorInfo' }
              & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
            ), text: (
              { __typename: 'PromotionStyleColorInfo' }
              & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
            ), font: (
              { __typename: 'PromotionStyleFontInfo' }
              & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
            ) }
          )>, productPage: (
            { __typename: 'PromotionStyleProductPage' }
            & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
          ) }
        )>, catalogFixedAmountDiscount: (
          { __typename: 'CatalogPromotionFixedAmountDiscount' }
          & Pick<CatalogPromotionFixedAmountDiscount, 'amount'>
        ) }
      ) | (
        { __typename: 'CatalogPromotionPercent' }
        & Pick<CatalogPromotionPercent, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
        & { catalogDiscountType: CatalogPromotionPercent['discountType'] }
        & { style: Maybe<(
          { __typename: 'PromotionStyle' }
          & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
          & { mainTheme: (
            { __typename: 'PromotionStyleTheme' }
            & { background: (
              { __typename: 'PromotionStyleColorInfo' }
              & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
            ), text: (
              { __typename: 'PromotionStyleColorInfo' }
              & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
            ), font: (
              { __typename: 'PromotionStyleFontInfo' }
              & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
            ) }
          ), altTheme: Maybe<(
            { __typename: 'PromotionStyleTheme' }
            & { background: (
              { __typename: 'PromotionStyleColorInfo' }
              & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
            ), text: (
              { __typename: 'PromotionStyleColorInfo' }
              & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
            ), font: (
              { __typename: 'PromotionStyleFontInfo' }
              & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
            ) }
          )>, productPage: (
            { __typename: 'PromotionStyleProductPage' }
            & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
          ) }
        )>, catalogPercentDiscount: (
          { __typename: 'CatalogPromotionPercentDiscount' }
          & Pick<CatalogPromotionPercentDiscount, 'percent'>
        ) }
      ) | (
        { __typename: 'CatalogPromotionProductPromotionPrice' }
        & Pick<CatalogPromotionProductPromotionPrice, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
        & { catalogDiscountType: CatalogPromotionProductPromotionPrice['discountType'] }
        & { style: Maybe<(
          { __typename: 'PromotionStyle' }
          & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
          & { mainTheme: (
            { __typename: 'PromotionStyleTheme' }
            & { background: (
              { __typename: 'PromotionStyleColorInfo' }
              & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
            ), text: (
              { __typename: 'PromotionStyleColorInfo' }
              & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
            ), font: (
              { __typename: 'PromotionStyleFontInfo' }
              & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
            ) }
          ), altTheme: Maybe<(
            { __typename: 'PromotionStyleTheme' }
            & { background: (
              { __typename: 'PromotionStyleColorInfo' }
              & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
            ), text: (
              { __typename: 'PromotionStyleColorInfo' }
              & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
            ), font: (
              { __typename: 'PromotionStyleFontInfo' }
              & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
            ) }
          )>, productPage: (
            { __typename: 'PromotionStyleProductPage' }
            & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
          ) }
        )> }
      )> }
    )> }
  ), seo: (
    { __typename: 'ProductSeo' }
    & Pick<ProductSeo, 'slug'>
  ), listingImage: Maybe<(
    { __typename: 'ProductImage' }
    & Pick<ProductImage, 'id' | 'url'>
  )> }
);

type ListProductData_SimpleProduct_Fragment = (
  { __typename: 'SimpleProduct' }
  & Pick<SimpleProduct, 'id' | 'name' | 'title' | 'specification'>
  & { pricing: (
    { __typename: 'ProductPricing' }
    & { price: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount'>
    )>, originalPrice: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount'>
    )> }
  ), inventory: (
    { __typename: 'ProductInventory' }
    & Pick<ProductInventory, 'availableQuantity'>
  ), promotions: Array<(
    { __typename: 'CatalogPromotionFixedAmount' }
    & Pick<CatalogPromotionFixedAmount, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
    & { catalogDiscountType: CatalogPromotionFixedAmount['discountType'] }
    & { style: Maybe<(
      { __typename: 'PromotionStyle' }
      & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
      & { mainTheme: (
        { __typename: 'PromotionStyleTheme' }
        & { background: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), text: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), font: (
          { __typename: 'PromotionStyleFontInfo' }
          & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
        ) }
      ), altTheme: Maybe<(
        { __typename: 'PromotionStyleTheme' }
        & { background: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), text: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), font: (
          { __typename: 'PromotionStyleFontInfo' }
          & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
        ) }
      )>, productPage: (
        { __typename: 'PromotionStyleProductPage' }
        & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
      ) }
    )>, catalogFixedAmountDiscount: (
      { __typename: 'CatalogPromotionFixedAmountDiscount' }
      & Pick<CatalogPromotionFixedAmountDiscount, 'amount'>
    ) }
  ) | (
    { __typename: 'CatalogPromotionPercent' }
    & Pick<CatalogPromotionPercent, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
    & { catalogDiscountType: CatalogPromotionPercent['discountType'] }
    & { style: Maybe<(
      { __typename: 'PromotionStyle' }
      & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
      & { mainTheme: (
        { __typename: 'PromotionStyleTheme' }
        & { background: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), text: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), font: (
          { __typename: 'PromotionStyleFontInfo' }
          & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
        ) }
      ), altTheme: Maybe<(
        { __typename: 'PromotionStyleTheme' }
        & { background: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), text: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), font: (
          { __typename: 'PromotionStyleFontInfo' }
          & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
        ) }
      )>, productPage: (
        { __typename: 'PromotionStyleProductPage' }
        & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
      ) }
    )>, catalogPercentDiscount: (
      { __typename: 'CatalogPromotionPercentDiscount' }
      & Pick<CatalogPromotionPercentDiscount, 'percent'>
    ) }
  ) | (
    { __typename: 'CatalogPromotionProductPromotionPrice' }
    & Pick<CatalogPromotionProductPromotionPrice, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
    & { catalogDiscountType: CatalogPromotionProductPromotionPrice['discountType'] }
    & { style: Maybe<(
      { __typename: 'PromotionStyle' }
      & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
      & { mainTheme: (
        { __typename: 'PromotionStyleTheme' }
        & { background: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), text: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), font: (
          { __typename: 'PromotionStyleFontInfo' }
          & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
        ) }
      ), altTheme: Maybe<(
        { __typename: 'PromotionStyleTheme' }
        & { background: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), text: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), font: (
          { __typename: 'PromotionStyleFontInfo' }
          & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
        ) }
      )>, productPage: (
        { __typename: 'PromotionStyleProductPage' }
        & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
      ) }
    )> }
  )>, seo: (
    { __typename: 'ProductSeo' }
    & Pick<ProductSeo, 'slug'>
  ), listingImage: Maybe<(
    { __typename: 'ProductImage' }
    & Pick<ProductImage, 'id' | 'url'>
  )> }
);

export type ListProductDataFragment = ListProductData_ConfigurableProduct_Fragment | ListProductData_SimpleProduct_Fragment;

export type ViewCategoriesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ViewCategoriesQuery = (
  { __typename: 'Query' }
  & { categories: (
    { __typename: 'CategoriesConnection' }
    & { pageInfo: (
      { __typename: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'endCursor'>
    ), edges: Array<(
      { __typename: 'CategoriesEdge' }
      & { node: (
        { __typename: 'Category' }
        & Pick<Category, 'id' | 'title' | 'description' | 'state' | 'type' | 'publishedFrom' | 'publishedTo' | 'position' | 'image' | 'productCount'>
        & { parent: Maybe<(
          { __typename: 'Category' }
          & Pick<Category, 'id'>
        )>, seo: (
          { __typename: 'CategorySeo' }
          & Pick<CategorySeo, 'title' | 'description' | 'keywords' | 'slug' | 'hasCustomSlug'>
        ) }
      ) }
    )> }
  ) }
);

export type OrderAddressCreateFromCustomerAddressMutationVariables = Exact<{
  customerAddressId: Scalars['ID']['input'];
}>;


export type OrderAddressCreateFromCustomerAddressMutation = (
  { __typename: 'Mutation' }
  & { orderAddressCreateFromCustomerAddress: (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) | (
    { __typename: 'OrderAddressCreatePayload' }
    & { orderAddress: (
      { __typename: 'OrderAddress' }
      & Pick<OrderAddress, 'id' | 'firstName' | 'lastName' | 'companyName' | 'businessIdentityCode' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode'>
    ) }
  ) }
);

export type OrderAddressCreateMutationVariables = Exact<{
  input: OrderAddressCreateInput;
}>;


export type OrderAddressCreateMutation = (
  { __typename: 'Mutation' }
  & { orderAddressCreate: (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) | (
    { __typename: 'OrderAddressCreatePayload' }
    & { orderAddress: (
      { __typename: 'OrderAddress' }
      & Pick<OrderAddress, 'id' | 'firstName' | 'lastName' | 'companyName' | 'businessIdentityCode' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode'>
    ) }
  ) }
);

export type OrderAddressUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: OrderAddressUpdateInput;
}>;


export type OrderAddressUpdateMutation = (
  { __typename: 'Mutation' }
  & { orderAddressUpdate: (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) | (
    { __typename: 'OrderAddressUpdatePayload' }
    & { orderAddress: (
      { __typename: 'OrderAddress' }
      & Pick<OrderAddress, 'id' | 'firstName' | 'lastName' | 'companyName' | 'businessIdentityCode' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode'>
    ), order: Maybe<(
      { __typename: 'Order' }
      & Pick<Order, 'id'>
      & { billingAddress: Maybe<(
        { __typename: 'OrderAddress' }
        & Pick<OrderAddress, 'id' | 'firstName' | 'lastName' | 'companyName' | 'businessIdentityCode' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode'>
      )>, shippingAddress: Maybe<(
        { __typename: 'OrderAddress' }
        & Pick<OrderAddress, 'id' | 'firstName' | 'lastName' | 'companyName' | 'businessIdentityCode' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode'>
      )> }
    )> }
  ) }
);

export type OrderFindCustomerQueryVariables = Exact<{
  email: Scalars['EmailAddress']['input'];
}>;


export type OrderFindCustomerQuery = (
  { __typename: 'Query' }
  & { customer: (
    { __typename: 'Customer' }
    & Pick<Customer, 'id'>
  ) | (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) }
);

export type OrderListCustomerAddressesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderListCustomerAddressesQuery = (
  { __typename: 'Query' }
  & { me: Maybe<(
    { __typename: 'User' }
    & Pick<User, 'id'>
    & { customer: (
      { __typename: 'Customer' }
      & Pick<Customer, 'id'>
      & { addresses: (
        { __typename: 'CustomerAddressesConnection' }
        & { pageInfo: (
          { __typename: 'PageInfo' }
          & Pick<PageInfo, 'endCursor' | 'hasNextPage'>
        ), edges: Array<(
          { __typename: 'CustomerAddressesEdge' }
          & { node: (
            { __typename: 'CustomerAddress' }
            & Pick<CustomerAddress, 'id' | 'type' | 'firstName' | 'lastName' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode' | 'companyName' | 'businessIdentityCode'>
          ) }
        )> }
      ) }
    ) }
  )> }
);

export type OrderSetBillingAddressMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  addressId: Scalars['ID']['input'];
}>;


export type OrderSetBillingAddressMutation = (
  { __typename: 'Mutation' }
  & { orderSetBillingAddress: (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message' | 'detailedMessage'>
  ) | (
    { __typename: 'OrderUpdatePayload' }
    & { order: (
      { __typename: 'Order' }
      & Pick<Order, 'id'>
      & { billingAddress: Maybe<(
        { __typename: 'OrderAddress' }
        & Pick<OrderAddress, 'id' | 'firstName' | 'lastName' | 'companyName' | 'businessIdentityCode' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode'>
      )> }
    ) }
  ) }
);

export type OrderSetCustomerMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
}>;


export type OrderSetCustomerMutation = (
  { __typename: 'Mutation' }
  & { orderSetCustomer: (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) | (
    { __typename: 'OrderUpdatePayload' }
    & { order: (
      { __typename: 'Order' }
      & Pick<Order, 'id'>
      & { customer: Maybe<(
        { __typename: 'Customer' }
        & Pick<Customer, 'id' | 'firstName' | 'lastName' | 'email' | 'phone' | 'allowEmailMarketing' | 'allowSmsMarketing' | 'countryCode'>
      )> }
    ) }
  ) }
);

export type OrderSetShippingAddressMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  addressId: Scalars['ID']['input'];
}>;


export type OrderSetShippingAddressMutation = (
  { __typename: 'Mutation' }
  & { orderSetShippingAddress: (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message' | 'detailedMessage'>
  ) | (
    { __typename: 'OrderUpdatePayload' }
    & { order: (
      { __typename: 'Order' }
      & Pick<Order, 'id'>
      & { shippingAddress: Maybe<(
        { __typename: 'OrderAddress' }
        & Pick<OrderAddress, 'id' | 'firstName' | 'lastName' | 'companyName' | 'businessIdentityCode' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode'>
      )> }
    ) }
  ) }
);

export type OrderAddressDataFragment = (
  { __typename: 'OrderAddress' }
  & Pick<OrderAddress, 'id' | 'firstName' | 'lastName' | 'companyName' | 'businessIdentityCode' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode'>
);

export type OrderCreateFromCartMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type OrderCreateFromCartMutation = (
  { __typename: 'Mutation' }
  & { orderCreateFromCart: (
    { __typename: 'InvalidInputError' }
    & Pick<InvalidInputError, 'message' | 'detailedMessage'>
  ) | (
    { __typename: 'OrderCreatePayload' }
    & { order: (
      { __typename: 'Order' }
      & Pick<Order, 'id' | 'number' | 'state' | 'createdAt' | 'hasFreeShipping' | 'saleNumber' | 'deliveryEstimate' | 'originalDeliveryEstimate'>
      & { payment: Maybe<(
        { __typename: 'OrderPaymentInfoAvarda' }
        & Pick<OrderPaymentInfoAvarda, 'paymentType'>
        & { method: (
          { __typename: 'PaymentMethodAvarda' }
          & Pick<PaymentMethodAvarda, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodAvardaEstonia' }
          & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodEsto' }
          & Pick<PaymentMethodEsto, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodHolmbank' }
          & Pick<PaymentMethodHolmbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodInbank' }
          & Pick<PaymentMethodInbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMaksekeskus' }
          & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMontonio' }
          & Pick<PaymentMethodMontonio, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaytrail' }
          & Pick<PaymentMethodPaytrail, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaywerk' }
          & Pick<PaymentMethodPaywerk, 'id' | 'title'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderPaymentInfoAvardaEstonia' }
        & { method: (
          { __typename: 'PaymentMethodAvarda' }
          & Pick<PaymentMethodAvarda, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodAvardaEstonia' }
          & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodEsto' }
          & Pick<PaymentMethodEsto, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodHolmbank' }
          & Pick<PaymentMethodHolmbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodInbank' }
          & Pick<PaymentMethodInbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMaksekeskus' }
          & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMontonio' }
          & Pick<PaymentMethodMontonio, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaytrail' }
          & Pick<PaymentMethodPaytrail, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaywerk' }
          & Pick<PaymentMethodPaywerk, 'id' | 'title'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderPaymentInfoEsto' }
        & { method: (
          { __typename: 'PaymentMethodAvarda' }
          & Pick<PaymentMethodAvarda, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodAvardaEstonia' }
          & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodEsto' }
          & Pick<PaymentMethodEsto, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodHolmbank' }
          & Pick<PaymentMethodHolmbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodInbank' }
          & Pick<PaymentMethodInbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMaksekeskus' }
          & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMontonio' }
          & Pick<PaymentMethodMontonio, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaytrail' }
          & Pick<PaymentMethodPaytrail, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaywerk' }
          & Pick<PaymentMethodPaywerk, 'id' | 'title'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderPaymentInfoInbank' }
        & { method: (
          { __typename: 'PaymentMethodAvarda' }
          & Pick<PaymentMethodAvarda, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodAvardaEstonia' }
          & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodEsto' }
          & Pick<PaymentMethodEsto, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodHolmbank' }
          & Pick<PaymentMethodHolmbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodInbank' }
          & Pick<PaymentMethodInbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMaksekeskus' }
          & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMontonio' }
          & Pick<PaymentMethodMontonio, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaytrail' }
          & Pick<PaymentMethodPaytrail, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaywerk' }
          & Pick<PaymentMethodPaywerk, 'id' | 'title'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderPaymentInfoMaksekeskus' }
        & { method: (
          { __typename: 'PaymentMethodAvarda' }
          & Pick<PaymentMethodAvarda, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodAvardaEstonia' }
          & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodEsto' }
          & Pick<PaymentMethodEsto, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodHolmbank' }
          & Pick<PaymentMethodHolmbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodInbank' }
          & Pick<PaymentMethodInbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMaksekeskus' }
          & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMontonio' }
          & Pick<PaymentMethodMontonio, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaytrail' }
          & Pick<PaymentMethodPaytrail, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaywerk' }
          & Pick<PaymentMethodPaywerk, 'id' | 'title'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderPaymentInfoMontonio' }
        & { method: (
          { __typename: 'PaymentMethodAvarda' }
          & Pick<PaymentMethodAvarda, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodAvardaEstonia' }
          & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodEsto' }
          & Pick<PaymentMethodEsto, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodHolmbank' }
          & Pick<PaymentMethodHolmbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodInbank' }
          & Pick<PaymentMethodInbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMaksekeskus' }
          & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMontonio' }
          & Pick<PaymentMethodMontonio, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaytrail' }
          & Pick<PaymentMethodPaytrail, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaywerk' }
          & Pick<PaymentMethodPaywerk, 'id' | 'title'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderPaymentInfoPaytrail' }
        & { method: (
          { __typename: 'PaymentMethodAvarda' }
          & Pick<PaymentMethodAvarda, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodAvardaEstonia' }
          & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodEsto' }
          & Pick<PaymentMethodEsto, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodHolmbank' }
          & Pick<PaymentMethodHolmbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodInbank' }
          & Pick<PaymentMethodInbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMaksekeskus' }
          & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMontonio' }
          & Pick<PaymentMethodMontonio, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaytrail' }
          & Pick<PaymentMethodPaytrail, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaywerk' }
          & Pick<PaymentMethodPaywerk, 'id' | 'title'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderPaymentInfoPaywerk' }
        & { method: (
          { __typename: 'PaymentMethodAvarda' }
          & Pick<PaymentMethodAvarda, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodAvardaEstonia' }
          & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodEsto' }
          & Pick<PaymentMethodEsto, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodHolmbank' }
          & Pick<PaymentMethodHolmbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodInbank' }
          & Pick<PaymentMethodInbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMaksekeskus' }
          & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMontonio' }
          & Pick<PaymentMethodMontonio, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaytrail' }
          & Pick<PaymentMethodPaytrail, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaywerk' }
          & Pick<PaymentMethodPaywerk, 'id' | 'title'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      )>, totalDiscountsAmount: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), shipping: Maybe<(
        { __typename: 'OrderShippingInfoEmail' }
        & Pick<OrderShippingInfoEmail, 'taxRate'>
        & { price: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )>, originalPrice: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )>, method: (
          { __typename: 'ShippingMethodEmail' }
          & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodHakonen' }
          & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodLocalDelivery' }
          & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodMatkahuolto' }
          & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodOmniva' }
          & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPickUpFromStore' }
          & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPosti' }
          & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderShippingInfoHakonen' }
        & Pick<OrderShippingInfoHakonen, 'taxRate'>
        & { price: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )>, originalPrice: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )>, method: (
          { __typename: 'ShippingMethodEmail' }
          & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodHakonen' }
          & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodLocalDelivery' }
          & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodMatkahuolto' }
          & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodOmniva' }
          & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPickUpFromStore' }
          & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPosti' }
          & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderShippingInfoLocalDelivery' }
        & Pick<OrderShippingInfoLocalDelivery, 'taxRate'>
        & { price: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )>, originalPrice: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )>, method: (
          { __typename: 'ShippingMethodEmail' }
          & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodHakonen' }
          & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodLocalDelivery' }
          & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodMatkahuolto' }
          & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodOmniva' }
          & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPickUpFromStore' }
          & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPosti' }
          & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderShippingInfoMatkahuolto' }
        & Pick<OrderShippingInfoMatkahuolto, 'taxRate'>
        & { price: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )>, originalPrice: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )>, method: (
          { __typename: 'ShippingMethodEmail' }
          & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodHakonen' }
          & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodLocalDelivery' }
          & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodMatkahuolto' }
          & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodOmniva' }
          & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPickUpFromStore' }
          & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPosti' }
          & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderShippingInfoOmniva' }
        & Pick<OrderShippingInfoOmniva, 'taxRate'>
        & { price: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )>, originalPrice: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )>, method: (
          { __typename: 'ShippingMethodEmail' }
          & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodHakonen' }
          & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodLocalDelivery' }
          & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodMatkahuolto' }
          & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodOmniva' }
          & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPickUpFromStore' }
          & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPosti' }
          & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderShippingInfoPickUpFromStore' }
        & Pick<OrderShippingInfoPickUpFromStore, 'taxRate'>
        & { outlet: Maybe<(
          { __typename: 'Outlet' }
          & Pick<Outlet, 'id' | 'title' | 'address' | 'city' | 'state' | 'postalCode' | 'location'>
        )>, price: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )>, originalPrice: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )>, method: (
          { __typename: 'ShippingMethodEmail' }
          & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodHakonen' }
          & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodLocalDelivery' }
          & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodMatkahuolto' }
          & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodOmniva' }
          & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPickUpFromStore' }
          & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPosti' }
          & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderShippingInfoPosti' }
        & Pick<OrderShippingInfoPosti, 'taxRate'>
        & { price: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )>, originalPrice: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )>, method: (
          { __typename: 'ShippingMethodEmail' }
          & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodHakonen' }
          & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodLocalDelivery' }
          & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodMatkahuolto' }
          & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodOmniva' }
          & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPickUpFromStore' }
          & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPosti' }
          & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      )>, customer: Maybe<(
        { __typename: 'Customer' }
        & Pick<Customer, 'id' | 'firstName' | 'lastName' | 'email' | 'phone' | 'allowEmailMarketing' | 'allowSmsMarketing' | 'countryCode'>
      )>, company: Maybe<(
        { __typename: 'Company' }
        & Pick<Company, 'id' | 'name'>
      )>, totalAmount: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )>, taxLines: Array<(
        { __typename: 'OrderTaxLine' }
        & { amount: (
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        ) }
      )>, giftCardOrders: Array<(
        { __typename: 'GiftCardOrder' }
        & Pick<GiftCardOrder, 'id' | 'confirmedAt' | 'createdAt' | 'updatedAt'>
        & { amount: (
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        ) }
      )>, billingAddress: Maybe<(
        { __typename: 'OrderAddress' }
        & Pick<OrderAddress, 'id' | 'firstName' | 'lastName' | 'companyName' | 'businessIdentityCode' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode'>
      )>, shippingAddress: Maybe<(
        { __typename: 'OrderAddress' }
        & Pick<OrderAddress, 'id' | 'firstName' | 'lastName' | 'companyName' | 'businessIdentityCode' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode'>
      )>, products: Array<(
        { __typename: 'OrderProduct' }
        & Pick<OrderProduct, 'id' | 'quantity' | 'taxRate'>
        & { price: (
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        ), unitPrice: (
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        ), discounts: Array<(
          { __typename: 'OrderProductDiscount' }
          & Pick<OrderProductDiscount, 'id'>
          & { amount: (
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          ) }
        )>, product: (
          { __typename: 'SimpleProduct' }
          & Pick<SimpleProduct, 'id' | 'name' | 'title' | 'specification' | 'sku' | 'state'>
          & { listingImage: Maybe<(
            { __typename: 'ProductImage' }
            & Pick<ProductImage, 'id' | 'url'>
          )>, productClass: Maybe<(
            { __typename: 'ProductClass' }
            & Pick<ProductClass, 'id' | 'title'>
          )>, parentProduct: Maybe<(
            { __typename: 'ConfigurableProduct' }
            & Pick<ConfigurableProduct, 'id'>
          )>, categories: Array<(
            { __typename: 'Category' }
            & Pick<Category, 'id' | 'title'>
          )>, pricing: (
            { __typename: 'ProductPricing' }
            & { price: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, originalPrice: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, clubPrice: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )> }
          ), inventory: (
            { __typename: 'ProductInventory' }
            & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
          ), cartPromotions: Array<(
            { __typename: 'CartPromotionClubPrice' }
            & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromCart' }
            & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromProduct' }
            & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFreeShipping' }
            & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFreebie' }
            & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionPercent' }
            & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
            & { percentDiscount: (
              { __typename: 'CartPromotionPercentDiscount' }
              & Pick<CartPromotionPercentDiscount, 'percent'>
            ) }
          ) | (
            { __typename: 'CartPromotionProductCartPromotionPrice' }
            & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
          )> }
        ) }
      )>, availablePaymentMethods: Array<(
        { __typename: 'PaymentMethodAvarda' }
        & Pick<PaymentMethodAvarda, 'paymentType' | 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
        & { group: Maybe<(
          { __typename: 'PaymentMethodGroup' }
          & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) | (
        { __typename: 'PaymentMethodAvardaEstonia' }
        & Pick<PaymentMethodAvardaEstonia, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
        & { group: Maybe<(
          { __typename: 'PaymentMethodGroup' }
          & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) | (
        { __typename: 'PaymentMethodEsto' }
        & Pick<PaymentMethodEsto, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
        & { group: Maybe<(
          { __typename: 'PaymentMethodGroup' }
          & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) | (
        { __typename: 'PaymentMethodHolmbank' }
        & Pick<PaymentMethodHolmbank, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
        & { group: Maybe<(
          { __typename: 'PaymentMethodGroup' }
          & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) | (
        { __typename: 'PaymentMethodInbank' }
        & Pick<PaymentMethodInbank, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
        & { group: Maybe<(
          { __typename: 'PaymentMethodGroup' }
          & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) | (
        { __typename: 'PaymentMethodMaksekeskus' }
        & Pick<PaymentMethodMaksekeskus, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
        & { group: Maybe<(
          { __typename: 'PaymentMethodGroup' }
          & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) | (
        { __typename: 'PaymentMethodMontonio' }
        & Pick<PaymentMethodMontonio, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
        & { group: Maybe<(
          { __typename: 'PaymentMethodGroup' }
          & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) | (
        { __typename: 'PaymentMethodPaytrail' }
        & Pick<PaymentMethodPaytrail, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
        & { group: Maybe<(
          { __typename: 'PaymentMethodGroup' }
          & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) | (
        { __typename: 'PaymentMethodPaywerk' }
        & Pick<PaymentMethodPaywerk, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
        & { group: Maybe<(
          { __typename: 'PaymentMethodGroup' }
          & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      )> }
    ) }
  ) }
);

export type OrderCustomerDataFragment = (
  { __typename: 'Customer' }
  & Pick<Customer, 'id' | 'firstName' | 'lastName' | 'email' | 'phone' | 'allowEmailMarketing' | 'allowSmsMarketing' | 'countryCode'>
);

export type OrderDataFragment = (
  { __typename: 'Order' }
  & Pick<Order, 'id' | 'number' | 'state' | 'createdAt' | 'hasFreeShipping' | 'saleNumber' | 'deliveryEstimate' | 'originalDeliveryEstimate'>
  & { payment: Maybe<(
    { __typename: 'OrderPaymentInfoAvarda' }
    & Pick<OrderPaymentInfoAvarda, 'paymentType'>
    & { method: (
      { __typename: 'PaymentMethodAvarda' }
      & Pick<PaymentMethodAvarda, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodAvardaEstonia' }
      & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodEsto' }
      & Pick<PaymentMethodEsto, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodHolmbank' }
      & Pick<PaymentMethodHolmbank, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodInbank' }
      & Pick<PaymentMethodInbank, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodMaksekeskus' }
      & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodMontonio' }
      & Pick<PaymentMethodMontonio, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodPaytrail' }
      & Pick<PaymentMethodPaytrail, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodPaywerk' }
      & Pick<PaymentMethodPaywerk, 'id' | 'title'>
    ), data: Array<(
      { __typename: 'OrderData' }
      & Pick<OrderData, 'key' | 'value'>
    )> }
  ) | (
    { __typename: 'OrderPaymentInfoAvardaEstonia' }
    & { method: (
      { __typename: 'PaymentMethodAvarda' }
      & Pick<PaymentMethodAvarda, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodAvardaEstonia' }
      & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodEsto' }
      & Pick<PaymentMethodEsto, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodHolmbank' }
      & Pick<PaymentMethodHolmbank, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodInbank' }
      & Pick<PaymentMethodInbank, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodMaksekeskus' }
      & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodMontonio' }
      & Pick<PaymentMethodMontonio, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodPaytrail' }
      & Pick<PaymentMethodPaytrail, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodPaywerk' }
      & Pick<PaymentMethodPaywerk, 'id' | 'title'>
    ), data: Array<(
      { __typename: 'OrderData' }
      & Pick<OrderData, 'key' | 'value'>
    )> }
  ) | (
    { __typename: 'OrderPaymentInfoEsto' }
    & { method: (
      { __typename: 'PaymentMethodAvarda' }
      & Pick<PaymentMethodAvarda, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodAvardaEstonia' }
      & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodEsto' }
      & Pick<PaymentMethodEsto, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodHolmbank' }
      & Pick<PaymentMethodHolmbank, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodInbank' }
      & Pick<PaymentMethodInbank, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodMaksekeskus' }
      & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodMontonio' }
      & Pick<PaymentMethodMontonio, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodPaytrail' }
      & Pick<PaymentMethodPaytrail, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodPaywerk' }
      & Pick<PaymentMethodPaywerk, 'id' | 'title'>
    ), data: Array<(
      { __typename: 'OrderData' }
      & Pick<OrderData, 'key' | 'value'>
    )> }
  ) | (
    { __typename: 'OrderPaymentInfoInbank' }
    & { method: (
      { __typename: 'PaymentMethodAvarda' }
      & Pick<PaymentMethodAvarda, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodAvardaEstonia' }
      & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodEsto' }
      & Pick<PaymentMethodEsto, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodHolmbank' }
      & Pick<PaymentMethodHolmbank, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodInbank' }
      & Pick<PaymentMethodInbank, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodMaksekeskus' }
      & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodMontonio' }
      & Pick<PaymentMethodMontonio, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodPaytrail' }
      & Pick<PaymentMethodPaytrail, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodPaywerk' }
      & Pick<PaymentMethodPaywerk, 'id' | 'title'>
    ), data: Array<(
      { __typename: 'OrderData' }
      & Pick<OrderData, 'key' | 'value'>
    )> }
  ) | (
    { __typename: 'OrderPaymentInfoMaksekeskus' }
    & { method: (
      { __typename: 'PaymentMethodAvarda' }
      & Pick<PaymentMethodAvarda, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodAvardaEstonia' }
      & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodEsto' }
      & Pick<PaymentMethodEsto, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodHolmbank' }
      & Pick<PaymentMethodHolmbank, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodInbank' }
      & Pick<PaymentMethodInbank, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodMaksekeskus' }
      & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodMontonio' }
      & Pick<PaymentMethodMontonio, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodPaytrail' }
      & Pick<PaymentMethodPaytrail, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodPaywerk' }
      & Pick<PaymentMethodPaywerk, 'id' | 'title'>
    ), data: Array<(
      { __typename: 'OrderData' }
      & Pick<OrderData, 'key' | 'value'>
    )> }
  ) | (
    { __typename: 'OrderPaymentInfoMontonio' }
    & { method: (
      { __typename: 'PaymentMethodAvarda' }
      & Pick<PaymentMethodAvarda, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodAvardaEstonia' }
      & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodEsto' }
      & Pick<PaymentMethodEsto, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodHolmbank' }
      & Pick<PaymentMethodHolmbank, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodInbank' }
      & Pick<PaymentMethodInbank, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodMaksekeskus' }
      & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodMontonio' }
      & Pick<PaymentMethodMontonio, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodPaytrail' }
      & Pick<PaymentMethodPaytrail, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodPaywerk' }
      & Pick<PaymentMethodPaywerk, 'id' | 'title'>
    ), data: Array<(
      { __typename: 'OrderData' }
      & Pick<OrderData, 'key' | 'value'>
    )> }
  ) | (
    { __typename: 'OrderPaymentInfoPaytrail' }
    & { method: (
      { __typename: 'PaymentMethodAvarda' }
      & Pick<PaymentMethodAvarda, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodAvardaEstonia' }
      & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodEsto' }
      & Pick<PaymentMethodEsto, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodHolmbank' }
      & Pick<PaymentMethodHolmbank, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodInbank' }
      & Pick<PaymentMethodInbank, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodMaksekeskus' }
      & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodMontonio' }
      & Pick<PaymentMethodMontonio, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodPaytrail' }
      & Pick<PaymentMethodPaytrail, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodPaywerk' }
      & Pick<PaymentMethodPaywerk, 'id' | 'title'>
    ), data: Array<(
      { __typename: 'OrderData' }
      & Pick<OrderData, 'key' | 'value'>
    )> }
  ) | (
    { __typename: 'OrderPaymentInfoPaywerk' }
    & { method: (
      { __typename: 'PaymentMethodAvarda' }
      & Pick<PaymentMethodAvarda, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodAvardaEstonia' }
      & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodEsto' }
      & Pick<PaymentMethodEsto, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodHolmbank' }
      & Pick<PaymentMethodHolmbank, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodInbank' }
      & Pick<PaymentMethodInbank, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodMaksekeskus' }
      & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodMontonio' }
      & Pick<PaymentMethodMontonio, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodPaytrail' }
      & Pick<PaymentMethodPaytrail, 'id' | 'title'>
    ) | (
      { __typename: 'PaymentMethodPaywerk' }
      & Pick<PaymentMethodPaywerk, 'id' | 'title'>
    ), data: Array<(
      { __typename: 'OrderData' }
      & Pick<OrderData, 'key' | 'value'>
    )> }
  )>, totalDiscountsAmount: (
    { __typename: 'Money' }
    & Pick<Money, 'amount'>
  ), shipping: Maybe<(
    { __typename: 'OrderShippingInfoEmail' }
    & Pick<OrderShippingInfoEmail, 'taxRate'>
    & { price: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount' | 'currencyCode'>
    )>, originalPrice: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount'>
    )>, method: (
      { __typename: 'ShippingMethodEmail' }
      & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodHakonen' }
      & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodLocalDelivery' }
      & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodMatkahuolto' }
      & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodOmniva' }
      & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodPickUpFromStore' }
      & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodPosti' }
      & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
    ), data: Array<(
      { __typename: 'OrderData' }
      & Pick<OrderData, 'key' | 'value'>
    )> }
  ) | (
    { __typename: 'OrderShippingInfoHakonen' }
    & Pick<OrderShippingInfoHakonen, 'taxRate'>
    & { price: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount' | 'currencyCode'>
    )>, originalPrice: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount'>
    )>, method: (
      { __typename: 'ShippingMethodEmail' }
      & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodHakonen' }
      & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodLocalDelivery' }
      & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodMatkahuolto' }
      & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodOmniva' }
      & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodPickUpFromStore' }
      & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodPosti' }
      & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
    ), data: Array<(
      { __typename: 'OrderData' }
      & Pick<OrderData, 'key' | 'value'>
    )> }
  ) | (
    { __typename: 'OrderShippingInfoLocalDelivery' }
    & Pick<OrderShippingInfoLocalDelivery, 'taxRate'>
    & { price: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount' | 'currencyCode'>
    )>, originalPrice: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount'>
    )>, method: (
      { __typename: 'ShippingMethodEmail' }
      & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodHakonen' }
      & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodLocalDelivery' }
      & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodMatkahuolto' }
      & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodOmniva' }
      & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodPickUpFromStore' }
      & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodPosti' }
      & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
    ), data: Array<(
      { __typename: 'OrderData' }
      & Pick<OrderData, 'key' | 'value'>
    )> }
  ) | (
    { __typename: 'OrderShippingInfoMatkahuolto' }
    & Pick<OrderShippingInfoMatkahuolto, 'taxRate'>
    & { price: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount' | 'currencyCode'>
    )>, originalPrice: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount'>
    )>, method: (
      { __typename: 'ShippingMethodEmail' }
      & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodHakonen' }
      & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodLocalDelivery' }
      & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodMatkahuolto' }
      & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodOmniva' }
      & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodPickUpFromStore' }
      & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodPosti' }
      & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
    ), data: Array<(
      { __typename: 'OrderData' }
      & Pick<OrderData, 'key' | 'value'>
    )> }
  ) | (
    { __typename: 'OrderShippingInfoOmniva' }
    & Pick<OrderShippingInfoOmniva, 'taxRate'>
    & { price: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount' | 'currencyCode'>
    )>, originalPrice: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount'>
    )>, method: (
      { __typename: 'ShippingMethodEmail' }
      & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodHakonen' }
      & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodLocalDelivery' }
      & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodMatkahuolto' }
      & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodOmniva' }
      & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodPickUpFromStore' }
      & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodPosti' }
      & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
    ), data: Array<(
      { __typename: 'OrderData' }
      & Pick<OrderData, 'key' | 'value'>
    )> }
  ) | (
    { __typename: 'OrderShippingInfoPickUpFromStore' }
    & Pick<OrderShippingInfoPickUpFromStore, 'taxRate'>
    & { outlet: Maybe<(
      { __typename: 'Outlet' }
      & Pick<Outlet, 'id' | 'title' | 'address' | 'city' | 'state' | 'postalCode' | 'location'>
    )>, price: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount' | 'currencyCode'>
    )>, originalPrice: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount'>
    )>, method: (
      { __typename: 'ShippingMethodEmail' }
      & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodHakonen' }
      & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodLocalDelivery' }
      & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodMatkahuolto' }
      & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodOmniva' }
      & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodPickUpFromStore' }
      & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodPosti' }
      & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
    ), data: Array<(
      { __typename: 'OrderData' }
      & Pick<OrderData, 'key' | 'value'>
    )> }
  ) | (
    { __typename: 'OrderShippingInfoPosti' }
    & Pick<OrderShippingInfoPosti, 'taxRate'>
    & { price: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount' | 'currencyCode'>
    )>, originalPrice: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount'>
    )>, method: (
      { __typename: 'ShippingMethodEmail' }
      & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodHakonen' }
      & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodLocalDelivery' }
      & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodMatkahuolto' }
      & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodOmniva' }
      & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodPickUpFromStore' }
      & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
    ) | (
      { __typename: 'ShippingMethodPosti' }
      & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
    ), data: Array<(
      { __typename: 'OrderData' }
      & Pick<OrderData, 'key' | 'value'>
    )> }
  )>, customer: Maybe<(
    { __typename: 'Customer' }
    & Pick<Customer, 'id' | 'firstName' | 'lastName' | 'email' | 'phone' | 'allowEmailMarketing' | 'allowSmsMarketing' | 'countryCode'>
  )>, company: Maybe<(
    { __typename: 'Company' }
    & Pick<Company, 'id' | 'name'>
  )>, totalAmount: Maybe<(
    { __typename: 'Money' }
    & Pick<Money, 'amount' | 'currencyCode'>
  )>, taxLines: Array<(
    { __typename: 'OrderTaxLine' }
    & { amount: (
      { __typename: 'Money' }
      & Pick<Money, 'amount'>
    ) }
  )>, giftCardOrders: Array<(
    { __typename: 'GiftCardOrder' }
    & Pick<GiftCardOrder, 'id' | 'confirmedAt' | 'createdAt' | 'updatedAt'>
    & { amount: (
      { __typename: 'Money' }
      & Pick<Money, 'amount' | 'currencyCode'>
    ) }
  )>, billingAddress: Maybe<(
    { __typename: 'OrderAddress' }
    & Pick<OrderAddress, 'id' | 'firstName' | 'lastName' | 'companyName' | 'businessIdentityCode' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode'>
  )>, shippingAddress: Maybe<(
    { __typename: 'OrderAddress' }
    & Pick<OrderAddress, 'id' | 'firstName' | 'lastName' | 'companyName' | 'businessIdentityCode' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode'>
  )>, products: Array<(
    { __typename: 'OrderProduct' }
    & Pick<OrderProduct, 'id' | 'quantity' | 'taxRate'>
    & { price: (
      { __typename: 'Money' }
      & Pick<Money, 'amount'>
    ), unitPrice: (
      { __typename: 'Money' }
      & Pick<Money, 'amount'>
    ), discounts: Array<(
      { __typename: 'OrderProductDiscount' }
      & Pick<OrderProductDiscount, 'id'>
      & { amount: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ) }
    )>, product: (
      { __typename: 'SimpleProduct' }
      & Pick<SimpleProduct, 'id' | 'name' | 'title' | 'specification' | 'sku' | 'state'>
      & { listingImage: Maybe<(
        { __typename: 'ProductImage' }
        & Pick<ProductImage, 'id' | 'url'>
      )>, productClass: Maybe<(
        { __typename: 'ProductClass' }
        & Pick<ProductClass, 'id' | 'title'>
      )>, parentProduct: Maybe<(
        { __typename: 'ConfigurableProduct' }
        & Pick<ConfigurableProduct, 'id'>
      )>, categories: Array<(
        { __typename: 'Category' }
        & Pick<Category, 'id' | 'title'>
      )>, pricing: (
        { __typename: 'ProductPricing' }
        & { price: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )>, originalPrice: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )>, clubPrice: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )> }
      ), inventory: (
        { __typename: 'ProductInventory' }
        & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
      ), cartPromotions: Array<(
        { __typename: 'CartPromotionClubPrice' }
        & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
      ) | (
        { __typename: 'CartPromotionFixedAmountFromCart' }
        & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
      ) | (
        { __typename: 'CartPromotionFixedAmountFromProduct' }
        & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
      ) | (
        { __typename: 'CartPromotionFreeShipping' }
        & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
      ) | (
        { __typename: 'CartPromotionFreebie' }
        & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
      ) | (
        { __typename: 'CartPromotionPercent' }
        & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
        & { percentDiscount: (
          { __typename: 'CartPromotionPercentDiscount' }
          & Pick<CartPromotionPercentDiscount, 'percent'>
        ) }
      ) | (
        { __typename: 'CartPromotionProductCartPromotionPrice' }
        & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
      )> }
    ) }
  )>, availablePaymentMethods: Array<(
    { __typename: 'PaymentMethodAvarda' }
    & Pick<PaymentMethodAvarda, 'paymentType' | 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
    & { group: Maybe<(
      { __typename: 'PaymentMethodGroup' }
      & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
    )> }
  ) | (
    { __typename: 'PaymentMethodAvardaEstonia' }
    & Pick<PaymentMethodAvardaEstonia, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
    & { group: Maybe<(
      { __typename: 'PaymentMethodGroup' }
      & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
    )> }
  ) | (
    { __typename: 'PaymentMethodEsto' }
    & Pick<PaymentMethodEsto, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
    & { group: Maybe<(
      { __typename: 'PaymentMethodGroup' }
      & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
    )> }
  ) | (
    { __typename: 'PaymentMethodHolmbank' }
    & Pick<PaymentMethodHolmbank, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
    & { group: Maybe<(
      { __typename: 'PaymentMethodGroup' }
      & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
    )> }
  ) | (
    { __typename: 'PaymentMethodInbank' }
    & Pick<PaymentMethodInbank, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
    & { group: Maybe<(
      { __typename: 'PaymentMethodGroup' }
      & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
    )> }
  ) | (
    { __typename: 'PaymentMethodMaksekeskus' }
    & Pick<PaymentMethodMaksekeskus, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
    & { group: Maybe<(
      { __typename: 'PaymentMethodGroup' }
      & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
    )> }
  ) | (
    { __typename: 'PaymentMethodMontonio' }
    & Pick<PaymentMethodMontonio, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
    & { group: Maybe<(
      { __typename: 'PaymentMethodGroup' }
      & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
    )> }
  ) | (
    { __typename: 'PaymentMethodPaytrail' }
    & Pick<PaymentMethodPaytrail, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
    & { group: Maybe<(
      { __typename: 'PaymentMethodGroup' }
      & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
    )> }
  ) | (
    { __typename: 'PaymentMethodPaywerk' }
    & Pick<PaymentMethodPaywerk, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
    & { group: Maybe<(
      { __typename: 'PaymentMethodGroup' }
      & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
    )> }
  )> }
);

export type OrderFinalizeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderFinalizeMutation = (
  { __typename: 'Mutation' }
  & { orderFinalize: (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) | (
    { __typename: 'InvalidInputError' }
    & Pick<InvalidInputError, 'message' | 'detailedMessage'>
  ) | (
    { __typename: 'OrderFinalizePayload' }
    & { order: (
      { __typename: 'Order' }
      & Pick<Order, 'id' | 'state'>
      & { paymentMethod: Maybe<(
        { __typename: 'PaymentMethodAvarda' }
        & Pick<PaymentMethodAvarda, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodAvardaEstonia' }
        & Pick<PaymentMethodAvardaEstonia, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodEsto' }
        & Pick<PaymentMethodEsto, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodHolmbank' }
        & Pick<PaymentMethodHolmbank, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodInbank' }
        & Pick<PaymentMethodInbank, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodMaksekeskus' }
        & Pick<PaymentMethodMaksekeskus, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodMontonio' }
        & Pick<PaymentMethodMontonio, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodPaytrail' }
        & Pick<PaymentMethodPaytrail, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodPaywerk' }
        & Pick<PaymentMethodPaywerk, 'id' | 'type'>
      )> }
    ) }
  ) }
);

type OrderPaymentData_OrderPaymentInfoAvarda_Fragment = (
  { __typename: 'OrderPaymentInfoAvarda' }
  & Pick<OrderPaymentInfoAvarda, 'paymentType'>
  & { method: (
    { __typename: 'PaymentMethodAvarda' }
    & Pick<PaymentMethodAvarda, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodAvardaEstonia' }
    & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodEsto' }
    & Pick<PaymentMethodEsto, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodHolmbank' }
    & Pick<PaymentMethodHolmbank, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodInbank' }
    & Pick<PaymentMethodInbank, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodMaksekeskus' }
    & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodMontonio' }
    & Pick<PaymentMethodMontonio, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodPaytrail' }
    & Pick<PaymentMethodPaytrail, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodPaywerk' }
    & Pick<PaymentMethodPaywerk, 'id' | 'title'>
  ), data: Array<(
    { __typename: 'OrderData' }
    & Pick<OrderData, 'key' | 'value'>
  )> }
);

type OrderPaymentData_OrderPaymentInfoAvardaEstonia_Fragment = (
  { __typename: 'OrderPaymentInfoAvardaEstonia' }
  & { method: (
    { __typename: 'PaymentMethodAvarda' }
    & Pick<PaymentMethodAvarda, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodAvardaEstonia' }
    & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodEsto' }
    & Pick<PaymentMethodEsto, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodHolmbank' }
    & Pick<PaymentMethodHolmbank, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodInbank' }
    & Pick<PaymentMethodInbank, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodMaksekeskus' }
    & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodMontonio' }
    & Pick<PaymentMethodMontonio, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodPaytrail' }
    & Pick<PaymentMethodPaytrail, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodPaywerk' }
    & Pick<PaymentMethodPaywerk, 'id' | 'title'>
  ), data: Array<(
    { __typename: 'OrderData' }
    & Pick<OrderData, 'key' | 'value'>
  )> }
);

type OrderPaymentData_OrderPaymentInfoEsto_Fragment = (
  { __typename: 'OrderPaymentInfoEsto' }
  & { method: (
    { __typename: 'PaymentMethodAvarda' }
    & Pick<PaymentMethodAvarda, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodAvardaEstonia' }
    & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodEsto' }
    & Pick<PaymentMethodEsto, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodHolmbank' }
    & Pick<PaymentMethodHolmbank, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodInbank' }
    & Pick<PaymentMethodInbank, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodMaksekeskus' }
    & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodMontonio' }
    & Pick<PaymentMethodMontonio, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodPaytrail' }
    & Pick<PaymentMethodPaytrail, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodPaywerk' }
    & Pick<PaymentMethodPaywerk, 'id' | 'title'>
  ), data: Array<(
    { __typename: 'OrderData' }
    & Pick<OrderData, 'key' | 'value'>
  )> }
);

type OrderPaymentData_OrderPaymentInfoInbank_Fragment = (
  { __typename: 'OrderPaymentInfoInbank' }
  & { method: (
    { __typename: 'PaymentMethodAvarda' }
    & Pick<PaymentMethodAvarda, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodAvardaEstonia' }
    & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodEsto' }
    & Pick<PaymentMethodEsto, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodHolmbank' }
    & Pick<PaymentMethodHolmbank, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodInbank' }
    & Pick<PaymentMethodInbank, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodMaksekeskus' }
    & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodMontonio' }
    & Pick<PaymentMethodMontonio, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodPaytrail' }
    & Pick<PaymentMethodPaytrail, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodPaywerk' }
    & Pick<PaymentMethodPaywerk, 'id' | 'title'>
  ), data: Array<(
    { __typename: 'OrderData' }
    & Pick<OrderData, 'key' | 'value'>
  )> }
);

type OrderPaymentData_OrderPaymentInfoMaksekeskus_Fragment = (
  { __typename: 'OrderPaymentInfoMaksekeskus' }
  & { method: (
    { __typename: 'PaymentMethodAvarda' }
    & Pick<PaymentMethodAvarda, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodAvardaEstonia' }
    & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodEsto' }
    & Pick<PaymentMethodEsto, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodHolmbank' }
    & Pick<PaymentMethodHolmbank, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodInbank' }
    & Pick<PaymentMethodInbank, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodMaksekeskus' }
    & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodMontonio' }
    & Pick<PaymentMethodMontonio, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodPaytrail' }
    & Pick<PaymentMethodPaytrail, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodPaywerk' }
    & Pick<PaymentMethodPaywerk, 'id' | 'title'>
  ), data: Array<(
    { __typename: 'OrderData' }
    & Pick<OrderData, 'key' | 'value'>
  )> }
);

type OrderPaymentData_OrderPaymentInfoMontonio_Fragment = (
  { __typename: 'OrderPaymentInfoMontonio' }
  & { method: (
    { __typename: 'PaymentMethodAvarda' }
    & Pick<PaymentMethodAvarda, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodAvardaEstonia' }
    & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodEsto' }
    & Pick<PaymentMethodEsto, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodHolmbank' }
    & Pick<PaymentMethodHolmbank, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodInbank' }
    & Pick<PaymentMethodInbank, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodMaksekeskus' }
    & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodMontonio' }
    & Pick<PaymentMethodMontonio, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodPaytrail' }
    & Pick<PaymentMethodPaytrail, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodPaywerk' }
    & Pick<PaymentMethodPaywerk, 'id' | 'title'>
  ), data: Array<(
    { __typename: 'OrderData' }
    & Pick<OrderData, 'key' | 'value'>
  )> }
);

type OrderPaymentData_OrderPaymentInfoPaytrail_Fragment = (
  { __typename: 'OrderPaymentInfoPaytrail' }
  & { method: (
    { __typename: 'PaymentMethodAvarda' }
    & Pick<PaymentMethodAvarda, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodAvardaEstonia' }
    & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodEsto' }
    & Pick<PaymentMethodEsto, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodHolmbank' }
    & Pick<PaymentMethodHolmbank, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodInbank' }
    & Pick<PaymentMethodInbank, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodMaksekeskus' }
    & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodMontonio' }
    & Pick<PaymentMethodMontonio, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodPaytrail' }
    & Pick<PaymentMethodPaytrail, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodPaywerk' }
    & Pick<PaymentMethodPaywerk, 'id' | 'title'>
  ), data: Array<(
    { __typename: 'OrderData' }
    & Pick<OrderData, 'key' | 'value'>
  )> }
);

type OrderPaymentData_OrderPaymentInfoPaywerk_Fragment = (
  { __typename: 'OrderPaymentInfoPaywerk' }
  & { method: (
    { __typename: 'PaymentMethodAvarda' }
    & Pick<PaymentMethodAvarda, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodAvardaEstonia' }
    & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodEsto' }
    & Pick<PaymentMethodEsto, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodHolmbank' }
    & Pick<PaymentMethodHolmbank, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodInbank' }
    & Pick<PaymentMethodInbank, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodMaksekeskus' }
    & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodMontonio' }
    & Pick<PaymentMethodMontonio, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodPaytrail' }
    & Pick<PaymentMethodPaytrail, 'id' | 'title'>
  ) | (
    { __typename: 'PaymentMethodPaywerk' }
    & Pick<PaymentMethodPaywerk, 'id' | 'title'>
  ), data: Array<(
    { __typename: 'OrderData' }
    & Pick<OrderData, 'key' | 'value'>
  )> }
);

export type OrderPaymentDataFragment = OrderPaymentData_OrderPaymentInfoAvarda_Fragment | OrderPaymentData_OrderPaymentInfoAvardaEstonia_Fragment | OrderPaymentData_OrderPaymentInfoEsto_Fragment | OrderPaymentData_OrderPaymentInfoInbank_Fragment | OrderPaymentData_OrderPaymentInfoMaksekeskus_Fragment | OrderPaymentData_OrderPaymentInfoMontonio_Fragment | OrderPaymentData_OrderPaymentInfoPaytrail_Fragment | OrderPaymentData_OrderPaymentInfoPaywerk_Fragment;

type OrderShippingData_OrderShippingInfoEmail_Fragment = (
  { __typename: 'OrderShippingInfoEmail' }
  & Pick<OrderShippingInfoEmail, 'taxRate'>
  & { price: Maybe<(
    { __typename: 'Money' }
    & Pick<Money, 'amount' | 'currencyCode'>
  )>, originalPrice: Maybe<(
    { __typename: 'Money' }
    & Pick<Money, 'amount'>
  )>, method: (
    { __typename: 'ShippingMethodEmail' }
    & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodHakonen' }
    & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodLocalDelivery' }
    & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodMatkahuolto' }
    & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodOmniva' }
    & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodPickUpFromStore' }
    & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodPosti' }
    & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
  ), data: Array<(
    { __typename: 'OrderData' }
    & Pick<OrderData, 'key' | 'value'>
  )> }
);

type OrderShippingData_OrderShippingInfoHakonen_Fragment = (
  { __typename: 'OrderShippingInfoHakonen' }
  & Pick<OrderShippingInfoHakonen, 'taxRate'>
  & { price: Maybe<(
    { __typename: 'Money' }
    & Pick<Money, 'amount' | 'currencyCode'>
  )>, originalPrice: Maybe<(
    { __typename: 'Money' }
    & Pick<Money, 'amount'>
  )>, method: (
    { __typename: 'ShippingMethodEmail' }
    & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodHakonen' }
    & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodLocalDelivery' }
    & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodMatkahuolto' }
    & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodOmniva' }
    & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodPickUpFromStore' }
    & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodPosti' }
    & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
  ), data: Array<(
    { __typename: 'OrderData' }
    & Pick<OrderData, 'key' | 'value'>
  )> }
);

type OrderShippingData_OrderShippingInfoLocalDelivery_Fragment = (
  { __typename: 'OrderShippingInfoLocalDelivery' }
  & Pick<OrderShippingInfoLocalDelivery, 'taxRate'>
  & { price: Maybe<(
    { __typename: 'Money' }
    & Pick<Money, 'amount' | 'currencyCode'>
  )>, originalPrice: Maybe<(
    { __typename: 'Money' }
    & Pick<Money, 'amount'>
  )>, method: (
    { __typename: 'ShippingMethodEmail' }
    & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodHakonen' }
    & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodLocalDelivery' }
    & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodMatkahuolto' }
    & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodOmniva' }
    & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodPickUpFromStore' }
    & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodPosti' }
    & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
  ), data: Array<(
    { __typename: 'OrderData' }
    & Pick<OrderData, 'key' | 'value'>
  )> }
);

type OrderShippingData_OrderShippingInfoMatkahuolto_Fragment = (
  { __typename: 'OrderShippingInfoMatkahuolto' }
  & Pick<OrderShippingInfoMatkahuolto, 'taxRate'>
  & { price: Maybe<(
    { __typename: 'Money' }
    & Pick<Money, 'amount' | 'currencyCode'>
  )>, originalPrice: Maybe<(
    { __typename: 'Money' }
    & Pick<Money, 'amount'>
  )>, method: (
    { __typename: 'ShippingMethodEmail' }
    & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodHakonen' }
    & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodLocalDelivery' }
    & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodMatkahuolto' }
    & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodOmniva' }
    & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodPickUpFromStore' }
    & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodPosti' }
    & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
  ), data: Array<(
    { __typename: 'OrderData' }
    & Pick<OrderData, 'key' | 'value'>
  )> }
);

type OrderShippingData_OrderShippingInfoOmniva_Fragment = (
  { __typename: 'OrderShippingInfoOmniva' }
  & Pick<OrderShippingInfoOmniva, 'taxRate'>
  & { price: Maybe<(
    { __typename: 'Money' }
    & Pick<Money, 'amount' | 'currencyCode'>
  )>, originalPrice: Maybe<(
    { __typename: 'Money' }
    & Pick<Money, 'amount'>
  )>, method: (
    { __typename: 'ShippingMethodEmail' }
    & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodHakonen' }
    & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodLocalDelivery' }
    & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodMatkahuolto' }
    & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodOmniva' }
    & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodPickUpFromStore' }
    & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodPosti' }
    & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
  ), data: Array<(
    { __typename: 'OrderData' }
    & Pick<OrderData, 'key' | 'value'>
  )> }
);

type OrderShippingData_OrderShippingInfoPickUpFromStore_Fragment = (
  { __typename: 'OrderShippingInfoPickUpFromStore' }
  & Pick<OrderShippingInfoPickUpFromStore, 'taxRate'>
  & { outlet: Maybe<(
    { __typename: 'Outlet' }
    & Pick<Outlet, 'id' | 'title' | 'address' | 'city' | 'state' | 'postalCode' | 'location'>
  )>, price: Maybe<(
    { __typename: 'Money' }
    & Pick<Money, 'amount' | 'currencyCode'>
  )>, originalPrice: Maybe<(
    { __typename: 'Money' }
    & Pick<Money, 'amount'>
  )>, method: (
    { __typename: 'ShippingMethodEmail' }
    & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodHakonen' }
    & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodLocalDelivery' }
    & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodMatkahuolto' }
    & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodOmniva' }
    & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodPickUpFromStore' }
    & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodPosti' }
    & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
  ), data: Array<(
    { __typename: 'OrderData' }
    & Pick<OrderData, 'key' | 'value'>
  )> }
);

type OrderShippingData_OrderShippingInfoPosti_Fragment = (
  { __typename: 'OrderShippingInfoPosti' }
  & Pick<OrderShippingInfoPosti, 'taxRate'>
  & { price: Maybe<(
    { __typename: 'Money' }
    & Pick<Money, 'amount' | 'currencyCode'>
  )>, originalPrice: Maybe<(
    { __typename: 'Money' }
    & Pick<Money, 'amount'>
  )>, method: (
    { __typename: 'ShippingMethodEmail' }
    & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodHakonen' }
    & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodLocalDelivery' }
    & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodMatkahuolto' }
    & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodOmniva' }
    & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodPickUpFromStore' }
    & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
  ) | (
    { __typename: 'ShippingMethodPosti' }
    & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
  ), data: Array<(
    { __typename: 'OrderData' }
    & Pick<OrderData, 'key' | 'value'>
  )> }
);

export type OrderShippingDataFragment = OrderShippingData_OrderShippingInfoEmail_Fragment | OrderShippingData_OrderShippingInfoHakonen_Fragment | OrderShippingData_OrderShippingInfoLocalDelivery_Fragment | OrderShippingData_OrderShippingInfoMatkahuolto_Fragment | OrderShippingData_OrderShippingInfoOmniva_Fragment | OrderShippingData_OrderShippingInfoPickUpFromStore_Fragment | OrderShippingData_OrderShippingInfoPosti_Fragment;

export type OrderUndoFinalizeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderUndoFinalizeMutation = (
  { __typename: 'Mutation' }
  & { orderUndoFinalize: (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) | (
    { __typename: 'InvalidInputError' }
    & Pick<InvalidInputError, 'message' | 'detailedMessage'>
  ) | (
    { __typename: 'OrderUndoFinalizePayload' }
    & { order: (
      { __typename: 'Order' }
      & Pick<Order, 'id' | 'state'>
      & { paymentMethod: Maybe<(
        { __typename: 'PaymentMethodAvarda' }
        & Pick<PaymentMethodAvarda, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodAvardaEstonia' }
        & Pick<PaymentMethodAvardaEstonia, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodEsto' }
        & Pick<PaymentMethodEsto, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodHolmbank' }
        & Pick<PaymentMethodHolmbank, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodInbank' }
        & Pick<PaymentMethodInbank, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodMaksekeskus' }
        & Pick<PaymentMethodMaksekeskus, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodMontonio' }
        & Pick<PaymentMethodMontonio, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodPaytrail' }
        & Pick<PaymentMethodPaytrail, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodPaywerk' }
        & Pick<PaymentMethodPaywerk, 'id' | 'type'>
      )> }
    ) }
  ) }
);

export type OrderCancelPaymentMutationVariables = Exact<{
  fingerprint: Scalars['UUID']['input'];
}>;


export type OrderCancelPaymentMutation = (
  { __typename: 'Mutation' }
  & { orderPaymentCancel: (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) | (
    { __typename: 'OrderPaymentCancelPayload' }
    & { orderPayment: (
      { __typename: 'OrderPayment' }
      & Pick<OrderPayment, 'id' | 'state'>
    ), order: (
      { __typename: 'Order' }
      & Pick<Order, 'id' | 'state'>
    ) }
  ) }
);

export type OrderCompletePaymentMutationVariables = Exact<{
  fingerprint: Scalars['UUID']['input'];
  response: Array<OrderPaymentResponseDataInput> | OrderPaymentResponseDataInput;
}>;


export type OrderCompletePaymentMutation = (
  { __typename: 'Mutation' }
  & { orderPaymentComplete: (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) | (
    { __typename: 'OrderPaymentCompletePayload' }
    & { orderPayment: (
      { __typename: 'OrderPayment' }
      & Pick<OrderPayment, 'id' | 'state'>
      & { paymentMethod: (
        { __typename: 'PaymentMethodAvarda' }
        & Pick<PaymentMethodAvarda, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodAvardaEstonia' }
        & Pick<PaymentMethodAvardaEstonia, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodEsto' }
        & Pick<PaymentMethodEsto, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodHolmbank' }
        & Pick<PaymentMethodHolmbank, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodInbank' }
        & Pick<PaymentMethodInbank, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodMaksekeskus' }
        & Pick<PaymentMethodMaksekeskus, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodMontonio' }
        & Pick<PaymentMethodMontonio, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodPaytrail' }
        & Pick<PaymentMethodPaytrail, 'id' | 'type'>
      ) | (
        { __typename: 'PaymentMethodPaywerk' }
        & Pick<PaymentMethodPaywerk, 'id' | 'type'>
      ) }
    ), order: (
      { __typename: 'Order' }
      & Pick<Order, 'id' | 'state'>
    ) }
  ) }
);

export type OrderCreatePaymentMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type OrderCreatePaymentMutation = (
  { __typename: 'Mutation' }
  & { orderPaymentCreate: (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) | (
    { __typename: 'InvalidInputError' }
    & Pick<InvalidInputError, 'message'>
  ) | (
    { __typename: 'OrderPaymentCreatePayload' }
    & { orderPayment: (
      { __typename: 'OrderPayment' }
      & Pick<OrderPayment, 'id' | 'fingerprint'>
    ) }
  ) }
);

export type OrderExecutePaymentMutationVariables = Exact<{
  fingerprint: Scalars['UUID']['input'];
  successUrl: Scalars['NonEmptyString']['input'];
  cancelUrl: Scalars['NonEmptyString']['input'];
  notifyUrl: Scalars['NonEmptyString']['input'];
}>;


export type OrderExecutePaymentMutation = (
  { __typename: 'Mutation' }
  & { orderPaymentExecute: { __typename: 'EntityNotFoundError' } | (
    { __typename: 'OrderPaymentExecutePayload' }
    & { orderPayment: (
      { __typename: 'OrderPayment' }
      & Pick<OrderPayment, 'id'>
      & { paymentMethod: (
        { __typename: 'PaymentMethodAvarda' }
        & Pick<PaymentMethodAvarda, 'id' | 'environment'>
      ) | (
        { __typename: 'PaymentMethodAvardaEstonia' }
        & Pick<PaymentMethodAvardaEstonia, 'id' | 'environment'>
      ) | (
        { __typename: 'PaymentMethodEsto' }
        & Pick<PaymentMethodEsto, 'id' | 'environment'>
      ) | (
        { __typename: 'PaymentMethodHolmbank' }
        & Pick<PaymentMethodHolmbank, 'id' | 'environment'>
      ) | (
        { __typename: 'PaymentMethodInbank' }
        & Pick<PaymentMethodInbank, 'id' | 'environment'>
      ) | (
        { __typename: 'PaymentMethodMaksekeskus' }
        & Pick<PaymentMethodMaksekeskus, 'id' | 'environment'>
      ) | (
        { __typename: 'PaymentMethodMontonio' }
        & Pick<PaymentMethodMontonio, 'id' | 'environment'>
      ) | (
        { __typename: 'PaymentMethodPaytrail' }
        & Pick<PaymentMethodPaytrail, 'id' | 'environment'>
      ) | (
        { __typename: 'PaymentMethodPaywerk' }
        & Pick<PaymentMethodPaywerk, 'id' | 'environment'>
      ) }
    ), paymentAction: (
      { __typename: 'OrderPaymentAvarda' }
      & Pick<OrderPaymentAvarda, 'token'>
    ) | (
      { __typename: 'OrderPaymentAvardaEstonia' }
      & Pick<OrderPaymentAvardaEstonia, 'redirectUrl'>
    ) | (
      { __typename: 'OrderPaymentEsto' }
      & Pick<OrderPaymentEsto, 'redirectUrl'>
    ) | (
      { __typename: 'OrderPaymentHolmbank' }
      & Pick<OrderPaymentHolmbank, 'redirectUrl'>
    ) | (
      { __typename: 'OrderPaymentInbank' }
      & Pick<OrderPaymentInbank, 'redirectUrl'>
    ) | (
      { __typename: 'OrderPaymentMaksekeskus' }
      & Pick<OrderPaymentMaksekeskus, 'redirectUrl'>
    ) | (
      { __typename: 'OrderPaymentMontonio' }
      & Pick<OrderPaymentMontonio, 'redirectUrl'>
    ) | (
      { __typename: 'OrderPaymentPaytrail' }
      & Pick<OrderPaymentPaytrail, 'formActionUrl'>
      & { fields: Array<(
        { __typename: 'OrderPaymentPaytrailFormField' }
        & Pick<OrderPaymentPaytrailFormField, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderPaymentPaywerk' }
      & Pick<OrderPaymentPaywerk, 'paywerkId'>
    ) }
  ) }
);

export type OrderNotifyPaymentMutationVariables = Exact<{
  fingerprint: Scalars['UUID']['input'];
  response: Array<OrderPaymentResponseDataInput> | OrderPaymentResponseDataInput;
}>;


export type OrderNotifyPaymentMutation = (
  { __typename: 'Mutation' }
  & { orderPaymentNotify: (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) | (
    { __typename: 'OrderPaymentNotifyPayload' }
    & { orderPayment: (
      { __typename: 'OrderPayment' }
      & Pick<OrderPayment, 'id' | 'state'>
    ), order: (
      { __typename: 'Order' }
      & Pick<Order, 'id' | 'state'>
    ) }
  ) }
);

export type OrderSetPaymentMethodMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  paymentMethodId: Scalars['ID']['input'];
  paymentMethodData: Array<OrderDataInput> | OrderDataInput;
}>;


export type OrderSetPaymentMethodMutation = (
  { __typename: 'Mutation' }
  & { orderSetPaymentMethod: (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message' | 'detailedMessage'>
  ) | (
    { __typename: 'OrderUpdatePayload' }
    & { order: (
      { __typename: 'Order' }
      & Pick<Order, 'id'>
      & { payment: Maybe<(
        { __typename: 'OrderPaymentInfoAvarda' }
        & Pick<OrderPaymentInfoAvarda, 'paymentType'>
        & { method: (
          { __typename: 'PaymentMethodAvarda' }
          & Pick<PaymentMethodAvarda, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodAvardaEstonia' }
          & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodEsto' }
          & Pick<PaymentMethodEsto, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodHolmbank' }
          & Pick<PaymentMethodHolmbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodInbank' }
          & Pick<PaymentMethodInbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMaksekeskus' }
          & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMontonio' }
          & Pick<PaymentMethodMontonio, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaytrail' }
          & Pick<PaymentMethodPaytrail, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaywerk' }
          & Pick<PaymentMethodPaywerk, 'id' | 'title'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderPaymentInfoAvardaEstonia' }
        & { method: (
          { __typename: 'PaymentMethodAvarda' }
          & Pick<PaymentMethodAvarda, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodAvardaEstonia' }
          & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodEsto' }
          & Pick<PaymentMethodEsto, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodHolmbank' }
          & Pick<PaymentMethodHolmbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodInbank' }
          & Pick<PaymentMethodInbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMaksekeskus' }
          & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMontonio' }
          & Pick<PaymentMethodMontonio, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaytrail' }
          & Pick<PaymentMethodPaytrail, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaywerk' }
          & Pick<PaymentMethodPaywerk, 'id' | 'title'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderPaymentInfoEsto' }
        & { method: (
          { __typename: 'PaymentMethodAvarda' }
          & Pick<PaymentMethodAvarda, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodAvardaEstonia' }
          & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodEsto' }
          & Pick<PaymentMethodEsto, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodHolmbank' }
          & Pick<PaymentMethodHolmbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodInbank' }
          & Pick<PaymentMethodInbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMaksekeskus' }
          & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMontonio' }
          & Pick<PaymentMethodMontonio, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaytrail' }
          & Pick<PaymentMethodPaytrail, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaywerk' }
          & Pick<PaymentMethodPaywerk, 'id' | 'title'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderPaymentInfoInbank' }
        & { method: (
          { __typename: 'PaymentMethodAvarda' }
          & Pick<PaymentMethodAvarda, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodAvardaEstonia' }
          & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodEsto' }
          & Pick<PaymentMethodEsto, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodHolmbank' }
          & Pick<PaymentMethodHolmbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodInbank' }
          & Pick<PaymentMethodInbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMaksekeskus' }
          & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMontonio' }
          & Pick<PaymentMethodMontonio, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaytrail' }
          & Pick<PaymentMethodPaytrail, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaywerk' }
          & Pick<PaymentMethodPaywerk, 'id' | 'title'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderPaymentInfoMaksekeskus' }
        & { method: (
          { __typename: 'PaymentMethodAvarda' }
          & Pick<PaymentMethodAvarda, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodAvardaEstonia' }
          & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodEsto' }
          & Pick<PaymentMethodEsto, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodHolmbank' }
          & Pick<PaymentMethodHolmbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodInbank' }
          & Pick<PaymentMethodInbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMaksekeskus' }
          & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMontonio' }
          & Pick<PaymentMethodMontonio, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaytrail' }
          & Pick<PaymentMethodPaytrail, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaywerk' }
          & Pick<PaymentMethodPaywerk, 'id' | 'title'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderPaymentInfoMontonio' }
        & { method: (
          { __typename: 'PaymentMethodAvarda' }
          & Pick<PaymentMethodAvarda, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodAvardaEstonia' }
          & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodEsto' }
          & Pick<PaymentMethodEsto, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodHolmbank' }
          & Pick<PaymentMethodHolmbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodInbank' }
          & Pick<PaymentMethodInbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMaksekeskus' }
          & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMontonio' }
          & Pick<PaymentMethodMontonio, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaytrail' }
          & Pick<PaymentMethodPaytrail, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaywerk' }
          & Pick<PaymentMethodPaywerk, 'id' | 'title'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderPaymentInfoPaytrail' }
        & { method: (
          { __typename: 'PaymentMethodAvarda' }
          & Pick<PaymentMethodAvarda, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodAvardaEstonia' }
          & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodEsto' }
          & Pick<PaymentMethodEsto, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodHolmbank' }
          & Pick<PaymentMethodHolmbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodInbank' }
          & Pick<PaymentMethodInbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMaksekeskus' }
          & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMontonio' }
          & Pick<PaymentMethodMontonio, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaytrail' }
          & Pick<PaymentMethodPaytrail, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaywerk' }
          & Pick<PaymentMethodPaywerk, 'id' | 'title'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderPaymentInfoPaywerk' }
        & { method: (
          { __typename: 'PaymentMethodAvarda' }
          & Pick<PaymentMethodAvarda, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodAvardaEstonia' }
          & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodEsto' }
          & Pick<PaymentMethodEsto, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodHolmbank' }
          & Pick<PaymentMethodHolmbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodInbank' }
          & Pick<PaymentMethodInbank, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMaksekeskus' }
          & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodMontonio' }
          & Pick<PaymentMethodMontonio, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaytrail' }
          & Pick<PaymentMethodPaytrail, 'id' | 'title'>
        ) | (
          { __typename: 'PaymentMethodPaywerk' }
          & Pick<PaymentMethodPaywerk, 'id' | 'title'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      )> }
    ) }
  ) }
);

export type ViewOrderPaymentQueryVariables = Exact<{
  where: OrderPaymentUniqueWhereInputWithFingerprint;
}>;


export type ViewOrderPaymentQuery = (
  { __typename: 'Query' }
  & { orderPayment: (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) | (
    { __typename: 'OrderPayment' }
    & Pick<OrderPayment, 'id' | 'fingerprint'>
  ) }
);

export type OrderSetShippingMethodMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
  shippingMethodId: Scalars['ID']['input'];
  shippingData: Array<OrderDataInput> | OrderDataInput;
}>;


export type OrderSetShippingMethodMutation = (
  { __typename: 'Mutation' }
  & { orderSetShippingMethod: (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message' | 'detailedMessage'>
  ) | (
    { __typename: 'OrderUpdatePayload' }
    & { order: (
      { __typename: 'Order' }
      & Pick<Order, 'id'>
      & { shipping: Maybe<(
        { __typename: 'OrderShippingInfoEmail' }
        & Pick<OrderShippingInfoEmail, 'taxRate'>
        & { price: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )>, originalPrice: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )>, method: (
          { __typename: 'ShippingMethodEmail' }
          & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodHakonen' }
          & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodLocalDelivery' }
          & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodMatkahuolto' }
          & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodOmniva' }
          & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPickUpFromStore' }
          & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPosti' }
          & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderShippingInfoHakonen' }
        & Pick<OrderShippingInfoHakonen, 'taxRate'>
        & { price: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )>, originalPrice: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )>, method: (
          { __typename: 'ShippingMethodEmail' }
          & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodHakonen' }
          & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodLocalDelivery' }
          & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodMatkahuolto' }
          & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodOmniva' }
          & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPickUpFromStore' }
          & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPosti' }
          & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderShippingInfoLocalDelivery' }
        & Pick<OrderShippingInfoLocalDelivery, 'taxRate'>
        & { price: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )>, originalPrice: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )>, method: (
          { __typename: 'ShippingMethodEmail' }
          & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodHakonen' }
          & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodLocalDelivery' }
          & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodMatkahuolto' }
          & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodOmniva' }
          & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPickUpFromStore' }
          & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPosti' }
          & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderShippingInfoMatkahuolto' }
        & Pick<OrderShippingInfoMatkahuolto, 'taxRate'>
        & { price: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )>, originalPrice: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )>, method: (
          { __typename: 'ShippingMethodEmail' }
          & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodHakonen' }
          & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodLocalDelivery' }
          & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodMatkahuolto' }
          & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodOmniva' }
          & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPickUpFromStore' }
          & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPosti' }
          & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderShippingInfoOmniva' }
        & Pick<OrderShippingInfoOmniva, 'taxRate'>
        & { price: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )>, originalPrice: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )>, method: (
          { __typename: 'ShippingMethodEmail' }
          & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodHakonen' }
          & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodLocalDelivery' }
          & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodMatkahuolto' }
          & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodOmniva' }
          & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPickUpFromStore' }
          & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPosti' }
          & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderShippingInfoPickUpFromStore' }
        & Pick<OrderShippingInfoPickUpFromStore, 'taxRate'>
        & { outlet: Maybe<(
          { __typename: 'Outlet' }
          & Pick<Outlet, 'id' | 'title' | 'address' | 'city' | 'state' | 'postalCode' | 'location'>
        )>, price: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )>, originalPrice: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )>, method: (
          { __typename: 'ShippingMethodEmail' }
          & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodHakonen' }
          & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodLocalDelivery' }
          & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodMatkahuolto' }
          & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodOmniva' }
          & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPickUpFromStore' }
          & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPosti' }
          & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      ) | (
        { __typename: 'OrderShippingInfoPosti' }
        & Pick<OrderShippingInfoPosti, 'taxRate'>
        & { price: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )>, originalPrice: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )>, method: (
          { __typename: 'ShippingMethodEmail' }
          & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodHakonen' }
          & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodLocalDelivery' }
          & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodMatkahuolto' }
          & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodOmniva' }
          & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPickUpFromStore' }
          & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
        ) | (
          { __typename: 'ShippingMethodPosti' }
          & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
        ), data: Array<(
          { __typename: 'OrderData' }
          & Pick<OrderData, 'key' | 'value'>
        )> }
      )>, totalAmount: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )>, availablePaymentMethods: Array<(
        { __typename: 'PaymentMethodAvarda' }
        & Pick<PaymentMethodAvarda, 'paymentType' | 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      ) | (
        { __typename: 'PaymentMethodAvardaEstonia' }
        & Pick<PaymentMethodAvardaEstonia, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      ) | (
        { __typename: 'PaymentMethodEsto' }
        & Pick<PaymentMethodEsto, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      ) | (
        { __typename: 'PaymentMethodHolmbank' }
        & Pick<PaymentMethodHolmbank, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      ) | (
        { __typename: 'PaymentMethodInbank' }
        & Pick<PaymentMethodInbank, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      ) | (
        { __typename: 'PaymentMethodMaksekeskus' }
        & Pick<PaymentMethodMaksekeskus, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      ) | (
        { __typename: 'PaymentMethodMontonio' }
        & Pick<PaymentMethodMontonio, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      ) | (
        { __typename: 'PaymentMethodPaytrail' }
        & Pick<PaymentMethodPaytrail, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      ) | (
        { __typename: 'PaymentMethodPaywerk' }
        & Pick<PaymentMethodPaywerk, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      )> }
    ) }
  ) }
);

export type ViewCheckoutOrderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
  loadOffices: Scalars['Boolean']['input'];
  officesPostalCode: Scalars['PostalCode']['input'];
  officesCountryCode: Scalars['CountryCode']['input'];
}>;


export type ViewCheckoutOrderQuery = (
  { __typename: 'Query' }
  & { order: (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) | (
    { __typename: 'Order' }
    & Pick<Order, 'id' | 'number' | 'state' | 'createdAt' | 'hasFreeShipping' | 'saleNumber' | 'deliveryEstimate' | 'originalDeliveryEstimate'>
    & { availableShippingMethods: Array<(
      { __typename: 'ShippingMethodEmail' }
      & Pick<ShippingMethodEmail, 'id' | 'title' | 'description' | 'position' | 'logo' | 'type'>
      & { originalPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), priceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), freeShippingPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), group: Maybe<(
        { __typename: 'ShippingMethodGroup' }
        & Pick<ShippingMethodGroup, 'id' | 'title' | 'position'>
      )> }
    ) | (
      { __typename: 'ShippingMethodHakonen' }
      & Pick<ShippingMethodHakonen, 'id' | 'title' | 'description' | 'position' | 'logo' | 'type'>
      & { originalPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), priceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), freeShippingPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), group: Maybe<(
        { __typename: 'ShippingMethodGroup' }
        & Pick<ShippingMethodGroup, 'id' | 'title' | 'position'>
      )> }
    ) | (
      { __typename: 'ShippingMethodLocalDelivery' }
      & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'description' | 'position' | 'logo' | 'type'>
      & { originalPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), priceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), freeShippingPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), group: Maybe<(
        { __typename: 'ShippingMethodGroup' }
        & Pick<ShippingMethodGroup, 'id' | 'title' | 'position'>
      )> }
    ) | (
      { __typename: 'ShippingMethodMatkahuolto' }
      & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'description' | 'position' | 'logo' | 'type'>
      & { offices?: Array<(
        { __typename: 'ShippingMethodMatkahuoltoOffice' }
        & Pick<ShippingMethodMatkahuoltoOffice, 'id' | 'name' | 'address' | 'postalCode' | 'city' | 'distance'>
      )>, originalPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), priceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), freeShippingPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), group: Maybe<(
        { __typename: 'ShippingMethodGroup' }
        & Pick<ShippingMethodGroup, 'id' | 'title' | 'position'>
      )> }
    ) | (
      { __typename: 'ShippingMethodOmniva' }
      & Pick<ShippingMethodOmniva, 'id' | 'title' | 'description' | 'position' | 'logo' | 'type'>
      & { locations?: Array<(
        { __typename: 'ShippingMethodOmnivaLocation' }
        & Pick<ShippingMethodOmnivaLocation, 'id' | 'name' | 'type' | 'serviceHours' | 'notes' | 'approximateDistance'>
      )>, originalPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), priceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), freeShippingPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), group: Maybe<(
        { __typename: 'ShippingMethodGroup' }
        & Pick<ShippingMethodGroup, 'id' | 'title' | 'position'>
      )> }
    ) | (
      { __typename: 'ShippingMethodPickUpFromStore' }
      & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'description' | 'position' | 'logo' | 'type'>
      & { outlets: Array<(
        { __typename: 'Outlet' }
        & Pick<Outlet, 'id' | 'title' | 'address' | 'postalCode' | 'city' | 'number' | 'state' | 'location'>
      )>, originalPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), priceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), freeShippingPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), group: Maybe<(
        { __typename: 'ShippingMethodGroup' }
        & Pick<ShippingMethodGroup, 'id' | 'title' | 'position'>
      )> }
    ) | (
      { __typename: 'ShippingMethodPosti' }
      & Pick<ShippingMethodPosti, 'id' | 'title' | 'description' | 'position' | 'logo' | 'type'>
      & { originalPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), priceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), freeShippingPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), group: Maybe<(
        { __typename: 'ShippingMethodGroup' }
        & Pick<ShippingMethodGroup, 'id' | 'title' | 'position'>
      )> }
    )>, payment: Maybe<(
      { __typename: 'OrderPaymentInfoAvarda' }
      & Pick<OrderPaymentInfoAvarda, 'paymentType'>
      & { method: (
        { __typename: 'PaymentMethodAvarda' }
        & Pick<PaymentMethodAvarda, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodAvardaEstonia' }
        & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodEsto' }
        & Pick<PaymentMethodEsto, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodHolmbank' }
        & Pick<PaymentMethodHolmbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodInbank' }
        & Pick<PaymentMethodInbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMaksekeskus' }
        & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMontonio' }
        & Pick<PaymentMethodMontonio, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaytrail' }
        & Pick<PaymentMethodPaytrail, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaywerk' }
        & Pick<PaymentMethodPaywerk, 'id' | 'title'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderPaymentInfoAvardaEstonia' }
      & { method: (
        { __typename: 'PaymentMethodAvarda' }
        & Pick<PaymentMethodAvarda, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodAvardaEstonia' }
        & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodEsto' }
        & Pick<PaymentMethodEsto, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodHolmbank' }
        & Pick<PaymentMethodHolmbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodInbank' }
        & Pick<PaymentMethodInbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMaksekeskus' }
        & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMontonio' }
        & Pick<PaymentMethodMontonio, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaytrail' }
        & Pick<PaymentMethodPaytrail, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaywerk' }
        & Pick<PaymentMethodPaywerk, 'id' | 'title'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderPaymentInfoEsto' }
      & { method: (
        { __typename: 'PaymentMethodAvarda' }
        & Pick<PaymentMethodAvarda, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodAvardaEstonia' }
        & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodEsto' }
        & Pick<PaymentMethodEsto, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodHolmbank' }
        & Pick<PaymentMethodHolmbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodInbank' }
        & Pick<PaymentMethodInbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMaksekeskus' }
        & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMontonio' }
        & Pick<PaymentMethodMontonio, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaytrail' }
        & Pick<PaymentMethodPaytrail, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaywerk' }
        & Pick<PaymentMethodPaywerk, 'id' | 'title'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderPaymentInfoInbank' }
      & { method: (
        { __typename: 'PaymentMethodAvarda' }
        & Pick<PaymentMethodAvarda, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodAvardaEstonia' }
        & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodEsto' }
        & Pick<PaymentMethodEsto, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodHolmbank' }
        & Pick<PaymentMethodHolmbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodInbank' }
        & Pick<PaymentMethodInbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMaksekeskus' }
        & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMontonio' }
        & Pick<PaymentMethodMontonio, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaytrail' }
        & Pick<PaymentMethodPaytrail, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaywerk' }
        & Pick<PaymentMethodPaywerk, 'id' | 'title'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderPaymentInfoMaksekeskus' }
      & { method: (
        { __typename: 'PaymentMethodAvarda' }
        & Pick<PaymentMethodAvarda, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodAvardaEstonia' }
        & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodEsto' }
        & Pick<PaymentMethodEsto, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodHolmbank' }
        & Pick<PaymentMethodHolmbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodInbank' }
        & Pick<PaymentMethodInbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMaksekeskus' }
        & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMontonio' }
        & Pick<PaymentMethodMontonio, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaytrail' }
        & Pick<PaymentMethodPaytrail, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaywerk' }
        & Pick<PaymentMethodPaywerk, 'id' | 'title'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderPaymentInfoMontonio' }
      & { method: (
        { __typename: 'PaymentMethodAvarda' }
        & Pick<PaymentMethodAvarda, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodAvardaEstonia' }
        & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodEsto' }
        & Pick<PaymentMethodEsto, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodHolmbank' }
        & Pick<PaymentMethodHolmbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodInbank' }
        & Pick<PaymentMethodInbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMaksekeskus' }
        & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMontonio' }
        & Pick<PaymentMethodMontonio, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaytrail' }
        & Pick<PaymentMethodPaytrail, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaywerk' }
        & Pick<PaymentMethodPaywerk, 'id' | 'title'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderPaymentInfoPaytrail' }
      & { method: (
        { __typename: 'PaymentMethodAvarda' }
        & Pick<PaymentMethodAvarda, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodAvardaEstonia' }
        & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodEsto' }
        & Pick<PaymentMethodEsto, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodHolmbank' }
        & Pick<PaymentMethodHolmbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodInbank' }
        & Pick<PaymentMethodInbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMaksekeskus' }
        & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMontonio' }
        & Pick<PaymentMethodMontonio, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaytrail' }
        & Pick<PaymentMethodPaytrail, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaywerk' }
        & Pick<PaymentMethodPaywerk, 'id' | 'title'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderPaymentInfoPaywerk' }
      & { method: (
        { __typename: 'PaymentMethodAvarda' }
        & Pick<PaymentMethodAvarda, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodAvardaEstonia' }
        & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodEsto' }
        & Pick<PaymentMethodEsto, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodHolmbank' }
        & Pick<PaymentMethodHolmbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodInbank' }
        & Pick<PaymentMethodInbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMaksekeskus' }
        & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMontonio' }
        & Pick<PaymentMethodMontonio, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaytrail' }
        & Pick<PaymentMethodPaytrail, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaywerk' }
        & Pick<PaymentMethodPaywerk, 'id' | 'title'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    )>, totalDiscountsAmount: (
      { __typename: 'Money' }
      & Pick<Money, 'amount'>
    ), shipping: Maybe<(
      { __typename: 'OrderShippingInfoEmail' }
      & Pick<OrderShippingInfoEmail, 'taxRate'>
      & { price: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )>, originalPrice: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      )>, method: (
        { __typename: 'ShippingMethodEmail' }
        & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodHakonen' }
        & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodLocalDelivery' }
        & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodMatkahuolto' }
        & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodOmniva' }
        & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPickUpFromStore' }
        & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPosti' }
        & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderShippingInfoHakonen' }
      & Pick<OrderShippingInfoHakonen, 'taxRate'>
      & { price: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )>, originalPrice: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      )>, method: (
        { __typename: 'ShippingMethodEmail' }
        & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodHakonen' }
        & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodLocalDelivery' }
        & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodMatkahuolto' }
        & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodOmniva' }
        & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPickUpFromStore' }
        & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPosti' }
        & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderShippingInfoLocalDelivery' }
      & Pick<OrderShippingInfoLocalDelivery, 'taxRate'>
      & { price: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )>, originalPrice: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      )>, method: (
        { __typename: 'ShippingMethodEmail' }
        & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodHakonen' }
        & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodLocalDelivery' }
        & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodMatkahuolto' }
        & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodOmniva' }
        & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPickUpFromStore' }
        & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPosti' }
        & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderShippingInfoMatkahuolto' }
      & Pick<OrderShippingInfoMatkahuolto, 'taxRate'>
      & { price: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )>, originalPrice: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      )>, method: (
        { __typename: 'ShippingMethodEmail' }
        & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodHakonen' }
        & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodLocalDelivery' }
        & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodMatkahuolto' }
        & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodOmniva' }
        & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPickUpFromStore' }
        & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPosti' }
        & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderShippingInfoOmniva' }
      & Pick<OrderShippingInfoOmniva, 'taxRate'>
      & { price: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )>, originalPrice: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      )>, method: (
        { __typename: 'ShippingMethodEmail' }
        & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodHakonen' }
        & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodLocalDelivery' }
        & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodMatkahuolto' }
        & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodOmniva' }
        & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPickUpFromStore' }
        & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPosti' }
        & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderShippingInfoPickUpFromStore' }
      & Pick<OrderShippingInfoPickUpFromStore, 'taxRate'>
      & { outlet: Maybe<(
        { __typename: 'Outlet' }
        & Pick<Outlet, 'id' | 'title' | 'address' | 'city' | 'state' | 'postalCode' | 'location'>
      )>, price: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )>, originalPrice: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      )>, method: (
        { __typename: 'ShippingMethodEmail' }
        & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodHakonen' }
        & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodLocalDelivery' }
        & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodMatkahuolto' }
        & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodOmniva' }
        & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPickUpFromStore' }
        & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPosti' }
        & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderShippingInfoPosti' }
      & Pick<OrderShippingInfoPosti, 'taxRate'>
      & { price: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )>, originalPrice: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      )>, method: (
        { __typename: 'ShippingMethodEmail' }
        & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodHakonen' }
        & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodLocalDelivery' }
        & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodMatkahuolto' }
        & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodOmniva' }
        & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPickUpFromStore' }
        & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPosti' }
        & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    )>, customer: Maybe<(
      { __typename: 'Customer' }
      & Pick<Customer, 'id' | 'firstName' | 'lastName' | 'email' | 'phone' | 'allowEmailMarketing' | 'allowSmsMarketing' | 'countryCode'>
    )>, company: Maybe<(
      { __typename: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>, totalAmount: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount' | 'currencyCode'>
    )>, taxLines: Array<(
      { __typename: 'OrderTaxLine' }
      & { amount: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ) }
    )>, giftCardOrders: Array<(
      { __typename: 'GiftCardOrder' }
      & Pick<GiftCardOrder, 'id' | 'confirmedAt' | 'createdAt' | 'updatedAt'>
      & { amount: (
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      ) }
    )>, billingAddress: Maybe<(
      { __typename: 'OrderAddress' }
      & Pick<OrderAddress, 'id' | 'firstName' | 'lastName' | 'companyName' | 'businessIdentityCode' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode'>
    )>, shippingAddress: Maybe<(
      { __typename: 'OrderAddress' }
      & Pick<OrderAddress, 'id' | 'firstName' | 'lastName' | 'companyName' | 'businessIdentityCode' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode'>
    )>, products: Array<(
      { __typename: 'OrderProduct' }
      & Pick<OrderProduct, 'id' | 'quantity' | 'taxRate'>
      & { price: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), unitPrice: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), discounts: Array<(
        { __typename: 'OrderProductDiscount' }
        & Pick<OrderProductDiscount, 'id'>
        & { amount: (
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        ) }
      )>, product: (
        { __typename: 'SimpleProduct' }
        & Pick<SimpleProduct, 'id' | 'name' | 'title' | 'specification' | 'sku' | 'state'>
        & { listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )>, productClass: Maybe<(
          { __typename: 'ProductClass' }
          & Pick<ProductClass, 'id' | 'title'>
        )>, parentProduct: Maybe<(
          { __typename: 'ConfigurableProduct' }
          & Pick<ConfigurableProduct, 'id'>
        )>, categories: Array<(
          { __typename: 'Category' }
          & Pick<Category, 'id' | 'title'>
        )>, pricing: (
          { __typename: 'ProductPricing' }
          & { price: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )>, originalPrice: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )>, clubPrice: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )> }
        ), inventory: (
          { __typename: 'ProductInventory' }
          & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
        ), cartPromotions: Array<(
          { __typename: 'CartPromotionClubPrice' }
          & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
        ) | (
          { __typename: 'CartPromotionFixedAmountFromCart' }
          & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
        ) | (
          { __typename: 'CartPromotionFixedAmountFromProduct' }
          & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
        ) | (
          { __typename: 'CartPromotionFreeShipping' }
          & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
        ) | (
          { __typename: 'CartPromotionFreebie' }
          & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
        ) | (
          { __typename: 'CartPromotionPercent' }
          & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
          & { percentDiscount: (
            { __typename: 'CartPromotionPercentDiscount' }
            & Pick<CartPromotionPercentDiscount, 'percent'>
          ) }
        ) | (
          { __typename: 'CartPromotionProductCartPromotionPrice' }
          & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
        )> }
      ) }
    )>, availablePaymentMethods: Array<(
      { __typename: 'PaymentMethodAvarda' }
      & Pick<PaymentMethodAvarda, 'paymentType' | 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      & { group: Maybe<(
        { __typename: 'PaymentMethodGroup' }
        & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) | (
      { __typename: 'PaymentMethodAvardaEstonia' }
      & Pick<PaymentMethodAvardaEstonia, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      & { group: Maybe<(
        { __typename: 'PaymentMethodGroup' }
        & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) | (
      { __typename: 'PaymentMethodEsto' }
      & Pick<PaymentMethodEsto, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      & { group: Maybe<(
        { __typename: 'PaymentMethodGroup' }
        & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) | (
      { __typename: 'PaymentMethodHolmbank' }
      & Pick<PaymentMethodHolmbank, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      & { group: Maybe<(
        { __typename: 'PaymentMethodGroup' }
        & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) | (
      { __typename: 'PaymentMethodInbank' }
      & Pick<PaymentMethodInbank, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      & { group: Maybe<(
        { __typename: 'PaymentMethodGroup' }
        & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) | (
      { __typename: 'PaymentMethodMaksekeskus' }
      & Pick<PaymentMethodMaksekeskus, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      & { group: Maybe<(
        { __typename: 'PaymentMethodGroup' }
        & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) | (
      { __typename: 'PaymentMethodMontonio' }
      & Pick<PaymentMethodMontonio, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      & { group: Maybe<(
        { __typename: 'PaymentMethodGroup' }
        & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) | (
      { __typename: 'PaymentMethodPaytrail' }
      & Pick<PaymentMethodPaytrail, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      & { group: Maybe<(
        { __typename: 'PaymentMethodGroup' }
        & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) | (
      { __typename: 'PaymentMethodPaywerk' }
      & Pick<PaymentMethodPaywerk, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      & { group: Maybe<(
        { __typename: 'PaymentMethodGroup' }
        & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    )> }
  ), me: Maybe<(
    { __typename: 'User' }
    & Pick<User, 'id'>
    & { customer: (
      { __typename: 'Customer' }
      & Pick<Customer, 'id'>
      & { addresses: (
        { __typename: 'CustomerAddressesConnection' }
        & { edges: Array<(
          { __typename: 'CustomerAddressesEdge' }
          & { node: (
            { __typename: 'CustomerAddress' }
            & Pick<CustomerAddress, 'id' | 'type' | 'firstName' | 'lastName' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode' | 'companyName' | 'businessIdentityCode'>
          ) }
        )> }
      ) }
    ) }
  )> }
);

export type ListProductsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ListProductsQuery = (
  { __typename: 'Query' }
  & { products: (
    { __typename: 'ProductsConnection' }
    & Pick<ProductsConnection, 'totalCount'>
    & { pageInfo: (
      { __typename: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'endCursor'>
    ), edges: Array<(
      { __typename: 'ProductsEdge' }
      & { node: (
        { __typename: 'ConfigurableProduct' }
        & Pick<ConfigurableProduct, 'id' | 'name' | 'title' | 'specification'>
        & { configuration: (
          { __typename: 'ProductConfiguration' }
          & { defaultProduct: Maybe<(
            { __typename: 'SimpleProduct' }
            & Pick<SimpleProduct, 'id'>
            & { listingImage: Maybe<(
              { __typename: 'ProductImage' }
              & Pick<ProductImage, 'id' | 'url'>
            )>, pricing: (
              { __typename: 'ProductPricing' }
              & { price: Maybe<(
                { __typename: 'Money' }
                & Pick<Money, 'amount'>
              )>, originalPrice: Maybe<(
                { __typename: 'Money' }
                & Pick<Money, 'amount'>
              )> }
            ), inventory: (
              { __typename: 'ProductInventory' }
              & Pick<ProductInventory, 'availableQuantity'>
            ), promotions: Array<(
              { __typename: 'CatalogPromotionFixedAmount' }
              & Pick<CatalogPromotionFixedAmount, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
              & { catalogDiscountType: CatalogPromotionFixedAmount['discountType'] }
              & { style: Maybe<(
                { __typename: 'PromotionStyle' }
                & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
                & { mainTheme: (
                  { __typename: 'PromotionStyleTheme' }
                  & { background: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), text: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), font: (
                    { __typename: 'PromotionStyleFontInfo' }
                    & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                  ) }
                ), altTheme: Maybe<(
                  { __typename: 'PromotionStyleTheme' }
                  & { background: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), text: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), font: (
                    { __typename: 'PromotionStyleFontInfo' }
                    & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                  ) }
                )>, productPage: (
                  { __typename: 'PromotionStyleProductPage' }
                  & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
                ) }
              )>, catalogFixedAmountDiscount: (
                { __typename: 'CatalogPromotionFixedAmountDiscount' }
                & Pick<CatalogPromotionFixedAmountDiscount, 'amount'>
              ) }
            ) | (
              { __typename: 'CatalogPromotionPercent' }
              & Pick<CatalogPromotionPercent, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
              & { catalogDiscountType: CatalogPromotionPercent['discountType'] }
              & { style: Maybe<(
                { __typename: 'PromotionStyle' }
                & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
                & { mainTheme: (
                  { __typename: 'PromotionStyleTheme' }
                  & { background: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), text: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), font: (
                    { __typename: 'PromotionStyleFontInfo' }
                    & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                  ) }
                ), altTheme: Maybe<(
                  { __typename: 'PromotionStyleTheme' }
                  & { background: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), text: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), font: (
                    { __typename: 'PromotionStyleFontInfo' }
                    & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                  ) }
                )>, productPage: (
                  { __typename: 'PromotionStyleProductPage' }
                  & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
                ) }
              )>, catalogPercentDiscount: (
                { __typename: 'CatalogPromotionPercentDiscount' }
                & Pick<CatalogPromotionPercentDiscount, 'percent'>
              ) }
            ) | (
              { __typename: 'CatalogPromotionProductPromotionPrice' }
              & Pick<CatalogPromotionProductPromotionPrice, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
              & { catalogDiscountType: CatalogPromotionProductPromotionPrice['discountType'] }
              & { style: Maybe<(
                { __typename: 'PromotionStyle' }
                & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
                & { mainTheme: (
                  { __typename: 'PromotionStyleTheme' }
                  & { background: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), text: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), font: (
                    { __typename: 'PromotionStyleFontInfo' }
                    & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                  ) }
                ), altTheme: Maybe<(
                  { __typename: 'PromotionStyleTheme' }
                  & { background: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), text: (
                    { __typename: 'PromotionStyleColorInfo' }
                    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                  ), font: (
                    { __typename: 'PromotionStyleFontInfo' }
                    & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                  ) }
                )>, productPage: (
                  { __typename: 'PromotionStyleProductPage' }
                  & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
                ) }
              )> }
            )> }
          )> }
        ), seo: (
          { __typename: 'ProductSeo' }
          & Pick<ProductSeo, 'slug'>
        ), listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )> }
      ) | (
        { __typename: 'SimpleProduct' }
        & Pick<SimpleProduct, 'id' | 'name' | 'title' | 'specification'>
        & { pricing: (
          { __typename: 'ProductPricing' }
          & { price: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )>, originalPrice: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )> }
        ), inventory: (
          { __typename: 'ProductInventory' }
          & Pick<ProductInventory, 'availableQuantity'>
        ), promotions: Array<(
          { __typename: 'CatalogPromotionFixedAmount' }
          & Pick<CatalogPromotionFixedAmount, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
          & { catalogDiscountType: CatalogPromotionFixedAmount['discountType'] }
          & { style: Maybe<(
            { __typename: 'PromotionStyle' }
            & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
            & { mainTheme: (
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            ), altTheme: Maybe<(
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            )>, productPage: (
              { __typename: 'PromotionStyleProductPage' }
              & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
            ) }
          )>, catalogFixedAmountDiscount: (
            { __typename: 'CatalogPromotionFixedAmountDiscount' }
            & Pick<CatalogPromotionFixedAmountDiscount, 'amount'>
          ) }
        ) | (
          { __typename: 'CatalogPromotionPercent' }
          & Pick<CatalogPromotionPercent, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
          & { catalogDiscountType: CatalogPromotionPercent['discountType'] }
          & { style: Maybe<(
            { __typename: 'PromotionStyle' }
            & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
            & { mainTheme: (
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            ), altTheme: Maybe<(
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            )>, productPage: (
              { __typename: 'PromotionStyleProductPage' }
              & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
            ) }
          )>, catalogPercentDiscount: (
            { __typename: 'CatalogPromotionPercentDiscount' }
            & Pick<CatalogPromotionPercentDiscount, 'percent'>
          ) }
        ) | (
          { __typename: 'CatalogPromotionProductPromotionPrice' }
          & Pick<CatalogPromotionProductPromotionPrice, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
          & { catalogDiscountType: CatalogPromotionProductPromotionPrice['discountType'] }
          & { style: Maybe<(
            { __typename: 'PromotionStyle' }
            & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
            & { mainTheme: (
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            ), altTheme: Maybe<(
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            )>, productPage: (
              { __typename: 'PromotionStyleProductPage' }
              & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
            ) }
          )> }
        )>, seo: (
          { __typename: 'ProductSeo' }
          & Pick<ProductSeo, 'slug'>
        ), listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )> }
      ) }
    )> }
  ) }
);

export type CreateCompanyAddressMutationVariables = Exact<{
  input: CompanyAddressCreateInput;
}>;


export type CreateCompanyAddressMutation = (
  { __typename: 'Mutation' }
  & { companyAddressCreate: (
    { __typename: 'CompanyAddressCreatePayload' }
    & { companyAddress: (
      { __typename: 'CompanyAddress' }
      & Pick<CompanyAddress, 'id' | 'firstName' | 'lastName' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode'>
    ) }
  ) | (
    { __typename: 'InvalidInputError' }
    & Pick<InvalidInputError, 'message'>
  ) }
);

export type CreateCompanyCustomerMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  role: CompanyCustomerRole;
}>;


export type CreateCompanyCustomerMutation = (
  { __typename: 'Mutation' }
  & { companyAddCustomer: (
    { __typename: 'CompanyAddCustomerPayload' }
    & { company: (
      { __typename: 'Company' }
      & Pick<Company, 'id'>
    ) }
  ) | (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) }
);

export type CreateCompanyMutationVariables = Exact<{
  input: CompanyCreateInput;
}>;


export type CreateCompanyMutation = (
  { __typename: 'Mutation' }
  & { companyCreate: (
    { __typename: 'CompanyCreatePayload' }
    & { company: (
      { __typename: 'Company' }
      & Pick<Company, 'id'>
    ) }
  ) | (
    { __typename: 'InvalidInputError' }
    & Pick<InvalidInputError, 'message'>
  ) }
);

export type CreateCustomerMutationVariables = Exact<{
  input: CustomerCreateInput;
}>;


export type CreateCustomerMutation = (
  { __typename: 'Mutation' }
  & { customerCreate: (
    { __typename: 'CustomerCreatePayload' }
    & { customer: (
      { __typename: 'Customer' }
      & Pick<Customer, 'id'>
    ) }
  ) | (
    { __typename: 'CustomerExistsError' }
    & Pick<CustomerExistsError, 'message'>
  ) | (
    { __typename: 'InvalidInputError' }
    & Pick<InvalidInputError, 'message'>
  ) }
);

export type CreateCustomerAddressMutationVariables = Exact<{
  input: CustomerAddressCreateInput;
}>;


export type CreateCustomerAddressMutation = (
  { __typename: 'Mutation' }
  & { customerAddressCreate: (
    { __typename: 'CustomerAddressCreatePayload' }
    & { customerAddress: (
      { __typename: 'CustomerAddress' }
      & Pick<CustomerAddress, 'id' | 'type' | 'firstName' | 'lastName' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode' | 'companyName' | 'businessIdentityCode'>
    ) }
  ) | (
    { __typename: 'InvalidInputError' }
    & Pick<InvalidInputError, 'message'>
  ) }
);

export type CustomerAddressDataFragment = (
  { __typename: 'CustomerAddress' }
  & Pick<CustomerAddress, 'id' | 'type' | 'firstName' | 'lastName' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode' | 'companyName' | 'businessIdentityCode'>
);

export type CustomerDataFragment = (
  { __typename: 'Customer' }
  & Pick<Customer, 'id' | 'number' | 'firstName' | 'lastName' | 'email' | 'phone' | 'createdAt' | 'updatedAt' | 'allowEmailMarketing' | 'allowSmsMarketing'>
  & { company: Maybe<(
    { __typename: 'Company' }
    & Pick<Company, 'id' | 'name' | 'businessIdentityCode'>
  )> }
);

export type CustomerSendEmailVerificationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CustomerSendEmailVerificationMutation = (
  { __typename: 'Mutation' }
  & { customerSendEmailVerification: (
    { __typename: 'CustomerUpdatePayload' }
    & { customer: (
      { __typename: 'Customer' }
      & Pick<Customer, 'id'>
    ) }
  ) | (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) }
);

export type DeleteCustomerAddressMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCustomerAddressMutation = (
  { __typename: 'Mutation' }
  & { customerAddressDelete: (
    { __typename: 'CustomerAddressDeletePayload' }
    & { customerAddress: (
      { __typename: 'CustomerAddress' }
      & Pick<CustomerAddress, 'id'>
    ) }
  ) | (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) }
);

export type DeleteCustomerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCustomerMutation = (
  { __typename: 'Mutation' }
  & { customerDelete: (
    { __typename: 'CustomerDeletePayload' }
    & { customer: (
      { __typename: 'Customer' }
      & Pick<Customer, 'id'>
    ) }
  ) | (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) }
);

export type FinishFirstTimeCustomerSetupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FinishFirstTimeCustomerSetupMutation = (
  { __typename: 'Mutation' }
  & { customerFinishFirstTimeSetup: (
    { __typename: 'CustomerUpdatePayload' }
    & { customer: (
      { __typename: 'Customer' }
      & Pick<Customer, 'id' | 'isFirstTimeSetupDone'>
    ) }
  ) | (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) }
);

export type ListCustomerAddressesQueryVariables = Exact<{
  type: CustomerAddressType;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListCustomerAddressesQuery = (
  { __typename: 'Query' }
  & { me: Maybe<(
    { __typename: 'User' }
    & Pick<User, 'id'>
    & { customer: (
      { __typename: 'Customer' }
      & Pick<Customer, 'id'>
      & { addresses: (
        { __typename: 'CustomerAddressesConnection' }
        & { pageInfo: (
          { __typename: 'PageInfo' }
          & Pick<PageInfo, 'endCursor' | 'hasNextPage'>
        ), edges: Array<(
          { __typename: 'CustomerAddressesEdge' }
          & { node: (
            { __typename: 'CustomerAddress' }
            & Pick<CustomerAddress, 'id' | 'type' | 'firstName' | 'lastName' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode' | 'companyName' | 'businessIdentityCode'>
          ) }
        )> }
      ) }
    ) }
  )> }
);

export type ListCustomerOrdersQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
}>;


export type ListCustomerOrdersQuery = (
  { __typename: 'Query' }
  & { orders: (
    { __typename: 'OrdersConnection' }
    & Pick<OrdersConnection, 'totalCount'>
    & { pageInfo: (
      { __typename: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage'>
    ), edges: Array<(
      { __typename: 'OrdersEdge' }
      & { node: (
        { __typename: 'Order' }
        & Pick<Order, 'id' | 'number' | 'createdAt' | 'state'>
        & { totalAmount: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )> }
      ) }
    )> }
  ) }
);

export type UpdateCustomerAddressMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CustomerAddressUpdateInput;
}>;


export type UpdateCustomerAddressMutation = (
  { __typename: 'Mutation' }
  & { customerAddressUpdate: (
    { __typename: 'CustomerAddressUpdatePayload' }
    & { customerAddress: (
      { __typename: 'CustomerAddress' }
      & Pick<CustomerAddress, 'id' | 'type' | 'firstName' | 'lastName' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode' | 'companyName' | 'businessIdentityCode'>
    ) }
  ) | (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) }
);

export type UpdateCustomerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CustomerUpdateInput;
}>;


export type UpdateCustomerMutation = (
  { __typename: 'Mutation' }
  & { customerUpdate: (
    { __typename: 'CustomerUpdatePayload' }
    & { customer: (
      { __typename: 'Customer' }
      & Pick<Customer, 'id' | 'number' | 'firstName' | 'lastName' | 'email' | 'phone' | 'createdAt' | 'updatedAt' | 'allowEmailMarketing' | 'allowSmsMarketing'>
      & { company: Maybe<(
        { __typename: 'Company' }
        & Pick<Company, 'id' | 'name' | 'businessIdentityCode'>
      )> }
    ) }
  ) | (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) }
);

export type ViewCustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewCustomerQuery = (
  { __typename: 'Query' }
  & { me: Maybe<(
    { __typename: 'User' }
    & Pick<User, 'id'>
    & { customer: (
      { __typename: 'Customer' }
      & Pick<Customer, 'id' | 'number' | 'firstName' | 'lastName' | 'email' | 'phone' | 'createdAt' | 'updatedAt' | 'allowEmailMarketing' | 'allowSmsMarketing'>
      & { orders: (
        { __typename: 'OrdersConnection' }
        & Pick<OrdersConnection, 'totalCount'>
        & { pageInfo: (
          { __typename: 'PageInfo' }
          & Pick<PageInfo, 'endCursor' | 'hasNextPage'>
        ), edges: Array<(
          { __typename: 'OrdersEdge' }
          & { node: (
            { __typename: 'Order' }
            & Pick<Order, 'id' | 'number' | 'createdAt' | 'state' | 'saleNumber'>
            & { totalAmount: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, products: Array<(
              { __typename: 'OrderProduct' }
              & Pick<OrderProduct, 'id'>
              & { product: (
                { __typename: 'SimpleProduct' }
                & Pick<SimpleProduct, 'id' | 'name'>
                & { listingImage: Maybe<(
                  { __typename: 'ProductImage' }
                  & Pick<ProductImage, 'id' | 'url'>
                )> }
              ) }
            )> }
          ) }
        )> }
      ), addresses: (
        { __typename: 'CustomerAddressesConnection' }
        & Pick<CustomerAddressesConnection, 'totalCount'>
        & { pageInfo: (
          { __typename: 'PageInfo' }
          & Pick<PageInfo, 'endCursor' | 'hasNextPage'>
        ), edges: Array<(
          { __typename: 'CustomerAddressesEdge' }
          & { node: (
            { __typename: 'CustomerAddress' }
            & Pick<CustomerAddress, 'id' | 'type' | 'firstName' | 'lastName' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode' | 'companyName' | 'businessIdentityCode'>
          ) }
        )> }
      ), company: Maybe<(
        { __typename: 'Company' }
        & Pick<Company, 'id' | 'name' | 'businessIdentityCode'>
      )> }
    ) }
  )> }
);

export type ListCustomersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<CustomerWhereInput>;
}>;


export type ListCustomersQuery = (
  { __typename: 'Query' }
  & { customers: (
    { __typename: 'CustomersConnection' }
    & Pick<CustomersConnection, 'totalCount'>
    & { pageInfo: (
      { __typename: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'endCursor'>
    ), edges: Array<(
      { __typename: 'CustomersEdge' }
      & { node: (
        { __typename: 'Customer' }
        & Pick<Customer, 'id' | 'number' | 'firstName' | 'lastName' | 'email'>
        & { orders: (
          { __typename: 'OrdersConnection' }
          & { edges: Array<(
            { __typename: 'OrdersEdge' }
            & { node: (
              { __typename: 'Order' }
              & Pick<Order, 'id' | 'createdAt'>
            ) }
          )> }
        ), company: Maybe<(
          { __typename: 'Company' }
          & Pick<Company, 'id' | 'name' | 'businessIdentityCode'>
        )> }
      ) }
    )> }
  ) }
);

export type GiftCardQueryVariables = Exact<{
  code: Scalars['NonEmptyString']['input'];
}>;


export type GiftCardQuery = (
  { __typename: 'Query' }
  & { giftCard: (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) | (
    { __typename: 'GiftCard' }
    & Pick<GiftCard, 'id' | 'code' | 'email' | 'createDate' | 'validUntil'>
    & { initialAmount: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount' | 'currencyCode'>
    )>, remainingAmount: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount' | 'currencyCode'>
    )> }
  ) | { __typename: 'InvalidInputError' } }
);

export type ListOrdersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OrderWhereInput>;
}>;


export type ListOrdersQuery = (
  { __typename: 'Query' }
  & { orders: (
    { __typename: 'OrdersConnection' }
    & Pick<OrdersConnection, 'totalCount'>
    & { pageInfo: (
      { __typename: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'endCursor'>
    ), edges: Array<(
      { __typename: 'OrdersEdge' }
      & { node: (
        { __typename: 'Order' }
        & Pick<Order, 'id' | 'number' | 'createdAt' | 'state'>
        & { totalAmount: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )>, customer: Maybe<(
          { __typename: 'Customer' }
          & Pick<Customer, 'id' | 'firstName' | 'lastName' | 'email'>
        )>, company: Maybe<(
          { __typename: 'Company' }
          & Pick<Company, 'id' | 'name'>
        )> }
      ) }
    )> }
  ) }
);

export type ViewOrderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ViewOrderQuery = (
  { __typename: 'Query' }
  & { order: (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) | (
    { __typename: 'Order' }
    & Pick<Order, 'id' | 'number' | 'state' | 'createdAt' | 'hasFreeShipping' | 'saleNumber' | 'deliveryEstimate' | 'originalDeliveryEstimate'>
    & { payment: Maybe<(
      { __typename: 'OrderPaymentInfoAvarda' }
      & Pick<OrderPaymentInfoAvarda, 'paymentType'>
      & { method: (
        { __typename: 'PaymentMethodAvarda' }
        & Pick<PaymentMethodAvarda, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodAvardaEstonia' }
        & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodEsto' }
        & Pick<PaymentMethodEsto, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodHolmbank' }
        & Pick<PaymentMethodHolmbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodInbank' }
        & Pick<PaymentMethodInbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMaksekeskus' }
        & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMontonio' }
        & Pick<PaymentMethodMontonio, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaytrail' }
        & Pick<PaymentMethodPaytrail, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaywerk' }
        & Pick<PaymentMethodPaywerk, 'id' | 'title'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderPaymentInfoAvardaEstonia' }
      & { method: (
        { __typename: 'PaymentMethodAvarda' }
        & Pick<PaymentMethodAvarda, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodAvardaEstonia' }
        & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodEsto' }
        & Pick<PaymentMethodEsto, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodHolmbank' }
        & Pick<PaymentMethodHolmbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodInbank' }
        & Pick<PaymentMethodInbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMaksekeskus' }
        & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMontonio' }
        & Pick<PaymentMethodMontonio, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaytrail' }
        & Pick<PaymentMethodPaytrail, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaywerk' }
        & Pick<PaymentMethodPaywerk, 'id' | 'title'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderPaymentInfoEsto' }
      & { method: (
        { __typename: 'PaymentMethodAvarda' }
        & Pick<PaymentMethodAvarda, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodAvardaEstonia' }
        & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodEsto' }
        & Pick<PaymentMethodEsto, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodHolmbank' }
        & Pick<PaymentMethodHolmbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodInbank' }
        & Pick<PaymentMethodInbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMaksekeskus' }
        & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMontonio' }
        & Pick<PaymentMethodMontonio, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaytrail' }
        & Pick<PaymentMethodPaytrail, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaywerk' }
        & Pick<PaymentMethodPaywerk, 'id' | 'title'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderPaymentInfoInbank' }
      & { method: (
        { __typename: 'PaymentMethodAvarda' }
        & Pick<PaymentMethodAvarda, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodAvardaEstonia' }
        & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodEsto' }
        & Pick<PaymentMethodEsto, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodHolmbank' }
        & Pick<PaymentMethodHolmbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodInbank' }
        & Pick<PaymentMethodInbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMaksekeskus' }
        & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMontonio' }
        & Pick<PaymentMethodMontonio, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaytrail' }
        & Pick<PaymentMethodPaytrail, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaywerk' }
        & Pick<PaymentMethodPaywerk, 'id' | 'title'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderPaymentInfoMaksekeskus' }
      & { method: (
        { __typename: 'PaymentMethodAvarda' }
        & Pick<PaymentMethodAvarda, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodAvardaEstonia' }
        & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodEsto' }
        & Pick<PaymentMethodEsto, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodHolmbank' }
        & Pick<PaymentMethodHolmbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodInbank' }
        & Pick<PaymentMethodInbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMaksekeskus' }
        & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMontonio' }
        & Pick<PaymentMethodMontonio, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaytrail' }
        & Pick<PaymentMethodPaytrail, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaywerk' }
        & Pick<PaymentMethodPaywerk, 'id' | 'title'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderPaymentInfoMontonio' }
      & { method: (
        { __typename: 'PaymentMethodAvarda' }
        & Pick<PaymentMethodAvarda, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodAvardaEstonia' }
        & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodEsto' }
        & Pick<PaymentMethodEsto, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodHolmbank' }
        & Pick<PaymentMethodHolmbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodInbank' }
        & Pick<PaymentMethodInbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMaksekeskus' }
        & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMontonio' }
        & Pick<PaymentMethodMontonio, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaytrail' }
        & Pick<PaymentMethodPaytrail, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaywerk' }
        & Pick<PaymentMethodPaywerk, 'id' | 'title'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderPaymentInfoPaytrail' }
      & { method: (
        { __typename: 'PaymentMethodAvarda' }
        & Pick<PaymentMethodAvarda, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodAvardaEstonia' }
        & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodEsto' }
        & Pick<PaymentMethodEsto, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodHolmbank' }
        & Pick<PaymentMethodHolmbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodInbank' }
        & Pick<PaymentMethodInbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMaksekeskus' }
        & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMontonio' }
        & Pick<PaymentMethodMontonio, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaytrail' }
        & Pick<PaymentMethodPaytrail, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaywerk' }
        & Pick<PaymentMethodPaywerk, 'id' | 'title'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderPaymentInfoPaywerk' }
      & { method: (
        { __typename: 'PaymentMethodAvarda' }
        & Pick<PaymentMethodAvarda, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodAvardaEstonia' }
        & Pick<PaymentMethodAvardaEstonia, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodEsto' }
        & Pick<PaymentMethodEsto, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodHolmbank' }
        & Pick<PaymentMethodHolmbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodInbank' }
        & Pick<PaymentMethodInbank, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMaksekeskus' }
        & Pick<PaymentMethodMaksekeskus, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodMontonio' }
        & Pick<PaymentMethodMontonio, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaytrail' }
        & Pick<PaymentMethodPaytrail, 'id' | 'title'>
      ) | (
        { __typename: 'PaymentMethodPaywerk' }
        & Pick<PaymentMethodPaywerk, 'id' | 'title'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    )>, totalDiscountsAmount: (
      { __typename: 'Money' }
      & Pick<Money, 'amount'>
    ), shipping: Maybe<(
      { __typename: 'OrderShippingInfoEmail' }
      & Pick<OrderShippingInfoEmail, 'taxRate'>
      & { price: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )>, originalPrice: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      )>, method: (
        { __typename: 'ShippingMethodEmail' }
        & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodHakonen' }
        & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodLocalDelivery' }
        & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodMatkahuolto' }
        & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodOmniva' }
        & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPickUpFromStore' }
        & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPosti' }
        & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderShippingInfoHakonen' }
      & Pick<OrderShippingInfoHakonen, 'taxRate'>
      & { price: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )>, originalPrice: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      )>, method: (
        { __typename: 'ShippingMethodEmail' }
        & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodHakonen' }
        & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodLocalDelivery' }
        & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodMatkahuolto' }
        & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodOmniva' }
        & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPickUpFromStore' }
        & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPosti' }
        & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderShippingInfoLocalDelivery' }
      & Pick<OrderShippingInfoLocalDelivery, 'taxRate'>
      & { price: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )>, originalPrice: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      )>, method: (
        { __typename: 'ShippingMethodEmail' }
        & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodHakonen' }
        & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodLocalDelivery' }
        & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodMatkahuolto' }
        & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodOmniva' }
        & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPickUpFromStore' }
        & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPosti' }
        & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderShippingInfoMatkahuolto' }
      & Pick<OrderShippingInfoMatkahuolto, 'taxRate'>
      & { price: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )>, originalPrice: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      )>, method: (
        { __typename: 'ShippingMethodEmail' }
        & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodHakonen' }
        & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodLocalDelivery' }
        & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodMatkahuolto' }
        & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodOmniva' }
        & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPickUpFromStore' }
        & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPosti' }
        & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderShippingInfoOmniva' }
      & Pick<OrderShippingInfoOmniva, 'taxRate'>
      & { price: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )>, originalPrice: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      )>, method: (
        { __typename: 'ShippingMethodEmail' }
        & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodHakonen' }
        & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodLocalDelivery' }
        & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodMatkahuolto' }
        & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodOmniva' }
        & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPickUpFromStore' }
        & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPosti' }
        & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderShippingInfoPickUpFromStore' }
      & Pick<OrderShippingInfoPickUpFromStore, 'taxRate'>
      & { outlet: Maybe<(
        { __typename: 'Outlet' }
        & Pick<Outlet, 'id' | 'title' | 'address' | 'city' | 'state' | 'postalCode' | 'location'>
      )>, price: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )>, originalPrice: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      )>, method: (
        { __typename: 'ShippingMethodEmail' }
        & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodHakonen' }
        & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodLocalDelivery' }
        & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodMatkahuolto' }
        & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodOmniva' }
        & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPickUpFromStore' }
        & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPosti' }
        & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    ) | (
      { __typename: 'OrderShippingInfoPosti' }
      & Pick<OrderShippingInfoPosti, 'taxRate'>
      & { price: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )>, originalPrice: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      )>, method: (
        { __typename: 'ShippingMethodEmail' }
        & Pick<ShippingMethodEmail, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodHakonen' }
        & Pick<ShippingMethodHakonen, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodLocalDelivery' }
        & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodMatkahuolto' }
        & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodOmniva' }
        & Pick<ShippingMethodOmniva, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPickUpFromStore' }
        & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'type'>
      ) | (
        { __typename: 'ShippingMethodPosti' }
        & Pick<ShippingMethodPosti, 'id' | 'title' | 'type'>
      ), data: Array<(
        { __typename: 'OrderData' }
        & Pick<OrderData, 'key' | 'value'>
      )> }
    )>, customer: Maybe<(
      { __typename: 'Customer' }
      & Pick<Customer, 'id' | 'firstName' | 'lastName' | 'email' | 'phone' | 'allowEmailMarketing' | 'allowSmsMarketing' | 'countryCode'>
    )>, company: Maybe<(
      { __typename: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>, totalAmount: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount' | 'currencyCode'>
    )>, taxLines: Array<(
      { __typename: 'OrderTaxLine' }
      & { amount: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ) }
    )>, giftCardOrders: Array<(
      { __typename: 'GiftCardOrder' }
      & Pick<GiftCardOrder, 'id' | 'confirmedAt' | 'createdAt' | 'updatedAt'>
      & { amount: (
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      ) }
    )>, billingAddress: Maybe<(
      { __typename: 'OrderAddress' }
      & Pick<OrderAddress, 'id' | 'firstName' | 'lastName' | 'companyName' | 'businessIdentityCode' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode'>
    )>, shippingAddress: Maybe<(
      { __typename: 'OrderAddress' }
      & Pick<OrderAddress, 'id' | 'firstName' | 'lastName' | 'companyName' | 'businessIdentityCode' | 'phone' | 'address' | 'postalCode' | 'city' | 'countryCode'>
    )>, products: Array<(
      { __typename: 'OrderProduct' }
      & Pick<OrderProduct, 'id' | 'quantity' | 'taxRate'>
      & { price: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), unitPrice: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), discounts: Array<(
        { __typename: 'OrderProductDiscount' }
        & Pick<OrderProductDiscount, 'id'>
        & { amount: (
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        ) }
      )>, product: (
        { __typename: 'SimpleProduct' }
        & Pick<SimpleProduct, 'id' | 'name' | 'title' | 'specification' | 'sku' | 'state'>
        & { listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )>, productClass: Maybe<(
          { __typename: 'ProductClass' }
          & Pick<ProductClass, 'id' | 'title'>
        )>, parentProduct: Maybe<(
          { __typename: 'ConfigurableProduct' }
          & Pick<ConfigurableProduct, 'id'>
        )>, categories: Array<(
          { __typename: 'Category' }
          & Pick<Category, 'id' | 'title'>
        )>, pricing: (
          { __typename: 'ProductPricing' }
          & { price: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )>, originalPrice: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )>, clubPrice: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )> }
        ), inventory: (
          { __typename: 'ProductInventory' }
          & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
        ), cartPromotions: Array<(
          { __typename: 'CartPromotionClubPrice' }
          & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
        ) | (
          { __typename: 'CartPromotionFixedAmountFromCart' }
          & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
        ) | (
          { __typename: 'CartPromotionFixedAmountFromProduct' }
          & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
        ) | (
          { __typename: 'CartPromotionFreeShipping' }
          & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
        ) | (
          { __typename: 'CartPromotionFreebie' }
          & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
        ) | (
          { __typename: 'CartPromotionPercent' }
          & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
          & { percentDiscount: (
            { __typename: 'CartPromotionPercentDiscount' }
            & Pick<CartPromotionPercentDiscount, 'percent'>
          ) }
        ) | (
          { __typename: 'CartPromotionProductCartPromotionPrice' }
          & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
        )> }
      ) }
    )>, availablePaymentMethods: Array<(
      { __typename: 'PaymentMethodAvarda' }
      & Pick<PaymentMethodAvarda, 'paymentType' | 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      & { group: Maybe<(
        { __typename: 'PaymentMethodGroup' }
        & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) | (
      { __typename: 'PaymentMethodAvardaEstonia' }
      & Pick<PaymentMethodAvardaEstonia, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      & { group: Maybe<(
        { __typename: 'PaymentMethodGroup' }
        & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) | (
      { __typename: 'PaymentMethodEsto' }
      & Pick<PaymentMethodEsto, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      & { group: Maybe<(
        { __typename: 'PaymentMethodGroup' }
        & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) | (
      { __typename: 'PaymentMethodHolmbank' }
      & Pick<PaymentMethodHolmbank, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      & { group: Maybe<(
        { __typename: 'PaymentMethodGroup' }
        & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) | (
      { __typename: 'PaymentMethodInbank' }
      & Pick<PaymentMethodInbank, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      & { group: Maybe<(
        { __typename: 'PaymentMethodGroup' }
        & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) | (
      { __typename: 'PaymentMethodMaksekeskus' }
      & Pick<PaymentMethodMaksekeskus, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      & { group: Maybe<(
        { __typename: 'PaymentMethodGroup' }
        & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) | (
      { __typename: 'PaymentMethodMontonio' }
      & Pick<PaymentMethodMontonio, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      & { group: Maybe<(
        { __typename: 'PaymentMethodGroup' }
        & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) | (
      { __typename: 'PaymentMethodPaytrail' }
      & Pick<PaymentMethodPaytrail, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      & { group: Maybe<(
        { __typename: 'PaymentMethodGroup' }
        & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) | (
      { __typename: 'PaymentMethodPaywerk' }
      & Pick<PaymentMethodPaywerk, 'id' | 'title' | 'type' | 'logo' | 'position' | 'description'>
      & { group: Maybe<(
        { __typename: 'PaymentMethodGroup' }
        & Pick<PaymentMethodGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    )> }
  ) }
);

export type ConfigurableProductDataFragment = (
  { __typename: 'ConfigurableProduct' }
  & Pick<ConfigurableProduct, 'id' | 'state' | 'name' | 'shortDescription' | 'description'>
  & { medias: Array<(
    { __typename: 'ProductImage' }
    & Pick<ProductImage, 'isDefault' | 'height' | 'width' | 'shotType' | 'orientation' | 'id' | 'title' | 'url' | 'position'>
  ) | (
    { __typename: 'ProductModel' }
    & Pick<ProductModel, 'id' | 'title' | 'url' | 'position'>
  ) | (
    { __typename: 'ProductVideo' }
    & Pick<ProductVideo, 'id' | 'title' | 'url' | 'position'>
  )>, maskMedias: Array<(
    { __typename: 'ProductMaskMedia' }
    & Pick<ProductMaskMedia, 'id' | 'url' | 'specifier' | 'type'>
    & { linkedOptions: Array<(
      { __typename: 'AttributeOption' }
      & Pick<AttributeOption, 'id'>
    )> }
  )>, assets: Array<(
    { __typename: 'ProductAsset' }
    & Pick<ProductAsset, 'id' | 'title' | 'url' | 'position' | 'type' | 'isMeasurement'>
  )>, seo: (
    { __typename: 'ProductSeo' }
    & Pick<ProductSeo, 'title' | 'slug' | 'keywords' | 'description'>
  ), configuration: (
    { __typename: 'ProductConfiguration' }
    & { attributes: Array<(
      { __typename: 'ProductConfigurableAttribute' }
      & Pick<ProductConfigurableAttribute, 'id'>
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'prefix' | 'suffix' | 'name' | 'code'>
      ), options: Array<(
        { __typename: 'ProductConfigurableAttributeOption' }
        & { option: (
          { __typename: 'AttributeOption' }
          & Pick<AttributeOption, 'id' | 'title' | 'description' | 'color' | 'image'>
        ), products: Array<(
          { __typename: 'SimpleProduct' }
          & Pick<SimpleProduct, 'id'>
        )> }
      )> }
    )>, defaultProduct: Maybe<(
      { __typename: 'SimpleProduct' }
      & Pick<SimpleProduct, 'id' | 'name' | 'sku' | 'title' | 'specification' | 'shortDescription' | 'description' | 'state' | 'brandLogo' | 'brandTitle'>
      & { qaItems: Maybe<Array<(
        { __typename: 'QuestionAndAnswer' }
        & Pick<QuestionAndAnswer, 'question' | 'answer'>
      )>>, seo: (
        { __typename: 'ProductSeo' }
        & Pick<ProductSeo, 'title' | 'slug' | 'keywords' | 'description'>
      ), listingImage: Maybe<(
        { __typename: 'ProductImage' }
        & Pick<ProductImage, 'id' | 'url'>
      )>, mainCategory: Maybe<(
        { __typename: 'Category' }
        & Pick<Category, 'id'>
      )>, categories: Array<(
        { __typename: 'Category' }
        & Pick<Category, 'id' | 'title' | 'position' | 'pimCode'>
        & { parent: Maybe<(
          { __typename: 'Category' }
          & Pick<Category, 'id'>
        )> }
      )>, medias: Array<(
        { __typename: 'ProductImage' }
        & Pick<ProductImage, 'isDefault' | 'height' | 'width' | 'shotType' | 'orientation' | 'id' | 'title' | 'url' | 'position'>
      ) | (
        { __typename: 'ProductModel' }
        & Pick<ProductModel, 'id' | 'title' | 'url' | 'position'>
      ) | (
        { __typename: 'ProductVideo' }
        & Pick<ProductVideo, 'id' | 'title' | 'url' | 'position'>
      )>, brand: Maybe<(
        { __typename: 'Brand' }
        & Pick<Brand, 'id' | 'title' | 'state' | 'logo' | 'url'>
        & { parent: Maybe<(
          { __typename: 'Brand' }
          & Pick<Brand, 'id' | 'title' | 'state' | 'logo' | 'url'>
        )> }
      )>, disclaimers: Array<(
        { __typename: 'ProductDisclaimer' }
        & Pick<ProductDisclaimer, 'id' | 'title' | 'content' | 'contentTitle' | 'titleColor' | 'backgroundColor' | 'textColor' | 'link' | 'state' | 'publishedFrom' | 'publishedTo'>
      )>, parentProduct: Maybe<(
        { __typename: 'ConfigurableProduct' }
        & Pick<ConfigurableProduct, 'id' | 'state' | 'shortDescription'>
      )>, productClass: Maybe<(
        { __typename: 'ProductClass' }
        & Pick<ProductClass, 'id' | 'title'>
      )>, productBadges: Array<(
        { __typename: 'ProductBadge' }
        & Pick<ProductBadge, 'id' | 'title' | 'listingTitle' | 'textColor' | 'backgroundColor' | 'url' | 'icon' | 'position' | 'transparentBackground'>
      )>, assets: Array<(
        { __typename: 'ProductAsset' }
        & Pick<ProductAsset, 'id' | 'title' | 'url' | 'position' | 'type' | 'isMeasurement'>
      )>, dimensions: (
        { __typename: 'ProductDimensions' }
        & Pick<ProductDimensions, 'width' | 'height' | 'depth' | 'weight'>
      ), colorForFilteringAttribute: Array<(
        { __typename: 'ProductColorValue' }
        & Pick<ProductColorValue, 'id'>
        & { color: ProductColorValue['value'] }
        & { attribute: (
          { __typename: 'Attribute' }
          & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
          & { group: Maybe<(
            { __typename: 'AttributeGroup' }
            & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
          )> }
        ) }
      ) | (
        { __typename: 'ProductDateValue' }
        & Pick<ProductDateValue, 'id'>
        & { date: ProductDateValue['value'] }
        & { attribute: (
          { __typename: 'Attribute' }
          & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
          & { group: Maybe<(
            { __typename: 'AttributeGroup' }
            & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
          )> }
        ) }
      ) | (
        { __typename: 'ProductDropdownValue' }
        & Pick<ProductDropdownValue, 'id'>
        & { attribute: (
          { __typename: 'Attribute' }
          & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
          & { group: Maybe<(
            { __typename: 'AttributeGroup' }
            & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
          )> }
        ), dropdown: Maybe<(
          { __typename: 'AttributeOption' }
          & Pick<AttributeOption, 'id' | 'title'>
        )> }
      ) | (
        { __typename: 'ProductMultiselectValue' }
        & Pick<ProductMultiselectValue, 'id'>
        & { attribute: (
          { __typename: 'Attribute' }
          & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
          & { group: Maybe<(
            { __typename: 'AttributeGroup' }
            & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
          )> }
        ), multiselect: Array<(
          { __typename: 'AttributeOption' }
          & Pick<AttributeOption, 'id' | 'title'>
        )> }
      ) | (
        { __typename: 'ProductNumberValue' }
        & Pick<ProductNumberValue, 'id'>
        & { number: ProductNumberValue['value'] }
        & { attribute: (
          { __typename: 'Attribute' }
          & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
          & { group: Maybe<(
            { __typename: 'AttributeGroup' }
            & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
          )> }
        ) }
      ) | (
        { __typename: 'ProductTagsValue' }
        & Pick<ProductTagsValue, 'id'>
        & { tags: ProductTagsValue['value'] }
        & { attribute: (
          { __typename: 'Attribute' }
          & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
          & { group: Maybe<(
            { __typename: 'AttributeGroup' }
            & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
          )> }
        ) }
      ) | (
        { __typename: 'ProductTextValue' }
        & Pick<ProductTextValue, 'id'>
        & { text: ProductTextValue['value'] }
        & { attribute: (
          { __typename: 'Attribute' }
          & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
          & { group: Maybe<(
            { __typename: 'AttributeGroup' }
            & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
          )> }
        ) }
      ) | (
        { __typename: 'ProductTextareaValue' }
        & Pick<ProductTextareaValue, 'id'>
        & { textarea: ProductTextareaValue['value'] }
        & { attribute: (
          { __typename: 'Attribute' }
          & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
          & { group: Maybe<(
            { __typename: 'AttributeGroup' }
            & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
          )> }
        ) }
      ) | (
        { __typename: 'ProductToggleValue' }
        & Pick<ProductToggleValue, 'id'>
        & { toggle: ProductToggleValue['value'] }
        & { attribute: (
          { __typename: 'Attribute' }
          & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
          & { group: Maybe<(
            { __typename: 'AttributeGroup' }
            & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
          )> }
        ) }
      )>, materialsAttribute: Array<(
        { __typename: 'ProductColorValue' }
        & Pick<ProductColorValue, 'id'>
        & { color: ProductColorValue['value'] }
        & { attribute: (
          { __typename: 'Attribute' }
          & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
          & { group: Maybe<(
            { __typename: 'AttributeGroup' }
            & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
          )> }
        ) }
      ) | (
        { __typename: 'ProductDateValue' }
        & Pick<ProductDateValue, 'id'>
        & { date: ProductDateValue['value'] }
        & { attribute: (
          { __typename: 'Attribute' }
          & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
          & { group: Maybe<(
            { __typename: 'AttributeGroup' }
            & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
          )> }
        ) }
      ) | (
        { __typename: 'ProductDropdownValue' }
        & Pick<ProductDropdownValue, 'id'>
        & { attribute: (
          { __typename: 'Attribute' }
          & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
          & { group: Maybe<(
            { __typename: 'AttributeGroup' }
            & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
          )> }
        ), dropdown: Maybe<(
          { __typename: 'AttributeOption' }
          & Pick<AttributeOption, 'id' | 'title'>
        )> }
      ) | (
        { __typename: 'ProductMultiselectValue' }
        & Pick<ProductMultiselectValue, 'id'>
        & { attribute: (
          { __typename: 'Attribute' }
          & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
          & { group: Maybe<(
            { __typename: 'AttributeGroup' }
            & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
          )> }
        ), multiselect: Array<(
          { __typename: 'AttributeOption' }
          & Pick<AttributeOption, 'id' | 'title'>
        )> }
      ) | (
        { __typename: 'ProductNumberValue' }
        & Pick<ProductNumberValue, 'id'>
        & { number: ProductNumberValue['value'] }
        & { attribute: (
          { __typename: 'Attribute' }
          & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
          & { group: Maybe<(
            { __typename: 'AttributeGroup' }
            & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
          )> }
        ) }
      ) | (
        { __typename: 'ProductTagsValue' }
        & Pick<ProductTagsValue, 'id'>
        & { tags: ProductTagsValue['value'] }
        & { attribute: (
          { __typename: 'Attribute' }
          & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
          & { group: Maybe<(
            { __typename: 'AttributeGroup' }
            & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
          )> }
        ) }
      ) | (
        { __typename: 'ProductTextValue' }
        & Pick<ProductTextValue, 'id'>
        & { text: ProductTextValue['value'] }
        & { attribute: (
          { __typename: 'Attribute' }
          & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
          & { group: Maybe<(
            { __typename: 'AttributeGroup' }
            & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
          )> }
        ) }
      ) | (
        { __typename: 'ProductTextareaValue' }
        & Pick<ProductTextareaValue, 'id'>
        & { textarea: ProductTextareaValue['value'] }
        & { attribute: (
          { __typename: 'Attribute' }
          & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
          & { group: Maybe<(
            { __typename: 'AttributeGroup' }
            & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
          )> }
        ) }
      ) | (
        { __typename: 'ProductToggleValue' }
        & Pick<ProductToggleValue, 'id'>
        & { toggle: ProductToggleValue['value'] }
        & { attribute: (
          { __typename: 'Attribute' }
          & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
          & { group: Maybe<(
            { __typename: 'AttributeGroup' }
            & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
          )> }
        ) }
      )>, estimatedShippingPriceRange: (
        { __typename: 'MoneyRange' }
        & { min: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )>, max: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount'>
        )> }
      ), pricing: (
        { __typename: 'ProductPricing' }
        & { lowestPrice: (
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        ), price: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )>, originalPrice: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )>, promotionPrice: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )>, clubPrice: Maybe<(
          { __typename: 'Money' }
          & Pick<Money, 'amount' | 'currencyCode'>
        )> }
      ), inventory: (
        { __typename: 'ProductInventory' }
        & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
      ), outlets: Array<(
        { __typename: 'ProductOutlet' }
        & Pick<ProductOutlet, 'id' | 'availableQuantity' | 'modelQuantity'>
        & { outlet: (
          { __typename: 'Outlet' }
          & Pick<Outlet, 'id' | 'title'>
        ) }
      )>, outletsWithBundling: Array<(
        { __typename: 'ProductOutletStock' }
        & Pick<ProductOutletStock, 'availableQuantity' | 'modelQuantity'>
        & { outlet: (
          { __typename: 'ProductOutletStockOutlet' }
          & Pick<ProductOutletStockOutlet, 'id' | 'title'>
        ) }
      )>, cartPromotions: Array<(
        { __typename: 'CartPromotionClubPrice' }
        & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
      ) | (
        { __typename: 'CartPromotionFixedAmountFromCart' }
        & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
      ) | (
        { __typename: 'CartPromotionFixedAmountFromProduct' }
        & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
      ) | (
        { __typename: 'CartPromotionFreeShipping' }
        & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
      ) | (
        { __typename: 'CartPromotionFreebie' }
        & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
      ) | (
        { __typename: 'CartPromotionPercent' }
        & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
        & { percentDiscount: (
          { __typename: 'CartPromotionPercentDiscount' }
          & Pick<CartPromotionPercentDiscount, 'percent'>
        ) }
      ) | (
        { __typename: 'CartPromotionProductCartPromotionPrice' }
        & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
      )> }
    )>, products: Array<(
      { __typename: 'SimpleProduct' }
      & Pick<SimpleProduct, 'id' | 'sku'>
      & { seo: (
        { __typename: 'ProductSeo' }
        & Pick<ProductSeo, 'slug'>
      ) }
    )> }
  ) }
);

export type MarkerSimpleProductDataFragment = (
  { __typename: 'SimpleProduct' }
  & Pick<SimpleProduct, 'id' | 'title' | 'specification'>
  & { seo: (
    { __typename: 'ProductSeo' }
    & Pick<ProductSeo, 'slug'>
  ), pricing: (
    { __typename: 'ProductPricing' }
    & { price: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount'>
    )>, originalPrice: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount'>
    )> }
  ) }
);

type ProductAttributeData_ProductColorValue_Fragment = (
  { __typename: 'ProductColorValue' }
  & Pick<ProductColorValue, 'id'>
  & { color: ProductColorValue['value'] }
  & { attribute: (
    { __typename: 'Attribute' }
    & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
    & { group: Maybe<(
      { __typename: 'AttributeGroup' }
      & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
    )> }
  ) }
);

type ProductAttributeData_ProductDateValue_Fragment = (
  { __typename: 'ProductDateValue' }
  & Pick<ProductDateValue, 'id'>
  & { date: ProductDateValue['value'] }
  & { attribute: (
    { __typename: 'Attribute' }
    & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
    & { group: Maybe<(
      { __typename: 'AttributeGroup' }
      & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
    )> }
  ) }
);

type ProductAttributeData_ProductDropdownValue_Fragment = (
  { __typename: 'ProductDropdownValue' }
  & Pick<ProductDropdownValue, 'id'>
  & { attribute: (
    { __typename: 'Attribute' }
    & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
    & { group: Maybe<(
      { __typename: 'AttributeGroup' }
      & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
    )> }
  ), dropdown: Maybe<(
    { __typename: 'AttributeOption' }
    & Pick<AttributeOption, 'id' | 'title'>
  )> }
);

type ProductAttributeData_ProductMultiselectValue_Fragment = (
  { __typename: 'ProductMultiselectValue' }
  & Pick<ProductMultiselectValue, 'id'>
  & { attribute: (
    { __typename: 'Attribute' }
    & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
    & { group: Maybe<(
      { __typename: 'AttributeGroup' }
      & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
    )> }
  ), multiselect: Array<(
    { __typename: 'AttributeOption' }
    & Pick<AttributeOption, 'id' | 'title'>
  )> }
);

type ProductAttributeData_ProductNumberValue_Fragment = (
  { __typename: 'ProductNumberValue' }
  & Pick<ProductNumberValue, 'id'>
  & { number: ProductNumberValue['value'] }
  & { attribute: (
    { __typename: 'Attribute' }
    & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
    & { group: Maybe<(
      { __typename: 'AttributeGroup' }
      & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
    )> }
  ) }
);

type ProductAttributeData_ProductTagsValue_Fragment = (
  { __typename: 'ProductTagsValue' }
  & Pick<ProductTagsValue, 'id'>
  & { tags: ProductTagsValue['value'] }
  & { attribute: (
    { __typename: 'Attribute' }
    & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
    & { group: Maybe<(
      { __typename: 'AttributeGroup' }
      & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
    )> }
  ) }
);

type ProductAttributeData_ProductTextValue_Fragment = (
  { __typename: 'ProductTextValue' }
  & Pick<ProductTextValue, 'id'>
  & { text: ProductTextValue['value'] }
  & { attribute: (
    { __typename: 'Attribute' }
    & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
    & { group: Maybe<(
      { __typename: 'AttributeGroup' }
      & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
    )> }
  ) }
);

type ProductAttributeData_ProductTextareaValue_Fragment = (
  { __typename: 'ProductTextareaValue' }
  & Pick<ProductTextareaValue, 'id'>
  & { textarea: ProductTextareaValue['value'] }
  & { attribute: (
    { __typename: 'Attribute' }
    & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
    & { group: Maybe<(
      { __typename: 'AttributeGroup' }
      & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
    )> }
  ) }
);

type ProductAttributeData_ProductToggleValue_Fragment = (
  { __typename: 'ProductToggleValue' }
  & Pick<ProductToggleValue, 'id'>
  & { toggle: ProductToggleValue['value'] }
  & { attribute: (
    { __typename: 'Attribute' }
    & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
    & { group: Maybe<(
      { __typename: 'AttributeGroup' }
      & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
    )> }
  ) }
);

export type ProductAttributeDataFragment = ProductAttributeData_ProductColorValue_Fragment | ProductAttributeData_ProductDateValue_Fragment | ProductAttributeData_ProductDropdownValue_Fragment | ProductAttributeData_ProductMultiselectValue_Fragment | ProductAttributeData_ProductNumberValue_Fragment | ProductAttributeData_ProductTagsValue_Fragment | ProductAttributeData_ProductTextValue_Fragment | ProductAttributeData_ProductTextareaValue_Fragment | ProductAttributeData_ProductToggleValue_Fragment;

type ProductAttributeValueTypes_ProductColorValue_Fragment = (
  { __typename: 'ProductColorValue' }
  & { color: ProductColorValue['value'] }
);

type ProductAttributeValueTypes_ProductDateValue_Fragment = (
  { __typename: 'ProductDateValue' }
  & { date: ProductDateValue['value'] }
);

type ProductAttributeValueTypes_ProductDropdownValue_Fragment = (
  { __typename: 'ProductDropdownValue' }
  & { dropdown: Maybe<(
    { __typename: 'AttributeOption' }
    & Pick<AttributeOption, 'id' | 'title'>
  )> }
);

type ProductAttributeValueTypes_ProductMultiselectValue_Fragment = (
  { __typename: 'ProductMultiselectValue' }
  & { multiselect: Array<(
    { __typename: 'AttributeOption' }
    & Pick<AttributeOption, 'id' | 'title'>
  )> }
);

type ProductAttributeValueTypes_ProductNumberValue_Fragment = (
  { __typename: 'ProductNumberValue' }
  & { number: ProductNumberValue['value'] }
);

type ProductAttributeValueTypes_ProductTagsValue_Fragment = (
  { __typename: 'ProductTagsValue' }
  & { tags: ProductTagsValue['value'] }
);

type ProductAttributeValueTypes_ProductTextValue_Fragment = (
  { __typename: 'ProductTextValue' }
  & { text: ProductTextValue['value'] }
);

type ProductAttributeValueTypes_ProductTextareaValue_Fragment = (
  { __typename: 'ProductTextareaValue' }
  & { textarea: ProductTextareaValue['value'] }
);

type ProductAttributeValueTypes_ProductToggleValue_Fragment = (
  { __typename: 'ProductToggleValue' }
  & { toggle: ProductToggleValue['value'] }
);

export type ProductAttributeValueTypesFragment = ProductAttributeValueTypes_ProductColorValue_Fragment | ProductAttributeValueTypes_ProductDateValue_Fragment | ProductAttributeValueTypes_ProductDropdownValue_Fragment | ProductAttributeValueTypes_ProductMultiselectValue_Fragment | ProductAttributeValueTypes_ProductNumberValue_Fragment | ProductAttributeValueTypes_ProductTagsValue_Fragment | ProductAttributeValueTypes_ProductTextValue_Fragment | ProductAttributeValueTypes_ProductTextareaValue_Fragment | ProductAttributeValueTypes_ProductToggleValue_Fragment;

export type ProductBrandDataFragment = (
  { __typename: 'Brand' }
  & Pick<Brand, 'id' | 'title' | 'state' | 'logo' | 'url'>
);

export type ProductClubPriceDataFragment = (
  { __typename: 'SimpleProduct' }
  & { cartPromotions: Array<(
    { __typename: 'CartPromotionClubPrice' }
    & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
  ) | (
    { __typename: 'CartPromotionFixedAmountFromCart' }
    & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
  ) | (
    { __typename: 'CartPromotionFixedAmountFromProduct' }
    & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
  ) | (
    { __typename: 'CartPromotionFreeShipping' }
    & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
  ) | (
    { __typename: 'CartPromotionFreebie' }
    & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
  ) | (
    { __typename: 'CartPromotionPercent' }
    & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
    & { percentDiscount: (
      { __typename: 'CartPromotionPercentDiscount' }
      & Pick<CartPromotionPercentDiscount, 'percent'>
    ) }
  ) | (
    { __typename: 'CartPromotionProductCartPromotionPrice' }
    & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
  )>, pricing: (
    { __typename: 'ProductPricing' }
    & { price: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount'>
    )>, clubPrice: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount'>
    )> }
  ) }
);

export type ProductInventoryDataFragment = (
  { __typename: 'SimpleProduct' }
  & { inventory: (
    { __typename: 'ProductInventory' }
    & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
  ) }
);

type ProductMediaData_ProductImage_Fragment = (
  { __typename: 'ProductImage' }
  & Pick<ProductImage, 'isDefault' | 'height' | 'width' | 'shotType' | 'orientation' | 'id' | 'title' | 'url' | 'position'>
);

type ProductMediaData_ProductModel_Fragment = (
  { __typename: 'ProductModel' }
  & Pick<ProductModel, 'id' | 'title' | 'url' | 'position'>
);

type ProductMediaData_ProductVideo_Fragment = (
  { __typename: 'ProductVideo' }
  & Pick<ProductVideo, 'id' | 'title' | 'url' | 'position'>
);

export type ProductMediaDataFragment = ProductMediaData_ProductImage_Fragment | ProductMediaData_ProductModel_Fragment | ProductMediaData_ProductVideo_Fragment;

export type SimpleProductCriticalDataFragment = (
  { __typename: 'SimpleProduct' }
  & { pricing: (
    { __typename: 'ProductPricing' }
    & { lowestPrice: (
      { __typename: 'Money' }
      & Pick<Money, 'amount' | 'currencyCode'>
    ), price: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount' | 'currencyCode'>
    )>, originalPrice: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount' | 'currencyCode'>
    )>, promotionPrice: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount' | 'currencyCode'>
    )>, clubPrice: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount' | 'currencyCode'>
    )> }
  ), inventory: (
    { __typename: 'ProductInventory' }
    & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
  ), outlets: Array<(
    { __typename: 'ProductOutlet' }
    & Pick<ProductOutlet, 'id' | 'availableQuantity' | 'modelQuantity'>
    & { outlet: (
      { __typename: 'Outlet' }
      & Pick<Outlet, 'id' | 'title'>
    ) }
  )>, outletsWithBundling: Array<(
    { __typename: 'ProductOutletStock' }
    & Pick<ProductOutletStock, 'availableQuantity' | 'modelQuantity'>
    & { outlet: (
      { __typename: 'ProductOutletStockOutlet' }
      & Pick<ProductOutletStockOutlet, 'id' | 'title'>
    ) }
  )>, cartPromotions: Array<(
    { __typename: 'CartPromotionClubPrice' }
    & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
  ) | (
    { __typename: 'CartPromotionFixedAmountFromCart' }
    & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
  ) | (
    { __typename: 'CartPromotionFixedAmountFromProduct' }
    & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
  ) | (
    { __typename: 'CartPromotionFreeShipping' }
    & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
  ) | (
    { __typename: 'CartPromotionFreebie' }
    & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
  ) | (
    { __typename: 'CartPromotionPercent' }
    & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
    & { percentDiscount: (
      { __typename: 'CartPromotionPercentDiscount' }
      & Pick<CartPromotionPercentDiscount, 'percent'>
    ) }
  ) | (
    { __typename: 'CartPromotionProductCartPromotionPrice' }
    & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
  )> }
);

export type SimpleProductDataFragment = (
  { __typename: 'SimpleProduct' }
  & Pick<SimpleProduct, 'id' | 'name' | 'sku' | 'title' | 'specification' | 'shortDescription' | 'description' | 'state' | 'brandLogo' | 'brandTitle'>
  & { qaItems: Maybe<Array<(
    { __typename: 'QuestionAndAnswer' }
    & Pick<QuestionAndAnswer, 'question' | 'answer'>
  )>>, seo: (
    { __typename: 'ProductSeo' }
    & Pick<ProductSeo, 'title' | 'slug' | 'keywords' | 'description'>
  ), listingImage: Maybe<(
    { __typename: 'ProductImage' }
    & Pick<ProductImage, 'id' | 'url'>
  )>, mainCategory: Maybe<(
    { __typename: 'Category' }
    & Pick<Category, 'id'>
  )>, categories: Array<(
    { __typename: 'Category' }
    & Pick<Category, 'id' | 'title' | 'position' | 'pimCode'>
    & { parent: Maybe<(
      { __typename: 'Category' }
      & Pick<Category, 'id'>
    )> }
  )>, medias: Array<(
    { __typename: 'ProductImage' }
    & Pick<ProductImage, 'isDefault' | 'height' | 'width' | 'shotType' | 'orientation' | 'id' | 'title' | 'url' | 'position'>
  ) | (
    { __typename: 'ProductModel' }
    & Pick<ProductModel, 'id' | 'title' | 'url' | 'position'>
  ) | (
    { __typename: 'ProductVideo' }
    & Pick<ProductVideo, 'id' | 'title' | 'url' | 'position'>
  )>, brand: Maybe<(
    { __typename: 'Brand' }
    & Pick<Brand, 'id' | 'title' | 'state' | 'logo' | 'url'>
    & { parent: Maybe<(
      { __typename: 'Brand' }
      & Pick<Brand, 'id' | 'title' | 'state' | 'logo' | 'url'>
    )> }
  )>, disclaimers: Array<(
    { __typename: 'ProductDisclaimer' }
    & Pick<ProductDisclaimer, 'id' | 'title' | 'content' | 'contentTitle' | 'titleColor' | 'backgroundColor' | 'textColor' | 'link' | 'state' | 'publishedFrom' | 'publishedTo'>
  )>, parentProduct: Maybe<(
    { __typename: 'ConfigurableProduct' }
    & Pick<ConfigurableProduct, 'id' | 'state' | 'shortDescription'>
  )>, productClass: Maybe<(
    { __typename: 'ProductClass' }
    & Pick<ProductClass, 'id' | 'title'>
  )>, productBadges: Array<(
    { __typename: 'ProductBadge' }
    & Pick<ProductBadge, 'id' | 'title' | 'listingTitle' | 'textColor' | 'backgroundColor' | 'url' | 'icon' | 'position' | 'transparentBackground'>
  )>, assets: Array<(
    { __typename: 'ProductAsset' }
    & Pick<ProductAsset, 'id' | 'title' | 'url' | 'position' | 'type' | 'isMeasurement'>
  )>, dimensions: (
    { __typename: 'ProductDimensions' }
    & Pick<ProductDimensions, 'width' | 'height' | 'depth' | 'weight'>
  ), colorForFilteringAttribute: Array<(
    { __typename: 'ProductColorValue' }
    & Pick<ProductColorValue, 'id'>
    & { color: ProductColorValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductDateValue' }
    & Pick<ProductDateValue, 'id'>
    & { date: ProductDateValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductDropdownValue' }
    & Pick<ProductDropdownValue, 'id'>
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ), dropdown: Maybe<(
      { __typename: 'AttributeOption' }
      & Pick<AttributeOption, 'id' | 'title'>
    )> }
  ) | (
    { __typename: 'ProductMultiselectValue' }
    & Pick<ProductMultiselectValue, 'id'>
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ), multiselect: Array<(
      { __typename: 'AttributeOption' }
      & Pick<AttributeOption, 'id' | 'title'>
    )> }
  ) | (
    { __typename: 'ProductNumberValue' }
    & Pick<ProductNumberValue, 'id'>
    & { number: ProductNumberValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductTagsValue' }
    & Pick<ProductTagsValue, 'id'>
    & { tags: ProductTagsValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductTextValue' }
    & Pick<ProductTextValue, 'id'>
    & { text: ProductTextValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductTextareaValue' }
    & Pick<ProductTextareaValue, 'id'>
    & { textarea: ProductTextareaValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductToggleValue' }
    & Pick<ProductToggleValue, 'id'>
    & { toggle: ProductToggleValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  )>, materialsAttribute: Array<(
    { __typename: 'ProductColorValue' }
    & Pick<ProductColorValue, 'id'>
    & { color: ProductColorValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductDateValue' }
    & Pick<ProductDateValue, 'id'>
    & { date: ProductDateValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductDropdownValue' }
    & Pick<ProductDropdownValue, 'id'>
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ), dropdown: Maybe<(
      { __typename: 'AttributeOption' }
      & Pick<AttributeOption, 'id' | 'title'>
    )> }
  ) | (
    { __typename: 'ProductMultiselectValue' }
    & Pick<ProductMultiselectValue, 'id'>
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ), multiselect: Array<(
      { __typename: 'AttributeOption' }
      & Pick<AttributeOption, 'id' | 'title'>
    )> }
  ) | (
    { __typename: 'ProductNumberValue' }
    & Pick<ProductNumberValue, 'id'>
    & { number: ProductNumberValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductTagsValue' }
    & Pick<ProductTagsValue, 'id'>
    & { tags: ProductTagsValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductTextValue' }
    & Pick<ProductTextValue, 'id'>
    & { text: ProductTextValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductTextareaValue' }
    & Pick<ProductTextareaValue, 'id'>
    & { textarea: ProductTextareaValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductToggleValue' }
    & Pick<ProductToggleValue, 'id'>
    & { toggle: ProductToggleValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  )>, estimatedShippingPriceRange: (
    { __typename: 'MoneyRange' }
    & { min: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount'>
    )>, max: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount'>
    )> }
  ), pricing: (
    { __typename: 'ProductPricing' }
    & { lowestPrice: (
      { __typename: 'Money' }
      & Pick<Money, 'amount' | 'currencyCode'>
    ), price: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount' | 'currencyCode'>
    )>, originalPrice: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount' | 'currencyCode'>
    )>, promotionPrice: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount' | 'currencyCode'>
    )>, clubPrice: Maybe<(
      { __typename: 'Money' }
      & Pick<Money, 'amount' | 'currencyCode'>
    )> }
  ), inventory: (
    { __typename: 'ProductInventory' }
    & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
  ), outlets: Array<(
    { __typename: 'ProductOutlet' }
    & Pick<ProductOutlet, 'id' | 'availableQuantity' | 'modelQuantity'>
    & { outlet: (
      { __typename: 'Outlet' }
      & Pick<Outlet, 'id' | 'title'>
    ) }
  )>, outletsWithBundling: Array<(
    { __typename: 'ProductOutletStock' }
    & Pick<ProductOutletStock, 'availableQuantity' | 'modelQuantity'>
    & { outlet: (
      { __typename: 'ProductOutletStockOutlet' }
      & Pick<ProductOutletStockOutlet, 'id' | 'title'>
    ) }
  )>, cartPromotions: Array<(
    { __typename: 'CartPromotionClubPrice' }
    & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
  ) | (
    { __typename: 'CartPromotionFixedAmountFromCart' }
    & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
  ) | (
    { __typename: 'CartPromotionFixedAmountFromProduct' }
    & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
  ) | (
    { __typename: 'CartPromotionFreeShipping' }
    & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
  ) | (
    { __typename: 'CartPromotionFreebie' }
    & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
  ) | (
    { __typename: 'CartPromotionPercent' }
    & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
    & { percentDiscount: (
      { __typename: 'CartPromotionPercentDiscount' }
      & Pick<CartPromotionPercentDiscount, 'percent'>
    ) }
  ) | (
    { __typename: 'CartPromotionProductCartPromotionPrice' }
    & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
  )> }
);

export type SimpleProductDetailsDataFragment = (
  { __typename: 'SimpleProduct' }
  & Pick<SimpleProduct, 'id' | 'description' | 'parcelsAreVisible'>
  & { listingAttributes: Array<(
    { __typename: 'ProductColorValue' }
    & Pick<ProductColorValue, 'id'>
    & { color: ProductColorValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductDateValue' }
    & Pick<ProductDateValue, 'id'>
    & { date: ProductDateValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductDropdownValue' }
    & Pick<ProductDropdownValue, 'id'>
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ), dropdown: Maybe<(
      { __typename: 'AttributeOption' }
      & Pick<AttributeOption, 'id' | 'title'>
    )> }
  ) | (
    { __typename: 'ProductMultiselectValue' }
    & Pick<ProductMultiselectValue, 'id'>
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ), multiselect: Array<(
      { __typename: 'AttributeOption' }
      & Pick<AttributeOption, 'id' | 'title'>
    )> }
  ) | (
    { __typename: 'ProductNumberValue' }
    & Pick<ProductNumberValue, 'id'>
    & { number: ProductNumberValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductTagsValue' }
    & Pick<ProductTagsValue, 'id'>
    & { tags: ProductTagsValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductTextValue' }
    & Pick<ProductTextValue, 'id'>
    & { text: ProductTextValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductTextareaValue' }
    & Pick<ProductTextareaValue, 'id'>
    & { textarea: ProductTextareaValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductToggleValue' }
    & Pick<ProductToggleValue, 'id'>
    & { toggle: ProductToggleValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  )>, attributes: Array<(
    { __typename: 'ProductColorValue' }
    & Pick<ProductColorValue, 'id'>
    & { color: ProductColorValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductDateValue' }
    & Pick<ProductDateValue, 'id'>
    & { date: ProductDateValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductDropdownValue' }
    & Pick<ProductDropdownValue, 'id'>
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ), dropdown: Maybe<(
      { __typename: 'AttributeOption' }
      & Pick<AttributeOption, 'id' | 'title'>
    )> }
  ) | (
    { __typename: 'ProductMultiselectValue' }
    & Pick<ProductMultiselectValue, 'id'>
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ), multiselect: Array<(
      { __typename: 'AttributeOption' }
      & Pick<AttributeOption, 'id' | 'title'>
    )> }
  ) | (
    { __typename: 'ProductNumberValue' }
    & Pick<ProductNumberValue, 'id'>
    & { number: ProductNumberValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductTagsValue' }
    & Pick<ProductTagsValue, 'id'>
    & { tags: ProductTagsValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductTextValue' }
    & Pick<ProductTextValue, 'id'>
    & { text: ProductTextValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductTextareaValue' }
    & Pick<ProductTextareaValue, 'id'>
    & { textarea: ProductTextareaValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  ) | (
    { __typename: 'ProductToggleValue' }
    & Pick<ProductToggleValue, 'id'>
    & { toggle: ProductToggleValue['value'] }
    & { attribute: (
      { __typename: 'Attribute' }
      & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
      & { group: Maybe<(
        { __typename: 'AttributeGroup' }
        & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
      )> }
    ) }
  )>, parcels: Array<(
    { __typename: 'ProductParcel' }
    & Pick<ProductParcel, 'id' | 'number' | 'quantity' | 'productQuantity' | 'height' | 'width' | 'depth' | 'weight' | 'tareWeight' | 'volume'>
  )>, promotions: Array<(
    { __typename: 'CatalogPromotionFixedAmount' }
    & Pick<CatalogPromotionFixedAmount, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
    & { catalogDiscountType: CatalogPromotionFixedAmount['discountType'] }
    & { style: Maybe<(
      { __typename: 'PromotionStyle' }
      & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
      & { mainTheme: (
        { __typename: 'PromotionStyleTheme' }
        & { background: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), text: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), font: (
          { __typename: 'PromotionStyleFontInfo' }
          & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
        ) }
      ), altTheme: Maybe<(
        { __typename: 'PromotionStyleTheme' }
        & { background: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), text: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), font: (
          { __typename: 'PromotionStyleFontInfo' }
          & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
        ) }
      )>, productPage: (
        { __typename: 'PromotionStyleProductPage' }
        & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
      ) }
    )>, catalogFixedAmountDiscount: (
      { __typename: 'CatalogPromotionFixedAmountDiscount' }
      & Pick<CatalogPromotionFixedAmountDiscount, 'amount'>
    ) }
  ) | (
    { __typename: 'CatalogPromotionPercent' }
    & Pick<CatalogPromotionPercent, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
    & { catalogDiscountType: CatalogPromotionPercent['discountType'] }
    & { style: Maybe<(
      { __typename: 'PromotionStyle' }
      & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
      & { mainTheme: (
        { __typename: 'PromotionStyleTheme' }
        & { background: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), text: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), font: (
          { __typename: 'PromotionStyleFontInfo' }
          & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
        ) }
      ), altTheme: Maybe<(
        { __typename: 'PromotionStyleTheme' }
        & { background: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), text: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), font: (
          { __typename: 'PromotionStyleFontInfo' }
          & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
        ) }
      )>, productPage: (
        { __typename: 'PromotionStyleProductPage' }
        & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
      ) }
    )>, catalogPercentDiscount: (
      { __typename: 'CatalogPromotionPercentDiscount' }
      & Pick<CatalogPromotionPercentDiscount, 'percent'>
    ) }
  ) | (
    { __typename: 'CatalogPromotionProductPromotionPrice' }
    & Pick<CatalogPromotionProductPromotionPrice, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
    & { catalogDiscountType: CatalogPromotionProductPromotionPrice['discountType'] }
    & { style: Maybe<(
      { __typename: 'PromotionStyle' }
      & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
      & { mainTheme: (
        { __typename: 'PromotionStyleTheme' }
        & { background: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), text: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), font: (
          { __typename: 'PromotionStyleFontInfo' }
          & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
        ) }
      ), altTheme: Maybe<(
        { __typename: 'PromotionStyleTheme' }
        & { background: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), text: (
          { __typename: 'PromotionStyleColorInfo' }
          & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
        ), font: (
          { __typename: 'PromotionStyleFontInfo' }
          & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
        ) }
      )>, productPage: (
        { __typename: 'PromotionStyleProductPage' }
        & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
      ) }
    )> }
  )>, dimensions: (
    { __typename: 'ProductDimensions' }
    & Pick<ProductDimensions, 'height' | 'width' | 'depth' | 'diameter' | 'weight' | 'volume'>
  ), categories: Array<(
    { __typename: 'Category' }
    & Pick<Category, 'id' | 'title' | 'position' | 'pimCode'>
  )>, brand: Maybe<(
    { __typename: 'Brand' }
    & Pick<Brand, 'id' | 'title' | 'logo' | 'url'>
  )>, cart: (
    { __typename: 'ProductCart' }
    & Pick<ProductCart, 'minAmount' | 'maxAmount' | 'multiplier'>
  ), outlets: Array<(
    { __typename: 'ProductOutlet' }
    & Pick<ProductOutlet, 'id' | 'availableQuantity' | 'modelQuantity'>
    & { outlet: (
      { __typename: 'Outlet' }
      & Pick<Outlet, 'id' | 'title'>
    ) }
  )>, outletsWithBundling: Array<(
    { __typename: 'ProductOutletStock' }
    & Pick<ProductOutletStock, 'availableQuantity' | 'modelQuantity'>
    & { outlet: (
      { __typename: 'ProductOutletStockOutlet' }
      & Pick<ProductOutletStockOutlet, 'id' | 'title'>
    ) }
  )>, productBadges: Array<(
    { __typename: 'ProductBadge' }
    & Pick<ProductBadge, 'id' | 'title' | 'listingTitle' | 'textColor' | 'backgroundColor' | 'url' | 'icon' | 'position' | 'transparentBackground'>
  )> }
);

export type ListSubProductsQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type ListSubProductsQuery = (
  { __typename: 'Query' }
  & { product: (
    { __typename: 'ConfigurableProduct' }
    & Pick<ConfigurableProduct, 'id'>
    & { configuration: (
      { __typename: 'ProductConfiguration' }
      & { attributes: Array<(
        { __typename: 'ProductConfigurableAttribute' }
        & Pick<ProductConfigurableAttribute, 'id'>
        & { attribute: (
          { __typename: 'Attribute' }
          & Pick<Attribute, 'id' | 'title'>
        ), options: Array<(
          { __typename: 'ProductConfigurableAttributeOption' }
          & { option: (
            { __typename: 'AttributeOption' }
            & Pick<AttributeOption, 'id' | 'title'>
          ), products: Array<(
            { __typename: 'SimpleProduct' }
            & Pick<SimpleProduct, 'id'>
          )> }
        )> }
      )>, defaultProduct: Maybe<(
        { __typename: 'SimpleProduct' }
        & Pick<SimpleProduct, 'id'>
      )>, products: Array<(
        { __typename: 'SimpleProduct' }
        & Pick<SimpleProduct, 'id' | 'name' | 'sku'>
        & { listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )>, inventory: (
          { __typename: 'ProductInventory' }
          & Pick<ProductInventory, 'availableQuantity'>
        ), attributes: Array<(
          { __typename: 'ProductColorValue' }
          & Pick<ProductColorValue, 'id'>
          & { color: ProductColorValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'description' | 'showInProductPage'>
          ) }
        ) | (
          { __typename: 'ProductDateValue' }
          & Pick<ProductDateValue, 'id'>
          & { date: ProductDateValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'description' | 'showInProductPage'>
          ) }
        ) | (
          { __typename: 'ProductDropdownValue' }
          & Pick<ProductDropdownValue, 'id'>
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'description' | 'showInProductPage'>
          ), dropdown: Maybe<(
            { __typename: 'AttributeOption' }
            & Pick<AttributeOption, 'id' | 'title'>
          )> }
        ) | (
          { __typename: 'ProductMultiselectValue' }
          & Pick<ProductMultiselectValue, 'id'>
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'description' | 'showInProductPage'>
          ), multiselect: Array<(
            { __typename: 'AttributeOption' }
            & Pick<AttributeOption, 'id' | 'title'>
          )> }
        ) | (
          { __typename: 'ProductNumberValue' }
          & Pick<ProductNumberValue, 'id'>
          & { number: ProductNumberValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'description' | 'showInProductPage'>
          ) }
        ) | (
          { __typename: 'ProductTagsValue' }
          & Pick<ProductTagsValue, 'id'>
          & { tags: ProductTagsValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'description' | 'showInProductPage'>
          ) }
        ) | (
          { __typename: 'ProductTextValue' }
          & Pick<ProductTextValue, 'id'>
          & { text: ProductTextValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'description' | 'showInProductPage'>
          ) }
        ) | (
          { __typename: 'ProductTextareaValue' }
          & Pick<ProductTextareaValue, 'id'>
          & { textarea: ProductTextareaValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'description' | 'showInProductPage'>
          ) }
        ) | (
          { __typename: 'ProductToggleValue' }
          & Pick<ProductToggleValue, 'id'>
          & { toggle: ProductToggleValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'description' | 'showInProductPage'>
          ) }
        )>, pricing: (
          { __typename: 'ProductPricing' }
          & { price: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )> }
        ) }
      )> }
    ) }
  ) | (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) | (
    { __typename: 'SimpleProduct' }
    & Pick<SimpleProduct, 'id'>
  ) }
);

export type ViewMarkerProductsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ViewMarkerProductsQuery = (
  { __typename: 'Query' }
  & { products: (
    { __typename: 'ProductsConnection' }
    & { edges: Array<(
      { __typename: 'ProductsEdge' }
      & { node: (
        { __typename: 'ConfigurableProduct' }
        & Pick<ConfigurableProduct, 'id'>
        & { configuration: (
          { __typename: 'ProductConfiguration' }
          & { defaultProduct: Maybe<(
            { __typename: 'SimpleProduct' }
            & Pick<SimpleProduct, 'id' | 'title' | 'specification'>
            & { seo: (
              { __typename: 'ProductSeo' }
              & Pick<ProductSeo, 'slug'>
            ), pricing: (
              { __typename: 'ProductPricing' }
              & { price: Maybe<(
                { __typename: 'Money' }
                & Pick<Money, 'amount'>
              )>, originalPrice: Maybe<(
                { __typename: 'Money' }
                & Pick<Money, 'amount'>
              )> }
            ) }
          )> }
        ) }
      ) | (
        { __typename: 'SimpleProduct' }
        & Pick<SimpleProduct, 'id' | 'title' | 'specification'>
        & { seo: (
          { __typename: 'ProductSeo' }
          & Pick<ProductSeo, 'slug'>
        ), pricing: (
          { __typename: 'ProductPricing' }
          & { price: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )>, originalPrice: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )> }
        ) }
      ) }
    )> }
  ) }
);

export type ViewProductCriticalQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ViewProductCriticalQuery = (
  { __typename: 'Query' }
  & { product: { __typename: 'ConfigurableProduct' } | { __typename: 'EntityNotFoundError' } | (
    { __typename: 'SimpleProduct' }
    & Pick<SimpleProduct, 'id'>
    & { pricing: (
      { __typename: 'ProductPricing' }
      & { lowestPrice: (
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      ), price: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )>, originalPrice: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )>, promotionPrice: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )>, clubPrice: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )> }
    ), inventory: (
      { __typename: 'ProductInventory' }
      & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
    ), outlets: Array<(
      { __typename: 'ProductOutlet' }
      & Pick<ProductOutlet, 'id' | 'availableQuantity' | 'modelQuantity'>
      & { outlet: (
        { __typename: 'Outlet' }
        & Pick<Outlet, 'id' | 'title'>
      ) }
    )>, outletsWithBundling: Array<(
      { __typename: 'ProductOutletStock' }
      & Pick<ProductOutletStock, 'availableQuantity' | 'modelQuantity'>
      & { outlet: (
        { __typename: 'ProductOutletStockOutlet' }
        & Pick<ProductOutletStockOutlet, 'id' | 'title'>
      ) }
    )>, cartPromotions: Array<(
      { __typename: 'CartPromotionClubPrice' }
      & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
    ) | (
      { __typename: 'CartPromotionFixedAmountFromCart' }
      & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
    ) | (
      { __typename: 'CartPromotionFixedAmountFromProduct' }
      & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
    ) | (
      { __typename: 'CartPromotionFreeShipping' }
      & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
    ) | (
      { __typename: 'CartPromotionFreebie' }
      & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
    ) | (
      { __typename: 'CartPromotionPercent' }
      & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
      & { percentDiscount: (
        { __typename: 'CartPromotionPercentDiscount' }
        & Pick<CartPromotionPercentDiscount, 'percent'>
      ) }
    ) | (
      { __typename: 'CartPromotionProductCartPromotionPrice' }
      & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
    )> }
  ) }
);

export type ViewProductDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ViewProductDetailsQuery = (
  { __typename: 'Query' }
  & { product: { __typename: 'ConfigurableProduct' } | (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) | (
    { __typename: 'SimpleProduct' }
    & Pick<SimpleProduct, 'id' | 'description' | 'parcelsAreVisible'>
    & { listingAttributes: Array<(
      { __typename: 'ProductColorValue' }
      & Pick<ProductColorValue, 'id'>
      & { color: ProductColorValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductDateValue' }
      & Pick<ProductDateValue, 'id'>
      & { date: ProductDateValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductDropdownValue' }
      & Pick<ProductDropdownValue, 'id'>
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ), dropdown: Maybe<(
        { __typename: 'AttributeOption' }
        & Pick<AttributeOption, 'id' | 'title'>
      )> }
    ) | (
      { __typename: 'ProductMultiselectValue' }
      & Pick<ProductMultiselectValue, 'id'>
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ), multiselect: Array<(
        { __typename: 'AttributeOption' }
        & Pick<AttributeOption, 'id' | 'title'>
      )> }
    ) | (
      { __typename: 'ProductNumberValue' }
      & Pick<ProductNumberValue, 'id'>
      & { number: ProductNumberValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductTagsValue' }
      & Pick<ProductTagsValue, 'id'>
      & { tags: ProductTagsValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductTextValue' }
      & Pick<ProductTextValue, 'id'>
      & { text: ProductTextValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductTextareaValue' }
      & Pick<ProductTextareaValue, 'id'>
      & { textarea: ProductTextareaValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductToggleValue' }
      & Pick<ProductToggleValue, 'id'>
      & { toggle: ProductToggleValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    )>, attributes: Array<(
      { __typename: 'ProductColorValue' }
      & Pick<ProductColorValue, 'id'>
      & { color: ProductColorValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductDateValue' }
      & Pick<ProductDateValue, 'id'>
      & { date: ProductDateValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductDropdownValue' }
      & Pick<ProductDropdownValue, 'id'>
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ), dropdown: Maybe<(
        { __typename: 'AttributeOption' }
        & Pick<AttributeOption, 'id' | 'title'>
      )> }
    ) | (
      { __typename: 'ProductMultiselectValue' }
      & Pick<ProductMultiselectValue, 'id'>
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ), multiselect: Array<(
        { __typename: 'AttributeOption' }
        & Pick<AttributeOption, 'id' | 'title'>
      )> }
    ) | (
      { __typename: 'ProductNumberValue' }
      & Pick<ProductNumberValue, 'id'>
      & { number: ProductNumberValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductTagsValue' }
      & Pick<ProductTagsValue, 'id'>
      & { tags: ProductTagsValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductTextValue' }
      & Pick<ProductTextValue, 'id'>
      & { text: ProductTextValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductTextareaValue' }
      & Pick<ProductTextareaValue, 'id'>
      & { textarea: ProductTextareaValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductToggleValue' }
      & Pick<ProductToggleValue, 'id'>
      & { toggle: ProductToggleValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    )>, parcels: Array<(
      { __typename: 'ProductParcel' }
      & Pick<ProductParcel, 'id' | 'number' | 'quantity' | 'productQuantity' | 'height' | 'width' | 'depth' | 'weight' | 'tareWeight' | 'volume'>
    )>, promotions: Array<(
      { __typename: 'CatalogPromotionFixedAmount' }
      & Pick<CatalogPromotionFixedAmount, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
      & { catalogDiscountType: CatalogPromotionFixedAmount['discountType'] }
      & { style: Maybe<(
        { __typename: 'PromotionStyle' }
        & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
        & { mainTheme: (
          { __typename: 'PromotionStyleTheme' }
          & { background: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), text: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), font: (
            { __typename: 'PromotionStyleFontInfo' }
            & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
          ) }
        ), altTheme: Maybe<(
          { __typename: 'PromotionStyleTheme' }
          & { background: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), text: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), font: (
            { __typename: 'PromotionStyleFontInfo' }
            & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
          ) }
        )>, productPage: (
          { __typename: 'PromotionStyleProductPage' }
          & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
        ) }
      )>, catalogFixedAmountDiscount: (
        { __typename: 'CatalogPromotionFixedAmountDiscount' }
        & Pick<CatalogPromotionFixedAmountDiscount, 'amount'>
      ) }
    ) | (
      { __typename: 'CatalogPromotionPercent' }
      & Pick<CatalogPromotionPercent, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
      & { catalogDiscountType: CatalogPromotionPercent['discountType'] }
      & { style: Maybe<(
        { __typename: 'PromotionStyle' }
        & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
        & { mainTheme: (
          { __typename: 'PromotionStyleTheme' }
          & { background: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), text: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), font: (
            { __typename: 'PromotionStyleFontInfo' }
            & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
          ) }
        ), altTheme: Maybe<(
          { __typename: 'PromotionStyleTheme' }
          & { background: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), text: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), font: (
            { __typename: 'PromotionStyleFontInfo' }
            & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
          ) }
        )>, productPage: (
          { __typename: 'PromotionStyleProductPage' }
          & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
        ) }
      )>, catalogPercentDiscount: (
        { __typename: 'CatalogPromotionPercentDiscount' }
        & Pick<CatalogPromotionPercentDiscount, 'percent'>
      ) }
    ) | (
      { __typename: 'CatalogPromotionProductPromotionPrice' }
      & Pick<CatalogPromotionProductPromotionPrice, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
      & { catalogDiscountType: CatalogPromotionProductPromotionPrice['discountType'] }
      & { style: Maybe<(
        { __typename: 'PromotionStyle' }
        & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
        & { mainTheme: (
          { __typename: 'PromotionStyleTheme' }
          & { background: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), text: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), font: (
            { __typename: 'PromotionStyleFontInfo' }
            & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
          ) }
        ), altTheme: Maybe<(
          { __typename: 'PromotionStyleTheme' }
          & { background: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), text: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), font: (
            { __typename: 'PromotionStyleFontInfo' }
            & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
          ) }
        )>, productPage: (
          { __typename: 'PromotionStyleProductPage' }
          & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
        ) }
      )> }
    )>, dimensions: (
      { __typename: 'ProductDimensions' }
      & Pick<ProductDimensions, 'height' | 'width' | 'depth' | 'diameter' | 'weight' | 'volume'>
    ), categories: Array<(
      { __typename: 'Category' }
      & Pick<Category, 'id' | 'title' | 'position' | 'pimCode'>
    )>, brand: Maybe<(
      { __typename: 'Brand' }
      & Pick<Brand, 'id' | 'title' | 'logo' | 'url'>
    )>, cart: (
      { __typename: 'ProductCart' }
      & Pick<ProductCart, 'minAmount' | 'maxAmount' | 'multiplier'>
    ), outlets: Array<(
      { __typename: 'ProductOutlet' }
      & Pick<ProductOutlet, 'id' | 'availableQuantity' | 'modelQuantity'>
      & { outlet: (
        { __typename: 'Outlet' }
        & Pick<Outlet, 'id' | 'title'>
      ) }
    )>, outletsWithBundling: Array<(
      { __typename: 'ProductOutletStock' }
      & Pick<ProductOutletStock, 'availableQuantity' | 'modelQuantity'>
      & { outlet: (
        { __typename: 'ProductOutletStockOutlet' }
        & Pick<ProductOutletStockOutlet, 'id' | 'title'>
      ) }
    )>, productBadges: Array<(
      { __typename: 'ProductBadge' }
      & Pick<ProductBadge, 'id' | 'title' | 'listingTitle' | 'textColor' | 'backgroundColor' | 'url' | 'icon' | 'position' | 'transparentBackground'>
    )> }
  ) }
);

export type ViewProductShippingMethodsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
}>;


export type ViewProductShippingMethodsQuery = (
  { __typename: 'Query' }
  & { product: { __typename: 'ConfigurableProduct' } | (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message'>
  ) | (
    { __typename: 'SimpleProduct' }
    & Pick<SimpleProduct, 'id' | 'isEligibleForFreeShipping'>
    & { availableShippingMethods: Array<(
      { __typename: 'ShippingMethodEmail' }
      & Pick<ShippingMethodEmail, 'id' | 'title' | 'description' | 'position' | 'type'>
      & { originalPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), priceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), freeShippingPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), group: Maybe<(
        { __typename: 'ShippingMethodGroup' }
        & Pick<ShippingMethodGroup, 'id' | 'title' | 'position'>
      )> }
    ) | (
      { __typename: 'ShippingMethodHakonen' }
      & Pick<ShippingMethodHakonen, 'id' | 'title' | 'description' | 'position' | 'type'>
      & { originalPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), priceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), freeShippingPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), group: Maybe<(
        { __typename: 'ShippingMethodGroup' }
        & Pick<ShippingMethodGroup, 'id' | 'title' | 'position'>
      )> }
    ) | (
      { __typename: 'ShippingMethodLocalDelivery' }
      & Pick<ShippingMethodLocalDelivery, 'id' | 'title' | 'description' | 'position' | 'type'>
      & { originalPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), priceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), freeShippingPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), group: Maybe<(
        { __typename: 'ShippingMethodGroup' }
        & Pick<ShippingMethodGroup, 'id' | 'title' | 'position'>
      )> }
    ) | (
      { __typename: 'ShippingMethodMatkahuolto' }
      & Pick<ShippingMethodMatkahuolto, 'id' | 'title' | 'description' | 'position' | 'type'>
      & { originalPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), priceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), freeShippingPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), group: Maybe<(
        { __typename: 'ShippingMethodGroup' }
        & Pick<ShippingMethodGroup, 'id' | 'title' | 'position'>
      )> }
    ) | (
      { __typename: 'ShippingMethodOmniva' }
      & Pick<ShippingMethodOmniva, 'id' | 'title' | 'description' | 'position' | 'type'>
      & { originalPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), priceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), freeShippingPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), group: Maybe<(
        { __typename: 'ShippingMethodGroup' }
        & Pick<ShippingMethodGroup, 'id' | 'title' | 'position'>
      )> }
    ) | (
      { __typename: 'ShippingMethodPickUpFromStore' }
      & Pick<ShippingMethodPickUpFromStore, 'id' | 'title' | 'description' | 'position' | 'type'>
      & { originalPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), priceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), freeShippingPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), group: Maybe<(
        { __typename: 'ShippingMethodGroup' }
        & Pick<ShippingMethodGroup, 'id' | 'title' | 'position'>
      )> }
    ) | (
      { __typename: 'ShippingMethodPosti' }
      & Pick<ShippingMethodPosti, 'id' | 'title' | 'description' | 'position' | 'type'>
      & { originalPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), priceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), freeShippingPriceWithServices: (
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      ), group: Maybe<(
        { __typename: 'ShippingMethodGroup' }
        & Pick<ShippingMethodGroup, 'id' | 'title' | 'position'>
      )> }
    )> }
  ) }
);

export type ViewProductQueryVariables = Exact<{
  slug: Scalars['NonEmptyString']['input'];
}>;


export type ViewProductQuery = (
  { __typename: 'Query' }
  & { product: (
    { __typename: 'ConfigurableProduct' }
    & Pick<ConfigurableProduct, 'id' | 'name' | 'brandLogo' | 'brandTitle' | 'state' | 'shortDescription' | 'description'>
    & { seo: (
      { __typename: 'ProductSeo' }
      & Pick<ProductSeo, 'title' | 'slug' | 'keywords' | 'description'>
    ), properties: Array<(
      { __typename: 'ProductProperty' }
      & Pick<ProductProperty, 'id' | 'title' | 'isRequired'>
      & { options: Array<(
        { __typename: 'ProductPropertyOption' }
        & Pick<ProductPropertyOption, 'id' | 'title' | 'description' | 'color' | 'image'>
      )> }
    )>, assets: Array<(
      { __typename: 'ProductAsset' }
      & Pick<ProductAsset, 'id' | 'title' | 'url' | 'position' | 'type' | 'isMeasurement'>
    )>, brand: Maybe<(
      { __typename: 'Brand' }
      & Pick<Brand, 'id' | 'title' | 'state' | 'logo' | 'url'>
    )>, disclaimers: Array<(
      { __typename: 'ProductDisclaimer' }
      & Pick<ProductDisclaimer, 'id' | 'title' | 'content' | 'contentTitle' | 'titleColor' | 'backgroundColor' | 'textColor' | 'link' | 'state' | 'publishedFrom' | 'publishedTo'>
    )>, productBadges: Array<(
      { __typename: 'ProductBadge' }
      & Pick<ProductBadge, 'id' | 'title' | 'listingTitle' | 'textColor' | 'backgroundColor' | 'url' | 'icon' | 'position' | 'transparentBackground'>
    )>, configuration: (
      { __typename: 'ProductConfiguration' }
      & { defaultProduct: Maybe<(
        { __typename: 'SimpleProduct' }
        & Pick<SimpleProduct, 'id' | 'name' | 'sku' | 'title' | 'specification' | 'shortDescription' | 'description' | 'state' | 'brandLogo' | 'brandTitle' | 'parcelsAreVisible'>
        & { properties: Array<(
          { __typename: 'ProductProperty' }
          & Pick<ProductProperty, 'id' | 'title' | 'isRequired'>
          & { options: Array<(
            { __typename: 'ProductPropertyOption' }
            & Pick<ProductPropertyOption, 'id' | 'title' | 'description' | 'color' | 'image'>
          )> }
        )>, parentProduct: Maybe<(
          { __typename: 'ConfigurableProduct' }
          & Pick<ConfigurableProduct, 'id' | 'state' | 'shortDescription' | 'name' | 'description'>
          & { configuration: (
            { __typename: 'ProductConfiguration' }
            & { defaultProduct: Maybe<(
              { __typename: 'SimpleProduct' }
              & Pick<SimpleProduct, 'id' | 'description' | 'parcelsAreVisible' | 'name' | 'sku' | 'title' | 'specification' | 'shortDescription' | 'state' | 'brandLogo' | 'brandTitle'>
              & { listingAttributes: Array<(
                { __typename: 'ProductColorValue' }
                & Pick<ProductColorValue, 'id'>
                & { color: ProductColorValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductDateValue' }
                & Pick<ProductDateValue, 'id'>
                & { date: ProductDateValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductDropdownValue' }
                & Pick<ProductDropdownValue, 'id'>
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ), dropdown: Maybe<(
                  { __typename: 'AttributeOption' }
                  & Pick<AttributeOption, 'id' | 'title'>
                )> }
              ) | (
                { __typename: 'ProductMultiselectValue' }
                & Pick<ProductMultiselectValue, 'id'>
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ), multiselect: Array<(
                  { __typename: 'AttributeOption' }
                  & Pick<AttributeOption, 'id' | 'title'>
                )> }
              ) | (
                { __typename: 'ProductNumberValue' }
                & Pick<ProductNumberValue, 'id'>
                & { number: ProductNumberValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductTagsValue' }
                & Pick<ProductTagsValue, 'id'>
                & { tags: ProductTagsValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductTextValue' }
                & Pick<ProductTextValue, 'id'>
                & { text: ProductTextValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductTextareaValue' }
                & Pick<ProductTextareaValue, 'id'>
                & { textarea: ProductTextareaValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductToggleValue' }
                & Pick<ProductToggleValue, 'id'>
                & { toggle: ProductToggleValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              )>, attributes: Array<(
                { __typename: 'ProductColorValue' }
                & Pick<ProductColorValue, 'id'>
                & { color: ProductColorValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductDateValue' }
                & Pick<ProductDateValue, 'id'>
                & { date: ProductDateValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductDropdownValue' }
                & Pick<ProductDropdownValue, 'id'>
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ), dropdown: Maybe<(
                  { __typename: 'AttributeOption' }
                  & Pick<AttributeOption, 'id' | 'title'>
                )> }
              ) | (
                { __typename: 'ProductMultiselectValue' }
                & Pick<ProductMultiselectValue, 'id'>
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ), multiselect: Array<(
                  { __typename: 'AttributeOption' }
                  & Pick<AttributeOption, 'id' | 'title'>
                )> }
              ) | (
                { __typename: 'ProductNumberValue' }
                & Pick<ProductNumberValue, 'id'>
                & { number: ProductNumberValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductTagsValue' }
                & Pick<ProductTagsValue, 'id'>
                & { tags: ProductTagsValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductTextValue' }
                & Pick<ProductTextValue, 'id'>
                & { text: ProductTextValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductTextareaValue' }
                & Pick<ProductTextareaValue, 'id'>
                & { textarea: ProductTextareaValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductToggleValue' }
                & Pick<ProductToggleValue, 'id'>
                & { toggle: ProductToggleValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              )>, parcels: Array<(
                { __typename: 'ProductParcel' }
                & Pick<ProductParcel, 'id' | 'number' | 'quantity' | 'productQuantity' | 'height' | 'width' | 'depth' | 'weight' | 'tareWeight' | 'volume'>
              )>, promotions: Array<(
                { __typename: 'CatalogPromotionFixedAmount' }
                & Pick<CatalogPromotionFixedAmount, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
                & { catalogDiscountType: CatalogPromotionFixedAmount['discountType'] }
                & { style: Maybe<(
                  { __typename: 'PromotionStyle' }
                  & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
                  & { mainTheme: (
                    { __typename: 'PromotionStyleTheme' }
                    & { background: (
                      { __typename: 'PromotionStyleColorInfo' }
                      & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                    ), text: (
                      { __typename: 'PromotionStyleColorInfo' }
                      & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                    ), font: (
                      { __typename: 'PromotionStyleFontInfo' }
                      & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                    ) }
                  ), altTheme: Maybe<(
                    { __typename: 'PromotionStyleTheme' }
                    & { background: (
                      { __typename: 'PromotionStyleColorInfo' }
                      & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                    ), text: (
                      { __typename: 'PromotionStyleColorInfo' }
                      & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                    ), font: (
                      { __typename: 'PromotionStyleFontInfo' }
                      & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                    ) }
                  )>, productPage: (
                    { __typename: 'PromotionStyleProductPage' }
                    & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
                  ) }
                )>, catalogFixedAmountDiscount: (
                  { __typename: 'CatalogPromotionFixedAmountDiscount' }
                  & Pick<CatalogPromotionFixedAmountDiscount, 'amount'>
                ) }
              ) | (
                { __typename: 'CatalogPromotionPercent' }
                & Pick<CatalogPromotionPercent, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
                & { catalogDiscountType: CatalogPromotionPercent['discountType'] }
                & { style: Maybe<(
                  { __typename: 'PromotionStyle' }
                  & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
                  & { mainTheme: (
                    { __typename: 'PromotionStyleTheme' }
                    & { background: (
                      { __typename: 'PromotionStyleColorInfo' }
                      & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                    ), text: (
                      { __typename: 'PromotionStyleColorInfo' }
                      & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                    ), font: (
                      { __typename: 'PromotionStyleFontInfo' }
                      & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                    ) }
                  ), altTheme: Maybe<(
                    { __typename: 'PromotionStyleTheme' }
                    & { background: (
                      { __typename: 'PromotionStyleColorInfo' }
                      & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                    ), text: (
                      { __typename: 'PromotionStyleColorInfo' }
                      & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                    ), font: (
                      { __typename: 'PromotionStyleFontInfo' }
                      & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                    ) }
                  )>, productPage: (
                    { __typename: 'PromotionStyleProductPage' }
                    & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
                  ) }
                )>, catalogPercentDiscount: (
                  { __typename: 'CatalogPromotionPercentDiscount' }
                  & Pick<CatalogPromotionPercentDiscount, 'percent'>
                ) }
              ) | (
                { __typename: 'CatalogPromotionProductPromotionPrice' }
                & Pick<CatalogPromotionProductPromotionPrice, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
                & { catalogDiscountType: CatalogPromotionProductPromotionPrice['discountType'] }
                & { style: Maybe<(
                  { __typename: 'PromotionStyle' }
                  & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
                  & { mainTheme: (
                    { __typename: 'PromotionStyleTheme' }
                    & { background: (
                      { __typename: 'PromotionStyleColorInfo' }
                      & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                    ), text: (
                      { __typename: 'PromotionStyleColorInfo' }
                      & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                    ), font: (
                      { __typename: 'PromotionStyleFontInfo' }
                      & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                    ) }
                  ), altTheme: Maybe<(
                    { __typename: 'PromotionStyleTheme' }
                    & { background: (
                      { __typename: 'PromotionStyleColorInfo' }
                      & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                    ), text: (
                      { __typename: 'PromotionStyleColorInfo' }
                      & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                    ), font: (
                      { __typename: 'PromotionStyleFontInfo' }
                      & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                    ) }
                  )>, productPage: (
                    { __typename: 'PromotionStyleProductPage' }
                    & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
                  ) }
                )> }
              )>, dimensions: (
                { __typename: 'ProductDimensions' }
                & Pick<ProductDimensions, 'height' | 'width' | 'depth' | 'diameter' | 'weight' | 'volume'>
              ), categories: Array<(
                { __typename: 'Category' }
                & Pick<Category, 'id' | 'title' | 'position' | 'pimCode'>
                & { parent: Maybe<(
                  { __typename: 'Category' }
                  & Pick<Category, 'id'>
                )> }
              )>, brand: Maybe<(
                { __typename: 'Brand' }
                & Pick<Brand, 'id' | 'title' | 'logo' | 'url' | 'state'>
                & { parent: Maybe<(
                  { __typename: 'Brand' }
                  & Pick<Brand, 'id' | 'title' | 'state' | 'logo' | 'url'>
                )> }
              )>, cart: (
                { __typename: 'ProductCart' }
                & Pick<ProductCart, 'minAmount' | 'maxAmount' | 'multiplier'>
              ), outlets: Array<(
                { __typename: 'ProductOutlet' }
                & Pick<ProductOutlet, 'id' | 'availableQuantity' | 'modelQuantity'>
                & { outlet: (
                  { __typename: 'Outlet' }
                  & Pick<Outlet, 'id' | 'title'>
                ) }
              )>, outletsWithBundling: Array<(
                { __typename: 'ProductOutletStock' }
                & Pick<ProductOutletStock, 'availableQuantity' | 'modelQuantity'>
                & { outlet: (
                  { __typename: 'ProductOutletStockOutlet' }
                  & Pick<ProductOutletStockOutlet, 'id' | 'title'>
                ) }
              )>, productBadges: Array<(
                { __typename: 'ProductBadge' }
                & Pick<ProductBadge, 'id' | 'title' | 'listingTitle' | 'textColor' | 'backgroundColor' | 'url' | 'icon' | 'position' | 'transparentBackground'>
              )>, qaItems: Maybe<Array<(
                { __typename: 'QuestionAndAnswer' }
                & Pick<QuestionAndAnswer, 'question' | 'answer'>
              )>>, seo: (
                { __typename: 'ProductSeo' }
                & Pick<ProductSeo, 'title' | 'slug' | 'keywords' | 'description'>
              ), listingImage: Maybe<(
                { __typename: 'ProductImage' }
                & Pick<ProductImage, 'id' | 'url'>
              )>, mainCategory: Maybe<(
                { __typename: 'Category' }
                & Pick<Category, 'id'>
              )>, medias: Array<(
                { __typename: 'ProductImage' }
                & Pick<ProductImage, 'isDefault' | 'height' | 'width' | 'shotType' | 'orientation' | 'id' | 'title' | 'url' | 'position'>
              ) | (
                { __typename: 'ProductModel' }
                & Pick<ProductModel, 'id' | 'title' | 'url' | 'position'>
              ) | (
                { __typename: 'ProductVideo' }
                & Pick<ProductVideo, 'id' | 'title' | 'url' | 'position'>
              )>, disclaimers: Array<(
                { __typename: 'ProductDisclaimer' }
                & Pick<ProductDisclaimer, 'id' | 'title' | 'content' | 'contentTitle' | 'titleColor' | 'backgroundColor' | 'textColor' | 'link' | 'state' | 'publishedFrom' | 'publishedTo'>
              )>, parentProduct: Maybe<(
                { __typename: 'ConfigurableProduct' }
                & Pick<ConfigurableProduct, 'id' | 'state' | 'shortDescription'>
              )>, productClass: Maybe<(
                { __typename: 'ProductClass' }
                & Pick<ProductClass, 'id' | 'title'>
              )>, assets: Array<(
                { __typename: 'ProductAsset' }
                & Pick<ProductAsset, 'id' | 'title' | 'url' | 'position' | 'type' | 'isMeasurement'>
              )>, colorForFilteringAttribute: Array<(
                { __typename: 'ProductColorValue' }
                & Pick<ProductColorValue, 'id'>
                & { color: ProductColorValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductDateValue' }
                & Pick<ProductDateValue, 'id'>
                & { date: ProductDateValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductDropdownValue' }
                & Pick<ProductDropdownValue, 'id'>
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ), dropdown: Maybe<(
                  { __typename: 'AttributeOption' }
                  & Pick<AttributeOption, 'id' | 'title'>
                )> }
              ) | (
                { __typename: 'ProductMultiselectValue' }
                & Pick<ProductMultiselectValue, 'id'>
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ), multiselect: Array<(
                  { __typename: 'AttributeOption' }
                  & Pick<AttributeOption, 'id' | 'title'>
                )> }
              ) | (
                { __typename: 'ProductNumberValue' }
                & Pick<ProductNumberValue, 'id'>
                & { number: ProductNumberValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductTagsValue' }
                & Pick<ProductTagsValue, 'id'>
                & { tags: ProductTagsValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductTextValue' }
                & Pick<ProductTextValue, 'id'>
                & { text: ProductTextValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductTextareaValue' }
                & Pick<ProductTextareaValue, 'id'>
                & { textarea: ProductTextareaValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductToggleValue' }
                & Pick<ProductToggleValue, 'id'>
                & { toggle: ProductToggleValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              )>, materialsAttribute: Array<(
                { __typename: 'ProductColorValue' }
                & Pick<ProductColorValue, 'id'>
                & { color: ProductColorValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductDateValue' }
                & Pick<ProductDateValue, 'id'>
                & { date: ProductDateValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductDropdownValue' }
                & Pick<ProductDropdownValue, 'id'>
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ), dropdown: Maybe<(
                  { __typename: 'AttributeOption' }
                  & Pick<AttributeOption, 'id' | 'title'>
                )> }
              ) | (
                { __typename: 'ProductMultiselectValue' }
                & Pick<ProductMultiselectValue, 'id'>
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ), multiselect: Array<(
                  { __typename: 'AttributeOption' }
                  & Pick<AttributeOption, 'id' | 'title'>
                )> }
              ) | (
                { __typename: 'ProductNumberValue' }
                & Pick<ProductNumberValue, 'id'>
                & { number: ProductNumberValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductTagsValue' }
                & Pick<ProductTagsValue, 'id'>
                & { tags: ProductTagsValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductTextValue' }
                & Pick<ProductTextValue, 'id'>
                & { text: ProductTextValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductTextareaValue' }
                & Pick<ProductTextareaValue, 'id'>
                & { textarea: ProductTextareaValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              ) | (
                { __typename: 'ProductToggleValue' }
                & Pick<ProductToggleValue, 'id'>
                & { toggle: ProductToggleValue['value'] }
                & { attribute: (
                  { __typename: 'Attribute' }
                  & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
                  & { group: Maybe<(
                    { __typename: 'AttributeGroup' }
                    & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
                  )> }
                ) }
              )>, estimatedShippingPriceRange: (
                { __typename: 'MoneyRange' }
                & { min: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount'>
                )>, max: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount'>
                )> }
              ), pricing: (
                { __typename: 'ProductPricing' }
                & { lowestPrice: (
                  { __typename: 'Money' }
                  & Pick<Money, 'amount' | 'currencyCode'>
                ), price: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount' | 'currencyCode'>
                )>, originalPrice: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount' | 'currencyCode'>
                )>, promotionPrice: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount' | 'currencyCode'>
                )>, clubPrice: Maybe<(
                  { __typename: 'Money' }
                  & Pick<Money, 'amount' | 'currencyCode'>
                )> }
              ), inventory: (
                { __typename: 'ProductInventory' }
                & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
              ), cartPromotions: Array<(
                { __typename: 'CartPromotionClubPrice' }
                & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFixedAmountFromCart' }
                & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFixedAmountFromProduct' }
                & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFreeShipping' }
                & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionFreebie' }
                & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
              ) | (
                { __typename: 'CartPromotionPercent' }
                & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
                & { percentDiscount: (
                  { __typename: 'CartPromotionPercentDiscount' }
                  & Pick<CartPromotionPercentDiscount, 'percent'>
                ) }
              ) | (
                { __typename: 'CartPromotionProductCartPromotionPrice' }
                & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
              )> }
            )>, attributes: Array<(
              { __typename: 'ProductConfigurableAttribute' }
              & Pick<ProductConfigurableAttribute, 'id'>
              & { attribute: (
                { __typename: 'Attribute' }
                & Pick<Attribute, 'id' | 'title' | 'prefix' | 'suffix' | 'name' | 'code'>
              ), options: Array<(
                { __typename: 'ProductConfigurableAttributeOption' }
                & { option: (
                  { __typename: 'AttributeOption' }
                  & Pick<AttributeOption, 'id' | 'title' | 'description' | 'color' | 'image'>
                ), products: Array<(
                  { __typename: 'SimpleProduct' }
                  & Pick<SimpleProduct, 'id'>
                )> }
              )> }
            )>, products: Array<(
              { __typename: 'SimpleProduct' }
              & Pick<SimpleProduct, 'id' | 'sku'>
              & { seo: (
                { __typename: 'ProductSeo' }
                & Pick<ProductSeo, 'slug'>
              ) }
            )> }
          ), medias: Array<(
            { __typename: 'ProductImage' }
            & Pick<ProductImage, 'isDefault' | 'height' | 'width' | 'shotType' | 'orientation' | 'id' | 'title' | 'url' | 'position'>
          ) | (
            { __typename: 'ProductModel' }
            & Pick<ProductModel, 'id' | 'title' | 'url' | 'position'>
          ) | (
            { __typename: 'ProductVideo' }
            & Pick<ProductVideo, 'id' | 'title' | 'url' | 'position'>
          )>, maskMedias: Array<(
            { __typename: 'ProductMaskMedia' }
            & Pick<ProductMaskMedia, 'id' | 'url' | 'specifier' | 'type'>
            & { linkedOptions: Array<(
              { __typename: 'AttributeOption' }
              & Pick<AttributeOption, 'id'>
            )> }
          )>, assets: Array<(
            { __typename: 'ProductAsset' }
            & Pick<ProductAsset, 'id' | 'title' | 'url' | 'position' | 'type' | 'isMeasurement'>
          )>, seo: (
            { __typename: 'ProductSeo' }
            & Pick<ProductSeo, 'title' | 'slug' | 'keywords' | 'description'>
          ) }
        )>, qaItems: Maybe<Array<(
          { __typename: 'QuestionAndAnswer' }
          & Pick<QuestionAndAnswer, 'question' | 'answer'>
        )>>, seo: (
          { __typename: 'ProductSeo' }
          & Pick<ProductSeo, 'title' | 'slug' | 'keywords' | 'description'>
        ), listingImage: Maybe<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'id' | 'url'>
        )>, mainCategory: Maybe<(
          { __typename: 'Category' }
          & Pick<Category, 'id'>
        )>, categories: Array<(
          { __typename: 'Category' }
          & Pick<Category, 'id' | 'title' | 'position' | 'pimCode'>
          & { parent: Maybe<(
            { __typename: 'Category' }
            & Pick<Category, 'id'>
          )> }
        )>, medias: Array<(
          { __typename: 'ProductImage' }
          & Pick<ProductImage, 'isDefault' | 'height' | 'width' | 'shotType' | 'orientation' | 'id' | 'title' | 'url' | 'position'>
        ) | (
          { __typename: 'ProductModel' }
          & Pick<ProductModel, 'id' | 'title' | 'url' | 'position'>
        ) | (
          { __typename: 'ProductVideo' }
          & Pick<ProductVideo, 'id' | 'title' | 'url' | 'position'>
        )>, brand: Maybe<(
          { __typename: 'Brand' }
          & Pick<Brand, 'id' | 'title' | 'logo' | 'url' | 'state'>
          & { parent: Maybe<(
            { __typename: 'Brand' }
            & Pick<Brand, 'id' | 'title' | 'state' | 'logo' | 'url'>
          )> }
        )>, disclaimers: Array<(
          { __typename: 'ProductDisclaimer' }
          & Pick<ProductDisclaimer, 'id' | 'title' | 'content' | 'contentTitle' | 'titleColor' | 'backgroundColor' | 'textColor' | 'link' | 'state' | 'publishedFrom' | 'publishedTo'>
        )>, productClass: Maybe<(
          { __typename: 'ProductClass' }
          & Pick<ProductClass, 'id' | 'title'>
        )>, productBadges: Array<(
          { __typename: 'ProductBadge' }
          & Pick<ProductBadge, 'id' | 'title' | 'listingTitle' | 'textColor' | 'backgroundColor' | 'url' | 'icon' | 'position' | 'transparentBackground'>
        )>, assets: Array<(
          { __typename: 'ProductAsset' }
          & Pick<ProductAsset, 'id' | 'title' | 'url' | 'position' | 'type' | 'isMeasurement'>
        )>, dimensions: (
          { __typename: 'ProductDimensions' }
          & Pick<ProductDimensions, 'height' | 'width' | 'depth' | 'diameter' | 'weight' | 'volume'>
        ), colorForFilteringAttribute: Array<(
          { __typename: 'ProductColorValue' }
          & Pick<ProductColorValue, 'id'>
          & { color: ProductColorValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductDateValue' }
          & Pick<ProductDateValue, 'id'>
          & { date: ProductDateValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductDropdownValue' }
          & Pick<ProductDropdownValue, 'id'>
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ), dropdown: Maybe<(
            { __typename: 'AttributeOption' }
            & Pick<AttributeOption, 'id' | 'title'>
          )> }
        ) | (
          { __typename: 'ProductMultiselectValue' }
          & Pick<ProductMultiselectValue, 'id'>
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ), multiselect: Array<(
            { __typename: 'AttributeOption' }
            & Pick<AttributeOption, 'id' | 'title'>
          )> }
        ) | (
          { __typename: 'ProductNumberValue' }
          & Pick<ProductNumberValue, 'id'>
          & { number: ProductNumberValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductTagsValue' }
          & Pick<ProductTagsValue, 'id'>
          & { tags: ProductTagsValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductTextValue' }
          & Pick<ProductTextValue, 'id'>
          & { text: ProductTextValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductTextareaValue' }
          & Pick<ProductTextareaValue, 'id'>
          & { textarea: ProductTextareaValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductToggleValue' }
          & Pick<ProductToggleValue, 'id'>
          & { toggle: ProductToggleValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        )>, materialsAttribute: Array<(
          { __typename: 'ProductColorValue' }
          & Pick<ProductColorValue, 'id'>
          & { color: ProductColorValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductDateValue' }
          & Pick<ProductDateValue, 'id'>
          & { date: ProductDateValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductDropdownValue' }
          & Pick<ProductDropdownValue, 'id'>
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ), dropdown: Maybe<(
            { __typename: 'AttributeOption' }
            & Pick<AttributeOption, 'id' | 'title'>
          )> }
        ) | (
          { __typename: 'ProductMultiselectValue' }
          & Pick<ProductMultiselectValue, 'id'>
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ), multiselect: Array<(
            { __typename: 'AttributeOption' }
            & Pick<AttributeOption, 'id' | 'title'>
          )> }
        ) | (
          { __typename: 'ProductNumberValue' }
          & Pick<ProductNumberValue, 'id'>
          & { number: ProductNumberValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductTagsValue' }
          & Pick<ProductTagsValue, 'id'>
          & { tags: ProductTagsValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductTextValue' }
          & Pick<ProductTextValue, 'id'>
          & { text: ProductTextValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductTextareaValue' }
          & Pick<ProductTextareaValue, 'id'>
          & { textarea: ProductTextareaValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductToggleValue' }
          & Pick<ProductToggleValue, 'id'>
          & { toggle: ProductToggleValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        )>, estimatedShippingPriceRange: (
          { __typename: 'MoneyRange' }
          & { min: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )>, max: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount'>
          )> }
        ), listingAttributes: Array<(
          { __typename: 'ProductColorValue' }
          & Pick<ProductColorValue, 'id'>
          & { color: ProductColorValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductDateValue' }
          & Pick<ProductDateValue, 'id'>
          & { date: ProductDateValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductDropdownValue' }
          & Pick<ProductDropdownValue, 'id'>
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ), dropdown: Maybe<(
            { __typename: 'AttributeOption' }
            & Pick<AttributeOption, 'id' | 'title'>
          )> }
        ) | (
          { __typename: 'ProductMultiselectValue' }
          & Pick<ProductMultiselectValue, 'id'>
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ), multiselect: Array<(
            { __typename: 'AttributeOption' }
            & Pick<AttributeOption, 'id' | 'title'>
          )> }
        ) | (
          { __typename: 'ProductNumberValue' }
          & Pick<ProductNumberValue, 'id'>
          & { number: ProductNumberValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductTagsValue' }
          & Pick<ProductTagsValue, 'id'>
          & { tags: ProductTagsValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductTextValue' }
          & Pick<ProductTextValue, 'id'>
          & { text: ProductTextValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductTextareaValue' }
          & Pick<ProductTextareaValue, 'id'>
          & { textarea: ProductTextareaValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductToggleValue' }
          & Pick<ProductToggleValue, 'id'>
          & { toggle: ProductToggleValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        )>, attributes: Array<(
          { __typename: 'ProductColorValue' }
          & Pick<ProductColorValue, 'id'>
          & { color: ProductColorValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductDateValue' }
          & Pick<ProductDateValue, 'id'>
          & { date: ProductDateValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductDropdownValue' }
          & Pick<ProductDropdownValue, 'id'>
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ), dropdown: Maybe<(
            { __typename: 'AttributeOption' }
            & Pick<AttributeOption, 'id' | 'title'>
          )> }
        ) | (
          { __typename: 'ProductMultiselectValue' }
          & Pick<ProductMultiselectValue, 'id'>
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ), multiselect: Array<(
            { __typename: 'AttributeOption' }
            & Pick<AttributeOption, 'id' | 'title'>
          )> }
        ) | (
          { __typename: 'ProductNumberValue' }
          & Pick<ProductNumberValue, 'id'>
          & { number: ProductNumberValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductTagsValue' }
          & Pick<ProductTagsValue, 'id'>
          & { tags: ProductTagsValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductTextValue' }
          & Pick<ProductTextValue, 'id'>
          & { text: ProductTextValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductTextareaValue' }
          & Pick<ProductTextareaValue, 'id'>
          & { textarea: ProductTextareaValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        ) | (
          { __typename: 'ProductToggleValue' }
          & Pick<ProductToggleValue, 'id'>
          & { toggle: ProductToggleValue['value'] }
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
            & { group: Maybe<(
              { __typename: 'AttributeGroup' }
              & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
            )> }
          ) }
        )>, parcels: Array<(
          { __typename: 'ProductParcel' }
          & Pick<ProductParcel, 'id' | 'number' | 'quantity' | 'productQuantity' | 'height' | 'width' | 'depth' | 'weight' | 'tareWeight' | 'volume'>
        )>, promotions: Array<(
          { __typename: 'CatalogPromotionFixedAmount' }
          & Pick<CatalogPromotionFixedAmount, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
          & { catalogDiscountType: CatalogPromotionFixedAmount['discountType'] }
          & { style: Maybe<(
            { __typename: 'PromotionStyle' }
            & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
            & { mainTheme: (
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            ), altTheme: Maybe<(
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            )>, productPage: (
              { __typename: 'PromotionStyleProductPage' }
              & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
            ) }
          )>, catalogFixedAmountDiscount: (
            { __typename: 'CatalogPromotionFixedAmountDiscount' }
            & Pick<CatalogPromotionFixedAmountDiscount, 'amount'>
          ) }
        ) | (
          { __typename: 'CatalogPromotionPercent' }
          & Pick<CatalogPromotionPercent, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
          & { catalogDiscountType: CatalogPromotionPercent['discountType'] }
          & { style: Maybe<(
            { __typename: 'PromotionStyle' }
            & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
            & { mainTheme: (
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            ), altTheme: Maybe<(
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            )>, productPage: (
              { __typename: 'PromotionStyleProductPage' }
              & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
            ) }
          )>, catalogPercentDiscount: (
            { __typename: 'CatalogPromotionPercentDiscount' }
            & Pick<CatalogPromotionPercentDiscount, 'percent'>
          ) }
        ) | (
          { __typename: 'CatalogPromotionProductPromotionPrice' }
          & Pick<CatalogPromotionProductPromotionPrice, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
          & { catalogDiscountType: CatalogPromotionProductPromotionPrice['discountType'] }
          & { style: Maybe<(
            { __typename: 'PromotionStyle' }
            & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
            & { mainTheme: (
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            ), altTheme: Maybe<(
              { __typename: 'PromotionStyleTheme' }
              & { background: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), text: (
                { __typename: 'PromotionStyleColorInfo' }
                & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
              ), font: (
                { __typename: 'PromotionStyleFontInfo' }
                & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
              ) }
            )>, productPage: (
              { __typename: 'PromotionStyleProductPage' }
              & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
            ) }
          )> }
        )>, cart: (
          { __typename: 'ProductCart' }
          & Pick<ProductCart, 'minAmount' | 'maxAmount' | 'multiplier'>
        ), outlets: Array<(
          { __typename: 'ProductOutlet' }
          & Pick<ProductOutlet, 'id' | 'availableQuantity' | 'modelQuantity'>
          & { outlet: (
            { __typename: 'Outlet' }
            & Pick<Outlet, 'id' | 'title'>
          ) }
        )>, outletsWithBundling: Array<(
          { __typename: 'ProductOutletStock' }
          & Pick<ProductOutletStock, 'availableQuantity' | 'modelQuantity'>
          & { outlet: (
            { __typename: 'ProductOutletStockOutlet' }
            & Pick<ProductOutletStockOutlet, 'id' | 'title'>
          ) }
        )>, pricing: (
          { __typename: 'ProductPricing' }
          & { lowestPrice: (
            { __typename: 'Money' }
            & Pick<Money, 'amount' | 'currencyCode'>
          ), price: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount' | 'currencyCode'>
          )>, originalPrice: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount' | 'currencyCode'>
          )>, promotionPrice: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount' | 'currencyCode'>
          )>, clubPrice: Maybe<(
            { __typename: 'Money' }
            & Pick<Money, 'amount' | 'currencyCode'>
          )> }
        ), inventory: (
          { __typename: 'ProductInventory' }
          & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
        ), cartPromotions: Array<(
          { __typename: 'CartPromotionClubPrice' }
          & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
        ) | (
          { __typename: 'CartPromotionFixedAmountFromCart' }
          & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
        ) | (
          { __typename: 'CartPromotionFixedAmountFromProduct' }
          & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
        ) | (
          { __typename: 'CartPromotionFreeShipping' }
          & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
        ) | (
          { __typename: 'CartPromotionFreebie' }
          & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
        ) | (
          { __typename: 'CartPromotionPercent' }
          & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
          & { percentDiscount: (
            { __typename: 'CartPromotionPercentDiscount' }
            & Pick<CartPromotionPercentDiscount, 'percent'>
          ) }
        ) | (
          { __typename: 'CartPromotionProductCartPromotionPrice' }
          & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
        )> }
      )>, attributes: Array<(
        { __typename: 'ProductConfigurableAttribute' }
        & Pick<ProductConfigurableAttribute, 'id'>
        & { attribute: (
          { __typename: 'Attribute' }
          & Pick<Attribute, 'id' | 'title' | 'prefix' | 'suffix' | 'name' | 'code'>
        ), options: Array<(
          { __typename: 'ProductConfigurableAttributeOption' }
          & { option: (
            { __typename: 'AttributeOption' }
            & Pick<AttributeOption, 'id' | 'title' | 'description' | 'color' | 'image'>
          ), products: Array<(
            { __typename: 'SimpleProduct' }
            & Pick<SimpleProduct, 'id'>
          )> }
        )> }
      )>, products: Array<(
        { __typename: 'SimpleProduct' }
        & Pick<SimpleProduct, 'id' | 'sku'>
        & { seo: (
          { __typename: 'ProductSeo' }
          & Pick<ProductSeo, 'slug'>
        ) }
      )> }
    ), medias: Array<(
      { __typename: 'ProductImage' }
      & Pick<ProductImage, 'isDefault' | 'height' | 'width' | 'shotType' | 'orientation' | 'id' | 'title' | 'url' | 'position'>
    ) | (
      { __typename: 'ProductModel' }
      & Pick<ProductModel, 'id' | 'title' | 'url' | 'position'>
    ) | (
      { __typename: 'ProductVideo' }
      & Pick<ProductVideo, 'id' | 'title' | 'url' | 'position'>
    )>, maskMedias: Array<(
      { __typename: 'ProductMaskMedia' }
      & Pick<ProductMaskMedia, 'id' | 'url' | 'specifier' | 'type'>
      & { linkedOptions: Array<(
        { __typename: 'AttributeOption' }
        & Pick<AttributeOption, 'id'>
      )> }
    )> }
  ) | (
    { __typename: 'EntityNotFoundError' }
    & Pick<EntityNotFoundError, 'message' | 'isError'>
  ) | (
    { __typename: 'SimpleProduct' }
    & Pick<SimpleProduct, 'id' | 'name' | 'brandLogo' | 'brandTitle' | 'state' | 'sku' | 'title' | 'specification' | 'shortDescription' | 'description' | 'parcelsAreVisible'>
    & { seo: (
      { __typename: 'ProductSeo' }
      & Pick<ProductSeo, 'title' | 'slug' | 'keywords' | 'description'>
    ), properties: Array<(
      { __typename: 'ProductProperty' }
      & Pick<ProductProperty, 'id' | 'title' | 'isRequired'>
      & { options: Array<(
        { __typename: 'ProductPropertyOption' }
        & Pick<ProductPropertyOption, 'id' | 'title' | 'description' | 'color' | 'image'>
      )> }
    )>, assets: Array<(
      { __typename: 'ProductAsset' }
      & Pick<ProductAsset, 'id' | 'title' | 'url' | 'position' | 'type' | 'isMeasurement'>
    )>, brand: Maybe<(
      { __typename: 'Brand' }
      & Pick<Brand, 'id' | 'title' | 'logo' | 'url' | 'state'>
      & { parent: Maybe<(
        { __typename: 'Brand' }
        & Pick<Brand, 'id' | 'title' | 'state' | 'logo' | 'url'>
      )> }
    )>, disclaimers: Array<(
      { __typename: 'ProductDisclaimer' }
      & Pick<ProductDisclaimer, 'id' | 'title' | 'content' | 'contentTitle' | 'titleColor' | 'backgroundColor' | 'textColor' | 'link' | 'state' | 'publishedFrom' | 'publishedTo'>
    )>, productBadges: Array<(
      { __typename: 'ProductBadge' }
      & Pick<ProductBadge, 'id' | 'title' | 'listingTitle' | 'textColor' | 'backgroundColor' | 'url' | 'icon' | 'position' | 'transparentBackground'>
    )>, parentProduct: Maybe<(
      { __typename: 'ConfigurableProduct' }
      & Pick<ConfigurableProduct, 'id' | 'state' | 'shortDescription' | 'name' | 'description'>
      & { configuration: (
        { __typename: 'ProductConfiguration' }
        & { defaultProduct: Maybe<(
          { __typename: 'SimpleProduct' }
          & Pick<SimpleProduct, 'id' | 'description' | 'parcelsAreVisible' | 'name' | 'sku' | 'title' | 'specification' | 'shortDescription' | 'state' | 'brandLogo' | 'brandTitle'>
          & { listingAttributes: Array<(
            { __typename: 'ProductColorValue' }
            & Pick<ProductColorValue, 'id'>
            & { color: ProductColorValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductDateValue' }
            & Pick<ProductDateValue, 'id'>
            & { date: ProductDateValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductDropdownValue' }
            & Pick<ProductDropdownValue, 'id'>
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ), dropdown: Maybe<(
              { __typename: 'AttributeOption' }
              & Pick<AttributeOption, 'id' | 'title'>
            )> }
          ) | (
            { __typename: 'ProductMultiselectValue' }
            & Pick<ProductMultiselectValue, 'id'>
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ), multiselect: Array<(
              { __typename: 'AttributeOption' }
              & Pick<AttributeOption, 'id' | 'title'>
            )> }
          ) | (
            { __typename: 'ProductNumberValue' }
            & Pick<ProductNumberValue, 'id'>
            & { number: ProductNumberValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductTagsValue' }
            & Pick<ProductTagsValue, 'id'>
            & { tags: ProductTagsValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductTextValue' }
            & Pick<ProductTextValue, 'id'>
            & { text: ProductTextValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductTextareaValue' }
            & Pick<ProductTextareaValue, 'id'>
            & { textarea: ProductTextareaValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductToggleValue' }
            & Pick<ProductToggleValue, 'id'>
            & { toggle: ProductToggleValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          )>, attributes: Array<(
            { __typename: 'ProductColorValue' }
            & Pick<ProductColorValue, 'id'>
            & { color: ProductColorValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductDateValue' }
            & Pick<ProductDateValue, 'id'>
            & { date: ProductDateValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductDropdownValue' }
            & Pick<ProductDropdownValue, 'id'>
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ), dropdown: Maybe<(
              { __typename: 'AttributeOption' }
              & Pick<AttributeOption, 'id' | 'title'>
            )> }
          ) | (
            { __typename: 'ProductMultiselectValue' }
            & Pick<ProductMultiselectValue, 'id'>
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ), multiselect: Array<(
              { __typename: 'AttributeOption' }
              & Pick<AttributeOption, 'id' | 'title'>
            )> }
          ) | (
            { __typename: 'ProductNumberValue' }
            & Pick<ProductNumberValue, 'id'>
            & { number: ProductNumberValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductTagsValue' }
            & Pick<ProductTagsValue, 'id'>
            & { tags: ProductTagsValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductTextValue' }
            & Pick<ProductTextValue, 'id'>
            & { text: ProductTextValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductTextareaValue' }
            & Pick<ProductTextareaValue, 'id'>
            & { textarea: ProductTextareaValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductToggleValue' }
            & Pick<ProductToggleValue, 'id'>
            & { toggle: ProductToggleValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          )>, parcels: Array<(
            { __typename: 'ProductParcel' }
            & Pick<ProductParcel, 'id' | 'number' | 'quantity' | 'productQuantity' | 'height' | 'width' | 'depth' | 'weight' | 'tareWeight' | 'volume'>
          )>, promotions: Array<(
            { __typename: 'CatalogPromotionFixedAmount' }
            & Pick<CatalogPromotionFixedAmount, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
            & { catalogDiscountType: CatalogPromotionFixedAmount['discountType'] }
            & { style: Maybe<(
              { __typename: 'PromotionStyle' }
              & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
              & { mainTheme: (
                { __typename: 'PromotionStyleTheme' }
                & { background: (
                  { __typename: 'PromotionStyleColorInfo' }
                  & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                ), text: (
                  { __typename: 'PromotionStyleColorInfo' }
                  & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                ), font: (
                  { __typename: 'PromotionStyleFontInfo' }
                  & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                ) }
              ), altTheme: Maybe<(
                { __typename: 'PromotionStyleTheme' }
                & { background: (
                  { __typename: 'PromotionStyleColorInfo' }
                  & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                ), text: (
                  { __typename: 'PromotionStyleColorInfo' }
                  & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                ), font: (
                  { __typename: 'PromotionStyleFontInfo' }
                  & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                ) }
              )>, productPage: (
                { __typename: 'PromotionStyleProductPage' }
                & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
              ) }
            )>, catalogFixedAmountDiscount: (
              { __typename: 'CatalogPromotionFixedAmountDiscount' }
              & Pick<CatalogPromotionFixedAmountDiscount, 'amount'>
            ) }
          ) | (
            { __typename: 'CatalogPromotionPercent' }
            & Pick<CatalogPromotionPercent, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
            & { catalogDiscountType: CatalogPromotionPercent['discountType'] }
            & { style: Maybe<(
              { __typename: 'PromotionStyle' }
              & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
              & { mainTheme: (
                { __typename: 'PromotionStyleTheme' }
                & { background: (
                  { __typename: 'PromotionStyleColorInfo' }
                  & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                ), text: (
                  { __typename: 'PromotionStyleColorInfo' }
                  & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                ), font: (
                  { __typename: 'PromotionStyleFontInfo' }
                  & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                ) }
              ), altTheme: Maybe<(
                { __typename: 'PromotionStyleTheme' }
                & { background: (
                  { __typename: 'PromotionStyleColorInfo' }
                  & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                ), text: (
                  { __typename: 'PromotionStyleColorInfo' }
                  & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                ), font: (
                  { __typename: 'PromotionStyleFontInfo' }
                  & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                ) }
              )>, productPage: (
                { __typename: 'PromotionStyleProductPage' }
                & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
              ) }
            )>, catalogPercentDiscount: (
              { __typename: 'CatalogPromotionPercentDiscount' }
              & Pick<CatalogPromotionPercentDiscount, 'percent'>
            ) }
          ) | (
            { __typename: 'CatalogPromotionProductPromotionPrice' }
            & Pick<CatalogPromotionProductPromotionPrice, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
            & { catalogDiscountType: CatalogPromotionProductPromotionPrice['discountType'] }
            & { style: Maybe<(
              { __typename: 'PromotionStyle' }
              & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
              & { mainTheme: (
                { __typename: 'PromotionStyleTheme' }
                & { background: (
                  { __typename: 'PromotionStyleColorInfo' }
                  & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                ), text: (
                  { __typename: 'PromotionStyleColorInfo' }
                  & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                ), font: (
                  { __typename: 'PromotionStyleFontInfo' }
                  & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                ) }
              ), altTheme: Maybe<(
                { __typename: 'PromotionStyleTheme' }
                & { background: (
                  { __typename: 'PromotionStyleColorInfo' }
                  & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                ), text: (
                  { __typename: 'PromotionStyleColorInfo' }
                  & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
                ), font: (
                  { __typename: 'PromotionStyleFontInfo' }
                  & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
                ) }
              )>, productPage: (
                { __typename: 'PromotionStyleProductPage' }
                & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
              ) }
            )> }
          )>, dimensions: (
            { __typename: 'ProductDimensions' }
            & Pick<ProductDimensions, 'height' | 'width' | 'depth' | 'diameter' | 'weight' | 'volume'>
          ), categories: Array<(
            { __typename: 'Category' }
            & Pick<Category, 'id' | 'title' | 'position' | 'pimCode'>
            & { parent: Maybe<(
              { __typename: 'Category' }
              & Pick<Category, 'id'>
            )> }
          )>, brand: Maybe<(
            { __typename: 'Brand' }
            & Pick<Brand, 'id' | 'title' | 'logo' | 'url' | 'state'>
            & { parent: Maybe<(
              { __typename: 'Brand' }
              & Pick<Brand, 'id' | 'title' | 'state' | 'logo' | 'url'>
            )> }
          )>, cart: (
            { __typename: 'ProductCart' }
            & Pick<ProductCart, 'minAmount' | 'maxAmount' | 'multiplier'>
          ), outlets: Array<(
            { __typename: 'ProductOutlet' }
            & Pick<ProductOutlet, 'id' | 'availableQuantity' | 'modelQuantity'>
            & { outlet: (
              { __typename: 'Outlet' }
              & Pick<Outlet, 'id' | 'title'>
            ) }
          )>, outletsWithBundling: Array<(
            { __typename: 'ProductOutletStock' }
            & Pick<ProductOutletStock, 'availableQuantity' | 'modelQuantity'>
            & { outlet: (
              { __typename: 'ProductOutletStockOutlet' }
              & Pick<ProductOutletStockOutlet, 'id' | 'title'>
            ) }
          )>, productBadges: Array<(
            { __typename: 'ProductBadge' }
            & Pick<ProductBadge, 'id' | 'title' | 'listingTitle' | 'textColor' | 'backgroundColor' | 'url' | 'icon' | 'position' | 'transparentBackground'>
          )>, qaItems: Maybe<Array<(
            { __typename: 'QuestionAndAnswer' }
            & Pick<QuestionAndAnswer, 'question' | 'answer'>
          )>>, seo: (
            { __typename: 'ProductSeo' }
            & Pick<ProductSeo, 'title' | 'slug' | 'keywords' | 'description'>
          ), listingImage: Maybe<(
            { __typename: 'ProductImage' }
            & Pick<ProductImage, 'id' | 'url'>
          )>, mainCategory: Maybe<(
            { __typename: 'Category' }
            & Pick<Category, 'id'>
          )>, medias: Array<(
            { __typename: 'ProductImage' }
            & Pick<ProductImage, 'isDefault' | 'height' | 'width' | 'shotType' | 'orientation' | 'id' | 'title' | 'url' | 'position'>
          ) | (
            { __typename: 'ProductModel' }
            & Pick<ProductModel, 'id' | 'title' | 'url' | 'position'>
          ) | (
            { __typename: 'ProductVideo' }
            & Pick<ProductVideo, 'id' | 'title' | 'url' | 'position'>
          )>, disclaimers: Array<(
            { __typename: 'ProductDisclaimer' }
            & Pick<ProductDisclaimer, 'id' | 'title' | 'content' | 'contentTitle' | 'titleColor' | 'backgroundColor' | 'textColor' | 'link' | 'state' | 'publishedFrom' | 'publishedTo'>
          )>, parentProduct: Maybe<(
            { __typename: 'ConfigurableProduct' }
            & Pick<ConfigurableProduct, 'id' | 'state' | 'shortDescription'>
          )>, productClass: Maybe<(
            { __typename: 'ProductClass' }
            & Pick<ProductClass, 'id' | 'title'>
          )>, assets: Array<(
            { __typename: 'ProductAsset' }
            & Pick<ProductAsset, 'id' | 'title' | 'url' | 'position' | 'type' | 'isMeasurement'>
          )>, colorForFilteringAttribute: Array<(
            { __typename: 'ProductColorValue' }
            & Pick<ProductColorValue, 'id'>
            & { color: ProductColorValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductDateValue' }
            & Pick<ProductDateValue, 'id'>
            & { date: ProductDateValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductDropdownValue' }
            & Pick<ProductDropdownValue, 'id'>
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ), dropdown: Maybe<(
              { __typename: 'AttributeOption' }
              & Pick<AttributeOption, 'id' | 'title'>
            )> }
          ) | (
            { __typename: 'ProductMultiselectValue' }
            & Pick<ProductMultiselectValue, 'id'>
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ), multiselect: Array<(
              { __typename: 'AttributeOption' }
              & Pick<AttributeOption, 'id' | 'title'>
            )> }
          ) | (
            { __typename: 'ProductNumberValue' }
            & Pick<ProductNumberValue, 'id'>
            & { number: ProductNumberValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductTagsValue' }
            & Pick<ProductTagsValue, 'id'>
            & { tags: ProductTagsValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductTextValue' }
            & Pick<ProductTextValue, 'id'>
            & { text: ProductTextValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductTextareaValue' }
            & Pick<ProductTextareaValue, 'id'>
            & { textarea: ProductTextareaValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductToggleValue' }
            & Pick<ProductToggleValue, 'id'>
            & { toggle: ProductToggleValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          )>, materialsAttribute: Array<(
            { __typename: 'ProductColorValue' }
            & Pick<ProductColorValue, 'id'>
            & { color: ProductColorValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductDateValue' }
            & Pick<ProductDateValue, 'id'>
            & { date: ProductDateValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductDropdownValue' }
            & Pick<ProductDropdownValue, 'id'>
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ), dropdown: Maybe<(
              { __typename: 'AttributeOption' }
              & Pick<AttributeOption, 'id' | 'title'>
            )> }
          ) | (
            { __typename: 'ProductMultiselectValue' }
            & Pick<ProductMultiselectValue, 'id'>
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ), multiselect: Array<(
              { __typename: 'AttributeOption' }
              & Pick<AttributeOption, 'id' | 'title'>
            )> }
          ) | (
            { __typename: 'ProductNumberValue' }
            & Pick<ProductNumberValue, 'id'>
            & { number: ProductNumberValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductTagsValue' }
            & Pick<ProductTagsValue, 'id'>
            & { tags: ProductTagsValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductTextValue' }
            & Pick<ProductTextValue, 'id'>
            & { text: ProductTextValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductTextareaValue' }
            & Pick<ProductTextareaValue, 'id'>
            & { textarea: ProductTextareaValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          ) | (
            { __typename: 'ProductToggleValue' }
            & Pick<ProductToggleValue, 'id'>
            & { toggle: ProductToggleValue['value'] }
            & { attribute: (
              { __typename: 'Attribute' }
              & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
              & { group: Maybe<(
                { __typename: 'AttributeGroup' }
                & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
              )> }
            ) }
          )>, estimatedShippingPriceRange: (
            { __typename: 'MoneyRange' }
            & { min: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )>, max: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount'>
            )> }
          ), pricing: (
            { __typename: 'ProductPricing' }
            & { lowestPrice: (
              { __typename: 'Money' }
              & Pick<Money, 'amount' | 'currencyCode'>
            ), price: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount' | 'currencyCode'>
            )>, originalPrice: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount' | 'currencyCode'>
            )>, promotionPrice: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount' | 'currencyCode'>
            )>, clubPrice: Maybe<(
              { __typename: 'Money' }
              & Pick<Money, 'amount' | 'currencyCode'>
            )> }
          ), inventory: (
            { __typename: 'ProductInventory' }
            & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
          ), cartPromotions: Array<(
            { __typename: 'CartPromotionClubPrice' }
            & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromCart' }
            & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFixedAmountFromProduct' }
            & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFreeShipping' }
            & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionFreebie' }
            & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
          ) | (
            { __typename: 'CartPromotionPercent' }
            & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
            & { percentDiscount: (
              { __typename: 'CartPromotionPercentDiscount' }
              & Pick<CartPromotionPercentDiscount, 'percent'>
            ) }
          ) | (
            { __typename: 'CartPromotionProductCartPromotionPrice' }
            & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
          )> }
        )>, attributes: Array<(
          { __typename: 'ProductConfigurableAttribute' }
          & Pick<ProductConfigurableAttribute, 'id'>
          & { attribute: (
            { __typename: 'Attribute' }
            & Pick<Attribute, 'id' | 'title' | 'prefix' | 'suffix' | 'name' | 'code'>
          ), options: Array<(
            { __typename: 'ProductConfigurableAttributeOption' }
            & { option: (
              { __typename: 'AttributeOption' }
              & Pick<AttributeOption, 'id' | 'title' | 'description' | 'color' | 'image'>
            ), products: Array<(
              { __typename: 'SimpleProduct' }
              & Pick<SimpleProduct, 'id'>
            )> }
          )> }
        )>, products: Array<(
          { __typename: 'SimpleProduct' }
          & Pick<SimpleProduct, 'id' | 'sku'>
          & { seo: (
            { __typename: 'ProductSeo' }
            & Pick<ProductSeo, 'slug'>
          ) }
        )> }
      ), medias: Array<(
        { __typename: 'ProductImage' }
        & Pick<ProductImage, 'isDefault' | 'height' | 'width' | 'shotType' | 'orientation' | 'id' | 'title' | 'url' | 'position'>
      ) | (
        { __typename: 'ProductModel' }
        & Pick<ProductModel, 'id' | 'title' | 'url' | 'position'>
      ) | (
        { __typename: 'ProductVideo' }
        & Pick<ProductVideo, 'id' | 'title' | 'url' | 'position'>
      )>, maskMedias: Array<(
        { __typename: 'ProductMaskMedia' }
        & Pick<ProductMaskMedia, 'id' | 'url' | 'specifier' | 'type'>
        & { linkedOptions: Array<(
          { __typename: 'AttributeOption' }
          & Pick<AttributeOption, 'id'>
        )> }
      )>, assets: Array<(
        { __typename: 'ProductAsset' }
        & Pick<ProductAsset, 'id' | 'title' | 'url' | 'position' | 'type' | 'isMeasurement'>
      )>, seo: (
        { __typename: 'ProductSeo' }
        & Pick<ProductSeo, 'title' | 'slug' | 'keywords' | 'description'>
      ) }
    )>, qaItems: Maybe<Array<(
      { __typename: 'QuestionAndAnswer' }
      & Pick<QuestionAndAnswer, 'question' | 'answer'>
    )>>, listingImage: Maybe<(
      { __typename: 'ProductImage' }
      & Pick<ProductImage, 'id' | 'url'>
    )>, mainCategory: Maybe<(
      { __typename: 'Category' }
      & Pick<Category, 'id'>
    )>, categories: Array<(
      { __typename: 'Category' }
      & Pick<Category, 'id' | 'title' | 'position' | 'pimCode'>
      & { parent: Maybe<(
        { __typename: 'Category' }
        & Pick<Category, 'id'>
      )> }
    )>, medias: Array<(
      { __typename: 'ProductImage' }
      & Pick<ProductImage, 'isDefault' | 'height' | 'width' | 'shotType' | 'orientation' | 'id' | 'title' | 'url' | 'position'>
    ) | (
      { __typename: 'ProductModel' }
      & Pick<ProductModel, 'id' | 'title' | 'url' | 'position'>
    ) | (
      { __typename: 'ProductVideo' }
      & Pick<ProductVideo, 'id' | 'title' | 'url' | 'position'>
    )>, productClass: Maybe<(
      { __typename: 'ProductClass' }
      & Pick<ProductClass, 'id' | 'title'>
    )>, dimensions: (
      { __typename: 'ProductDimensions' }
      & Pick<ProductDimensions, 'height' | 'width' | 'depth' | 'diameter' | 'weight' | 'volume'>
    ), colorForFilteringAttribute: Array<(
      { __typename: 'ProductColorValue' }
      & Pick<ProductColorValue, 'id'>
      & { color: ProductColorValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductDateValue' }
      & Pick<ProductDateValue, 'id'>
      & { date: ProductDateValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductDropdownValue' }
      & Pick<ProductDropdownValue, 'id'>
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ), dropdown: Maybe<(
        { __typename: 'AttributeOption' }
        & Pick<AttributeOption, 'id' | 'title'>
      )> }
    ) | (
      { __typename: 'ProductMultiselectValue' }
      & Pick<ProductMultiselectValue, 'id'>
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ), multiselect: Array<(
        { __typename: 'AttributeOption' }
        & Pick<AttributeOption, 'id' | 'title'>
      )> }
    ) | (
      { __typename: 'ProductNumberValue' }
      & Pick<ProductNumberValue, 'id'>
      & { number: ProductNumberValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductTagsValue' }
      & Pick<ProductTagsValue, 'id'>
      & { tags: ProductTagsValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductTextValue' }
      & Pick<ProductTextValue, 'id'>
      & { text: ProductTextValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductTextareaValue' }
      & Pick<ProductTextareaValue, 'id'>
      & { textarea: ProductTextareaValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductToggleValue' }
      & Pick<ProductToggleValue, 'id'>
      & { toggle: ProductToggleValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    )>, materialsAttribute: Array<(
      { __typename: 'ProductColorValue' }
      & Pick<ProductColorValue, 'id'>
      & { color: ProductColorValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductDateValue' }
      & Pick<ProductDateValue, 'id'>
      & { date: ProductDateValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductDropdownValue' }
      & Pick<ProductDropdownValue, 'id'>
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ), dropdown: Maybe<(
        { __typename: 'AttributeOption' }
        & Pick<AttributeOption, 'id' | 'title'>
      )> }
    ) | (
      { __typename: 'ProductMultiselectValue' }
      & Pick<ProductMultiselectValue, 'id'>
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ), multiselect: Array<(
        { __typename: 'AttributeOption' }
        & Pick<AttributeOption, 'id' | 'title'>
      )> }
    ) | (
      { __typename: 'ProductNumberValue' }
      & Pick<ProductNumberValue, 'id'>
      & { number: ProductNumberValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductTagsValue' }
      & Pick<ProductTagsValue, 'id'>
      & { tags: ProductTagsValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductTextValue' }
      & Pick<ProductTextValue, 'id'>
      & { text: ProductTextValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductTextareaValue' }
      & Pick<ProductTextareaValue, 'id'>
      & { textarea: ProductTextareaValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductToggleValue' }
      & Pick<ProductToggleValue, 'id'>
      & { toggle: ProductToggleValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    )>, estimatedShippingPriceRange: (
      { __typename: 'MoneyRange' }
      & { min: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      )>, max: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount'>
      )> }
    ), listingAttributes: Array<(
      { __typename: 'ProductColorValue' }
      & Pick<ProductColorValue, 'id'>
      & { color: ProductColorValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductDateValue' }
      & Pick<ProductDateValue, 'id'>
      & { date: ProductDateValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductDropdownValue' }
      & Pick<ProductDropdownValue, 'id'>
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ), dropdown: Maybe<(
        { __typename: 'AttributeOption' }
        & Pick<AttributeOption, 'id' | 'title'>
      )> }
    ) | (
      { __typename: 'ProductMultiselectValue' }
      & Pick<ProductMultiselectValue, 'id'>
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ), multiselect: Array<(
        { __typename: 'AttributeOption' }
        & Pick<AttributeOption, 'id' | 'title'>
      )> }
    ) | (
      { __typename: 'ProductNumberValue' }
      & Pick<ProductNumberValue, 'id'>
      & { number: ProductNumberValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductTagsValue' }
      & Pick<ProductTagsValue, 'id'>
      & { tags: ProductTagsValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductTextValue' }
      & Pick<ProductTextValue, 'id'>
      & { text: ProductTextValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductTextareaValue' }
      & Pick<ProductTextareaValue, 'id'>
      & { textarea: ProductTextareaValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductToggleValue' }
      & Pick<ProductToggleValue, 'id'>
      & { toggle: ProductToggleValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    )>, attributes: Array<(
      { __typename: 'ProductColorValue' }
      & Pick<ProductColorValue, 'id'>
      & { color: ProductColorValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductDateValue' }
      & Pick<ProductDateValue, 'id'>
      & { date: ProductDateValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductDropdownValue' }
      & Pick<ProductDropdownValue, 'id'>
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ), dropdown: Maybe<(
        { __typename: 'AttributeOption' }
        & Pick<AttributeOption, 'id' | 'title'>
      )> }
    ) | (
      { __typename: 'ProductMultiselectValue' }
      & Pick<ProductMultiselectValue, 'id'>
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ), multiselect: Array<(
        { __typename: 'AttributeOption' }
        & Pick<AttributeOption, 'id' | 'title'>
      )> }
    ) | (
      { __typename: 'ProductNumberValue' }
      & Pick<ProductNumberValue, 'id'>
      & { number: ProductNumberValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductTagsValue' }
      & Pick<ProductTagsValue, 'id'>
      & { tags: ProductTagsValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductTextValue' }
      & Pick<ProductTextValue, 'id'>
      & { text: ProductTextValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductTextareaValue' }
      & Pick<ProductTextareaValue, 'id'>
      & { textarea: ProductTextareaValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    ) | (
      { __typename: 'ProductToggleValue' }
      & Pick<ProductToggleValue, 'id'>
      & { toggle: ProductToggleValue['value'] }
      & { attribute: (
        { __typename: 'Attribute' }
        & Pick<Attribute, 'id' | 'title' | 'name' | 'prefix' | 'suffix'>
        & { group: Maybe<(
          { __typename: 'AttributeGroup' }
          & Pick<AttributeGroup, 'id' | 'title' | 'description' | 'position'>
        )> }
      ) }
    )>, parcels: Array<(
      { __typename: 'ProductParcel' }
      & Pick<ProductParcel, 'id' | 'number' | 'quantity' | 'productQuantity' | 'height' | 'width' | 'depth' | 'weight' | 'tareWeight' | 'volume'>
    )>, promotions: Array<(
      { __typename: 'CatalogPromotionFixedAmount' }
      & Pick<CatalogPromotionFixedAmount, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
      & { catalogDiscountType: CatalogPromotionFixedAmount['discountType'] }
      & { style: Maybe<(
        { __typename: 'PromotionStyle' }
        & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
        & { mainTheme: (
          { __typename: 'PromotionStyleTheme' }
          & { background: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), text: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), font: (
            { __typename: 'PromotionStyleFontInfo' }
            & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
          ) }
        ), altTheme: Maybe<(
          { __typename: 'PromotionStyleTheme' }
          & { background: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), text: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), font: (
            { __typename: 'PromotionStyleFontInfo' }
            & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
          ) }
        )>, productPage: (
          { __typename: 'PromotionStyleProductPage' }
          & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
        ) }
      )>, catalogFixedAmountDiscount: (
        { __typename: 'CatalogPromotionFixedAmountDiscount' }
        & Pick<CatalogPromotionFixedAmountDiscount, 'amount'>
      ) }
    ) | (
      { __typename: 'CatalogPromotionPercent' }
      & Pick<CatalogPromotionPercent, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
      & { catalogDiscountType: CatalogPromotionPercent['discountType'] }
      & { style: Maybe<(
        { __typename: 'PromotionStyle' }
        & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
        & { mainTheme: (
          { __typename: 'PromotionStyleTheme' }
          & { background: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), text: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), font: (
            { __typename: 'PromotionStyleFontInfo' }
            & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
          ) }
        ), altTheme: Maybe<(
          { __typename: 'PromotionStyleTheme' }
          & { background: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), text: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), font: (
            { __typename: 'PromotionStyleFontInfo' }
            & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
          ) }
        )>, productPage: (
          { __typename: 'PromotionStyleProductPage' }
          & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
        ) }
      )>, catalogPercentDiscount: (
        { __typename: 'CatalogPromotionPercentDiscount' }
        & Pick<CatalogPromotionPercentDiscount, 'percent'>
      ) }
    ) | (
      { __typename: 'CatalogPromotionProductPromotionPrice' }
      & Pick<CatalogPromotionProductPromotionPrice, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
      & { catalogDiscountType: CatalogPromotionProductPromotionPrice['discountType'] }
      & { style: Maybe<(
        { __typename: 'PromotionStyle' }
        & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
        & { mainTheme: (
          { __typename: 'PromotionStyleTheme' }
          & { background: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), text: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), font: (
            { __typename: 'PromotionStyleFontInfo' }
            & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
          ) }
        ), altTheme: Maybe<(
          { __typename: 'PromotionStyleTheme' }
          & { background: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), text: (
            { __typename: 'PromotionStyleColorInfo' }
            & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
          ), font: (
            { __typename: 'PromotionStyleFontInfo' }
            & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
          ) }
        )>, productPage: (
          { __typename: 'PromotionStyleProductPage' }
          & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
        ) }
      )> }
    )>, cart: (
      { __typename: 'ProductCart' }
      & Pick<ProductCart, 'minAmount' | 'maxAmount' | 'multiplier'>
    ), outlets: Array<(
      { __typename: 'ProductOutlet' }
      & Pick<ProductOutlet, 'id' | 'availableQuantity' | 'modelQuantity'>
      & { outlet: (
        { __typename: 'Outlet' }
        & Pick<Outlet, 'id' | 'title'>
      ) }
    )>, outletsWithBundling: Array<(
      { __typename: 'ProductOutletStock' }
      & Pick<ProductOutletStock, 'availableQuantity' | 'modelQuantity'>
      & { outlet: (
        { __typename: 'ProductOutletStockOutlet' }
        & Pick<ProductOutletStockOutlet, 'id' | 'title'>
      ) }
    )>, pricing: (
      { __typename: 'ProductPricing' }
      & { lowestPrice: (
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      ), price: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )>, originalPrice: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )>, promotionPrice: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )>, clubPrice: Maybe<(
        { __typename: 'Money' }
        & Pick<Money, 'amount' | 'currencyCode'>
      )> }
    ), inventory: (
      { __typename: 'ProductInventory' }
      & Pick<ProductInventory, 'availableQuantity' | 'state' | 'useInventoryTracking' | 'deliveryEstimateDays' | 'isAvailableForPurchase' | 'expectedShipmentDate' | 'isGiftCard'>
    ), cartPromotions: Array<(
      { __typename: 'CartPromotionClubPrice' }
      & Pick<CartPromotionClubPrice, 'id' | 'discountType' | 'requiresLogin'>
    ) | (
      { __typename: 'CartPromotionFixedAmountFromCart' }
      & Pick<CartPromotionFixedAmountFromCart, 'id' | 'discountType' | 'requiresLogin'>
    ) | (
      { __typename: 'CartPromotionFixedAmountFromProduct' }
      & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'discountType' | 'requiresLogin'>
    ) | (
      { __typename: 'CartPromotionFreeShipping' }
      & Pick<CartPromotionFreeShipping, 'id' | 'discountType' | 'requiresLogin'>
    ) | (
      { __typename: 'CartPromotionFreebie' }
      & Pick<CartPromotionFreebie, 'id' | 'discountType' | 'requiresLogin'>
    ) | (
      { __typename: 'CartPromotionPercent' }
      & Pick<CartPromotionPercent, 'id' | 'discountType' | 'requiresLogin'>
      & { percentDiscount: (
        { __typename: 'CartPromotionPercentDiscount' }
        & Pick<CartPromotionPercentDiscount, 'percent'>
      ) }
    ) | (
      { __typename: 'CartPromotionProductCartPromotionPrice' }
      & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'discountType' | 'requiresLogin'>
    )> }
  ) }
);

export type ListPromotionsForPriorityListQueryVariables = Exact<{
  type: PromotionType;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListPromotionsForPriorityListQuery = (
  { __typename: 'Query' }
  & { promotions: (
    { __typename: 'PromotionsConnection' }
    & Pick<PromotionsConnection, 'totalCount'>
    & { pageInfo: (
      { __typename: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'endCursor'>
    ), edges: Array<(
      { __typename: 'PromotionsEdge' }
      & { node: (
        { __typename: 'CartPromotionClubPrice' }
        & Pick<CartPromotionClubPrice, 'id' | 'name' | 'createdAt' | 'priority' | 'isSticky' | 'activeFrom' | 'activeTo' | 'state' | 'continueProcessing'>
      ) | (
        { __typename: 'CartPromotionFixedAmountFromCart' }
        & Pick<CartPromotionFixedAmountFromCart, 'id' | 'name' | 'createdAt' | 'priority' | 'isSticky' | 'activeFrom' | 'activeTo' | 'state' | 'continueProcessing'>
      ) | (
        { __typename: 'CartPromotionFixedAmountFromProduct' }
        & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'name' | 'createdAt' | 'priority' | 'isSticky' | 'activeFrom' | 'activeTo' | 'state' | 'continueProcessing'>
      ) | (
        { __typename: 'CartPromotionFreeShipping' }
        & Pick<CartPromotionFreeShipping, 'id' | 'name' | 'createdAt' | 'priority' | 'isSticky' | 'activeFrom' | 'activeTo' | 'state' | 'continueProcessing'>
      ) | (
        { __typename: 'CartPromotionFreebie' }
        & Pick<CartPromotionFreebie, 'id' | 'name' | 'createdAt' | 'priority' | 'isSticky' | 'activeFrom' | 'activeTo' | 'state' | 'continueProcessing'>
      ) | (
        { __typename: 'CartPromotionPercent' }
        & Pick<CartPromotionPercent, 'id' | 'name' | 'createdAt' | 'priority' | 'isSticky' | 'activeFrom' | 'activeTo' | 'state' | 'continueProcessing'>
      ) | (
        { __typename: 'CartPromotionProductCartPromotionPrice' }
        & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'name' | 'createdAt' | 'priority' | 'isSticky' | 'activeFrom' | 'activeTo' | 'state' | 'continueProcessing'>
      ) | (
        { __typename: 'CatalogPromotionFixedAmount' }
        & Pick<CatalogPromotionFixedAmount, 'id' | 'name' | 'createdAt' | 'priority' | 'isSticky' | 'activeFrom' | 'activeTo' | 'state' | 'continueProcessing'>
      ) | (
        { __typename: 'CatalogPromotionPercent' }
        & Pick<CatalogPromotionPercent, 'id' | 'name' | 'createdAt' | 'priority' | 'isSticky' | 'activeFrom' | 'activeTo' | 'state' | 'continueProcessing'>
      ) | (
        { __typename: 'CatalogPromotionProductPromotionPrice' }
        & Pick<CatalogPromotionProductPromotionPrice, 'id' | 'name' | 'createdAt' | 'priority' | 'isSticky' | 'activeFrom' | 'activeTo' | 'state' | 'continueProcessing'>
      ) }
    )> }
  ) }
);

type PromotionData_CartPromotionClubPrice_Fragment = (
  { __typename: 'CartPromotionClubPrice' }
  & Pick<CartPromotionClubPrice, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
);

type PromotionData_CartPromotionFixedAmountFromCart_Fragment = (
  { __typename: 'CartPromotionFixedAmountFromCart' }
  & Pick<CartPromotionFixedAmountFromCart, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
);

type PromotionData_CartPromotionFixedAmountFromProduct_Fragment = (
  { __typename: 'CartPromotionFixedAmountFromProduct' }
  & Pick<CartPromotionFixedAmountFromProduct, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
);

type PromotionData_CartPromotionFreeShipping_Fragment = (
  { __typename: 'CartPromotionFreeShipping' }
  & Pick<CartPromotionFreeShipping, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
);

type PromotionData_CartPromotionFreebie_Fragment = (
  { __typename: 'CartPromotionFreebie' }
  & Pick<CartPromotionFreebie, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
);

type PromotionData_CartPromotionPercent_Fragment = (
  { __typename: 'CartPromotionPercent' }
  & Pick<CartPromotionPercent, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
);

type PromotionData_CartPromotionProductCartPromotionPrice_Fragment = (
  { __typename: 'CartPromotionProductCartPromotionPrice' }
  & Pick<CartPromotionProductCartPromotionPrice, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
);

type PromotionData_CatalogPromotionFixedAmount_Fragment = (
  { __typename: 'CatalogPromotionFixedAmount' }
  & Pick<CatalogPromotionFixedAmount, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
  & { catalogDiscountType: CatalogPromotionFixedAmount['discountType'] }
  & { style: Maybe<(
    { __typename: 'PromotionStyle' }
    & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
    & { mainTheme: (
      { __typename: 'PromotionStyleTheme' }
      & { background: (
        { __typename: 'PromotionStyleColorInfo' }
        & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
      ), text: (
        { __typename: 'PromotionStyleColorInfo' }
        & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
      ), font: (
        { __typename: 'PromotionStyleFontInfo' }
        & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
      ) }
    ), altTheme: Maybe<(
      { __typename: 'PromotionStyleTheme' }
      & { background: (
        { __typename: 'PromotionStyleColorInfo' }
        & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
      ), text: (
        { __typename: 'PromotionStyleColorInfo' }
        & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
      ), font: (
        { __typename: 'PromotionStyleFontInfo' }
        & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
      ) }
    )>, productPage: (
      { __typename: 'PromotionStyleProductPage' }
      & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
    ) }
  )>, catalogFixedAmountDiscount: (
    { __typename: 'CatalogPromotionFixedAmountDiscount' }
    & Pick<CatalogPromotionFixedAmountDiscount, 'amount'>
  ) }
);

type PromotionData_CatalogPromotionPercent_Fragment = (
  { __typename: 'CatalogPromotionPercent' }
  & Pick<CatalogPromotionPercent, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
  & { catalogDiscountType: CatalogPromotionPercent['discountType'] }
  & { style: Maybe<(
    { __typename: 'PromotionStyle' }
    & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
    & { mainTheme: (
      { __typename: 'PromotionStyleTheme' }
      & { background: (
        { __typename: 'PromotionStyleColorInfo' }
        & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
      ), text: (
        { __typename: 'PromotionStyleColorInfo' }
        & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
      ), font: (
        { __typename: 'PromotionStyleFontInfo' }
        & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
      ) }
    ), altTheme: Maybe<(
      { __typename: 'PromotionStyleTheme' }
      & { background: (
        { __typename: 'PromotionStyleColorInfo' }
        & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
      ), text: (
        { __typename: 'PromotionStyleColorInfo' }
        & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
      ), font: (
        { __typename: 'PromotionStyleFontInfo' }
        & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
      ) }
    )>, productPage: (
      { __typename: 'PromotionStyleProductPage' }
      & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
    ) }
  )>, catalogPercentDiscount: (
    { __typename: 'CatalogPromotionPercentDiscount' }
    & Pick<CatalogPromotionPercentDiscount, 'percent'>
  ) }
);

type PromotionData_CatalogPromotionProductPromotionPrice_Fragment = (
  { __typename: 'CatalogPromotionProductPromotionPrice' }
  & Pick<CatalogPromotionProductPromotionPrice, 'id' | 'name' | 'title' | 'priority' | 'activeTo'>
  & { catalogDiscountType: CatalogPromotionProductPromotionPrice['discountType'] }
  & { style: Maybe<(
    { __typename: 'PromotionStyle' }
    & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
    & { mainTheme: (
      { __typename: 'PromotionStyleTheme' }
      & { background: (
        { __typename: 'PromotionStyleColorInfo' }
        & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
      ), text: (
        { __typename: 'PromotionStyleColorInfo' }
        & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
      ), font: (
        { __typename: 'PromotionStyleFontInfo' }
        & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
      ) }
    ), altTheme: Maybe<(
      { __typename: 'PromotionStyleTheme' }
      & { background: (
        { __typename: 'PromotionStyleColorInfo' }
        & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
      ), text: (
        { __typename: 'PromotionStyleColorInfo' }
        & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
      ), font: (
        { __typename: 'PromotionStyleFontInfo' }
        & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
      ) }
    )>, productPage: (
      { __typename: 'PromotionStyleProductPage' }
      & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
    ) }
  )> }
);

export type PromotionDataFragment = PromotionData_CartPromotionClubPrice_Fragment | PromotionData_CartPromotionFixedAmountFromCart_Fragment | PromotionData_CartPromotionFixedAmountFromProduct_Fragment | PromotionData_CartPromotionFreeShipping_Fragment | PromotionData_CartPromotionFreebie_Fragment | PromotionData_CartPromotionPercent_Fragment | PromotionData_CartPromotionProductCartPromotionPrice_Fragment | PromotionData_CatalogPromotionFixedAmount_Fragment | PromotionData_CatalogPromotionPercent_Fragment | PromotionData_CatalogPromotionProductPromotionPrice_Fragment;

export type PromotionStyleDataFragment = (
  { __typename: 'PromotionStyle' }
  & Pick<PromotionStyle, 'id' | 'type' | 'content' | 'altContent' | 'title' | 'mirrored'>
  & { mainTheme: (
    { __typename: 'PromotionStyleTheme' }
    & { background: (
      { __typename: 'PromotionStyleColorInfo' }
      & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
    ), text: (
      { __typename: 'PromotionStyleColorInfo' }
      & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
    ), font: (
      { __typename: 'PromotionStyleFontInfo' }
      & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
    ) }
  ), altTheme: Maybe<(
    { __typename: 'PromotionStyleTheme' }
    & { background: (
      { __typename: 'PromotionStyleColorInfo' }
      & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
    ), text: (
      { __typename: 'PromotionStyleColorInfo' }
      & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
    ), font: (
      { __typename: 'PromotionStyleFontInfo' }
      & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
    ) }
  )>, productPage: (
    { __typename: 'PromotionStyleProductPage' }
    & Pick<PromotionStyleProductPage, 'hidePriceHistory' | 'showPromotionEndingTimer' | 'showCountdownTextContent' | 'promotionTimerContent' | 'deliveryPricingInfoOverride' | 'omnibusContent' | 'isTimedVisibility' | 'isCampaignModalEnabled' | 'campaignModalContent'>
  ) }
);

export type PromotionStyleThemeDataFragment = (
  { __typename: 'PromotionStyleTheme' }
  & { background: (
    { __typename: 'PromotionStyleColorInfo' }
    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
  ), text: (
    { __typename: 'PromotionStyleColorInfo' }
    & Pick<PromotionStyleColorInfo, 'color' | 'customColor'>
  ), font: (
    { __typename: 'PromotionStyleFontInfo' }
    & Pick<PromotionStyleFontInfo, 'family' | 'size' | 'customSize'>
  ) }
);

export type ViewStoreQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewStoreQuery = (
  { __typename: 'Query' }
  & { currentStore: Maybe<(
    { __typename: 'Store' }
    & Pick<Store, 'id' | 'title' | 'logo'>
  )> }
);

export type ViewMeQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewMeQuery = (
  { __typename: 'Query' }
  & { me: Maybe<(
    { __typename: 'User' }
    & Pick<User, 'id' | 'name' | 'email' | 'picture'>
    & { customer: (
      { __typename: 'Customer' }
      & Pick<Customer, 'id' | 'firstName' | 'lastName' | 'email' | 'allowEmailMarketing' | 'allowSmsMarketing' | 'isFirstTimeSetupDone' | 'requiresEmailVerification'>
    ) }
  )> }
);

export const ProductClubPriceDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductClubPriceData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartPromotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"requiresLogin"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"percentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]} as unknown as DocumentNode<ProductClubPriceDataFragment, unknown>;
export const ProductInventoryDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductInventoryData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"useInventoryTracking"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEstimateDays"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"expectedShipmentDate"}},{"kind":"Field","name":{"kind":"Name","value":"isGiftCard"}}]}}]}}]} as unknown as DocumentNode<ProductInventoryDataFragment, unknown>;
export const CartDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Cart"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productCount"}},{"kind":"Field","name":{"kind":"Name","value":"promotionCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"remainingAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"relatedProductsByCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInventoryData"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recommendedProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInventoryData"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductClubPriceData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartPromotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"requiresLogin"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"percentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductInventoryData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"useInventoryTracking"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEstimateDays"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"expectedShipmentDate"}},{"kind":"Field","name":{"kind":"Name","value":"isGiftCard"}}]}}]}}]} as unknown as DocumentNode<CartDataFragment, unknown>;
export const PromotionStyleThemeDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionStyleThemeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromotionStyleTheme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"customColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"customColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"font"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"family"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"customSize"}}]}}]}}]} as unknown as DocumentNode<PromotionStyleThemeDataFragment, unknown>;
export const PromotionStyleDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionStyleData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromotionStyle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"altContent"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mirrored"}},{"kind":"Field","name":{"kind":"Name","value":"mainTheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleThemeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"altTheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleThemeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hidePriceHistory"}},{"kind":"Field","name":{"kind":"Name","value":"showPromotionEndingTimer"}},{"kind":"Field","name":{"kind":"Name","value":"showCountdownTextContent"}},{"kind":"Field","name":{"kind":"Name","value":"promotionTimerContent"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryPricingInfoOverride"}},{"kind":"Field","name":{"kind":"Name","value":"omnibusContent"}},{"kind":"Field","name":{"kind":"Name","value":"isTimedVisibility"}},{"kind":"Field","name":{"kind":"Name","value":"isCampaignModalEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"campaignModalContent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionStyleThemeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromotionStyleTheme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"customColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"customColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"font"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"family"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"customSize"}}]}}]}}]} as unknown as DocumentNode<PromotionStyleDataFragment, unknown>;
export const PromotionDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Promotion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"activeTo"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"catalogDiscountType"},"name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"catalogPercentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotionFixedAmount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"catalogFixedAmountDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionStyleData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromotionStyle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"altContent"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mirrored"}},{"kind":"Field","name":{"kind":"Name","value":"mainTheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleThemeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"altTheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleThemeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hidePriceHistory"}},{"kind":"Field","name":{"kind":"Name","value":"showPromotionEndingTimer"}},{"kind":"Field","name":{"kind":"Name","value":"showCountdownTextContent"}},{"kind":"Field","name":{"kind":"Name","value":"promotionTimerContent"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryPricingInfoOverride"}},{"kind":"Field","name":{"kind":"Name","value":"omnibusContent"}},{"kind":"Field","name":{"kind":"Name","value":"isTimedVisibility"}},{"kind":"Field","name":{"kind":"Name","value":"isCampaignModalEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"campaignModalContent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionStyleThemeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromotionStyleTheme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"customColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"customColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"font"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"family"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"customSize"}}]}}]}}]} as unknown as DocumentNode<PromotionDataFragment, unknown>;
export const ListProductDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListProductData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConfigurableProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionData"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Promotion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"activeTo"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"catalogDiscountType"},"name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"catalogPercentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotionFixedAmount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"catalogFixedAmountDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionStyleData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromotionStyle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"altContent"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mirrored"}},{"kind":"Field","name":{"kind":"Name","value":"mainTheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleThemeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"altTheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleThemeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hidePriceHistory"}},{"kind":"Field","name":{"kind":"Name","value":"showPromotionEndingTimer"}},{"kind":"Field","name":{"kind":"Name","value":"showCountdownTextContent"}},{"kind":"Field","name":{"kind":"Name","value":"promotionTimerContent"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryPricingInfoOverride"}},{"kind":"Field","name":{"kind":"Name","value":"omnibusContent"}},{"kind":"Field","name":{"kind":"Name","value":"isTimedVisibility"}},{"kind":"Field","name":{"kind":"Name","value":"isCampaignModalEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"campaignModalContent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionStyleThemeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromotionStyleTheme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"customColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"customColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"font"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"family"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"customSize"}}]}}]}}]} as unknown as DocumentNode<ListProductDataFragment, unknown>;
export const OrderPaymentDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderPaymentData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"method"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentInfoAvarda"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentType"}}]}}]}}]} as unknown as DocumentNode<OrderPaymentDataFragment, unknown>;
export const OrderShippingDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderShippingData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderShippingInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"method"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderShippingInfoPickUpFromStore"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outlet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}}]}}]} as unknown as DocumentNode<OrderShippingDataFragment, unknown>;
export const OrderCustomerDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderCustomerData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Customer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"allowEmailMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"allowSmsMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]} as unknown as DocumentNode<OrderCustomerDataFragment, unknown>;
export const OrderAddressDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAddressData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"businessIdentityCode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]} as unknown as DocumentNode<OrderAddressDataFragment, unknown>;
export const OrderDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderPaymentData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountsAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasFreeShipping"}},{"kind":"Field","name":{"kind":"Name","value":"shipping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderShippingData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderCustomerData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"saleNumber"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEstimate"}},{"kind":"Field","name":{"kind":"Name","value":"originalDeliveryEstimate"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCardOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAddressData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAddressData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInventoryData"}},{"kind":"Field","name":{"kind":"Name","value":"productClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"availablePaymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentMethodAvarda"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentType"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAddressData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"businessIdentityCode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderCustomerData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Customer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"allowEmailMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"allowSmsMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderPaymentData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"method"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentInfoAvarda"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentType"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderShippingData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderShippingInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"method"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderShippingInfoPickUpFromStore"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outlet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductClubPriceData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartPromotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"requiresLogin"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"percentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductInventoryData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"useInventoryTracking"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEstimateDays"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"expectedShipmentDate"}},{"kind":"Field","name":{"kind":"Name","value":"isGiftCard"}}]}}]}}]} as unknown as DocumentNode<OrderDataFragment, unknown>;
export const CustomerAddressDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerAddressData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"businessIdentityCode"}}]}}]} as unknown as DocumentNode<CustomerAddressDataFragment, unknown>;
export const CustomerDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Customer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"allowEmailMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"allowSmsMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"businessIdentityCode"}}]}}]}}]} as unknown as DocumentNode<CustomerDataFragment, unknown>;
export const ProductMediaDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductMediaData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMedia"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"shotType"}},{"kind":"Field","name":{"kind":"Name","value":"orientation"}}]}}]}}]} as unknown as DocumentNode<ProductMediaDataFragment, unknown>;
export const ProductBrandDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductBrandData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Brand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<ProductBrandDataFragment, unknown>;
export const SimpleProductCriticalDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimpleProductCriticalData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lowestPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotionPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"useInventoryTracking"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEstimateDays"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"expectedShipmentDate"}},{"kind":"Field","name":{"kind":"Name","value":"isGiftCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outlets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"modelQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outletsWithBundling"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outlet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"modelQuantity"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductClubPriceData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartPromotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"requiresLogin"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"percentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]} as unknown as DocumentNode<SimpleProductCriticalDataFragment, unknown>;
export const ProductAttributeValueTypesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAttributeValueTypes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMultiselectValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"multiselect"},"name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDateValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"date"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDropdownValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dropdown"},"name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTextValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTextareaValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"textarea"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductToggleValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"toggle"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTagsValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tags"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductNumberValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"number"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductColorValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<ProductAttributeValueTypesFragment, unknown>;
export const ProductAttributeDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAttributeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"suffix"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAttributeValueTypes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAttributeValueTypes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMultiselectValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"multiselect"},"name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDateValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"date"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDropdownValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dropdown"},"name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTextValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTextareaValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"textarea"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductToggleValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"toggle"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTagsValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tags"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductNumberValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"number"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductColorValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<ProductAttributeDataFragment, unknown>;
export const SimpleProductDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimpleProductData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"qaItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"pimCode"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"medias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductMediaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductBrandData"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductBrandData"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brandLogo"}},{"kind":"Field","name":{"kind":"Name","value":"brandTitle"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"isPublished"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"contentTitle"}},{"kind":"Field","name":{"kind":"Name","value":"titleColor"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"publishedFrom"}},{"kind":"Field","name":{"kind":"Name","value":"publishedTo"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimpleProductCriticalData"}},{"kind":"Field","name":{"kind":"Name","value":"parentProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productBadges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"listingTitle"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"transparentBackground"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMeasurement"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dimensions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"depth"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"colorForFilteringAttribute"},"name":{"kind":"Name","value":"attributes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"StringValue","value":"color_multi","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAttributeData"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"materialsAttribute"},"name":{"kind":"Name","value":"attributes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"StringValue","value":"materials","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAttributeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimatedShippingPriceRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"StringValue","value":"00100","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"cache"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAttributeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"suffix"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAttributeValueTypes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAttributeValueTypes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMultiselectValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"multiselect"},"name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDateValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"date"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDropdownValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dropdown"},"name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTextValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTextareaValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"textarea"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductToggleValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"toggle"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTagsValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tags"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductNumberValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"number"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductColorValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductBrandData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Brand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductClubPriceData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartPromotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"requiresLogin"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"percentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductMediaData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMedia"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"shotType"}},{"kind":"Field","name":{"kind":"Name","value":"orientation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimpleProductCriticalData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lowestPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotionPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"useInventoryTracking"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEstimateDays"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"expectedShipmentDate"}},{"kind":"Field","name":{"kind":"Name","value":"isGiftCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outlets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"modelQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outletsWithBundling"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outlet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"modelQuantity"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}}]}}]} as unknown as DocumentNode<SimpleProductDataFragment, unknown>;
export const ConfigurableProductDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConfigurableProductData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConfigurableProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"medias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductMediaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maskMedias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"specifier"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"linkedOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMeasurement"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"suffix"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"option"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimpleProductData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAttributeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"suffix"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAttributeValueTypes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAttributeValueTypes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMultiselectValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"multiselect"},"name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDateValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"date"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDropdownValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dropdown"},"name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTextValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTextareaValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"textarea"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductToggleValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"toggle"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTagsValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tags"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductNumberValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"number"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductColorValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductBrandData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Brand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductClubPriceData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartPromotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"requiresLogin"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"percentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductMediaData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMedia"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"shotType"}},{"kind":"Field","name":{"kind":"Name","value":"orientation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimpleProductCriticalData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lowestPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotionPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"useInventoryTracking"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEstimateDays"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"expectedShipmentDate"}},{"kind":"Field","name":{"kind":"Name","value":"isGiftCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outlets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"modelQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outletsWithBundling"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outlet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"modelQuantity"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimpleProductData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"qaItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"pimCode"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"medias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductMediaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductBrandData"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductBrandData"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brandLogo"}},{"kind":"Field","name":{"kind":"Name","value":"brandTitle"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"isPublished"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"contentTitle"}},{"kind":"Field","name":{"kind":"Name","value":"titleColor"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"publishedFrom"}},{"kind":"Field","name":{"kind":"Name","value":"publishedTo"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimpleProductCriticalData"}},{"kind":"Field","name":{"kind":"Name","value":"parentProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productBadges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"listingTitle"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"transparentBackground"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMeasurement"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dimensions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"depth"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"colorForFilteringAttribute"},"name":{"kind":"Name","value":"attributes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"StringValue","value":"color_multi","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAttributeData"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"materialsAttribute"},"name":{"kind":"Name","value":"attributes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"StringValue","value":"materials","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAttributeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimatedShippingPriceRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"StringValue","value":"00100","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"cache"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]} as unknown as DocumentNode<ConfigurableProductDataFragment, unknown>;
export const MarkerSimpleProductDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarkerSimpleProductData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]} as unknown as DocumentNode<MarkerSimpleProductDataFragment, unknown>;
export const SimpleProductDetailsDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimpleProductDetailsData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"listingAttributes"},"name":{"kind":"Name","value":"attributes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"showInProductListing"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAttributeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"showInProductPage"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAttributeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parcelsAreVisible"}},{"kind":"Field","name":{"kind":"Name","value":"parcels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"productQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"depth"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"tareWeight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dimensions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"depth"}},{"kind":"Field","name":{"kind":"Name","value":"diameter"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"pimCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outlets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"modelQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outletsWithBundling"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outlet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"modelQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productBadges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"listingTitle"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"transparentBackground"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAttributeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"suffix"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAttributeValueTypes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAttributeValueTypes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMultiselectValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"multiselect"},"name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDateValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"date"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDropdownValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dropdown"},"name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTextValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTextareaValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"textarea"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductToggleValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"toggle"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTagsValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tags"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductNumberValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"number"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductColorValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Promotion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"activeTo"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"catalogDiscountType"},"name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"catalogPercentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotionFixedAmount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"catalogFixedAmountDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionStyleData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromotionStyle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"altContent"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mirrored"}},{"kind":"Field","name":{"kind":"Name","value":"mainTheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleThemeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"altTheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleThemeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hidePriceHistory"}},{"kind":"Field","name":{"kind":"Name","value":"showPromotionEndingTimer"}},{"kind":"Field","name":{"kind":"Name","value":"showCountdownTextContent"}},{"kind":"Field","name":{"kind":"Name","value":"promotionTimerContent"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryPricingInfoOverride"}},{"kind":"Field","name":{"kind":"Name","value":"omnibusContent"}},{"kind":"Field","name":{"kind":"Name","value":"isTimedVisibility"}},{"kind":"Field","name":{"kind":"Name","value":"isCampaignModalEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"campaignModalContent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionStyleThemeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromotionStyleTheme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"customColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"customColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"font"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"family"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"customSize"}}]}}]}}]} as unknown as DocumentNode<SimpleProductDetailsDataFragment, unknown>;
export const ListFilterableAttributesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListFilterableAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"showInCategoryFilter"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListFilterableAttributesQuery, ListFilterableAttributesQueryVariables>;
export const ListBrandProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListBrandProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"CREATED_AT"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListProductData"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListProductData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConfigurableProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionData"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Promotion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"activeTo"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"catalogDiscountType"},"name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"catalogPercentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotionFixedAmount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"catalogFixedAmountDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionStyleData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromotionStyle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"altContent"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mirrored"}},{"kind":"Field","name":{"kind":"Name","value":"mainTheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleThemeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"altTheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleThemeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hidePriceHistory"}},{"kind":"Field","name":{"kind":"Name","value":"showPromotionEndingTimer"}},{"kind":"Field","name":{"kind":"Name","value":"showCountdownTextContent"}},{"kind":"Field","name":{"kind":"Name","value":"promotionTimerContent"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryPricingInfoOverride"}},{"kind":"Field","name":{"kind":"Name","value":"omnibusContent"}},{"kind":"Field","name":{"kind":"Name","value":"isTimedVisibility"}},{"kind":"Field","name":{"kind":"Name","value":"isCampaignModalEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"campaignModalContent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionStyleThemeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromotionStyleTheme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"customColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"customColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"font"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"family"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"customSize"}}]}}]}}]} as unknown as DocumentNode<ListBrandProductsQuery, ListBrandProductsQueryVariables>;
export const CartCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CartCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CartCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartCreatePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Cart"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productCount"}},{"kind":"Field","name":{"kind":"Name","value":"promotionCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"remainingAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"relatedProductsByCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInventoryData"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recommendedProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInventoryData"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductClubPriceData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartPromotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"requiresLogin"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"percentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductInventoryData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"useInventoryTracking"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEstimateDays"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"expectedShipmentDate"}},{"kind":"Field","name":{"kind":"Name","value":"isGiftCard"}}]}}]}}]} as unknown as DocumentNode<CartCreateMutation, CartCreateMutationVariables>;
export const CartUpdateGiftCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CartUpdateGiftCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"giftCardCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NonEmptyString"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartUpdateGiftCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"giftCardCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"giftCardCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartUpdatePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityNotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"detailedMessage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Cart"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productCount"}},{"kind":"Field","name":{"kind":"Name","value":"promotionCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"remainingAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"relatedProductsByCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInventoryData"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recommendedProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInventoryData"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductClubPriceData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartPromotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"requiresLogin"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"percentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductInventoryData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"useInventoryTracking"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEstimateDays"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"expectedShipmentDate"}},{"kind":"Field","name":{"kind":"Name","value":"isGiftCard"}}]}}]}}]} as unknown as DocumentNode<CartUpdateGiftCardMutation, CartUpdateGiftCardMutationVariables>;
export const CartProductCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CartProductCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CartProductCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartProductCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartProductCreatePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidInputError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"detailedMessage"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Cart"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productCount"}},{"kind":"Field","name":{"kind":"Name","value":"promotionCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"remainingAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"relatedProductsByCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInventoryData"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recommendedProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInventoryData"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductClubPriceData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartPromotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"requiresLogin"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"percentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductInventoryData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"useInventoryTracking"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEstimateDays"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"expectedShipmentDate"}},{"kind":"Field","name":{"kind":"Name","value":"isGiftCard"}}]}}]}}]} as unknown as DocumentNode<CartProductCreateMutation, CartProductCreateMutationVariables>;
export const CartProductDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CartProductDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartProductDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartProductDeletePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityNotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"detailedMessage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Cart"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productCount"}},{"kind":"Field","name":{"kind":"Name","value":"promotionCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"remainingAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"relatedProductsByCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInventoryData"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recommendedProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInventoryData"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductClubPriceData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartPromotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"requiresLogin"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"percentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductInventoryData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"useInventoryTracking"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEstimateDays"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"expectedShipmentDate"}},{"kind":"Field","name":{"kind":"Name","value":"isGiftCard"}}]}}]}}]} as unknown as DocumentNode<CartProductDeleteMutation, CartProductDeleteMutationVariables>;
export const CartProductUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CartProductUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PositiveInt"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartProductUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"quantity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartProductUpdatePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cartProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityNotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"detailedMessage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Cart"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productCount"}},{"kind":"Field","name":{"kind":"Name","value":"promotionCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"remainingAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"relatedProductsByCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInventoryData"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recommendedProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInventoryData"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductClubPriceData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartPromotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"requiresLogin"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"percentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductInventoryData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"useInventoryTracking"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEstimateDays"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"expectedShipmentDate"}},{"kind":"Field","name":{"kind":"Name","value":"isGiftCard"}}]}}]}}]} as unknown as DocumentNode<CartProductUpdateMutation, CartProductUpdateMutationVariables>;
export const CartUpdatePromotionCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CartUpdatePromotionCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"promotionCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NonEmptyString"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartUpdatePromotionCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"promotionCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"promotionCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartUpdatePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityNotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"detailedMessage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Cart"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productCount"}},{"kind":"Field","name":{"kind":"Name","value":"promotionCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"remainingAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"relatedProductsByCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInventoryData"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recommendedProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInventoryData"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductClubPriceData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartPromotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"requiresLogin"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"percentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductInventoryData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"useInventoryTracking"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEstimateDays"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"expectedShipmentDate"}},{"kind":"Field","name":{"kind":"Name","value":"isGiftCard"}}]}}]}}]} as unknown as DocumentNode<CartUpdatePromotionCodeMutation, CartUpdatePromotionCodeMutationVariables>;
export const ViewCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewCart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Cart"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartData"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Cart"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productCount"}},{"kind":"Field","name":{"kind":"Name","value":"promotionCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"remainingAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"relatedProductsByCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInventoryData"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recommendedProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInventoryData"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductClubPriceData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartPromotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"requiresLogin"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"percentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductInventoryData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"useInventoryTracking"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEstimateDays"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"expectedShipmentDate"}},{"kind":"Field","name":{"kind":"Name","value":"isGiftCard"}}]}}]}}]} as unknown as DocumentNode<ViewCartQuery, ViewCartQueryVariables>;
export const CategoryProductPickerSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CategoryProductPickerSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CategoryProductPickerSearchQuery, CategoryProductPickerSearchQueryVariables>;
export const ListCategoryProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListCategoryProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"CREATED_AT"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListProductData"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListProductData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConfigurableProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionData"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Promotion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"activeTo"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"catalogDiscountType"},"name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"catalogPercentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotionFixedAmount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"catalogFixedAmountDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionStyleData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromotionStyle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"altContent"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mirrored"}},{"kind":"Field","name":{"kind":"Name","value":"mainTheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleThemeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"altTheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleThemeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hidePriceHistory"}},{"kind":"Field","name":{"kind":"Name","value":"showPromotionEndingTimer"}},{"kind":"Field","name":{"kind":"Name","value":"showCountdownTextContent"}},{"kind":"Field","name":{"kind":"Name","value":"promotionTimerContent"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryPricingInfoOverride"}},{"kind":"Field","name":{"kind":"Name","value":"omnibusContent"}},{"kind":"Field","name":{"kind":"Name","value":"isTimedVisibility"}},{"kind":"Field","name":{"kind":"Name","value":"isCampaignModalEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"campaignModalContent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionStyleThemeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromotionStyleTheme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"customColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"customColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"font"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"family"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"customSize"}}]}}]}}]} as unknown as DocumentNode<ListCategoryProductsQuery, ListCategoryProductsQueryVariables>;
export const ViewCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"publishedFrom"}},{"kind":"Field","name":{"kind":"Name","value":"publishedTo"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"productCount"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ViewCategoryQuery, ViewCategoryQueryVariables>;
export const ViewCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"POSITION"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"publishedFrom"}},{"kind":"Field","name":{"kind":"Name","value":"publishedTo"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"productCount"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hasCustomSlug"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ViewCategoriesQuery, ViewCategoriesQueryVariables>;
export const OrderAddressCreateFromCustomerAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderAddressCreateFromCustomerAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerAddressId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderAddressCreateFromCustomerAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerAddressId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerAddressId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderAddressCreatePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAddressData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAddressData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"businessIdentityCode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]} as unknown as DocumentNode<OrderAddressCreateFromCustomerAddressMutation, OrderAddressCreateFromCustomerAddressMutationVariables>;
export const OrderAddressCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderAddressCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderAddressCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderAddressCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderAddressCreatePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAddressData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAddressData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"businessIdentityCode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]} as unknown as DocumentNode<OrderAddressCreateMutation, OrderAddressCreateMutationVariables>;
export const OrderAddressUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderAddressUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderAddressUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderAddressUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderAddressUpdatePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAddressData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAddressData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAddressData"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAddressData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"businessIdentityCode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]} as unknown as DocumentNode<OrderAddressUpdateMutation, OrderAddressUpdateMutationVariables>;
export const OrderFindCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderFindCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailAddress"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Customer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<OrderFindCustomerQuery, OrderFindCustomerQueryVariables>;
export const OrderListCustomerAddressesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderListCustomerAddresses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"6"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerAddressData"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerAddressData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"businessIdentityCode"}}]}}]} as unknown as DocumentNode<OrderListCustomerAddressesQuery, OrderListCustomerAddressesQueryVariables>;
export const OrderSetBillingAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderSetBillingAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderSetBillingAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"addressId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderUpdatePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAddressData"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityNotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"detailedMessage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAddressData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"businessIdentityCode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]} as unknown as DocumentNode<OrderSetBillingAddressMutation, OrderSetBillingAddressMutationVariables>;
export const OrderSetCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderSetCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderSetCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderUpdatePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderCustomerData"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderCustomerData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Customer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"allowEmailMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"allowSmsMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]} as unknown as DocumentNode<OrderSetCustomerMutation, OrderSetCustomerMutationVariables>;
export const OrderSetShippingAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderSetShippingAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderSetShippingAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"addressId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderUpdatePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAddressData"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityNotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"detailedMessage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAddressData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"businessIdentityCode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]} as unknown as DocumentNode<OrderSetShippingAddressMutation, OrderSetShippingAddressMutationVariables>;
export const OrderCreateFromCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderCreateFromCart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cartId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderCreateFromCart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cartId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cartId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderCreatePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidInputError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"detailedMessage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAddressData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"businessIdentityCode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderCustomerData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Customer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"allowEmailMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"allowSmsMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderPaymentData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountsAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasFreeShipping"}},{"kind":"Field","name":{"kind":"Name","value":"shipping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderShippingData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderCustomerData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"saleNumber"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEstimate"}},{"kind":"Field","name":{"kind":"Name","value":"originalDeliveryEstimate"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCardOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAddressData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAddressData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInventoryData"}},{"kind":"Field","name":{"kind":"Name","value":"productClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"availablePaymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentMethodAvarda"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentType"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderPaymentData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"method"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentInfoAvarda"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentType"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderShippingData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderShippingInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"method"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderShippingInfoPickUpFromStore"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outlet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductClubPriceData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartPromotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"requiresLogin"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"percentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductInventoryData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"useInventoryTracking"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEstimateDays"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"expectedShipmentDate"}},{"kind":"Field","name":{"kind":"Name","value":"isGiftCard"}}]}}]}}]} as unknown as DocumentNode<OrderCreateFromCartMutation, OrderCreateFromCartMutationVariables>;
export const OrderFinalizeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderFinalize"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderFinalize"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderFinalizePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityNotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidInputError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"detailedMessage"}}]}}]}}]}}]} as unknown as DocumentNode<OrderFinalizeMutation, OrderFinalizeMutationVariables>;
export const OrderUndoFinalizeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderUndoFinalize"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderUndoFinalize"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderUndoFinalizePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityNotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidInputError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"detailedMessage"}}]}}]}}]}}]} as unknown as DocumentNode<OrderUndoFinalizeMutation, OrderUndoFinalizeMutationVariables>;
export const OrderCancelPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderCancelPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fingerprint"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderPaymentCancel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fingerprint"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fingerprint"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentCancelPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<OrderCancelPaymentMutation, OrderCancelPaymentMutationVariables>;
export const OrderCompletePaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderCompletePayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fingerprint"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"response"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentResponseDataInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderPaymentComplete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fingerprint"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fingerprint"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"response"},"value":{"kind":"Variable","name":{"kind":"Name","value":"response"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentCompletePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<OrderCompletePaymentMutation, OrderCompletePaymentMutationVariables>;
export const OrderCreatePaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderCreatePayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderPaymentCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentCreatePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fingerprint"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<OrderCreatePaymentMutation, OrderCreatePaymentMutationVariables>;
export const OrderExecutePaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderExecutePayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fingerprint"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"successUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NonEmptyString"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cancelUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NonEmptyString"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notifyUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NonEmptyString"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderPaymentExecute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fingerprint"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fingerprint"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"successUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"successUrl"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"cancelUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cancelUrl"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notifyUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notifyUrl"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentExecutePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"environment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentAvarda"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentAvardaEstonia"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentMaksekeskus"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentPaytrail"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formActionUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentInbank"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentPaywerk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paywerkId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentEsto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentMontonio"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentHolmbank"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrderExecutePaymentMutation, OrderExecutePaymentMutationVariables>;
export const OrderNotifyPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderNotifyPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fingerprint"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"response"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentResponseDataInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderPaymentNotify"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fingerprint"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fingerprint"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"response"},"value":{"kind":"Variable","name":{"kind":"Name","value":"response"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentNotifyPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<OrderNotifyPaymentMutation, OrderNotifyPaymentMutationVariables>;
export const OrderSetPaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderSetPaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethodId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethodData"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderDataInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderSetPaymentMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"paymentMethodId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethodId"}}},{"kind":"Argument","name":{"kind":"Name","value":"paymentData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethodData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderUpdatePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderPaymentData"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityNotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"detailedMessage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderPaymentData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"method"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentInfoAvarda"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentType"}}]}}]}}]} as unknown as DocumentNode<OrderSetPaymentMethodMutation, OrderSetPaymentMethodMutationVariables>;
export const ViewOrderPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewOrderPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentUniqueWhereInputWithFingerprint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPayment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fingerprint"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ViewOrderPaymentQuery, ViewOrderPaymentQueryVariables>;
export const OrderSetShippingMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrderSetShippingMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PostalCode"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shippingMethodId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shippingData"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderDataInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderSetShippingMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"shippingMethodId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shippingMethodId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shippingData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shippingData"}}},{"kind":"Argument","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderUpdatePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shipping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderShippingData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availablePaymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentMethodAvarda"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentType"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityNotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"detailedMessage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderShippingData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderShippingInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"method"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderShippingInfoPickUpFromStore"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outlet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}}]}}]} as unknown as DocumentNode<OrderSetShippingMethodMutation, OrderSetShippingMethodMutationVariables>;
export const ViewCheckoutOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewCheckoutOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PostalCode"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loadOffices"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"officesPostalCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostalCode"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"officesCountryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryCode"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderData"}},{"kind":"Field","name":{"kind":"Name","value":"availableShippingMethods"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"originalPriceWithServices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceWithServices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"freeShippingPriceWithServices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethodOmniva"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"officesCountryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"officesPostalCode"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loadOffices"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"serviceHours"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"approximateDistance"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethodPickUpFromStore"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outlets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethodMatkahuolto"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"officesCountryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"officesPostalCode"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loadOffices"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"6"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"CREATED_AT"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerAddressData"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAddressData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"businessIdentityCode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderCustomerData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Customer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"allowEmailMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"allowSmsMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderPaymentData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountsAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasFreeShipping"}},{"kind":"Field","name":{"kind":"Name","value":"shipping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderShippingData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderCustomerData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"saleNumber"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEstimate"}},{"kind":"Field","name":{"kind":"Name","value":"originalDeliveryEstimate"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCardOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAddressData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAddressData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInventoryData"}},{"kind":"Field","name":{"kind":"Name","value":"productClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"availablePaymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentMethodAvarda"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentType"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderPaymentData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"method"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentInfoAvarda"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentType"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderShippingData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderShippingInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"method"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderShippingInfoPickUpFromStore"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outlet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerAddressData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"businessIdentityCode"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductClubPriceData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartPromotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"requiresLogin"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"percentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductInventoryData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"useInventoryTracking"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEstimateDays"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"expectedShipmentDate"}},{"kind":"Field","name":{"kind":"Name","value":"isGiftCard"}}]}}]}}]} as unknown as DocumentNode<ViewCheckoutOrderQuery, ViewCheckoutOrderQueryVariables>;
export const ListProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"collectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"id_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"CREATED_AT"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListProductData"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListProductData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConfigurableProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionData"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Promotion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"activeTo"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"catalogDiscountType"},"name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"catalogPercentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotionFixedAmount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"catalogFixedAmountDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionStyleData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromotionStyle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"altContent"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mirrored"}},{"kind":"Field","name":{"kind":"Name","value":"mainTheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleThemeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"altTheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleThemeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hidePriceHistory"}},{"kind":"Field","name":{"kind":"Name","value":"showPromotionEndingTimer"}},{"kind":"Field","name":{"kind":"Name","value":"showCountdownTextContent"}},{"kind":"Field","name":{"kind":"Name","value":"promotionTimerContent"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryPricingInfoOverride"}},{"kind":"Field","name":{"kind":"Name","value":"omnibusContent"}},{"kind":"Field","name":{"kind":"Name","value":"isTimedVisibility"}},{"kind":"Field","name":{"kind":"Name","value":"isCampaignModalEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"campaignModalContent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionStyleThemeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromotionStyleTheme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"customColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"customColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"font"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"family"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"customSize"}}]}}]}}]} as unknown as DocumentNode<ListProductsQuery, ListProductsQueryVariables>;
export const CreateCompanyAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCompanyAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyAddressCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyAddressCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyAddressCreatePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCompanyAddressMutation, CreateCompanyAddressMutationVariables>;
export const CreateCompanyCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCompanyCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyCustomerRole"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyAddCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyAddCustomerPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCompanyCustomerMutation, CreateCompanyCustomerMutationVariables>;
export const CreateCompanyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCompany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyCreatePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const CreateCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerCreatePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const CreateCustomerAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCustomerAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerAddressCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerAddressCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerAddressCreatePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerAddressData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerAddressData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"businessIdentityCode"}}]}}]} as unknown as DocumentNode<CreateCustomerAddressMutation, CreateCustomerAddressMutationVariables>;
export const CustomerSendEmailVerificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CustomerSendEmailVerification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerSendEmailVerification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerUpdatePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CustomerSendEmailVerificationMutation, CustomerSendEmailVerificationMutationVariables>;
export const DeleteCustomerAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCustomerAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerAddressDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerAddressDeletePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteCustomerAddressMutation, DeleteCustomerAddressMutationVariables>;
export const DeleteCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerDeletePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteCustomerMutation, DeleteCustomerMutationVariables>;
export const FinishFirstTimeCustomerSetupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FinishFirstTimeCustomerSetup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerFinishFirstTimeSetup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerUpdatePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isFirstTimeSetupDone"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<FinishFirstTimeCustomerSetupMutation, FinishFirstTimeCustomerSetupMutationVariables>;
export const ListCustomerAddressesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListCustomerAddresses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerAddressType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerAddressData"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerAddressData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"businessIdentityCode"}}]}}]} as unknown as DocumentNode<ListCustomerAddressesQuery, ListCustomerAddressesQueryVariables>;
export const ListCustomerOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListCustomerOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"CREATED_AT"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListCustomerOrdersQuery, ListCustomerOrdersQueryVariables>;
export const UpdateCustomerAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCustomerAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerAddressUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerAddressUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerAddressUpdatePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerAddressData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerAddressData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"businessIdentityCode"}}]}}]} as unknown as DocumentNode<UpdateCustomerAddressMutation, UpdateCustomerAddressMutationVariables>;
export const UpdateCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerUpdatePayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Customer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"allowEmailMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"allowSmsMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"businessIdentityCode"}}]}}]}}]} as unknown as DocumentNode<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const ViewCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerData"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"EnumValue","value":"PROCESSED"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"EnumValue","value":"RECEIVED"}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"CREATED_AT"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"saleNumber"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"6"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerAddressData"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerAddressData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"businessIdentityCode"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Customer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"allowEmailMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"allowSmsMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"businessIdentityCode"}}]}}]}}]} as unknown as DocumentNode<ViewCustomerQuery, ViewCustomerQueryVariables>;
export const ListCustomersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListCustomers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"CREATED_AT"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"CREATED_AT"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"businessIdentityCode"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListCustomersQuery, ListCustomersQueryVariables>;
export const GiftCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GiftCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NonEmptyString"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"giftCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GiftCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"initialAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainingAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createDate"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityNotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GiftCardQuery, GiftCardQueryVariables>;
export const ListOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"CREATED_AT"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListOrdersQuery, ListOrdersQueryVariables>;
export const ViewOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderData"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAddressData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"businessIdentityCode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderCustomerData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Customer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"allowEmailMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"allowSmsMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderPaymentData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountsAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasFreeShipping"}},{"kind":"Field","name":{"kind":"Name","value":"shipping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderShippingData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderCustomerData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"saleNumber"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEstimate"}},{"kind":"Field","name":{"kind":"Name","value":"originalDeliveryEstimate"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCardOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAddressData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAddressData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductInventoryData"}},{"kind":"Field","name":{"kind":"Name","value":"productClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"availablePaymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentMethodAvarda"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentType"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderPaymentData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"method"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPaymentInfoAvarda"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentType"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderShippingData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderShippingInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"method"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderShippingInfoPickUpFromStore"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outlet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductClubPriceData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartPromotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"requiresLogin"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"percentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductInventoryData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"useInventoryTracking"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEstimateDays"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"expectedShipmentDate"}},{"kind":"Field","name":{"kind":"Name","value":"isGiftCard"}}]}}]}}]} as unknown as DocumentNode<ViewOrderQuery, ViewOrderQueryVariables>;
export const ListSubProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListSubProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConfigurableProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"option"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"showInProductPage"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAttributeValueTypes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAttributeValueTypes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMultiselectValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"multiselect"},"name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDateValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"date"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDropdownValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dropdown"},"name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTextValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTextareaValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"textarea"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductToggleValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"toggle"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTagsValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tags"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductNumberValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"number"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductColorValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<ListSubProductsQuery, ListSubProductsQueryVariables>;
export const ViewMarkerProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewMarkerProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MarkerSimpleProductData"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConfigurableProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MarkerSimpleProductData"}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarkerSimpleProductData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]} as unknown as DocumentNode<ViewMarkerProductsQuery, ViewMarkerProductsQueryVariables>;
export const ViewProductCriticalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewProductCritical"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimpleProductCriticalData"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductClubPriceData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartPromotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"requiresLogin"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"percentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimpleProductCriticalData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lowestPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotionPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"useInventoryTracking"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEstimateDays"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"expectedShipmentDate"}},{"kind":"Field","name":{"kind":"Name","value":"isGiftCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outlets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"modelQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outletsWithBundling"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outlet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"modelQuantity"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}}]}}]} as unknown as DocumentNode<ViewProductCriticalQuery, ViewProductCriticalQueryVariables>;
export const ViewProductDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewProductDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimpleProductDetailsData"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAttributeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"suffix"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAttributeValueTypes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAttributeValueTypes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMultiselectValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"multiselect"},"name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDateValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"date"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDropdownValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dropdown"},"name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTextValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTextareaValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"textarea"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductToggleValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"toggle"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTagsValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tags"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductNumberValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"number"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductColorValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimpleProductDetailsData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"listingAttributes"},"name":{"kind":"Name","value":"attributes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"showInProductListing"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAttributeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"showInProductPage"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAttributeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parcelsAreVisible"}},{"kind":"Field","name":{"kind":"Name","value":"parcels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"productQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"depth"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"tareWeight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dimensions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"depth"}},{"kind":"Field","name":{"kind":"Name","value":"diameter"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"pimCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outlets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"modelQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outletsWithBundling"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outlet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"modelQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productBadges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"listingTitle"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"transparentBackground"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Promotion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"activeTo"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"catalogDiscountType"},"name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"catalogPercentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotionFixedAmount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"catalogFixedAmountDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionStyleData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromotionStyle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"altContent"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mirrored"}},{"kind":"Field","name":{"kind":"Name","value":"mainTheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleThemeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"altTheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleThemeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hidePriceHistory"}},{"kind":"Field","name":{"kind":"Name","value":"showPromotionEndingTimer"}},{"kind":"Field","name":{"kind":"Name","value":"showCountdownTextContent"}},{"kind":"Field","name":{"kind":"Name","value":"promotionTimerContent"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryPricingInfoOverride"}},{"kind":"Field","name":{"kind":"Name","value":"omnibusContent"}},{"kind":"Field","name":{"kind":"Name","value":"isTimedVisibility"}},{"kind":"Field","name":{"kind":"Name","value":"isCampaignModalEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"campaignModalContent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionStyleThemeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromotionStyleTheme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"customColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"customColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"font"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"family"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"customSize"}}]}}]}}]} as unknown as DocumentNode<ViewProductDetailsQuery, ViewProductDetailsQueryVariables>;
export const ViewProductShippingMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewProductShippingMethods"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PostalCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEligibleForFreeShipping"}},{"kind":"Field","name":{"kind":"Name","value":"availableShippingMethods"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"originalPriceWithServices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceWithServices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"freeShippingPriceWithServices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ViewProductShippingMethodsQuery, ViewProductShippingMethodsQueryVariables>;
export const ViewProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NonEmptyString"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMeasurement"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brandLogo"}},{"kind":"Field","name":{"kind":"Name","value":"brandTitle"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductBrandData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"isPublished"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"contentTitle"}},{"kind":"Field","name":{"kind":"Name","value":"titleColor"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"publishedFrom"}},{"kind":"Field","name":{"kind":"Name","value":"publishedTo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productBadges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"listingTitle"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"transparentBackground"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimpleProductData"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimpleProductDetailsData"}},{"kind":"Field","name":{"kind":"Name","value":"parentProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConfigurableProductData"}},{"kind":"Field","name":{"kind":"Name","value":"configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimpleProductDetailsData"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConfigurableProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConfigurableProductData"}},{"kind":"Field","name":{"kind":"Name","value":"configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimpleProductData"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimpleProductDetailsData"}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConfigurableProductData"}},{"kind":"Field","name":{"kind":"Name","value":"configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimpleProductDetailsData"}}]}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"isError"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConfigurableProductData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConfigurableProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"medias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductMediaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maskMedias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"specifier"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"linkedOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMeasurement"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"suffix"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"option"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimpleProductData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAttributeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","name":{"kind":"Name","value":"suffix"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAttributeValueTypes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAttributeValueTypes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMultiselectValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"multiselect"},"name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDateValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"date"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDropdownValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dropdown"},"name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTextValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTextareaValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"textarea"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductToggleValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"toggle"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTagsValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tags"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductNumberValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"number"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductColorValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"color"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductBrandData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Brand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductClubPriceData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartPromotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"requiresLogin"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"percentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductMediaData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMedia"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"shotType"}},{"kind":"Field","name":{"kind":"Name","value":"orientation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimpleProductCriticalData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lowestPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotionPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"useInventoryTracking"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEstimateDays"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableForPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"expectedShipmentDate"}},{"kind":"Field","name":{"kind":"Name","value":"isGiftCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outlets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"modelQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outletsWithBundling"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outlet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"modelQuantity"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductClubPriceData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimpleProductData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"specification"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"qaItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"listingImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"pimCode"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"medias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductMediaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductBrandData"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductBrandData"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brandLogo"}},{"kind":"Field","name":{"kind":"Name","value":"brandTitle"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"isPublished"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"contentTitle"}},{"kind":"Field","name":{"kind":"Name","value":"titleColor"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"publishedFrom"}},{"kind":"Field","name":{"kind":"Name","value":"publishedTo"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimpleProductCriticalData"}},{"kind":"Field","name":{"kind":"Name","value":"parentProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productBadges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"listingTitle"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"transparentBackground"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMeasurement"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dimensions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"depth"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"colorForFilteringAttribute"},"name":{"kind":"Name","value":"attributes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"StringValue","value":"color_multi","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAttributeData"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"materialsAttribute"},"name":{"kind":"Name","value":"attributes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"StringValue","value":"materials","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAttributeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimatedShippingPriceRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"StringValue","value":"00100","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"cache"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimpleProductDetailsData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"listingAttributes"},"name":{"kind":"Name","value":"attributes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"showInProductListing"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAttributeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"showInProductPage"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAttributeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parcelsAreVisible"}},{"kind":"Field","name":{"kind":"Name","value":"parcels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"productQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"depth"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"tareWeight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dimensions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"depth"}},{"kind":"Field","name":{"kind":"Name","value":"diameter"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"pimCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outlets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"modelQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outletsWithBundling"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outlet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"modelQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productBadges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"listingTitle"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"transparentBackground"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Promotion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"activeTo"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"catalogDiscountType"},"name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotionPercent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"catalogPercentDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogPromotionFixedAmount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"catalogFixedAmountDiscount"},"name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleData"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionStyleData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromotionStyle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"altContent"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mirrored"}},{"kind":"Field","name":{"kind":"Name","value":"mainTheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleThemeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"altTheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionStyleThemeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hidePriceHistory"}},{"kind":"Field","name":{"kind":"Name","value":"showPromotionEndingTimer"}},{"kind":"Field","name":{"kind":"Name","value":"showCountdownTextContent"}},{"kind":"Field","name":{"kind":"Name","value":"promotionTimerContent"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryPricingInfoOverride"}},{"kind":"Field","name":{"kind":"Name","value":"omnibusContent"}},{"kind":"Field","name":{"kind":"Name","value":"isTimedVisibility"}},{"kind":"Field","name":{"kind":"Name","value":"isCampaignModalEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"campaignModalContent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionStyleThemeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromotionStyleTheme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"customColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"customColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"font"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"family"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"customSize"}}]}}]}}]} as unknown as DocumentNode<ViewProductQuery, ViewProductQueryVariables>;
export const ListPromotionsForPriorityListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListPromotionsForPriorityList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PromotionType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promotions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AND"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"EnumValue","value":"PUBLISHED"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"EnumValue","value":"SCHEDULED"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"EnumValue","value":"HIDDEN"}}]}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"PRIORITY"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"isSticky"}},{"kind":"Field","name":{"kind":"Name","value":"activeFrom"}},{"kind":"Field","name":{"kind":"Name","value":"activeTo"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"continueProcessing"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListPromotionsForPriorityListQuery, ListPromotionsForPriorityListQueryVariables>;
export const ViewStoreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewStore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]} as unknown as DocumentNode<ViewStoreQuery, ViewStoreQueryVariables>;
export const ViewMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"allowEmailMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"allowSmsMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"isFirstTimeSetupDone"}},{"kind":"Field","name":{"kind":"Name","value":"requiresEmailVerification"}}]}}]}}]}}]} as unknown as DocumentNode<ViewMeQuery, ViewMeQueryVariables>;